
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireba46"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireba46"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b8reE", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $81b591678b09dda1$export$ffb0004e005737fa, (v) => $81b591678b09dda1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $81b591678b09dda1$export$34b9dba7ce09269b, (v) => $81b591678b09dda1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $81b591678b09dda1$export$25062201e9e25d76, (v) => $81b591678b09dda1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81b591678b09dda1$export$ffb0004e005737fa;
var $81b591678b09dda1$export$34b9dba7ce09269b;
var $81b591678b09dda1$export$25062201e9e25d76;
"use strict";

var $8tsvq = parcelRequire("8tsvq");
var $81b591678b09dda1$var$k = Symbol.for("react.element"), $81b591678b09dda1$var$l = Symbol.for("react.fragment"), $81b591678b09dda1$var$m = Object.prototype.hasOwnProperty, $81b591678b09dda1$var$n = $8tsvq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $81b591678b09dda1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $81b591678b09dda1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$81b591678b09dda1$var$m.call(a, b) && !$81b591678b09dda1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $81b591678b09dda1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $81b591678b09dda1$var$n.current
    };
}
$81b591678b09dda1$export$ffb0004e005737fa = $81b591678b09dda1$var$l;
$81b591678b09dda1$export$34b9dba7ce09269b = $81b591678b09dda1$var$q;
$81b591678b09dda1$export$25062201e9e25d76 = $81b591678b09dda1$var$q;

});
parcelRegister("8tsvq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4rIOO"));

});
parcelRegister("4rIOO", function(module, exports) {

$parcel$export(module.exports, "Children", () => $33cc730c2de4ccfb$export$dca3b0875bd9a954, (v) => $33cc730c2de4ccfb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $33cc730c2de4ccfb$export$16fa2f45be04daa8, (v) => $33cc730c2de4ccfb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $33cc730c2de4ccfb$export$ffb0004e005737fa, (v) => $33cc730c2de4ccfb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $33cc730c2de4ccfb$export$e2c29f18771995cb, (v) => $33cc730c2de4ccfb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $33cc730c2de4ccfb$export$221d75b3f55bb0bd, (v) => $33cc730c2de4ccfb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $33cc730c2de4ccfb$export$5f8d39834fd61797, (v) => $33cc730c2de4ccfb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $33cc730c2de4ccfb$export$74bf444e3cd11ea5, (v) => $33cc730c2de4ccfb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $33cc730c2de4ccfb$export$ae55be85d98224ed, (v) => $33cc730c2de4ccfb$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $33cc730c2de4ccfb$export$3ba232387fd5d6dd, (v) => $33cc730c2de4ccfb$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $33cc730c2de4ccfb$export$e530037191fcd5d7, (v) => $33cc730c2de4ccfb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $33cc730c2de4ccfb$export$fd42f52fd3ae1109, (v) => $33cc730c2de4ccfb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $33cc730c2de4ccfb$export$c8a8987d4410bf2d, (v) => $33cc730c2de4ccfb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $33cc730c2de4ccfb$export$d38cd72104c1f0e9, (v) => $33cc730c2de4ccfb$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $33cc730c2de4ccfb$export$7d1e3a5e95ceca43, (v) => $33cc730c2de4ccfb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $33cc730c2de4ccfb$export$257a8862b851cb5b, (v) => $33cc730c2de4ccfb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $33cc730c2de4ccfb$export$a8257692ac88316c, (v) => $33cc730c2de4ccfb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $33cc730c2de4ccfb$export$488013bae63b21da, (v) => $33cc730c2de4ccfb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $33cc730c2de4ccfb$export$7c73462e0d25e514, (v) => $33cc730c2de4ccfb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $33cc730c2de4ccfb$export$7568632d0d33d16d, (v) => $33cc730c2de4ccfb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $33cc730c2de4ccfb$export$88948ce120ea2619, (v) => $33cc730c2de4ccfb$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $33cc730c2de4ccfb$export$35808ee640e87ca7, (v) => $33cc730c2de4ccfb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $33cc730c2de4ccfb$export$fae74005e78b1a27, (v) => $33cc730c2de4ccfb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e, (v) => $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $33cc730c2de4ccfb$export$6a7bc4e911dc01cf, (v) => $33cc730c2de4ccfb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $33cc730c2de4ccfb$export$6d9c69b0de29b591, (v) => $33cc730c2de4ccfb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $33cc730c2de4ccfb$export$f680877a34711e37, (v) => $33cc730c2de4ccfb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $33cc730c2de4ccfb$export$d5a552a76deda3c2, (v) => $33cc730c2de4ccfb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $33cc730c2de4ccfb$export$aaabe4eda9ed9969, (v) => $33cc730c2de4ccfb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $33cc730c2de4ccfb$export$e5c5a5f917a5871c, (v) => $33cc730c2de4ccfb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $33cc730c2de4ccfb$export$1538c33de8887b59, (v) => $33cc730c2de4ccfb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $33cc730c2de4ccfb$export$13e3392192263954, (v) => $33cc730c2de4ccfb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $33cc730c2de4ccfb$export$b8f5890fc79d6aca, (v) => $33cc730c2de4ccfb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $33cc730c2de4ccfb$export$60241385465d0a34, (v) => $33cc730c2de4ccfb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $33cc730c2de4ccfb$export$306c0aa65ff9ec16, (v) => $33cc730c2de4ccfb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $33cc730c2de4ccfb$export$7b286972b8d8ccbf, (v) => $33cc730c2de4ccfb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $33cc730c2de4ccfb$export$83d89fbfd8236492, (v) => $33cc730c2de4ccfb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $33cc730c2de4ccfb$export$dca3b0875bd9a954;
var $33cc730c2de4ccfb$export$16fa2f45be04daa8;
var $33cc730c2de4ccfb$export$ffb0004e005737fa;
var $33cc730c2de4ccfb$export$e2c29f18771995cb;
var $33cc730c2de4ccfb$export$221d75b3f55bb0bd;
var $33cc730c2de4ccfb$export$5f8d39834fd61797;
var $33cc730c2de4ccfb$export$74bf444e3cd11ea5;
var $33cc730c2de4ccfb$export$ae55be85d98224ed;
var $33cc730c2de4ccfb$export$3ba232387fd5d6dd;
var $33cc730c2de4ccfb$export$e530037191fcd5d7;
var $33cc730c2de4ccfb$export$fd42f52fd3ae1109;
var $33cc730c2de4ccfb$export$c8a8987d4410bf2d;
var $33cc730c2de4ccfb$export$d38cd72104c1f0e9;
var $33cc730c2de4ccfb$export$7d1e3a5e95ceca43;
var $33cc730c2de4ccfb$export$257a8862b851cb5b;
var $33cc730c2de4ccfb$export$a8257692ac88316c;
var $33cc730c2de4ccfb$export$488013bae63b21da;
var $33cc730c2de4ccfb$export$7c73462e0d25e514;
var $33cc730c2de4ccfb$export$7568632d0d33d16d;
var $33cc730c2de4ccfb$export$88948ce120ea2619;
var $33cc730c2de4ccfb$export$35808ee640e87ca7;
var $33cc730c2de4ccfb$export$fae74005e78b1a27;
var $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e;
var $33cc730c2de4ccfb$export$6a7bc4e911dc01cf;
var $33cc730c2de4ccfb$export$6d9c69b0de29b591;
var $33cc730c2de4ccfb$export$f680877a34711e37;
var $33cc730c2de4ccfb$export$d5a552a76deda3c2;
var $33cc730c2de4ccfb$export$aaabe4eda9ed9969;
var $33cc730c2de4ccfb$export$e5c5a5f917a5871c;
var $33cc730c2de4ccfb$export$1538c33de8887b59;
var $33cc730c2de4ccfb$export$13e3392192263954;
var $33cc730c2de4ccfb$export$b8f5890fc79d6aca;
var $33cc730c2de4ccfb$export$60241385465d0a34;
var $33cc730c2de4ccfb$export$306c0aa65ff9ec16;
var $33cc730c2de4ccfb$export$7b286972b8d8ccbf;
var $33cc730c2de4ccfb$export$83d89fbfd8236492;
"use strict";
var $33cc730c2de4ccfb$var$l = Symbol.for("react.element"), $33cc730c2de4ccfb$var$n = Symbol.for("react.portal"), $33cc730c2de4ccfb$var$p = Symbol.for("react.fragment"), $33cc730c2de4ccfb$var$q = Symbol.for("react.strict_mode"), $33cc730c2de4ccfb$var$r = Symbol.for("react.profiler"), $33cc730c2de4ccfb$var$t = Symbol.for("react.provider"), $33cc730c2de4ccfb$var$u = Symbol.for("react.context"), $33cc730c2de4ccfb$var$v = Symbol.for("react.forward_ref"), $33cc730c2de4ccfb$var$w = Symbol.for("react.suspense"), $33cc730c2de4ccfb$var$x = Symbol.for("react.memo"), $33cc730c2de4ccfb$var$y = Symbol.for("react.lazy"), $33cc730c2de4ccfb$var$z = Symbol.iterator;
function $33cc730c2de4ccfb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $33cc730c2de4ccfb$var$z && a[$33cc730c2de4ccfb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $33cc730c2de4ccfb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $33cc730c2de4ccfb$var$C = Object.assign, $33cc730c2de4ccfb$var$D = {};
function $33cc730c2de4ccfb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33cc730c2de4ccfb$var$D;
    this.updater = e || $33cc730c2de4ccfb$var$B;
}
$33cc730c2de4ccfb$var$E.prototype.isReactComponent = {};
$33cc730c2de4ccfb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$33cc730c2de4ccfb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $33cc730c2de4ccfb$var$F() {}
$33cc730c2de4ccfb$var$F.prototype = $33cc730c2de4ccfb$var$E.prototype;
function $33cc730c2de4ccfb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33cc730c2de4ccfb$var$D;
    this.updater = e || $33cc730c2de4ccfb$var$B;
}
var $33cc730c2de4ccfb$var$H = $33cc730c2de4ccfb$var$G.prototype = new $33cc730c2de4ccfb$var$F;
$33cc730c2de4ccfb$var$H.constructor = $33cc730c2de4ccfb$var$G;
$33cc730c2de4ccfb$var$C($33cc730c2de4ccfb$var$H, $33cc730c2de4ccfb$var$E.prototype);
$33cc730c2de4ccfb$var$H.isPureReactComponent = !0;
var $33cc730c2de4ccfb$var$I = Array.isArray, $33cc730c2de4ccfb$var$J = Object.prototype.hasOwnProperty, $33cc730c2de4ccfb$var$K = {
    current: null
}, $33cc730c2de4ccfb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $33cc730c2de4ccfb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$33cc730c2de4ccfb$var$J.call(b, d) && !$33cc730c2de4ccfb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $33cc730c2de4ccfb$var$K.current
    };
}
function $33cc730c2de4ccfb$var$N(a, b) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $33cc730c2de4ccfb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $33cc730c2de4ccfb$var$l;
}
function $33cc730c2de4ccfb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $33cc730c2de4ccfb$var$P = /\/+/g;
function $33cc730c2de4ccfb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $33cc730c2de4ccfb$var$escape("" + a.key) : b.toString(36);
}
function $33cc730c2de4ccfb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $33cc730c2de4ccfb$var$l:
                case $33cc730c2de4ccfb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $33cc730c2de4ccfb$var$Q(h, 0) : d, $33cc730c2de4ccfb$var$I(c) ? (e = "", null != a && (e = a.replace($33cc730c2de4ccfb$var$P, "$&/") + "/"), $33cc730c2de4ccfb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($33cc730c2de4ccfb$var$O(c) && (c = $33cc730c2de4ccfb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($33cc730c2de4ccfb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($33cc730c2de4ccfb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $33cc730c2de4ccfb$var$Q(k, g);
        h += $33cc730c2de4ccfb$var$R(k, b, e, f, c);
    }
    else if (f = $33cc730c2de4ccfb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $33cc730c2de4ccfb$var$Q(k, g++), h += $33cc730c2de4ccfb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $33cc730c2de4ccfb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $33cc730c2de4ccfb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $33cc730c2de4ccfb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $33cc730c2de4ccfb$var$U = {
    current: null
}, $33cc730c2de4ccfb$var$V = {
    transition: null
}, $33cc730c2de4ccfb$var$W = {
    ReactCurrentDispatcher: $33cc730c2de4ccfb$var$U,
    ReactCurrentBatchConfig: $33cc730c2de4ccfb$var$V,
    ReactCurrentOwner: $33cc730c2de4ccfb$var$K
};
function $33cc730c2de4ccfb$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$33cc730c2de4ccfb$export$dca3b0875bd9a954 = {
    map: $33cc730c2de4ccfb$var$S,
    forEach: function(a, b, e) {
        $33cc730c2de4ccfb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $33cc730c2de4ccfb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $33cc730c2de4ccfb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$33cc730c2de4ccfb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$33cc730c2de4ccfb$export$16fa2f45be04daa8 = $33cc730c2de4ccfb$var$E;
$33cc730c2de4ccfb$export$ffb0004e005737fa = $33cc730c2de4ccfb$var$p;
$33cc730c2de4ccfb$export$e2c29f18771995cb = $33cc730c2de4ccfb$var$r;
$33cc730c2de4ccfb$export$221d75b3f55bb0bd = $33cc730c2de4ccfb$var$G;
$33cc730c2de4ccfb$export$5f8d39834fd61797 = $33cc730c2de4ccfb$var$q;
$33cc730c2de4ccfb$export$74bf444e3cd11ea5 = $33cc730c2de4ccfb$var$w;
$33cc730c2de4ccfb$export$ae55be85d98224ed = $33cc730c2de4ccfb$var$W;
$33cc730c2de4ccfb$export$3ba232387fd5d6dd = $33cc730c2de4ccfb$var$X;
$33cc730c2de4ccfb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $33cc730c2de4ccfb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $33cc730c2de4ccfb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$33cc730c2de4ccfb$var$J.call(b, f) && !$33cc730c2de4ccfb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$33cc730c2de4ccfb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $33cc730c2de4ccfb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $33cc730c2de4ccfb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$33cc730c2de4ccfb$export$c8a8987d4410bf2d = $33cc730c2de4ccfb$var$M;
$33cc730c2de4ccfb$export$d38cd72104c1f0e9 = function(a) {
    var b = $33cc730c2de4ccfb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$33cc730c2de4ccfb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$33cc730c2de4ccfb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$v,
        render: a
    };
};
$33cc730c2de4ccfb$export$a8257692ac88316c = $33cc730c2de4ccfb$var$O;
$33cc730c2de4ccfb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $33cc730c2de4ccfb$var$T
    };
};
$33cc730c2de4ccfb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$33cc730c2de4ccfb$export$7568632d0d33d16d = function(a) {
    var b = $33cc730c2de4ccfb$var$V.transition;
    $33cc730c2de4ccfb$var$V.transition = {};
    try {
        a();
    } finally{
        $33cc730c2de4ccfb$var$V.transition = b;
    }
};
$33cc730c2de4ccfb$export$88948ce120ea2619 = $33cc730c2de4ccfb$var$X;
$33cc730c2de4ccfb$export$35808ee640e87ca7 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useCallback(a, b);
};
$33cc730c2de4ccfb$export$fae74005e78b1a27 = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useContext(a);
};
$33cc730c2de4ccfb$export$dc8fbce3eb94dc1e = function() {};
$33cc730c2de4ccfb$export$6a7bc4e911dc01cf = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useDeferredValue(a);
};
$33cc730c2de4ccfb$export$6d9c69b0de29b591 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useEffect(a, b);
};
$33cc730c2de4ccfb$export$f680877a34711e37 = function() {
    return $33cc730c2de4ccfb$var$U.current.useId();
};
$33cc730c2de4ccfb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useImperativeHandle(a, b, e);
};
$33cc730c2de4ccfb$export$aaabe4eda9ed9969 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useInsertionEffect(a, b);
};
$33cc730c2de4ccfb$export$e5c5a5f917a5871c = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useLayoutEffect(a, b);
};
$33cc730c2de4ccfb$export$1538c33de8887b59 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useMemo(a, b);
};
$33cc730c2de4ccfb$export$13e3392192263954 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useReducer(a, b, e);
};
$33cc730c2de4ccfb$export$b8f5890fc79d6aca = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useRef(a);
};
$33cc730c2de4ccfb$export$60241385465d0a34 = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useState(a);
};
$33cc730c2de4ccfb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useSyncExternalStore(a, b, e);
};
$33cc730c2de4ccfb$export$7b286972b8d8ccbf = function() {
    return $33cc730c2de4ccfb$var$U.current.useTransition();
};
$33cc730c2de4ccfb$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("jhxbP", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e09959a092a7608b$export$ae55be85d98224ed, (v) => $e09959a092a7608b$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $e09959a092a7608b$export$d39a5bbd09211389, (v) => $e09959a092a7608b$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $e09959a092a7608b$export$882461b6382ed46c, (v) => $e09959a092a7608b$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $e09959a092a7608b$export$466bfc07425424d5, (v) => $e09959a092a7608b$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $e09959a092a7608b$export$cd75ccfd720a3cd4, (v) => $e09959a092a7608b$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $e09959a092a7608b$export$fa8d919ba61d84db, (v) => $e09959a092a7608b$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $e09959a092a7608b$export$757ceba2d55c277e, (v) => $e09959a092a7608b$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $e09959a092a7608b$export$b3890eb0ae9dca99, (v) => $e09959a092a7608b$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $e09959a092a7608b$export$502457920280e6be, (v) => $e09959a092a7608b$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e09959a092a7608b$export$c78a37762a8d58e1, (v) => $e09959a092a7608b$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $e09959a092a7608b$export$dc54d992c10e8a18, (v) => $e09959a092a7608b$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $e09959a092a7608b$export$83d89fbfd8236492, (v) => $e09959a092a7608b$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e09959a092a7608b$export$ae55be85d98224ed;
var $e09959a092a7608b$export$d39a5bbd09211389;
var $e09959a092a7608b$export$882461b6382ed46c;
var $e09959a092a7608b$export$466bfc07425424d5;
var $e09959a092a7608b$export$cd75ccfd720a3cd4;
var $e09959a092a7608b$export$fa8d919ba61d84db;
var $e09959a092a7608b$export$757ceba2d55c277e;
var $e09959a092a7608b$export$b3890eb0ae9dca99;
var $e09959a092a7608b$export$502457920280e6be;
var $e09959a092a7608b$export$c78a37762a8d58e1;
var $e09959a092a7608b$export$dc54d992c10e8a18;
var $e09959a092a7608b$export$83d89fbfd8236492;
"use strict";

var $8tsvq = parcelRequire("8tsvq");

var $7DCtq = parcelRequire("7DCtq");
function $e09959a092a7608b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e09959a092a7608b$var$da = new Set, $e09959a092a7608b$var$ea = {};
function $e09959a092a7608b$var$fa(a, b) {
    $e09959a092a7608b$var$ha(a, b);
    $e09959a092a7608b$var$ha(a + "Capture", b);
}
function $e09959a092a7608b$var$ha(a, b) {
    $e09959a092a7608b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e09959a092a7608b$var$da.add(b[a]);
}
var $e09959a092a7608b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e09959a092a7608b$var$ja = Object.prototype.hasOwnProperty, $e09959a092a7608b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e09959a092a7608b$var$la = {}, $e09959a092a7608b$var$ma = {};
function $e09959a092a7608b$var$oa(a) {
    if ($e09959a092a7608b$var$ja.call($e09959a092a7608b$var$ma, a)) return !0;
    if ($e09959a092a7608b$var$ja.call($e09959a092a7608b$var$la, a)) return !1;
    if ($e09959a092a7608b$var$ka.test(a)) return $e09959a092a7608b$var$ma[a] = !0;
    $e09959a092a7608b$var$la[a] = !0;
    return !1;
}
function $e09959a092a7608b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e09959a092a7608b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e09959a092a7608b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e09959a092a7608b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e09959a092a7608b$var$ra = /[\-:]([a-z])/g;
function $e09959a092a7608b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e09959a092a7608b$var$z.xlinkHref = new $e09959a092a7608b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e09959a092a7608b$var$ta(a, b, c, d) {
    var e = $e09959a092a7608b$var$z.hasOwnProperty(b) ? $e09959a092a7608b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e09959a092a7608b$var$qa(b, c, e, d) && (c = null), d || null === e ? $e09959a092a7608b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e09959a092a7608b$var$ua = $8tsvq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e09959a092a7608b$var$va = Symbol.for("react.element"), $e09959a092a7608b$var$wa = Symbol.for("react.portal"), $e09959a092a7608b$var$ya = Symbol.for("react.fragment"), $e09959a092a7608b$var$za = Symbol.for("react.strict_mode"), $e09959a092a7608b$var$Aa = Symbol.for("react.profiler"), $e09959a092a7608b$var$Ba = Symbol.for("react.provider"), $e09959a092a7608b$var$Ca = Symbol.for("react.context"), $e09959a092a7608b$var$Da = Symbol.for("react.forward_ref"), $e09959a092a7608b$var$Ea = Symbol.for("react.suspense"), $e09959a092a7608b$var$Fa = Symbol.for("react.suspense_list"), $e09959a092a7608b$var$Ga = Symbol.for("react.memo"), $e09959a092a7608b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e09959a092a7608b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e09959a092a7608b$var$Ja = Symbol.iterator;
function $e09959a092a7608b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e09959a092a7608b$var$Ja && a[$e09959a092a7608b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e09959a092a7608b$var$A = Object.assign, $e09959a092a7608b$var$La;
function $e09959a092a7608b$var$Ma(a) {
    if (void 0 === $e09959a092a7608b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e09959a092a7608b$var$La = b && b[1] || "";
    }
    return "\n" + $e09959a092a7608b$var$La + a;
}
var $e09959a092a7608b$var$Na = !1;
function $e09959a092a7608b$var$Oa(a, b) {
    if (!a || $e09959a092a7608b$var$Na) return "";
    $e09959a092a7608b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e09959a092a7608b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e09959a092a7608b$var$Ma(a) : "";
}
function $e09959a092a7608b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e09959a092a7608b$var$Ma(a.type);
        case 16:
            return $e09959a092a7608b$var$Ma("Lazy");
        case 13:
            return $e09959a092a7608b$var$Ma("Suspense");
        case 19:
            return $e09959a092a7608b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e09959a092a7608b$var$Oa(a.type, !1), a;
        case 11:
            return a = $e09959a092a7608b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e09959a092a7608b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e09959a092a7608b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e09959a092a7608b$var$ya:
            return "Fragment";
        case $e09959a092a7608b$var$wa:
            return "Portal";
        case $e09959a092a7608b$var$Aa:
            return "Profiler";
        case $e09959a092a7608b$var$za:
            return "StrictMode";
        case $e09959a092a7608b$var$Ea:
            return "Suspense";
        case $e09959a092a7608b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e09959a092a7608b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e09959a092a7608b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e09959a092a7608b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e09959a092a7608b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e09959a092a7608b$var$Qa(a.type) || "Memo";
        case $e09959a092a7608b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e09959a092a7608b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e09959a092a7608b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e09959a092a7608b$var$Qa(b);
        case 8:
            return b === $e09959a092a7608b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e09959a092a7608b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e09959a092a7608b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e09959a092a7608b$var$Ua(a) {
    var b = $e09959a092a7608b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e09959a092a7608b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e09959a092a7608b$var$Ua(a));
}
function $e09959a092a7608b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e09959a092a7608b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e09959a092a7608b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e09959a092a7608b$var$Ya(a, b) {
    var c = b.checked;
    return $e09959a092a7608b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e09959a092a7608b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e09959a092a7608b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e09959a092a7608b$var$ab(a, b) {
    b = b.checked;
    null != b && $e09959a092a7608b$var$ta(a, "checked", b, !1);
}
function $e09959a092a7608b$var$bb(a, b) {
    $e09959a092a7608b$var$ab(a, b);
    var c = $e09959a092a7608b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e09959a092a7608b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e09959a092a7608b$var$cb(a, b.type, $e09959a092a7608b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e09959a092a7608b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e09959a092a7608b$var$cb(a, b, c) {
    if ("number" !== b || $e09959a092a7608b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e09959a092a7608b$var$eb = Array.isArray;
function $e09959a092a7608b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e09959a092a7608b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e09959a092a7608b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e09959a092a7608b$var$p(91));
    return $e09959a092a7608b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e09959a092a7608b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e09959a092a7608b$var$p(92));
            if ($e09959a092a7608b$var$eb(c)) {
                if (1 < c.length) throw Error($e09959a092a7608b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e09959a092a7608b$var$Sa(c)
    };
}
function $e09959a092a7608b$var$ib(a, b) {
    var c = $e09959a092a7608b$var$Sa(b.value), d = $e09959a092a7608b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e09959a092a7608b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e09959a092a7608b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e09959a092a7608b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e09959a092a7608b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e09959a092a7608b$var$mb, $e09959a092a7608b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e09959a092a7608b$var$mb = $e09959a092a7608b$var$mb || document.createElement("div");
        $e09959a092a7608b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e09959a092a7608b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e09959a092a7608b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e09959a092a7608b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e09959a092a7608b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e09959a092a7608b$var$pb).forEach(function(a) {
    $e09959a092a7608b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e09959a092a7608b$var$pb[b] = $e09959a092a7608b$var$pb[a];
    });
});
function $e09959a092a7608b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e09959a092a7608b$var$pb.hasOwnProperty(a) && $e09959a092a7608b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e09959a092a7608b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e09959a092a7608b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e09959a092a7608b$var$tb = $e09959a092a7608b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e09959a092a7608b$var$ub(a, b) {
    if (b) {
        if ($e09959a092a7608b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e09959a092a7608b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e09959a092a7608b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e09959a092a7608b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e09959a092a7608b$var$p(62));
    }
}
function $e09959a092a7608b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e09959a092a7608b$var$wb = null;
function $e09959a092a7608b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e09959a092a7608b$var$yb = null, $e09959a092a7608b$var$zb = null, $e09959a092a7608b$var$Ab = null;
function $e09959a092a7608b$var$Bb(a) {
    if (a = $e09959a092a7608b$var$Cb(a)) {
        if ("function" !== typeof $e09959a092a7608b$var$yb) throw Error($e09959a092a7608b$var$p(280));
        var b = a.stateNode;
        b && (b = $e09959a092a7608b$var$Db(b), $e09959a092a7608b$var$yb(a.stateNode, a.type, b));
    }
}
function $e09959a092a7608b$var$Eb(a) {
    $e09959a092a7608b$var$zb ? $e09959a092a7608b$var$Ab ? $e09959a092a7608b$var$Ab.push(a) : $e09959a092a7608b$var$Ab = [
        a
    ] : $e09959a092a7608b$var$zb = a;
}
function $e09959a092a7608b$var$Fb() {
    if ($e09959a092a7608b$var$zb) {
        var a = $e09959a092a7608b$var$zb, b = $e09959a092a7608b$var$Ab;
        $e09959a092a7608b$var$Ab = $e09959a092a7608b$var$zb = null;
        $e09959a092a7608b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e09959a092a7608b$var$Bb(b[a]);
    }
}
function $e09959a092a7608b$var$Gb(a, b) {
    return a(b);
}
function $e09959a092a7608b$var$Hb() {}
var $e09959a092a7608b$var$Ib = !1;
function $e09959a092a7608b$var$Jb(a, b, c) {
    if ($e09959a092a7608b$var$Ib) return a(b, c);
    $e09959a092a7608b$var$Ib = !0;
    try {
        return $e09959a092a7608b$var$Gb(a, b, c);
    } finally{
        if ($e09959a092a7608b$var$Ib = !1, null !== $e09959a092a7608b$var$zb || null !== $e09959a092a7608b$var$Ab) $e09959a092a7608b$var$Hb(), $e09959a092a7608b$var$Fb();
    }
}
function $e09959a092a7608b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e09959a092a7608b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e09959a092a7608b$var$p(231, b, typeof c));
    return c;
}
var $e09959a092a7608b$var$Lb = !1;
if ($e09959a092a7608b$var$ia) try {
    var $e09959a092a7608b$var$Mb = {};
    Object.defineProperty($e09959a092a7608b$var$Mb, "passive", {
        get: function() {
            $e09959a092a7608b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e09959a092a7608b$var$Mb, $e09959a092a7608b$var$Mb);
    window.removeEventListener("test", $e09959a092a7608b$var$Mb, $e09959a092a7608b$var$Mb);
} catch (a) {
    $e09959a092a7608b$var$Lb = !1;
}
function $e09959a092a7608b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e09959a092a7608b$var$Ob = !1, $e09959a092a7608b$var$Pb = null, $e09959a092a7608b$var$Qb = !1, $e09959a092a7608b$var$Rb = null, $e09959a092a7608b$var$Sb = {
    onError: function(a) {
        $e09959a092a7608b$var$Ob = !0;
        $e09959a092a7608b$var$Pb = a;
    }
};
function $e09959a092a7608b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e09959a092a7608b$var$Ob = !1;
    $e09959a092a7608b$var$Pb = null;
    $e09959a092a7608b$var$Nb.apply($e09959a092a7608b$var$Sb, arguments);
}
function $e09959a092a7608b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e09959a092a7608b$var$Tb.apply(this, arguments);
    if ($e09959a092a7608b$var$Ob) {
        if ($e09959a092a7608b$var$Ob) {
            var l = $e09959a092a7608b$var$Pb;
            $e09959a092a7608b$var$Ob = !1;
            $e09959a092a7608b$var$Pb = null;
        } else throw Error($e09959a092a7608b$var$p(198));
        $e09959a092a7608b$var$Qb || ($e09959a092a7608b$var$Qb = !0, $e09959a092a7608b$var$Rb = l);
    }
}
function $e09959a092a7608b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e09959a092a7608b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e09959a092a7608b$var$Xb(a) {
    if ($e09959a092a7608b$var$Vb(a) !== a) throw Error($e09959a092a7608b$var$p(188));
}
function $e09959a092a7608b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e09959a092a7608b$var$Vb(a);
        if (null === b) throw Error($e09959a092a7608b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e09959a092a7608b$var$Xb(e), a;
                if (f === d) return $e09959a092a7608b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e09959a092a7608b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e09959a092a7608b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e09959a092a7608b$var$p(190));
    }
    if (3 !== c.tag) throw Error($e09959a092a7608b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e09959a092a7608b$var$Zb(a) {
    a = $e09959a092a7608b$var$Yb(a);
    return null !== a ? $e09959a092a7608b$var$$b(a) : null;
}
function $e09959a092a7608b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e09959a092a7608b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e09959a092a7608b$var$ac = $7DCtq.unstable_scheduleCallback, $e09959a092a7608b$var$bc = $7DCtq.unstable_cancelCallback, $e09959a092a7608b$var$cc = $7DCtq.unstable_shouldYield, $e09959a092a7608b$var$dc = $7DCtq.unstable_requestPaint, $e09959a092a7608b$var$B = $7DCtq.unstable_now, $e09959a092a7608b$var$ec = $7DCtq.unstable_getCurrentPriorityLevel, $e09959a092a7608b$var$fc = $7DCtq.unstable_ImmediatePriority, $e09959a092a7608b$var$gc = $7DCtq.unstable_UserBlockingPriority, $e09959a092a7608b$var$hc = $7DCtq.unstable_NormalPriority, $e09959a092a7608b$var$ic = $7DCtq.unstable_LowPriority, $e09959a092a7608b$var$jc = $7DCtq.unstable_IdlePriority, $e09959a092a7608b$var$kc = null, $e09959a092a7608b$var$lc = null;
function $e09959a092a7608b$var$mc(a) {
    if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onCommitFiberRoot) try {
        $e09959a092a7608b$var$lc.onCommitFiberRoot($e09959a092a7608b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e09959a092a7608b$var$oc = Math.clz32 ? Math.clz32 : $e09959a092a7608b$var$nc, $e09959a092a7608b$var$pc = Math.log, $e09959a092a7608b$var$qc = Math.LN2;
function $e09959a092a7608b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e09959a092a7608b$var$pc(a) / $e09959a092a7608b$var$qc | 0) | 0;
}
var $e09959a092a7608b$var$rc = 64, $e09959a092a7608b$var$sc = 4194304;
function $e09959a092a7608b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e09959a092a7608b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e09959a092a7608b$var$tc(h) : (f &= g, 0 !== f && (d = $e09959a092a7608b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e09959a092a7608b$var$tc(g) : 0 !== f && (d = $e09959a092a7608b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e09959a092a7608b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e09959a092a7608b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e09959a092a7608b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e09959a092a7608b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e09959a092a7608b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e09959a092a7608b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e09959a092a7608b$var$yc() {
    var a = $e09959a092a7608b$var$rc;
    $e09959a092a7608b$var$rc <<= 1;
    0 === ($e09959a092a7608b$var$rc & 4194240) && ($e09959a092a7608b$var$rc = 64);
    return a;
}
function $e09959a092a7608b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e09959a092a7608b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e09959a092a7608b$var$oc(b);
    a[b] = c;
}
function $e09959a092a7608b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e09959a092a7608b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e09959a092a7608b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e09959a092a7608b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e09959a092a7608b$var$C = 0;
function $e09959a092a7608b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e09959a092a7608b$var$Ec, $e09959a092a7608b$var$Fc, $e09959a092a7608b$var$Gc, $e09959a092a7608b$var$Hc, $e09959a092a7608b$var$Ic, $e09959a092a7608b$var$Jc = !1, $e09959a092a7608b$var$Kc = [], $e09959a092a7608b$var$Lc = null, $e09959a092a7608b$var$Mc = null, $e09959a092a7608b$var$Nc = null, $e09959a092a7608b$var$Oc = new Map, $e09959a092a7608b$var$Pc = new Map, $e09959a092a7608b$var$Qc = [], $e09959a092a7608b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e09959a092a7608b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e09959a092a7608b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e09959a092a7608b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e09959a092a7608b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e09959a092a7608b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e09959a092a7608b$var$Pc.delete(b.pointerId);
    }
}
function $e09959a092a7608b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e09959a092a7608b$var$Cb(b), null !== b && $e09959a092a7608b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e09959a092a7608b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e09959a092a7608b$var$Lc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e09959a092a7608b$var$Mc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e09959a092a7608b$var$Nc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e09959a092a7608b$var$Oc.set(f, $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e09959a092a7608b$var$Pc.set(f, $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e09959a092a7608b$var$Vc(a) {
    var b = $e09959a092a7608b$var$Wc(a.target);
    if (null !== b) {
        var c = $e09959a092a7608b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e09959a092a7608b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e09959a092a7608b$var$Ic(a.priority, function() {
                        $e09959a092a7608b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e09959a092a7608b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e09959a092a7608b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e09959a092a7608b$var$wb = d;
            c.target.dispatchEvent(d);
            $e09959a092a7608b$var$wb = null;
        } else return b = $e09959a092a7608b$var$Cb(c), null !== b && $e09959a092a7608b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e09959a092a7608b$var$Zc(a, b, c) {
    $e09959a092a7608b$var$Xc(a) && c.delete(b);
}
function $e09959a092a7608b$var$$c() {
    $e09959a092a7608b$var$Jc = !1;
    null !== $e09959a092a7608b$var$Lc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Lc) && ($e09959a092a7608b$var$Lc = null);
    null !== $e09959a092a7608b$var$Mc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Mc) && ($e09959a092a7608b$var$Mc = null);
    null !== $e09959a092a7608b$var$Nc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Nc) && ($e09959a092a7608b$var$Nc = null);
    $e09959a092a7608b$var$Oc.forEach($e09959a092a7608b$var$Zc);
    $e09959a092a7608b$var$Pc.forEach($e09959a092a7608b$var$Zc);
}
function $e09959a092a7608b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e09959a092a7608b$var$Jc || ($e09959a092a7608b$var$Jc = !0, $7DCtq.unstable_scheduleCallback($7DCtq.unstable_NormalPriority, $e09959a092a7608b$var$$c)));
}
function $e09959a092a7608b$var$bd(a) {
    function b(b) {
        return $e09959a092a7608b$var$ad(b, a);
    }
    if (0 < $e09959a092a7608b$var$Kc.length) {
        $e09959a092a7608b$var$ad($e09959a092a7608b$var$Kc[0], a);
        for(var c = 1; c < $e09959a092a7608b$var$Kc.length; c++){
            var d = $e09959a092a7608b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e09959a092a7608b$var$Lc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Lc, a);
    null !== $e09959a092a7608b$var$Mc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Mc, a);
    null !== $e09959a092a7608b$var$Nc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Nc, a);
    $e09959a092a7608b$var$Oc.forEach(b);
    $e09959a092a7608b$var$Pc.forEach(b);
    for(c = 0; c < $e09959a092a7608b$var$Qc.length; c++)d = $e09959a092a7608b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e09959a092a7608b$var$Qc.length && (c = $e09959a092a7608b$var$Qc[0], null === c.blockedOn);)$e09959a092a7608b$var$Vc(c), null === c.blockedOn && $e09959a092a7608b$var$Qc.shift();
}
var $e09959a092a7608b$var$cd = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$dd = !0;
function $e09959a092a7608b$var$ed(a, b, c, d) {
    var e = $e09959a092a7608b$var$C, f = $e09959a092a7608b$var$cd.transition;
    $e09959a092a7608b$var$cd.transition = null;
    try {
        $e09959a092a7608b$var$C = 1, $e09959a092a7608b$var$fd(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$C = e, $e09959a092a7608b$var$cd.transition = f;
    }
}
function $e09959a092a7608b$var$gd(a, b, c, d) {
    var e = $e09959a092a7608b$var$C, f = $e09959a092a7608b$var$cd.transition;
    $e09959a092a7608b$var$cd.transition = null;
    try {
        $e09959a092a7608b$var$C = 4, $e09959a092a7608b$var$fd(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$C = e, $e09959a092a7608b$var$cd.transition = f;
    }
}
function $e09959a092a7608b$var$fd(a, b, c, d) {
    if ($e09959a092a7608b$var$dd) {
        var e = $e09959a092a7608b$var$Yc(a, b, c, d);
        if (null === e) $e09959a092a7608b$var$hd(a, b, d, $e09959a092a7608b$var$id, c), $e09959a092a7608b$var$Sc(a, d);
        else if ($e09959a092a7608b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e09959a092a7608b$var$Sc(a, d), b & 4 && -1 < $e09959a092a7608b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e09959a092a7608b$var$Cb(e);
                null !== f && $e09959a092a7608b$var$Ec(f);
                f = $e09959a092a7608b$var$Yc(a, b, c, d);
                null === f && $e09959a092a7608b$var$hd(a, b, d, $e09959a092a7608b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e09959a092a7608b$var$hd(a, b, d, null, c);
    }
}
var $e09959a092a7608b$var$id = null;
function $e09959a092a7608b$var$Yc(a, b, c, d) {
    $e09959a092a7608b$var$id = null;
    a = $e09959a092a7608b$var$xb(d);
    a = $e09959a092a7608b$var$Wc(a);
    if (null !== a) {
        if (b = $e09959a092a7608b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e09959a092a7608b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e09959a092a7608b$var$id = a;
    return null;
}
function $e09959a092a7608b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e09959a092a7608b$var$ec()){
                case $e09959a092a7608b$var$fc:
                    return 1;
                case $e09959a092a7608b$var$gc:
                    return 4;
                case $e09959a092a7608b$var$hc:
                case $e09959a092a7608b$var$ic:
                    return 16;
                case $e09959a092a7608b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e09959a092a7608b$var$kd = null, $e09959a092a7608b$var$ld = null, $e09959a092a7608b$var$md = null;
function $e09959a092a7608b$var$nd() {
    if ($e09959a092a7608b$var$md) return $e09959a092a7608b$var$md;
    var a, b = $e09959a092a7608b$var$ld, c = b.length, d, e = "value" in $e09959a092a7608b$var$kd ? $e09959a092a7608b$var$kd.value : $e09959a092a7608b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e09959a092a7608b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e09959a092a7608b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e09959a092a7608b$var$pd() {
    return !0;
}
function $e09959a092a7608b$var$qd() {
    return !1;
}
function $e09959a092a7608b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e09959a092a7608b$var$pd : $e09959a092a7608b$var$qd;
        this.isPropagationStopped = $e09959a092a7608b$var$qd;
        return this;
    }
    $e09959a092a7608b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e09959a092a7608b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e09959a092a7608b$var$pd);
        },
        persist: function() {},
        isPersistent: $e09959a092a7608b$var$pd
    });
    return b;
}
var $e09959a092a7608b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e09959a092a7608b$var$td = $e09959a092a7608b$var$rd($e09959a092a7608b$var$sd), $e09959a092a7608b$var$ud = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    view: 0,
    detail: 0
}), $e09959a092a7608b$var$vd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$ud), $e09959a092a7608b$var$wd, $e09959a092a7608b$var$xd, $e09959a092a7608b$var$yd, $e09959a092a7608b$var$Ad = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e09959a092a7608b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e09959a092a7608b$var$yd && ($e09959a092a7608b$var$yd && "mousemove" === a.type ? ($e09959a092a7608b$var$wd = a.screenX - $e09959a092a7608b$var$yd.screenX, $e09959a092a7608b$var$xd = a.screenY - $e09959a092a7608b$var$yd.screenY) : $e09959a092a7608b$var$xd = $e09959a092a7608b$var$wd = 0, $e09959a092a7608b$var$yd = a);
        return $e09959a092a7608b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e09959a092a7608b$var$xd;
    }
}), $e09959a092a7608b$var$Bd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ad), $e09959a092a7608b$var$Cd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    dataTransfer: 0
}), $e09959a092a7608b$var$Dd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Cd), $e09959a092a7608b$var$Ed = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    relatedTarget: 0
}), $e09959a092a7608b$var$Fd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ed), $e09959a092a7608b$var$Gd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e09959a092a7608b$var$Hd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Gd), $e09959a092a7608b$var$Id = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e09959a092a7608b$var$Jd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Id), $e09959a092a7608b$var$Kd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    data: 0
}), $e09959a092a7608b$var$Ld = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Kd), $e09959a092a7608b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e09959a092a7608b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e09959a092a7608b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e09959a092a7608b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e09959a092a7608b$var$Od[a]) ? !!b[a] : !1;
}
function $e09959a092a7608b$var$zd() {
    return $e09959a092a7608b$var$Pd;
}
var $e09959a092a7608b$var$Qd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e09959a092a7608b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e09959a092a7608b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e09959a092a7608b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e09959a092a7608b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e09959a092a7608b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e09959a092a7608b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e09959a092a7608b$var$Rd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Qd), $e09959a092a7608b$var$Sd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e09959a092a7608b$var$Td = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Sd), $e09959a092a7608b$var$Ud = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e09959a092a7608b$var$zd
}), $e09959a092a7608b$var$Vd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ud), $e09959a092a7608b$var$Wd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e09959a092a7608b$var$Xd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Wd), $e09959a092a7608b$var$Yd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e09959a092a7608b$var$Zd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Yd), $e09959a092a7608b$var$$d = [
    9,
    13,
    27,
    32
], $e09959a092a7608b$var$ae = $e09959a092a7608b$var$ia && "CompositionEvent" in window, $e09959a092a7608b$var$be = null;
$e09959a092a7608b$var$ia && "documentMode" in document && ($e09959a092a7608b$var$be = document.documentMode);
var $e09959a092a7608b$var$ce = $e09959a092a7608b$var$ia && "TextEvent" in window && !$e09959a092a7608b$var$be, $e09959a092a7608b$var$de = $e09959a092a7608b$var$ia && (!$e09959a092a7608b$var$ae || $e09959a092a7608b$var$be && 8 < $e09959a092a7608b$var$be && 11 >= $e09959a092a7608b$var$be), $e09959a092a7608b$var$ee = String.fromCharCode(32), $e09959a092a7608b$var$fe = !1;
function $e09959a092a7608b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e09959a092a7608b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e09959a092a7608b$var$ie = !1;
function $e09959a092a7608b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e09959a092a7608b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e09959a092a7608b$var$fe = !0;
            return $e09959a092a7608b$var$ee;
        case "textInput":
            return a = b.data, a === $e09959a092a7608b$var$ee && $e09959a092a7608b$var$fe ? null : a;
        default:
            return null;
    }
}
function $e09959a092a7608b$var$ke(a, b) {
    if ($e09959a092a7608b$var$ie) return "compositionend" === a || !$e09959a092a7608b$var$ae && $e09959a092a7608b$var$ge(a, b) ? (a = $e09959a092a7608b$var$nd(), $e09959a092a7608b$var$md = $e09959a092a7608b$var$ld = $e09959a092a7608b$var$kd = null, $e09959a092a7608b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e09959a092a7608b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e09959a092a7608b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e09959a092a7608b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e09959a092a7608b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e09959a092a7608b$var$ne(a, b, c, d) {
    $e09959a092a7608b$var$Eb(d);
    b = $e09959a092a7608b$var$oe(b, "onChange");
    0 < b.length && (c = new $e09959a092a7608b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e09959a092a7608b$var$pe = null, $e09959a092a7608b$var$qe = null;
function $e09959a092a7608b$var$re(a) {
    $e09959a092a7608b$var$se(a, 0);
}
function $e09959a092a7608b$var$te(a) {
    var b = $e09959a092a7608b$var$ue(a);
    if ($e09959a092a7608b$var$Wa(b)) return a;
}
function $e09959a092a7608b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e09959a092a7608b$var$we = !1;
if ($e09959a092a7608b$var$ia) {
    var $e09959a092a7608b$var$xe;
    if ($e09959a092a7608b$var$ia) {
        var $e09959a092a7608b$var$ye = "oninput" in document;
        if (!$e09959a092a7608b$var$ye) {
            var $e09959a092a7608b$var$ze = document.createElement("div");
            $e09959a092a7608b$var$ze.setAttribute("oninput", "return;");
            $e09959a092a7608b$var$ye = "function" === typeof $e09959a092a7608b$var$ze.oninput;
        }
        $e09959a092a7608b$var$xe = $e09959a092a7608b$var$ye;
    } else $e09959a092a7608b$var$xe = !1;
    $e09959a092a7608b$var$we = $e09959a092a7608b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e09959a092a7608b$var$Ae() {
    $e09959a092a7608b$var$pe && ($e09959a092a7608b$var$pe.detachEvent("onpropertychange", $e09959a092a7608b$var$Be), $e09959a092a7608b$var$qe = $e09959a092a7608b$var$pe = null);
}
function $e09959a092a7608b$var$Be(a) {
    if ("value" === a.propertyName && $e09959a092a7608b$var$te($e09959a092a7608b$var$qe)) {
        var b = [];
        $e09959a092a7608b$var$ne(b, $e09959a092a7608b$var$qe, a, $e09959a092a7608b$var$xb(a));
        $e09959a092a7608b$var$Jb($e09959a092a7608b$var$re, b);
    }
}
function $e09959a092a7608b$var$Ce(a, b, c) {
    "focusin" === a ? ($e09959a092a7608b$var$Ae(), $e09959a092a7608b$var$pe = b, $e09959a092a7608b$var$qe = c, $e09959a092a7608b$var$pe.attachEvent("onpropertychange", $e09959a092a7608b$var$Be)) : "focusout" === a && $e09959a092a7608b$var$Ae();
}
function $e09959a092a7608b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e09959a092a7608b$var$te($e09959a092a7608b$var$qe);
}
function $e09959a092a7608b$var$Ee(a, b) {
    if ("click" === a) return $e09959a092a7608b$var$te(b);
}
function $e09959a092a7608b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e09959a092a7608b$var$te(b);
}
function $e09959a092a7608b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e09959a092a7608b$var$He = "function" === typeof Object.is ? Object.is : $e09959a092a7608b$var$Ge;
function $e09959a092a7608b$var$Ie(a, b) {
    if ($e09959a092a7608b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e09959a092a7608b$var$ja.call(b, e) || !$e09959a092a7608b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e09959a092a7608b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e09959a092a7608b$var$Ke(a, b) {
    var c = $e09959a092a7608b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e09959a092a7608b$var$Je(c);
    }
}
function $e09959a092a7608b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e09959a092a7608b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e09959a092a7608b$var$Me() {
    for(var a = window, b = $e09959a092a7608b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e09959a092a7608b$var$Xa(a.document);
    }
    return b;
}
function $e09959a092a7608b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e09959a092a7608b$var$Oe(a) {
    var b = $e09959a092a7608b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e09959a092a7608b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e09959a092a7608b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e09959a092a7608b$var$Ke(c, f);
                var g = $e09959a092a7608b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e09959a092a7608b$var$Pe = $e09959a092a7608b$var$ia && "documentMode" in document && 11 >= document.documentMode, $e09959a092a7608b$var$Qe = null, $e09959a092a7608b$var$Re = null, $e09959a092a7608b$var$Se = null, $e09959a092a7608b$var$Te = !1;
function $e09959a092a7608b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e09959a092a7608b$var$Te || null == $e09959a092a7608b$var$Qe || $e09959a092a7608b$var$Qe !== $e09959a092a7608b$var$Xa(d) || (d = $e09959a092a7608b$var$Qe, "selectionStart" in d && $e09959a092a7608b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e09959a092a7608b$var$Se && $e09959a092a7608b$var$Ie($e09959a092a7608b$var$Se, d) || ($e09959a092a7608b$var$Se = d, d = $e09959a092a7608b$var$oe($e09959a092a7608b$var$Re, "onSelect"), 0 < d.length && (b = new $e09959a092a7608b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e09959a092a7608b$var$Qe)));
}
function $e09959a092a7608b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e09959a092a7608b$var$We = {
    animationend: $e09959a092a7608b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e09959a092a7608b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e09959a092a7608b$var$Ve("Animation", "AnimationStart"),
    transitionend: $e09959a092a7608b$var$Ve("Transition", "TransitionEnd")
}, $e09959a092a7608b$var$Xe = {}, $e09959a092a7608b$var$Ye = {};
$e09959a092a7608b$var$ia && ($e09959a092a7608b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e09959a092a7608b$var$We.animationend.animation, delete $e09959a092a7608b$var$We.animationiteration.animation, delete $e09959a092a7608b$var$We.animationstart.animation), "TransitionEvent" in window || delete $e09959a092a7608b$var$We.transitionend.transition);
function $e09959a092a7608b$var$Ze(a) {
    if ($e09959a092a7608b$var$Xe[a]) return $e09959a092a7608b$var$Xe[a];
    if (!$e09959a092a7608b$var$We[a]) return a;
    var b = $e09959a092a7608b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e09959a092a7608b$var$Ye) return $e09959a092a7608b$var$Xe[a] = b[c];
    return a;
}
var $e09959a092a7608b$var$$e = $e09959a092a7608b$var$Ze("animationend"), $e09959a092a7608b$var$af = $e09959a092a7608b$var$Ze("animationiteration"), $e09959a092a7608b$var$bf = $e09959a092a7608b$var$Ze("animationstart"), $e09959a092a7608b$var$cf = $e09959a092a7608b$var$Ze("transitionend"), $e09959a092a7608b$var$df = new Map, $e09959a092a7608b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e09959a092a7608b$var$ff(a, b) {
    $e09959a092a7608b$var$df.set(a, b);
    $e09959a092a7608b$var$fa(b, [
        a
    ]);
}
for(var $e09959a092a7608b$var$gf = 0; $e09959a092a7608b$var$gf < $e09959a092a7608b$var$ef.length; $e09959a092a7608b$var$gf++){
    var $e09959a092a7608b$var$hf = $e09959a092a7608b$var$ef[$e09959a092a7608b$var$gf], $e09959a092a7608b$var$jf = $e09959a092a7608b$var$hf.toLowerCase(), $e09959a092a7608b$var$kf = $e09959a092a7608b$var$hf[0].toUpperCase() + $e09959a092a7608b$var$hf.slice(1);
    $e09959a092a7608b$var$ff($e09959a092a7608b$var$jf, "on" + $e09959a092a7608b$var$kf);
}
$e09959a092a7608b$var$ff($e09959a092a7608b$var$$e, "onAnimationEnd");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$af, "onAnimationIteration");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$bf, "onAnimationStart");
$e09959a092a7608b$var$ff("dblclick", "onDoubleClick");
$e09959a092a7608b$var$ff("focusin", "onFocus");
$e09959a092a7608b$var$ff("focusout", "onBlur");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$cf, "onTransitionEnd");
$e09959a092a7608b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e09959a092a7608b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e09959a092a7608b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e09959a092a7608b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e09959a092a7608b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e09959a092a7608b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e09959a092a7608b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e09959a092a7608b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e09959a092a7608b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e09959a092a7608b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e09959a092a7608b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e09959a092a7608b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e09959a092a7608b$var$lf));
function $e09959a092a7608b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e09959a092a7608b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e09959a092a7608b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e09959a092a7608b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e09959a092a7608b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e09959a092a7608b$var$Qb) throw a = $e09959a092a7608b$var$Rb, $e09959a092a7608b$var$Qb = !1, $e09959a092a7608b$var$Rb = null, a;
}
function $e09959a092a7608b$var$D(a, b) {
    var c = b[$e09959a092a7608b$var$of];
    void 0 === c && (c = b[$e09959a092a7608b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e09959a092a7608b$var$pf(b, a, 2, !1), c.add(d));
}
function $e09959a092a7608b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e09959a092a7608b$var$pf(c, a, d, b);
}
var $e09959a092a7608b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e09959a092a7608b$var$sf(a) {
    if (!a[$e09959a092a7608b$var$rf]) {
        a[$e09959a092a7608b$var$rf] = !0;
        $e09959a092a7608b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e09959a092a7608b$var$mf.has(b) || $e09959a092a7608b$var$qf(b, !1, a), $e09959a092a7608b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e09959a092a7608b$var$rf] || (b[$e09959a092a7608b$var$rf] = !0, $e09959a092a7608b$var$qf("selectionchange", !1, b));
    }
}
function $e09959a092a7608b$var$pf(a, b, c, d) {
    switch($e09959a092a7608b$var$jd(b)){
        case 1:
            var e = $e09959a092a7608b$var$ed;
            break;
        case 4:
            e = $e09959a092a7608b$var$gd;
            break;
        default:
            e = $e09959a092a7608b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e09959a092a7608b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e09959a092a7608b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e09959a092a7608b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e09959a092a7608b$var$Jb(function() {
        var d = f, e = $e09959a092a7608b$var$xb(c), g = [];
        a: {
            var h = $e09959a092a7608b$var$df.get(a);
            if (void 0 !== h) {
                var k = $e09959a092a7608b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e09959a092a7608b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e09959a092a7608b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e09959a092a7608b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e09959a092a7608b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e09959a092a7608b$var$Vd;
                        break;
                    case $e09959a092a7608b$var$$e:
                    case $e09959a092a7608b$var$af:
                    case $e09959a092a7608b$var$bf:
                        k = $e09959a092a7608b$var$Hd;
                        break;
                    case $e09959a092a7608b$var$cf:
                        k = $e09959a092a7608b$var$Xd;
                        break;
                    case "scroll":
                        k = $e09959a092a7608b$var$vd;
                        break;
                    case "wheel":
                        k = $e09959a092a7608b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e09959a092a7608b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e09959a092a7608b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e09959a092a7608b$var$Kb(w, x), null != F && t.push($e09959a092a7608b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e09959a092a7608b$var$wb && (n = c.relatedTarget || c.fromElement) && ($e09959a092a7608b$var$Wc(n) || n[$e09959a092a7608b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e09959a092a7608b$var$Wc(n) : null, null !== n && (J = $e09959a092a7608b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e09959a092a7608b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e09959a092a7608b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e09959a092a7608b$var$ue(k);
                        u = null == n ? h : $e09959a092a7608b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e09959a092a7608b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e09959a092a7608b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e09959a092a7608b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e09959a092a7608b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e09959a092a7608b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e09959a092a7608b$var$vf(t);
                                x = $e09959a092a7608b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e09959a092a7608b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e09959a092a7608b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e09959a092a7608b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e09959a092a7608b$var$ve;
                else if ($e09959a092a7608b$var$me(h)) {
                    if ($e09959a092a7608b$var$we) na = $e09959a092a7608b$var$Fe;
                    else {
                        na = $e09959a092a7608b$var$De;
                        var xa = $e09959a092a7608b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e09959a092a7608b$var$Ee);
                if (na && (na = na(a, d))) {
                    $e09959a092a7608b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e09959a092a7608b$var$cb(h, "number", h.value);
            }
            xa = d ? $e09959a092a7608b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e09959a092a7608b$var$me(xa) || "true" === xa.contentEditable) $e09959a092a7608b$var$Qe = xa, $e09959a092a7608b$var$Re = d, $e09959a092a7608b$var$Se = null;
                    break;
                case "focusout":
                    $e09959a092a7608b$var$Se = $e09959a092a7608b$var$Re = $e09959a092a7608b$var$Qe = null;
                    break;
                case "mousedown":
                    $e09959a092a7608b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e09959a092a7608b$var$Te = !1;
                    $e09959a092a7608b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e09959a092a7608b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e09959a092a7608b$var$Ue(g, c, e);
            }
            var $a;
            if ($e09959a092a7608b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e09959a092a7608b$var$ie ? $e09959a092a7608b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e09959a092a7608b$var$de && "ko" !== c.locale && ($e09959a092a7608b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e09959a092a7608b$var$ie && ($a = $e09959a092a7608b$var$nd()) : ($e09959a092a7608b$var$kd = e, $e09959a092a7608b$var$ld = "value" in $e09959a092a7608b$var$kd ? $e09959a092a7608b$var$kd.value : $e09959a092a7608b$var$kd.textContent, $e09959a092a7608b$var$ie = !0)), xa = $e09959a092a7608b$var$oe(d, ba), 0 < xa.length && (ba = new $e09959a092a7608b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e09959a092a7608b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e09959a092a7608b$var$ce ? $e09959a092a7608b$var$je(a, c) : $e09959a092a7608b$var$ke(a, c)) d = $e09959a092a7608b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e09959a092a7608b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e09959a092a7608b$var$se(g, b);
    });
}
function $e09959a092a7608b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e09959a092a7608b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e09959a092a7608b$var$Kb(a, c), null != f && d.unshift($e09959a092a7608b$var$tf(a, f, e)), f = $e09959a092a7608b$var$Kb(a, b), null != f && d.push($e09959a092a7608b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e09959a092a7608b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e09959a092a7608b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e09959a092a7608b$var$Kb(c, f), null != k && g.unshift($e09959a092a7608b$var$tf(c, k, h))) : e || (k = $e09959a092a7608b$var$Kb(c, f), null != k && g.push($e09959a092a7608b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e09959a092a7608b$var$xf = /\r\n?/g, $e09959a092a7608b$var$yf = /\u0000|\uFFFD/g;
function $e09959a092a7608b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e09959a092a7608b$var$xf, "\n").replace($e09959a092a7608b$var$yf, "");
}
function $e09959a092a7608b$var$Af(a, b, c) {
    b = $e09959a092a7608b$var$zf(b);
    if ($e09959a092a7608b$var$zf(a) !== b && c) throw Error($e09959a092a7608b$var$p(425));
}
function $e09959a092a7608b$var$Bf() {}
var $e09959a092a7608b$var$Cf = null, $e09959a092a7608b$var$Df = null;
function $e09959a092a7608b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e09959a092a7608b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e09959a092a7608b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e09959a092a7608b$var$Hf = "function" === typeof Promise ? Promise : void 0, $e09959a092a7608b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e09959a092a7608b$var$Hf ? function(a) {
    return $e09959a092a7608b$var$Hf.resolve(null).then(a).catch($e09959a092a7608b$var$If);
} : $e09959a092a7608b$var$Ff;
function $e09959a092a7608b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e09959a092a7608b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e09959a092a7608b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e09959a092a7608b$var$bd(b);
}
function $e09959a092a7608b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e09959a092a7608b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e09959a092a7608b$var$Nf = Math.random().toString(36).slice(2), $e09959a092a7608b$var$Of = "__reactFiber$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Pf = "__reactProps$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$uf = "__reactContainer$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$of = "__reactEvents$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Qf = "__reactListeners$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Rf = "__reactHandles$" + $e09959a092a7608b$var$Nf;
function $e09959a092a7608b$var$Wc(a) {
    var b = a[$e09959a092a7608b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e09959a092a7608b$var$uf] || c[$e09959a092a7608b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e09959a092a7608b$var$Mf(a); null !== a;){
                if (c = a[$e09959a092a7608b$var$Of]) return c;
                a = $e09959a092a7608b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e09959a092a7608b$var$Cb(a) {
    a = a[$e09959a092a7608b$var$Of] || a[$e09959a092a7608b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e09959a092a7608b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e09959a092a7608b$var$p(33));
}
function $e09959a092a7608b$var$Db(a) {
    return a[$e09959a092a7608b$var$Pf] || null;
}
var $e09959a092a7608b$var$Sf = [], $e09959a092a7608b$var$Tf = -1;
function $e09959a092a7608b$var$Uf(a) {
    return {
        current: a
    };
}
function $e09959a092a7608b$var$E(a) {
    0 > $e09959a092a7608b$var$Tf || (a.current = $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf], $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf] = null, $e09959a092a7608b$var$Tf--);
}
function $e09959a092a7608b$var$G(a, b) {
    $e09959a092a7608b$var$Tf++;
    $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf] = a.current;
    a.current = b;
}
var $e09959a092a7608b$var$Vf = {}, $e09959a092a7608b$var$H = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$Vf), $e09959a092a7608b$var$Wf = $e09959a092a7608b$var$Uf(!1), $e09959a092a7608b$var$Xf = $e09959a092a7608b$var$Vf;
function $e09959a092a7608b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e09959a092a7608b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e09959a092a7608b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e09959a092a7608b$var$$f() {
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
}
function $e09959a092a7608b$var$ag(a, b, c) {
    if ($e09959a092a7608b$var$H.current !== $e09959a092a7608b$var$Vf) throw Error($e09959a092a7608b$var$p(168));
    $e09959a092a7608b$var$G($e09959a092a7608b$var$H, b);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, c);
}
function $e09959a092a7608b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e09959a092a7608b$var$p(108, $e09959a092a7608b$var$Ra(a) || "Unknown", e));
    return $e09959a092a7608b$var$A({}, c, d);
}
function $e09959a092a7608b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e09959a092a7608b$var$Vf;
    $e09959a092a7608b$var$Xf = $e09959a092a7608b$var$H.current;
    $e09959a092a7608b$var$G($e09959a092a7608b$var$H, a);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, $e09959a092a7608b$var$Wf.current);
    return !0;
}
function $e09959a092a7608b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e09959a092a7608b$var$p(169));
    c ? (a = $e09959a092a7608b$var$bg(a, b, $e09959a092a7608b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf), $e09959a092a7608b$var$E($e09959a092a7608b$var$H), $e09959a092a7608b$var$G($e09959a092a7608b$var$H, a)) : $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, c);
}
var $e09959a092a7608b$var$eg = null, $e09959a092a7608b$var$fg = !1, $e09959a092a7608b$var$gg = !1;
function $e09959a092a7608b$var$hg(a) {
    null === $e09959a092a7608b$var$eg ? $e09959a092a7608b$var$eg = [
        a
    ] : $e09959a092a7608b$var$eg.push(a);
}
function $e09959a092a7608b$var$ig(a) {
    $e09959a092a7608b$var$fg = !0;
    $e09959a092a7608b$var$hg(a);
}
function $e09959a092a7608b$var$jg() {
    if (!$e09959a092a7608b$var$gg && null !== $e09959a092a7608b$var$eg) {
        $e09959a092a7608b$var$gg = !0;
        var a = 0, b = $e09959a092a7608b$var$C;
        try {
            var c = $e09959a092a7608b$var$eg;
            for($e09959a092a7608b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e09959a092a7608b$var$eg = null;
            $e09959a092a7608b$var$fg = !1;
        } catch (e) {
            throw null !== $e09959a092a7608b$var$eg && ($e09959a092a7608b$var$eg = $e09959a092a7608b$var$eg.slice(a + 1)), $e09959a092a7608b$var$ac($e09959a092a7608b$var$fc, $e09959a092a7608b$var$jg), e;
        } finally{
            $e09959a092a7608b$var$C = b, $e09959a092a7608b$var$gg = !1;
        }
    }
    return null;
}
var $e09959a092a7608b$var$kg = [], $e09959a092a7608b$var$lg = 0, $e09959a092a7608b$var$mg = null, $e09959a092a7608b$var$ng = 0, $e09959a092a7608b$var$og = [], $e09959a092a7608b$var$pg = 0, $e09959a092a7608b$var$qg = null, $e09959a092a7608b$var$rg = 1, $e09959a092a7608b$var$sg = "";
function $e09959a092a7608b$var$tg(a, b) {
    $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg++] = $e09959a092a7608b$var$ng;
    $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg++] = $e09959a092a7608b$var$mg;
    $e09959a092a7608b$var$mg = a;
    $e09959a092a7608b$var$ng = b;
}
function $e09959a092a7608b$var$ug(a, b, c) {
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$rg;
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$sg;
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$qg;
    $e09959a092a7608b$var$qg = a;
    var d = $e09959a092a7608b$var$rg;
    a = $e09959a092a7608b$var$sg;
    var e = 32 - $e09959a092a7608b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e09959a092a7608b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e09959a092a7608b$var$rg = 1 << 32 - $e09959a092a7608b$var$oc(b) + e | c << e | d;
        $e09959a092a7608b$var$sg = f + a;
    } else $e09959a092a7608b$var$rg = 1 << f | c << e | d, $e09959a092a7608b$var$sg = a;
}
function $e09959a092a7608b$var$vg(a) {
    null !== a.return && ($e09959a092a7608b$var$tg(a, 1), $e09959a092a7608b$var$ug(a, 1, 0));
}
function $e09959a092a7608b$var$wg(a) {
    for(; a === $e09959a092a7608b$var$mg;)$e09959a092a7608b$var$mg = $e09959a092a7608b$var$kg[--$e09959a092a7608b$var$lg], $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg] = null, $e09959a092a7608b$var$ng = $e09959a092a7608b$var$kg[--$e09959a092a7608b$var$lg], $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg] = null;
    for(; a === $e09959a092a7608b$var$qg;)$e09959a092a7608b$var$qg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null, $e09959a092a7608b$var$sg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null, $e09959a092a7608b$var$rg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null;
}
var $e09959a092a7608b$var$xg = null, $e09959a092a7608b$var$yg = null, $e09959a092a7608b$var$I = !1, $e09959a092a7608b$var$zg = null;
function $e09959a092a7608b$var$Ag(a, b) {
    var c = $e09959a092a7608b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e09959a092a7608b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e09959a092a7608b$var$qg ? {
                id: $e09959a092a7608b$var$rg,
                overflow: $e09959a092a7608b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e09959a092a7608b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e09959a092a7608b$var$Eg(a) {
    if ($e09959a092a7608b$var$I) {
        var b = $e09959a092a7608b$var$yg;
        if (b) {
            var c = b;
            if (!$e09959a092a7608b$var$Cg(a, b)) {
                if ($e09959a092a7608b$var$Dg(a)) throw Error($e09959a092a7608b$var$p(418));
                b = $e09959a092a7608b$var$Lf(c.nextSibling);
                var d = $e09959a092a7608b$var$xg;
                b && $e09959a092a7608b$var$Cg(a, b) ? $e09959a092a7608b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e09959a092a7608b$var$I = !1, $e09959a092a7608b$var$xg = a);
            }
        } else {
            if ($e09959a092a7608b$var$Dg(a)) throw Error($e09959a092a7608b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e09959a092a7608b$var$I = !1;
            $e09959a092a7608b$var$xg = a;
        }
    }
}
function $e09959a092a7608b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e09959a092a7608b$var$xg = a;
}
function $e09959a092a7608b$var$Gg(a) {
    if (a !== $e09959a092a7608b$var$xg) return !1;
    if (!$e09959a092a7608b$var$I) return $e09959a092a7608b$var$Fg(a), $e09959a092a7608b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e09959a092a7608b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e09959a092a7608b$var$yg)) {
        if ($e09959a092a7608b$var$Dg(a)) throw $e09959a092a7608b$var$Hg(), Error($e09959a092a7608b$var$p(418));
        for(; b;)$e09959a092a7608b$var$Ag(a, b), b = $e09959a092a7608b$var$Lf(b.nextSibling);
    }
    $e09959a092a7608b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e09959a092a7608b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e09959a092a7608b$var$yg = null;
        }
    } else $e09959a092a7608b$var$yg = $e09959a092a7608b$var$xg ? $e09959a092a7608b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e09959a092a7608b$var$Hg() {
    for(var a = $e09959a092a7608b$var$yg; a;)a = $e09959a092a7608b$var$Lf(a.nextSibling);
}
function $e09959a092a7608b$var$Ig() {
    $e09959a092a7608b$var$yg = $e09959a092a7608b$var$xg = null;
    $e09959a092a7608b$var$I = !1;
}
function $e09959a092a7608b$var$Jg(a) {
    null === $e09959a092a7608b$var$zg ? $e09959a092a7608b$var$zg = [
        a
    ] : $e09959a092a7608b$var$zg.push(a);
}
var $e09959a092a7608b$var$Kg = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig;
function $e09959a092a7608b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e09959a092a7608b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e09959a092a7608b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e09959a092a7608b$var$p(284));
        if (!c._owner) throw Error($e09959a092a7608b$var$p(290, a));
    }
    return a;
}
function $e09959a092a7608b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e09959a092a7608b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e09959a092a7608b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $e09959a092a7608b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e09959a092a7608b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e09959a092a7608b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e09959a092a7608b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e09959a092a7608b$var$Ha && $e09959a092a7608b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $e09959a092a7608b$var$Lg(a, b, c), d.return = a, d;
        d = $e09959a092a7608b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e09959a092a7608b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e09959a092a7608b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e09959a092a7608b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e09959a092a7608b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e09959a092a7608b$var$va:
                    return c = $e09959a092a7608b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e09959a092a7608b$var$Lg(a, null, b), c.return = a, c;
                case $e09959a092a7608b$var$wa:
                    return b = $e09959a092a7608b$var$Sg(b, a.mode, c), b.return = a, b;
                case $e09959a092a7608b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e09959a092a7608b$var$eb(b) || $e09959a092a7608b$var$Ka(b)) return b = $e09959a092a7608b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $e09959a092a7608b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e09959a092a7608b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e09959a092a7608b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e09959a092a7608b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e09959a092a7608b$var$eb(c) || $e09959a092a7608b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e09959a092a7608b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e09959a092a7608b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e09959a092a7608b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e09959a092a7608b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e09959a092a7608b$var$eb(d) || $e09959a092a7608b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e09959a092a7608b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e09959a092a7608b$var$Ka(h);
        if ("function" !== typeof l) throw Error($e09959a092a7608b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e09959a092a7608b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e09959a092a7608b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e09959a092a7608b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e09959a092a7608b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e09959a092a7608b$var$Ha && $e09959a092a7608b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e09959a092a7608b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e09959a092a7608b$var$ya ? (d = $e09959a092a7608b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e09959a092a7608b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e09959a092a7608b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e09959a092a7608b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e09959a092a7608b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e09959a092a7608b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e09959a092a7608b$var$eb(f)) return n(a, d, f, h);
            if ($e09959a092a7608b$var$Ka(f)) return t(a, d, f, h);
            $e09959a092a7608b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e09959a092a7608b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e09959a092a7608b$var$Ug = $e09959a092a7608b$var$Og(!0), $e09959a092a7608b$var$Vg = $e09959a092a7608b$var$Og(!1), $e09959a092a7608b$var$Wg = $e09959a092a7608b$var$Uf(null), $e09959a092a7608b$var$Xg = null, $e09959a092a7608b$var$Yg = null, $e09959a092a7608b$var$Zg = null;
function $e09959a092a7608b$var$$g() {
    $e09959a092a7608b$var$Zg = $e09959a092a7608b$var$Yg = $e09959a092a7608b$var$Xg = null;
}
function $e09959a092a7608b$var$ah(a) {
    var b = $e09959a092a7608b$var$Wg.current;
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Wg);
    a._currentValue = b;
}
function $e09959a092a7608b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e09959a092a7608b$var$ch(a, b) {
    $e09959a092a7608b$var$Xg = a;
    $e09959a092a7608b$var$Zg = $e09959a092a7608b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e09959a092a7608b$var$dh = !0), a.firstContext = null);
}
function $e09959a092a7608b$var$eh(a) {
    var b = a._currentValue;
    if ($e09959a092a7608b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e09959a092a7608b$var$Yg) {
            if (null === $e09959a092a7608b$var$Xg) throw Error($e09959a092a7608b$var$p(308));
            $e09959a092a7608b$var$Yg = a;
            $e09959a092a7608b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e09959a092a7608b$var$Yg = $e09959a092a7608b$var$Yg.next = a;
    }
    return b;
}
var $e09959a092a7608b$var$fh = null;
function $e09959a092a7608b$var$gh(a) {
    null === $e09959a092a7608b$var$fh ? $e09959a092a7608b$var$fh = [
        a
    ] : $e09959a092a7608b$var$fh.push(a);
}
function $e09959a092a7608b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e09959a092a7608b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e09959a092a7608b$var$ih(a, d);
}
function $e09959a092a7608b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e09959a092a7608b$var$jh = !1;
function $e09959a092a7608b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e09959a092a7608b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e09959a092a7608b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e09959a092a7608b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e09959a092a7608b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e09959a092a7608b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e09959a092a7608b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e09959a092a7608b$var$ih(a, c);
}
function $e09959a092a7608b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e09959a092a7608b$var$Cc(a, c);
    }
}
function $e09959a092a7608b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e09959a092a7608b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $e09959a092a7608b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e09959a092a7608b$var$A({}, q, r);
                            break a;
                        case 2:
                            $e09959a092a7608b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e09959a092a7608b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e09959a092a7608b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e09959a092a7608b$var$p(191, e));
            e.call(d);
        }
    }
}
var $e09959a092a7608b$var$th = {}, $e09959a092a7608b$var$uh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$th), $e09959a092a7608b$var$vh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$th), $e09959a092a7608b$var$wh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$th);
function $e09959a092a7608b$var$xh(a) {
    if (a === $e09959a092a7608b$var$th) throw Error($e09959a092a7608b$var$p(174));
    return a;
}
function $e09959a092a7608b$var$yh(a, b) {
    $e09959a092a7608b$var$G($e09959a092a7608b$var$wh, b);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$vh, a);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$uh, $e09959a092a7608b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e09959a092a7608b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e09959a092a7608b$var$lb(b, a);
    }
    $e09959a092a7608b$var$E($e09959a092a7608b$var$uh);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$uh, b);
}
function $e09959a092a7608b$var$zh() {
    $e09959a092a7608b$var$E($e09959a092a7608b$var$uh);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$vh);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$wh);
}
function $e09959a092a7608b$var$Ah(a) {
    $e09959a092a7608b$var$xh($e09959a092a7608b$var$wh.current);
    var b = $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
    var c = $e09959a092a7608b$var$lb(b, a.type);
    b !== c && ($e09959a092a7608b$var$G($e09959a092a7608b$var$vh, a), $e09959a092a7608b$var$G($e09959a092a7608b$var$uh, c));
}
function $e09959a092a7608b$var$Bh(a) {
    $e09959a092a7608b$var$vh.current === a && ($e09959a092a7608b$var$E($e09959a092a7608b$var$uh), $e09959a092a7608b$var$E($e09959a092a7608b$var$vh));
}
var $e09959a092a7608b$var$L = $e09959a092a7608b$var$Uf(0);
function $e09959a092a7608b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e09959a092a7608b$var$Dh = [];
function $e09959a092a7608b$var$Eh() {
    for(var a = 0; a < $e09959a092a7608b$var$Dh.length; a++)$e09959a092a7608b$var$Dh[a]._workInProgressVersionPrimary = null;
    $e09959a092a7608b$var$Dh.length = 0;
}
var $e09959a092a7608b$var$Fh = $e09959a092a7608b$var$ua.ReactCurrentDispatcher, $e09959a092a7608b$var$Gh = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$Hh = 0, $e09959a092a7608b$var$M = null, $e09959a092a7608b$var$N = null, $e09959a092a7608b$var$O = null, $e09959a092a7608b$var$Ih = !1, $e09959a092a7608b$var$Jh = !1, $e09959a092a7608b$var$Kh = 0, $e09959a092a7608b$var$Lh = 0;
function $e09959a092a7608b$var$P() {
    throw Error($e09959a092a7608b$var$p(321));
}
function $e09959a092a7608b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e09959a092a7608b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e09959a092a7608b$var$Nh(a, b, c, d, e, f) {
    $e09959a092a7608b$var$Hh = f;
    $e09959a092a7608b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e09959a092a7608b$var$Fh.current = null === a || null === a.memoizedState ? $e09959a092a7608b$var$Oh : $e09959a092a7608b$var$Ph;
    a = c(d, e);
    if ($e09959a092a7608b$var$Jh) {
        f = 0;
        do {
            $e09959a092a7608b$var$Jh = !1;
            $e09959a092a7608b$var$Kh = 0;
            if (25 <= f) throw Error($e09959a092a7608b$var$p(301));
            f += 1;
            $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = null;
            b.updateQueue = null;
            $e09959a092a7608b$var$Fh.current = $e09959a092a7608b$var$Qh;
            a = c(d, e);
        }while ($e09959a092a7608b$var$Jh);
    }
    $e09959a092a7608b$var$Fh.current = $e09959a092a7608b$var$Rh;
    b = null !== $e09959a092a7608b$var$N && null !== $e09959a092a7608b$var$N.next;
    $e09959a092a7608b$var$Hh = 0;
    $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = $e09959a092a7608b$var$M = null;
    $e09959a092a7608b$var$Ih = !1;
    if (b) throw Error($e09959a092a7608b$var$p(300));
    return a;
}
function $e09959a092a7608b$var$Sh() {
    var a = 0 !== $e09959a092a7608b$var$Kh;
    $e09959a092a7608b$var$Kh = 0;
    return a;
}
function $e09959a092a7608b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e09959a092a7608b$var$O ? $e09959a092a7608b$var$M.memoizedState = $e09959a092a7608b$var$O = a : $e09959a092a7608b$var$O = $e09959a092a7608b$var$O.next = a;
    return $e09959a092a7608b$var$O;
}
function $e09959a092a7608b$var$Uh() {
    if (null === $e09959a092a7608b$var$N) {
        var a = $e09959a092a7608b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e09959a092a7608b$var$N.next;
    var b = null === $e09959a092a7608b$var$O ? $e09959a092a7608b$var$M.memoizedState : $e09959a092a7608b$var$O.next;
    if (null !== b) $e09959a092a7608b$var$O = b, $e09959a092a7608b$var$N = a;
    else {
        if (null === a) throw Error($e09959a092a7608b$var$p(310));
        $e09959a092a7608b$var$N = a;
        a = {
            memoizedState: $e09959a092a7608b$var$N.memoizedState,
            baseState: $e09959a092a7608b$var$N.baseState,
            baseQueue: $e09959a092a7608b$var$N.baseQueue,
            queue: $e09959a092a7608b$var$N.queue,
            next: null
        };
        null === $e09959a092a7608b$var$O ? $e09959a092a7608b$var$M.memoizedState = $e09959a092a7608b$var$O = a : $e09959a092a7608b$var$O = $e09959a092a7608b$var$O.next = a;
    }
    return $e09959a092a7608b$var$O;
}
function $e09959a092a7608b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e09959a092a7608b$var$Wh(a) {
    var b = $e09959a092a7608b$var$Uh(), c = b.queue;
    if (null === c) throw Error($e09959a092a7608b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e09959a092a7608b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e09959a092a7608b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e09959a092a7608b$var$M.lanes |= m;
                $e09959a092a7608b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e09959a092a7608b$var$He(d, b.memoizedState) || ($e09959a092a7608b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e09959a092a7608b$var$M.lanes |= f, $e09959a092a7608b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e09959a092a7608b$var$Xh(a) {
    var b = $e09959a092a7608b$var$Uh(), c = b.queue;
    if (null === c) throw Error($e09959a092a7608b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e09959a092a7608b$var$He(f, b.memoizedState) || ($e09959a092a7608b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e09959a092a7608b$var$Yh() {}
function $e09959a092a7608b$var$Zh(a, b) {
    var c = $e09959a092a7608b$var$M, d = $e09959a092a7608b$var$Uh(), e = b(), f = !$e09959a092a7608b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e09959a092a7608b$var$dh = !0);
    d = d.queue;
    $e09959a092a7608b$var$$h($e09959a092a7608b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e09959a092a7608b$var$O && $e09959a092a7608b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e09959a092a7608b$var$bi(9, $e09959a092a7608b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $e09959a092a7608b$var$Q) throw Error($e09959a092a7608b$var$p(349));
        0 !== ($e09959a092a7608b$var$Hh & 30) || $e09959a092a7608b$var$di(c, b, e);
    }
    return e;
}
function $e09959a092a7608b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e09959a092a7608b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e09959a092a7608b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e09959a092a7608b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e09959a092a7608b$var$ei(b) && $e09959a092a7608b$var$fi(a);
}
function $e09959a092a7608b$var$ai(a, b, c) {
    return c(function() {
        $e09959a092a7608b$var$ei(b) && $e09959a092a7608b$var$fi(a);
    });
}
function $e09959a092a7608b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e09959a092a7608b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e09959a092a7608b$var$fi(a) {
    var b = $e09959a092a7608b$var$ih(a, 1);
    null !== b && $e09959a092a7608b$var$gi(b, a, 1, -1);
}
function $e09959a092a7608b$var$hi(a) {
    var b = $e09959a092a7608b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e09959a092a7608b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e09959a092a7608b$var$ii.bind(null, $e09959a092a7608b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e09959a092a7608b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e09959a092a7608b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e09959a092a7608b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e09959a092a7608b$var$ji() {
    return $e09959a092a7608b$var$Uh().memoizedState;
}
function $e09959a092a7608b$var$ki(a, b, c, d) {
    var e = $e09959a092a7608b$var$Th();
    $e09959a092a7608b$var$M.flags |= a;
    e.memoizedState = $e09959a092a7608b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e09959a092a7608b$var$li(a, b, c, d) {
    var e = $e09959a092a7608b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e09959a092a7608b$var$N) {
        var g = $e09959a092a7608b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e09959a092a7608b$var$Mh(d, g.deps)) {
            e.memoizedState = $e09959a092a7608b$var$bi(b, c, f, d);
            return;
        }
    }
    $e09959a092a7608b$var$M.flags |= a;
    e.memoizedState = $e09959a092a7608b$var$bi(1 | b, c, f, d);
}
function $e09959a092a7608b$var$mi(a, b) {
    return $e09959a092a7608b$var$ki(8390656, 8, a, b);
}
function $e09959a092a7608b$var$$h(a, b) {
    return $e09959a092a7608b$var$li(2048, 8, a, b);
}
function $e09959a092a7608b$var$ni(a, b) {
    return $e09959a092a7608b$var$li(4, 2, a, b);
}
function $e09959a092a7608b$var$oi(a, b) {
    return $e09959a092a7608b$var$li(4, 4, a, b);
}
function $e09959a092a7608b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e09959a092a7608b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e09959a092a7608b$var$li(4, 4, $e09959a092a7608b$var$pi.bind(null, b, a), c);
}
function $e09959a092a7608b$var$ri() {}
function $e09959a092a7608b$var$si(a, b) {
    var c = $e09959a092a7608b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e09959a092a7608b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e09959a092a7608b$var$ti(a, b) {
    var c = $e09959a092a7608b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e09959a092a7608b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e09959a092a7608b$var$ui(a, b, c) {
    if (0 === ($e09959a092a7608b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $e09959a092a7608b$var$dh = !0), a.memoizedState = c;
    $e09959a092a7608b$var$He(c, b) || (c = $e09959a092a7608b$var$yc(), $e09959a092a7608b$var$M.lanes |= c, $e09959a092a7608b$var$rh |= c, a.baseState = !0);
    return b;
}
function $e09959a092a7608b$var$vi(a, b) {
    var c = $e09959a092a7608b$var$C;
    $e09959a092a7608b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e09959a092a7608b$var$Gh.transition;
    $e09959a092a7608b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e09959a092a7608b$var$C = c, $e09959a092a7608b$var$Gh.transition = d;
    }
}
function $e09959a092a7608b$var$wi() {
    return $e09959a092a7608b$var$Uh().memoizedState;
}
function $e09959a092a7608b$var$xi(a, b, c) {
    var d = $e09959a092a7608b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e09959a092a7608b$var$zi(a)) $e09959a092a7608b$var$Ai(b, c);
    else if (c = $e09959a092a7608b$var$hh(a, b, c, d), null !== c) {
        var e = $e09959a092a7608b$var$R();
        $e09959a092a7608b$var$gi(c, a, d, e);
        $e09959a092a7608b$var$Bi(c, b, d);
    }
}
function $e09959a092a7608b$var$ii(a, b, c) {
    var d = $e09959a092a7608b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e09959a092a7608b$var$zi(a)) $e09959a092a7608b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e09959a092a7608b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e09959a092a7608b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e09959a092a7608b$var$hh(a, b, e, d);
        null !== c && (e = $e09959a092a7608b$var$R(), $e09959a092a7608b$var$gi(c, a, d, e), $e09959a092a7608b$var$Bi(c, b, d));
    }
}
function $e09959a092a7608b$var$zi(a) {
    var b = a.alternate;
    return a === $e09959a092a7608b$var$M || null !== b && b === $e09959a092a7608b$var$M;
}
function $e09959a092a7608b$var$Ai(a, b) {
    $e09959a092a7608b$var$Jh = $e09959a092a7608b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e09959a092a7608b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e09959a092a7608b$var$Cc(a, c);
    }
}
var $e09959a092a7608b$var$Rh = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: $e09959a092a7608b$var$P,
    useContext: $e09959a092a7608b$var$P,
    useEffect: $e09959a092a7608b$var$P,
    useImperativeHandle: $e09959a092a7608b$var$P,
    useInsertionEffect: $e09959a092a7608b$var$P,
    useLayoutEffect: $e09959a092a7608b$var$P,
    useMemo: $e09959a092a7608b$var$P,
    useReducer: $e09959a092a7608b$var$P,
    useRef: $e09959a092a7608b$var$P,
    useState: $e09959a092a7608b$var$P,
    useDebugValue: $e09959a092a7608b$var$P,
    useDeferredValue: $e09959a092a7608b$var$P,
    useTransition: $e09959a092a7608b$var$P,
    useMutableSource: $e09959a092a7608b$var$P,
    useSyncExternalStore: $e09959a092a7608b$var$P,
    useId: $e09959a092a7608b$var$P,
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Oh = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: function(a, b) {
        $e09959a092a7608b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e09959a092a7608b$var$eh,
    useEffect: $e09959a092a7608b$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e09959a092a7608b$var$ki(4194308, 4, $e09959a092a7608b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e09959a092a7608b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e09959a092a7608b$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e09959a092a7608b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e09959a092a7608b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e09959a092a7608b$var$xi.bind(null, $e09959a092a7608b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e09959a092a7608b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e09959a092a7608b$var$hi,
    useDebugValue: $e09959a092a7608b$var$ri,
    useDeferredValue: function(a) {
        return $e09959a092a7608b$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$hi(!1), b = a[0];
        a = $e09959a092a7608b$var$vi.bind(null, a[1]);
        $e09959a092a7608b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e09959a092a7608b$var$M, e = $e09959a092a7608b$var$Th();
        if ($e09959a092a7608b$var$I) {
            if (void 0 === c) throw Error($e09959a092a7608b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e09959a092a7608b$var$Q) throw Error($e09959a092a7608b$var$p(349));
            0 !== ($e09959a092a7608b$var$Hh & 30) || $e09959a092a7608b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e09959a092a7608b$var$mi($e09959a092a7608b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e09959a092a7608b$var$bi(9, $e09959a092a7608b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e09959a092a7608b$var$Th(), b = $e09959a092a7608b$var$Q.identifierPrefix;
        if ($e09959a092a7608b$var$I) {
            var c = $e09959a092a7608b$var$sg;
            var d = $e09959a092a7608b$var$rg;
            c = (d & ~(1 << 32 - $e09959a092a7608b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e09959a092a7608b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e09959a092a7608b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Ph = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: $e09959a092a7608b$var$si,
    useContext: $e09959a092a7608b$var$eh,
    useEffect: $e09959a092a7608b$var$$h,
    useImperativeHandle: $e09959a092a7608b$var$qi,
    useInsertionEffect: $e09959a092a7608b$var$ni,
    useLayoutEffect: $e09959a092a7608b$var$oi,
    useMemo: $e09959a092a7608b$var$ti,
    useReducer: $e09959a092a7608b$var$Wh,
    useRef: $e09959a092a7608b$var$ji,
    useState: function() {
        return $e09959a092a7608b$var$Wh($e09959a092a7608b$var$Vh);
    },
    useDebugValue: $e09959a092a7608b$var$ri,
    useDeferredValue: function(a) {
        var b = $e09959a092a7608b$var$Uh();
        return $e09959a092a7608b$var$ui(b, $e09959a092a7608b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$Wh($e09959a092a7608b$var$Vh)[0], b = $e09959a092a7608b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e09959a092a7608b$var$Yh,
    useSyncExternalStore: $e09959a092a7608b$var$Zh,
    useId: $e09959a092a7608b$var$wi,
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Qh = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: $e09959a092a7608b$var$si,
    useContext: $e09959a092a7608b$var$eh,
    useEffect: $e09959a092a7608b$var$$h,
    useImperativeHandle: $e09959a092a7608b$var$qi,
    useInsertionEffect: $e09959a092a7608b$var$ni,
    useLayoutEffect: $e09959a092a7608b$var$oi,
    useMemo: $e09959a092a7608b$var$ti,
    useReducer: $e09959a092a7608b$var$Xh,
    useRef: $e09959a092a7608b$var$ji,
    useState: function() {
        return $e09959a092a7608b$var$Xh($e09959a092a7608b$var$Vh);
    },
    useDebugValue: $e09959a092a7608b$var$ri,
    useDeferredValue: function(a) {
        var b = $e09959a092a7608b$var$Uh();
        return null === $e09959a092a7608b$var$N ? b.memoizedState = a : $e09959a092a7608b$var$ui(b, $e09959a092a7608b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$Xh($e09959a092a7608b$var$Vh)[0], b = $e09959a092a7608b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e09959a092a7608b$var$Yh,
    useSyncExternalStore: $e09959a092a7608b$var$Zh,
    useId: $e09959a092a7608b$var$wi,
    unstable_isNewReconciler: !1
};
function $e09959a092a7608b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $e09959a092a7608b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e09959a092a7608b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e09959a092a7608b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e09959a092a7608b$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e09959a092a7608b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e09959a092a7608b$var$R(), e = $e09959a092a7608b$var$yi(a), f = $e09959a092a7608b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e09959a092a7608b$var$nh(a, f, e);
        null !== b && ($e09959a092a7608b$var$gi(b, a, e, d), $e09959a092a7608b$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e09959a092a7608b$var$R(), e = $e09959a092a7608b$var$yi(a), f = $e09959a092a7608b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e09959a092a7608b$var$nh(a, f, e);
        null !== b && ($e09959a092a7608b$var$gi(b, a, e, d), $e09959a092a7608b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e09959a092a7608b$var$R(), d = $e09959a092a7608b$var$yi(a), e = $e09959a092a7608b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e09959a092a7608b$var$nh(a, e, d);
        null !== b && ($e09959a092a7608b$var$gi(b, a, d, c), $e09959a092a7608b$var$oh(b, a, d));
    }
};
function $e09959a092a7608b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e09959a092a7608b$var$Ie(c, d) || !$e09959a092a7608b$var$Ie(e, f) : !0;
}
function $e09959a092a7608b$var$Gi(a, b, c) {
    var d = !1, e = $e09959a092a7608b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e09959a092a7608b$var$eh(f) : (e = $e09959a092a7608b$var$Zf(b) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e09959a092a7608b$var$Yf(a, e) : $e09959a092a7608b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e09959a092a7608b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e09959a092a7608b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e09959a092a7608b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $e09959a092a7608b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e09959a092a7608b$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e09959a092a7608b$var$eh(f) : (f = $e09959a092a7608b$var$Zf(b) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, e.context = $e09959a092a7608b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e09959a092a7608b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e09959a092a7608b$var$Ei.enqueueReplaceState(e, e.state, null), $e09959a092a7608b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e09959a092a7608b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $e09959a092a7608b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e09959a092a7608b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e09959a092a7608b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e09959a092a7608b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $e09959a092a7608b$var$Ni(a, b, c) {
    c = $e09959a092a7608b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e09959a092a7608b$var$Oi || ($e09959a092a7608b$var$Oi = !0, $e09959a092a7608b$var$Pi = d);
        $e09959a092a7608b$var$Li(a, b);
    };
    return c;
}
function $e09959a092a7608b$var$Qi(a, b, c) {
    c = $e09959a092a7608b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e09959a092a7608b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e09959a092a7608b$var$Li(a, b);
        "function" !== typeof d && (null === $e09959a092a7608b$var$Ri ? $e09959a092a7608b$var$Ri = new Set([
            this
        ]) : $e09959a092a7608b$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e09959a092a7608b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e09959a092a7608b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e09959a092a7608b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $e09959a092a7608b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e09959a092a7608b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e09959a092a7608b$var$mh(-1, 1), b.tag = 2, $e09959a092a7608b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e09959a092a7608b$var$Wi = $e09959a092a7608b$var$ua.ReactCurrentOwner, $e09959a092a7608b$var$dh = !1;
function $e09959a092a7608b$var$Xi(a, b, c, d) {
    b.child = null === a ? $e09959a092a7608b$var$Vg(b, null, c, d) : $e09959a092a7608b$var$Ug(b, a.child, c, d);
}
function $e09959a092a7608b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e09959a092a7608b$var$ch(b, e);
    d = $e09959a092a7608b$var$Nh(a, b, c, d, f, e);
    c = $e09959a092a7608b$var$Sh();
    if (null !== a && !$e09959a092a7608b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e09959a092a7608b$var$Zi(a, b, e);
    $e09959a092a7608b$var$I && c && $e09959a092a7608b$var$vg(b);
    b.flags |= 1;
    $e09959a092a7608b$var$Xi(a, b, d, e);
    return b.child;
}
function $e09959a092a7608b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e09959a092a7608b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e09959a092a7608b$var$bj(a, b, f, d, e);
        a = $e09959a092a7608b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e09959a092a7608b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e09959a092a7608b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $e09959a092a7608b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e09959a092a7608b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e09959a092a7608b$var$Ie(f, d) && a.ref === b.ref) {
            if ($e09959a092a7608b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e09959a092a7608b$var$dh = !0);
            else return b.lanes = a.lanes, $e09959a092a7608b$var$Zi(a, b, e);
        }
    }
    return $e09959a092a7608b$var$cj(a, b, c, d, e);
}
function $e09959a092a7608b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj), $e09959a092a7608b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj), $e09959a092a7608b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj);
            $e09959a092a7608b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj), $e09959a092a7608b$var$fj |= d;
    $e09959a092a7608b$var$Xi(a, b, e, c);
    return b.child;
}
function $e09959a092a7608b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e09959a092a7608b$var$cj(a, b, c, d, e) {
    var f = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current;
    f = $e09959a092a7608b$var$Yf(b, f);
    $e09959a092a7608b$var$ch(b, e);
    c = $e09959a092a7608b$var$Nh(a, b, c, d, f, e);
    d = $e09959a092a7608b$var$Sh();
    if (null !== a && !$e09959a092a7608b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e09959a092a7608b$var$Zi(a, b, e);
    $e09959a092a7608b$var$I && d && $e09959a092a7608b$var$vg(b);
    b.flags |= 1;
    $e09959a092a7608b$var$Xi(a, b, c, e);
    return b.child;
}
function $e09959a092a7608b$var$hj(a, b, c, d, e) {
    if ($e09959a092a7608b$var$Zf(c)) {
        var f = !0;
        $e09959a092a7608b$var$cg(b);
    } else f = !1;
    $e09959a092a7608b$var$ch(b, e);
    if (null === b.stateNode) $e09959a092a7608b$var$ij(a, b), $e09959a092a7608b$var$Gi(b, c, d), $e09959a092a7608b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e09959a092a7608b$var$eh(l) : (l = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, l = $e09959a092a7608b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e09959a092a7608b$var$Hi(b, g, d, l);
        $e09959a092a7608b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e09959a092a7608b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e09959a092a7608b$var$Wf.current || $e09959a092a7608b$var$jh ? ("function" === typeof m && ($e09959a092a7608b$var$Di(b, c, m, d), k = b.memoizedState), (h = $e09959a092a7608b$var$jh || $e09959a092a7608b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e09959a092a7608b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e09959a092a7608b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e09959a092a7608b$var$eh(k) : (k = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, k = $e09959a092a7608b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e09959a092a7608b$var$Hi(b, g, d, k);
        $e09959a092a7608b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $e09959a092a7608b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e09959a092a7608b$var$Wf.current || $e09959a092a7608b$var$jh ? ("function" === typeof y && ($e09959a092a7608b$var$Di(b, c, y, d), n = b.memoizedState), (l = $e09959a092a7608b$var$jh || $e09959a092a7608b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e09959a092a7608b$var$jj(a, b, c, d, f, e);
}
function $e09959a092a7608b$var$jj(a, b, c, d, e, f) {
    $e09959a092a7608b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e09959a092a7608b$var$dg(b, c, !1), $e09959a092a7608b$var$Zi(a, b, f);
    d = b.stateNode;
    $e09959a092a7608b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e09959a092a7608b$var$Ug(b, a.child, null, f), b.child = $e09959a092a7608b$var$Ug(b, null, h, f)) : $e09959a092a7608b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e09959a092a7608b$var$dg(b, c, !0);
    return b.child;
}
function $e09959a092a7608b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e09959a092a7608b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e09959a092a7608b$var$ag(a, b.context, !1);
    $e09959a092a7608b$var$yh(a, b.containerInfo);
}
function $e09959a092a7608b$var$lj(a, b, c, d, e) {
    $e09959a092a7608b$var$Ig();
    $e09959a092a7608b$var$Jg(e);
    b.flags |= 256;
    $e09959a092a7608b$var$Xi(a, b, c, d);
    return b.child;
}
var $e09959a092a7608b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e09959a092a7608b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e09959a092a7608b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $e09959a092a7608b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e09959a092a7608b$var$G($e09959a092a7608b$var$L, e & 1);
    if (null === a) {
        $e09959a092a7608b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e09959a092a7608b$var$pj(g, d, 0, null), a = $e09959a092a7608b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e09959a092a7608b$var$nj(c), b.memoizedState = $e09959a092a7608b$var$mj, a) : $e09959a092a7608b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e09959a092a7608b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e09959a092a7608b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e09959a092a7608b$var$Pg(h, f) : (f = $e09959a092a7608b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e09959a092a7608b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e09959a092a7608b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e09959a092a7608b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e09959a092a7608b$var$qj(a, b) {
    b = $e09959a092a7608b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e09959a092a7608b$var$sj(a, b, c, d) {
    null !== d && $e09959a092a7608b$var$Jg(d);
    $e09959a092a7608b$var$Ug(b, a.child, null, c);
    a = $e09959a092a7608b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e09959a092a7608b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e09959a092a7608b$var$Ki(Error($e09959a092a7608b$var$p(422))), $e09959a092a7608b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e09959a092a7608b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e09959a092a7608b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e09959a092a7608b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $e09959a092a7608b$var$nj(g);
        b.memoizedState = $e09959a092a7608b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e09959a092a7608b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e09959a092a7608b$var$p(419));
        d = $e09959a092a7608b$var$Ki(f, d, void 0);
        return $e09959a092a7608b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e09959a092a7608b$var$dh || h) {
        d = $e09959a092a7608b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e09959a092a7608b$var$ih(a, e), $e09959a092a7608b$var$gi(d, a, e, -1));
        }
        $e09959a092a7608b$var$tj();
        d = $e09959a092a7608b$var$Ki(Error($e09959a092a7608b$var$p(421)));
        return $e09959a092a7608b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e09959a092a7608b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(e.nextSibling);
    $e09959a092a7608b$var$xg = b;
    $e09959a092a7608b$var$I = !0;
    $e09959a092a7608b$var$zg = null;
    null !== a && ($e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$rg, $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$sg, $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$qg, $e09959a092a7608b$var$rg = a.id, $e09959a092a7608b$var$sg = a.overflow, $e09959a092a7608b$var$qg = b);
    b = $e09959a092a7608b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e09959a092a7608b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e09959a092a7608b$var$bh(a.return, b, c);
}
function $e09959a092a7608b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e09959a092a7608b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e09959a092a7608b$var$Xi(a, b, d.children, c);
    d = $e09959a092a7608b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e09959a092a7608b$var$vj(a, c, b);
            else if (19 === a.tag) $e09959a092a7608b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e09959a092a7608b$var$G($e09959a092a7608b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e09959a092a7608b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e09959a092a7608b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e09959a092a7608b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e09959a092a7608b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $e09959a092a7608b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e09959a092a7608b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e09959a092a7608b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e09959a092a7608b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e09959a092a7608b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e09959a092a7608b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e09959a092a7608b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e09959a092a7608b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $e09959a092a7608b$var$kj(b);
            $e09959a092a7608b$var$Ig();
            break;
        case 5:
            $e09959a092a7608b$var$Ah(b);
            break;
        case 1:
            $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$cg(b);
            break;
        case 4:
            $e09959a092a7608b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e09959a092a7608b$var$G($e09959a092a7608b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e09959a092a7608b$var$oj(a, b, c);
                $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1);
                a = $e09959a092a7608b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e09959a092a7608b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e09959a092a7608b$var$dj(a, b, c);
    }
    return $e09959a092a7608b$var$Zi(a, b, c);
}
var $e09959a092a7608b$var$zj, $e09959a092a7608b$var$Aj, $e09959a092a7608b$var$Bj, $e09959a092a7608b$var$Cj;
$e09959a092a7608b$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e09959a092a7608b$var$Aj = function() {};
$e09959a092a7608b$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e09959a092a7608b$var$Ya(a, e);
                d = $e09959a092a7608b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e09959a092a7608b$var$A({}, e, {
                    value: void 0
                });
                d = $e09959a092a7608b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e09959a092a7608b$var$gb(a, e);
                d = $e09959a092a7608b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e09959a092a7608b$var$Bf);
        }
        $e09959a092a7608b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e09959a092a7608b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e09959a092a7608b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e09959a092a7608b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e09959a092a7608b$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e09959a092a7608b$var$Dj(a, b) {
    if (!$e09959a092a7608b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e09959a092a7608b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e09959a092a7608b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $e09959a092a7608b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e09959a092a7608b$var$S(b), null;
        case 1:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), $e09959a092a7608b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e09959a092a7608b$var$zh();
            $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
            $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
            $e09959a092a7608b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e09959a092a7608b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e09959a092a7608b$var$zg && ($e09959a092a7608b$var$Fj($e09959a092a7608b$var$zg), $e09959a092a7608b$var$zg = null));
            $e09959a092a7608b$var$Aj(a, b);
            $e09959a092a7608b$var$S(b);
            return null;
        case 5:
            $e09959a092a7608b$var$Bh(b);
            var e = $e09959a092a7608b$var$xh($e09959a092a7608b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e09959a092a7608b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e09959a092a7608b$var$p(166));
                    $e09959a092a7608b$var$S(b);
                    return null;
                }
                a = $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
                if ($e09959a092a7608b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e09959a092a7608b$var$Of] = b;
                    d[$e09959a092a7608b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e09959a092a7608b$var$D("cancel", d);
                            $e09959a092a7608b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e09959a092a7608b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e09959a092a7608b$var$lf.length; e++)$e09959a092a7608b$var$D($e09959a092a7608b$var$lf[e], d);
                            break;
                        case "source":
                            $e09959a092a7608b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e09959a092a7608b$var$D("error", d);
                            $e09959a092a7608b$var$D("load", d);
                            break;
                        case "details":
                            $e09959a092a7608b$var$D("toggle", d);
                            break;
                        case "input":
                            $e09959a092a7608b$var$Za(d, f);
                            $e09959a092a7608b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e09959a092a7608b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$hb(d, f), $e09959a092a7608b$var$D("invalid", d);
                    }
                    $e09959a092a7608b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e09959a092a7608b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e09959a092a7608b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e09959a092a7608b$var$Va(d);
                            $e09959a092a7608b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$Va(d);
                            $e09959a092a7608b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e09959a092a7608b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e09959a092a7608b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e09959a092a7608b$var$Of] = b;
                    a[$e09959a092a7608b$var$Pf] = d;
                    $e09959a092a7608b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e09959a092a7608b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e09959a092a7608b$var$D("cancel", a);
                                $e09959a092a7608b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e09959a092a7608b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e09959a092a7608b$var$lf.length; e++)$e09959a092a7608b$var$D($e09959a092a7608b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e09959a092a7608b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e09959a092a7608b$var$D("error", a);
                                $e09959a092a7608b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e09959a092a7608b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e09959a092a7608b$var$Za(a, d);
                                e = $e09959a092a7608b$var$Ya(a, d);
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e09959a092a7608b$var$A({}, d, {
                                    value: void 0
                                });
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e09959a092a7608b$var$hb(a, d);
                                e = $e09959a092a7608b$var$gb(a, d);
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e09959a092a7608b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e09959a092a7608b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e09959a092a7608b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e09959a092a7608b$var$ob(a, k) : "number" === typeof k && $e09959a092a7608b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e09959a092a7608b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e09959a092a7608b$var$D("scroll", a) : null != k && $e09959a092a7608b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e09959a092a7608b$var$Va(a);
                                $e09959a092a7608b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e09959a092a7608b$var$Va(a);
                                $e09959a092a7608b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e09959a092a7608b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e09959a092a7608b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e09959a092a7608b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e09959a092a7608b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e09959a092a7608b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e09959a092a7608b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e09959a092a7608b$var$p(166));
                c = $e09959a092a7608b$var$xh($e09959a092a7608b$var$wh.current);
                $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
                if ($e09959a092a7608b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e09959a092a7608b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e09959a092a7608b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e09959a092a7608b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e09959a092a7608b$var$Of] = b, b.stateNode = d;
            }
            $e09959a092a7608b$var$S(b);
            return null;
        case 13:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e09959a092a7608b$var$I && null !== $e09959a092a7608b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e09959a092a7608b$var$Hg(), $e09959a092a7608b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e09959a092a7608b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e09959a092a7608b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e09959a092a7608b$var$p(317));
                        f[$e09959a092a7608b$var$Of] = b;
                    } else $e09959a092a7608b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e09959a092a7608b$var$S(b);
                    f = !1;
                } else null !== $e09959a092a7608b$var$zg && ($e09959a092a7608b$var$Fj($e09959a092a7608b$var$zg), $e09959a092a7608b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e09959a092a7608b$var$L.current & 1) ? 0 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 3) : $e09959a092a7608b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e09959a092a7608b$var$S(b);
            return null;
        case 4:
            return $e09959a092a7608b$var$zh(), $e09959a092a7608b$var$Aj(a, b), null === a && $e09959a092a7608b$var$sf(b.stateNode.containerInfo), $e09959a092a7608b$var$S(b), null;
        case 10:
            return $e09959a092a7608b$var$ah(b.type._context), $e09959a092a7608b$var$S(b), null;
        case 17:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), $e09959a092a7608b$var$S(b), null;
        case 19:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
            f = b.memoizedState;
            if (null === f) return $e09959a092a7608b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e09959a092a7608b$var$Dj(f, !1);
                else {
                    if (0 !== $e09959a092a7608b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e09959a092a7608b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e09959a092a7608b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e09959a092a7608b$var$B() > $e09959a092a7608b$var$Gj && (b.flags |= 128, d = !0, $e09959a092a7608b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e09959a092a7608b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e09959a092a7608b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e09959a092a7608b$var$I) return $e09959a092a7608b$var$S(b), null;
                    } else 2 * $e09959a092a7608b$var$B() - f.renderingStartTime > $e09959a092a7608b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $e09959a092a7608b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e09959a092a7608b$var$B(), b.sibling = null, c = $e09959a092a7608b$var$L.current, $e09959a092a7608b$var$G($e09959a092a7608b$var$L, d ? c & 1 | 2 : c & 1), b;
            $e09959a092a7608b$var$S(b);
            return null;
        case 22:
        case 23:
            return $e09959a092a7608b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e09959a092a7608b$var$fj & 1073741824) && ($e09959a092a7608b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e09959a092a7608b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e09959a092a7608b$var$p(156, b.tag));
}
function $e09959a092a7608b$var$Ij(a, b) {
    $e09959a092a7608b$var$wg(b);
    switch(b.tag){
        case 1:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e09959a092a7608b$var$zh(), $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf), $e09959a092a7608b$var$E($e09959a092a7608b$var$H), $e09959a092a7608b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e09959a092a7608b$var$Bh(b), null;
        case 13:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e09959a092a7608b$var$p(340));
                $e09959a092a7608b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e09959a092a7608b$var$E($e09959a092a7608b$var$L), null;
        case 4:
            return $e09959a092a7608b$var$zh(), null;
        case 10:
            return $e09959a092a7608b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $e09959a092a7608b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e09959a092a7608b$var$Jj = !1, $e09959a092a7608b$var$U = !1, $e09959a092a7608b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $e09959a092a7608b$var$V = null;
function $e09959a092a7608b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e09959a092a7608b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e09959a092a7608b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e09959a092a7608b$var$W(a, b, d);
    }
}
var $e09959a092a7608b$var$Nj = !1;
function $e09959a092a7608b$var$Oj(a, b) {
    $e09959a092a7608b$var$Cf = $e09959a092a7608b$var$dd;
    a = $e09959a092a7608b$var$Me();
    if ($e09959a092a7608b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e09959a092a7608b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e09959a092a7608b$var$dd = !1;
    for($e09959a092a7608b$var$V = b; null !== $e09959a092a7608b$var$V;)if (b = $e09959a092a7608b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e09959a092a7608b$var$V = a;
    else for(; null !== $e09959a092a7608b$var$V;){
        b = $e09959a092a7608b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e09959a092a7608b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(163));
            }
        } catch (F) {
            $e09959a092a7608b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e09959a092a7608b$var$V = a;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
    n = $e09959a092a7608b$var$Nj;
    $e09959a092a7608b$var$Nj = !1;
    return n;
}
function $e09959a092a7608b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e09959a092a7608b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e09959a092a7608b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e09959a092a7608b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e09959a092a7608b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e09959a092a7608b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e09959a092a7608b$var$Of], delete b[$e09959a092a7608b$var$Pf], delete b[$e09959a092a7608b$var$of], delete b[$e09959a092a7608b$var$Qf], delete b[$e09959a092a7608b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e09959a092a7608b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e09959a092a7608b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e09959a092a7608b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e09959a092a7608b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e09959a092a7608b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e09959a092a7608b$var$Vj(a, b, c), a = a.sibling; null !== a;)$e09959a092a7608b$var$Vj(a, b, c), a = a.sibling;
}
function $e09959a092a7608b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e09959a092a7608b$var$Wj(a, b, c), a = a.sibling; null !== a;)$e09959a092a7608b$var$Wj(a, b, c), a = a.sibling;
}
var $e09959a092a7608b$var$X = null, $e09959a092a7608b$var$Xj = !1;
function $e09959a092a7608b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$e09959a092a7608b$var$Zj(a, b, c), c = c.sibling;
}
function $e09959a092a7608b$var$Zj(a, b, c) {
    if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onCommitFiberUnmount) try {
        $e09959a092a7608b$var$lc.onCommitFiberUnmount($e09959a092a7608b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e09959a092a7608b$var$U || $e09959a092a7608b$var$Lj(c, b);
        case 6:
            var d = $e09959a092a7608b$var$X, e = $e09959a092a7608b$var$Xj;
            $e09959a092a7608b$var$X = null;
            $e09959a092a7608b$var$Yj(a, b, c);
            $e09959a092a7608b$var$X = d;
            $e09959a092a7608b$var$Xj = e;
            null !== $e09959a092a7608b$var$X && ($e09959a092a7608b$var$Xj ? (a = $e09959a092a7608b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e09959a092a7608b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e09959a092a7608b$var$X && ($e09959a092a7608b$var$Xj ? (a = $e09959a092a7608b$var$X, c = c.stateNode, 8 === a.nodeType ? $e09959a092a7608b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e09959a092a7608b$var$Kf(a, c), $e09959a092a7608b$var$bd(a)) : $e09959a092a7608b$var$Kf($e09959a092a7608b$var$X, c.stateNode));
            break;
        case 4:
            d = $e09959a092a7608b$var$X;
            e = $e09959a092a7608b$var$Xj;
            $e09959a092a7608b$var$X = c.stateNode.containerInfo;
            $e09959a092a7608b$var$Xj = !0;
            $e09959a092a7608b$var$Yj(a, b, c);
            $e09959a092a7608b$var$X = d;
            $e09959a092a7608b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e09959a092a7608b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e09959a092a7608b$var$Mj(c, b, g) : 0 !== (f & 4) && $e09959a092a7608b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e09959a092a7608b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$e09959a092a7608b$var$U && ($e09959a092a7608b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e09959a092a7608b$var$W(c, b, h);
            }
            $e09959a092a7608b$var$Yj(a, b, c);
            break;
        case 21:
            $e09959a092a7608b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e09959a092a7608b$var$U = (d = $e09959a092a7608b$var$U) || null !== c.memoizedState, $e09959a092a7608b$var$Yj(a, b, c), $e09959a092a7608b$var$U = d) : $e09959a092a7608b$var$Yj(a, b, c);
            break;
        default:
            $e09959a092a7608b$var$Yj(a, b, c);
    }
}
function $e09959a092a7608b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e09959a092a7608b$var$Kj);
        b.forEach(function(b) {
            var d = $e09959a092a7608b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e09959a092a7608b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e09959a092a7608b$var$X = h.stateNode;
                        $e09959a092a7608b$var$Xj = !1;
                        break a;
                    case 3:
                        $e09959a092a7608b$var$X = h.stateNode.containerInfo;
                        $e09959a092a7608b$var$Xj = !0;
                        break a;
                    case 4:
                        $e09959a092a7608b$var$X = h.stateNode.containerInfo;
                        $e09959a092a7608b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e09959a092a7608b$var$X) throw Error($e09959a092a7608b$var$p(160));
            $e09959a092a7608b$var$Zj(f, g, e);
            $e09959a092a7608b$var$X = null;
            $e09959a092a7608b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e09959a092a7608b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e09959a092a7608b$var$dk(b, a), b = b.sibling;
}
function $e09959a092a7608b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 4) {
                try {
                    $e09959a092a7608b$var$Pj(3, a, a.return), $e09959a092a7608b$var$Qj(3, a);
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
                try {
                    $e09959a092a7608b$var$Pj(5, a, a.return);
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            d & 512 && null !== c && $e09959a092a7608b$var$Lj(c, c.return);
            break;
        case 5:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            d & 512 && null !== c && $e09959a092a7608b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e09959a092a7608b$var$ob(e, "");
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e09959a092a7608b$var$ab(e, f);
                    $e09959a092a7608b$var$vb(h, g);
                    var l = $e09959a092a7608b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e09959a092a7608b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e09959a092a7608b$var$nb(e, q) : "children" === m ? $e09959a092a7608b$var$ob(e, q) : $e09959a092a7608b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e09959a092a7608b$var$bb(e, f);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e09959a092a7608b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e09959a092a7608b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e09959a092a7608b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e09959a092a7608b$var$Pf] = f;
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e09959a092a7608b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e09959a092a7608b$var$bd(b.containerInfo);
            } catch (t) {
                $e09959a092a7608b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            break;
        case 13:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e09959a092a7608b$var$fk = $e09959a092a7608b$var$B()));
            d & 4 && $e09959a092a7608b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e09959a092a7608b$var$U = (l = $e09959a092a7608b$var$U) || m, $e09959a092a7608b$var$ck(b, a), $e09959a092a7608b$var$U = l) : $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e09959a092a7608b$var$V = a, m = a.child; null !== m;){
                    for(q = $e09959a092a7608b$var$V = m; null !== $e09959a092a7608b$var$V;){
                        r = $e09959a092a7608b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e09959a092a7608b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $e09959a092a7608b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e09959a092a7608b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e09959a092a7608b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e09959a092a7608b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e09959a092a7608b$var$V = y) : $e09959a092a7608b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e09959a092a7608b$var$rb("display", g));
                            } catch (t) {
                                $e09959a092a7608b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e09959a092a7608b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            d & 4 && $e09959a092a7608b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $e09959a092a7608b$var$ck(b, a), $e09959a092a7608b$var$ek(a);
    }
}
function $e09959a092a7608b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e09959a092a7608b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e09959a092a7608b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e09959a092a7608b$var$ob(e, ""), d.flags &= -33);
                    var f = $e09959a092a7608b$var$Uj(a);
                    $e09959a092a7608b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e09959a092a7608b$var$Uj(a);
                    $e09959a092a7608b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(161));
            }
        } catch (k) {
            $e09959a092a7608b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e09959a092a7608b$var$hk(a, b, c) {
    $e09959a092a7608b$var$V = a;
    $e09959a092a7608b$var$ik(a, b, c);
}
function $e09959a092a7608b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e09959a092a7608b$var$V;){
        var e = $e09959a092a7608b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e09959a092a7608b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e09959a092a7608b$var$U;
                h = $e09959a092a7608b$var$Jj;
                var l = $e09959a092a7608b$var$U;
                $e09959a092a7608b$var$Jj = g;
                if (($e09959a092a7608b$var$U = k) && !l) for($e09959a092a7608b$var$V = e; null !== $e09959a092a7608b$var$V;)g = $e09959a092a7608b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e09959a092a7608b$var$jk(e) : null !== k ? (k.return = g, $e09959a092a7608b$var$V = k) : $e09959a092a7608b$var$jk(e);
                for(; null !== f;)$e09959a092a7608b$var$V = f, $e09959a092a7608b$var$ik(f, b, c), f = f.sibling;
                $e09959a092a7608b$var$V = e;
                $e09959a092a7608b$var$Jj = h;
                $e09959a092a7608b$var$U = l;
            }
            $e09959a092a7608b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e09959a092a7608b$var$V = f) : $e09959a092a7608b$var$kk(a, b, c);
    }
}
function $e09959a092a7608b$var$kk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e09959a092a7608b$var$U || $e09959a092a7608b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e09959a092a7608b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e09959a092a7608b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e09959a092a7608b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e09959a092a7608b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e09959a092a7608b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e09959a092a7608b$var$p(163));
                }
                $e09959a092a7608b$var$U || b.flags & 512 && $e09959a092a7608b$var$Rj(b);
            } catch (r) {
                $e09959a092a7608b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e09959a092a7608b$var$V = c;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
function $e09959a092a7608b$var$gk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e09959a092a7608b$var$V = c;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
function $e09959a092a7608b$var$jk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e09959a092a7608b$var$Qj(4, b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e09959a092a7608b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e09959a092a7608b$var$Rj(b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e09959a092a7608b$var$Rj(b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e09959a092a7608b$var$W(b, b.return, k);
        }
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e09959a092a7608b$var$V = h;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
var $e09959a092a7608b$var$lk = Math.ceil, $e09959a092a7608b$var$mk = $e09959a092a7608b$var$ua.ReactCurrentDispatcher, $e09959a092a7608b$var$nk = $e09959a092a7608b$var$ua.ReactCurrentOwner, $e09959a092a7608b$var$ok = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$K = 0, $e09959a092a7608b$var$Q = null, $e09959a092a7608b$var$Y = null, $e09959a092a7608b$var$Z = 0, $e09959a092a7608b$var$fj = 0, $e09959a092a7608b$var$ej = $e09959a092a7608b$var$Uf(0), $e09959a092a7608b$var$T = 0, $e09959a092a7608b$var$pk = null, $e09959a092a7608b$var$rh = 0, $e09959a092a7608b$var$qk = 0, $e09959a092a7608b$var$rk = 0, $e09959a092a7608b$var$sk = null, $e09959a092a7608b$var$tk = null, $e09959a092a7608b$var$fk = 0, $e09959a092a7608b$var$Gj = Infinity, $e09959a092a7608b$var$uk = null, $e09959a092a7608b$var$Oi = !1, $e09959a092a7608b$var$Pi = null, $e09959a092a7608b$var$Ri = null, $e09959a092a7608b$var$vk = !1, $e09959a092a7608b$var$wk = null, $e09959a092a7608b$var$xk = 0, $e09959a092a7608b$var$yk = 0, $e09959a092a7608b$var$zk = null, $e09959a092a7608b$var$Ak = -1, $e09959a092a7608b$var$Bk = 0;
function $e09959a092a7608b$var$R() {
    return 0 !== ($e09959a092a7608b$var$K & 6) ? $e09959a092a7608b$var$B() : -1 !== $e09959a092a7608b$var$Ak ? $e09959a092a7608b$var$Ak : $e09959a092a7608b$var$Ak = $e09959a092a7608b$var$B();
}
function $e09959a092a7608b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e09959a092a7608b$var$K & 2) && 0 !== $e09959a092a7608b$var$Z) return $e09959a092a7608b$var$Z & -$e09959a092a7608b$var$Z;
    if (null !== $e09959a092a7608b$var$Kg.transition) return 0 === $e09959a092a7608b$var$Bk && ($e09959a092a7608b$var$Bk = $e09959a092a7608b$var$yc()), $e09959a092a7608b$var$Bk;
    a = $e09959a092a7608b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e09959a092a7608b$var$jd(a.type);
    return a;
}
function $e09959a092a7608b$var$gi(a, b, c, d) {
    if (50 < $e09959a092a7608b$var$yk) throw $e09959a092a7608b$var$yk = 0, $e09959a092a7608b$var$zk = null, Error($e09959a092a7608b$var$p(185));
    $e09959a092a7608b$var$Ac(a, c, d);
    if (0 === ($e09959a092a7608b$var$K & 2) || a !== $e09959a092a7608b$var$Q) a === $e09959a092a7608b$var$Q && (0 === ($e09959a092a7608b$var$K & 2) && ($e09959a092a7608b$var$qk |= c), 4 === $e09959a092a7608b$var$T && $e09959a092a7608b$var$Ck(a, $e09959a092a7608b$var$Z)), $e09959a092a7608b$var$Dk(a, d), 1 === c && 0 === $e09959a092a7608b$var$K && 0 === (b.mode & 1) && ($e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$fg && $e09959a092a7608b$var$jg());
}
function $e09959a092a7608b$var$Dk(a, b) {
    var c = a.callbackNode;
    $e09959a092a7608b$var$wc(a, b);
    var d = $e09959a092a7608b$var$uc(a, a === $e09959a092a7608b$var$Q ? $e09959a092a7608b$var$Z : 0);
    if (0 === d) null !== c && $e09959a092a7608b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e09959a092a7608b$var$bc(c);
        if (1 === b) 0 === a.tag ? $e09959a092a7608b$var$ig($e09959a092a7608b$var$Ek.bind(null, a)) : $e09959a092a7608b$var$hg($e09959a092a7608b$var$Ek.bind(null, a)), $e09959a092a7608b$var$Jf(function() {
            0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$jg();
        }), c = null;
        else {
            switch($e09959a092a7608b$var$Dc(d)){
                case 1:
                    c = $e09959a092a7608b$var$fc;
                    break;
                case 4:
                    c = $e09959a092a7608b$var$gc;
                    break;
                case 16:
                    c = $e09959a092a7608b$var$hc;
                    break;
                case 536870912:
                    c = $e09959a092a7608b$var$jc;
                    break;
                default:
                    c = $e09959a092a7608b$var$hc;
            }
            c = $e09959a092a7608b$var$Fk(c, $e09959a092a7608b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e09959a092a7608b$var$Gk(a, b) {
    $e09959a092a7608b$var$Ak = -1;
    $e09959a092a7608b$var$Bk = 0;
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    var c = a.callbackNode;
    if ($e09959a092a7608b$var$Hk() && a.callbackNode !== c) return null;
    var d = $e09959a092a7608b$var$uc(a, a === $e09959a092a7608b$var$Q ? $e09959a092a7608b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e09959a092a7608b$var$Ik(a, d);
    else {
        b = d;
        var e = $e09959a092a7608b$var$K;
        $e09959a092a7608b$var$K |= 2;
        var f = $e09959a092a7608b$var$Jk();
        if ($e09959a092a7608b$var$Q !== a || $e09959a092a7608b$var$Z !== b) $e09959a092a7608b$var$uk = null, $e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$Kk(a, b);
        for(;;)try {
            $e09959a092a7608b$var$Lk();
            break;
        } catch (h) {
            $e09959a092a7608b$var$Mk(a, h);
        }
        $e09959a092a7608b$var$$g();
        $e09959a092a7608b$var$mk.current = f;
        $e09959a092a7608b$var$K = e;
        null !== $e09959a092a7608b$var$Y ? b = 0 : ($e09959a092a7608b$var$Q = null, $e09959a092a7608b$var$Z = 0, b = $e09959a092a7608b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e09959a092a7608b$var$xc(a), 0 !== e && (d = e, b = $e09959a092a7608b$var$Nk(a, e)));
        if (1 === b) throw c = $e09959a092a7608b$var$pk, $e09959a092a7608b$var$Kk(a, 0), $e09959a092a7608b$var$Ck(a, d), $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), c;
        if (6 === b) $e09959a092a7608b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e09959a092a7608b$var$Ok(e) && (b = $e09959a092a7608b$var$Ik(a, d), 2 === b && (f = $e09959a092a7608b$var$xc(a), 0 !== f && (d = f, b = $e09959a092a7608b$var$Nk(a, f))), 1 === b)) throw c = $e09959a092a7608b$var$pk, $e09959a092a7608b$var$Kk(a, 0), $e09959a092a7608b$var$Ck(a, d), $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e09959a092a7608b$var$p(345));
                case 2:
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                case 3:
                    $e09959a092a7608b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $e09959a092a7608b$var$fk + 500 - $e09959a092a7608b$var$B(), 10 < b)) {
                        if (0 !== $e09959a092a7608b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e09959a092a7608b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e09959a092a7608b$var$Ff($e09959a092a7608b$var$Pk.bind(null, a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk), b);
                        break;
                    }
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                case 4:
                    $e09959a092a7608b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e09959a092a7608b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e09959a092a7608b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e09959a092a7608b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e09959a092a7608b$var$Ff($e09959a092a7608b$var$Pk.bind(null, a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk), d);
                        break;
                    }
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                case 5:
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(329));
            }
        }
    }
    $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B());
    return a.callbackNode === c ? $e09959a092a7608b$var$Gk.bind(null, a) : null;
}
function $e09959a092a7608b$var$Nk(a, b) {
    var c = $e09959a092a7608b$var$sk;
    a.current.memoizedState.isDehydrated && ($e09959a092a7608b$var$Kk(a, b).flags |= 256);
    a = $e09959a092a7608b$var$Ik(a, b);
    2 !== a && (b = $e09959a092a7608b$var$tk, $e09959a092a7608b$var$tk = c, null !== b && $e09959a092a7608b$var$Fj(b));
    return a;
}
function $e09959a092a7608b$var$Fj(a) {
    null === $e09959a092a7608b$var$tk ? $e09959a092a7608b$var$tk = a : $e09959a092a7608b$var$tk.push.apply($e09959a092a7608b$var$tk, a);
}
function $e09959a092a7608b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e09959a092a7608b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e09959a092a7608b$var$Ck(a, b) {
    b &= ~$e09959a092a7608b$var$rk;
    b &= ~$e09959a092a7608b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e09959a092a7608b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e09959a092a7608b$var$Ek(a) {
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    $e09959a092a7608b$var$Hk();
    var b = $e09959a092a7608b$var$uc(a, 0);
    if (0 === (b & 1)) return $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), null;
    var c = $e09959a092a7608b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e09959a092a7608b$var$xc(a);
        0 !== d && (b = d, c = $e09959a092a7608b$var$Nk(a, d));
    }
    if (1 === c) throw c = $e09959a092a7608b$var$pk, $e09959a092a7608b$var$Kk(a, 0), $e09959a092a7608b$var$Ck(a, b), $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), c;
    if (6 === c) throw Error($e09959a092a7608b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
    $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B());
    return null;
}
function $e09959a092a7608b$var$Qk(a, b) {
    var c = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e09959a092a7608b$var$K = c, 0 === $e09959a092a7608b$var$K && ($e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$fg && $e09959a092a7608b$var$jg());
    }
}
function $e09959a092a7608b$var$Rk(a) {
    null !== $e09959a092a7608b$var$wk && 0 === $e09959a092a7608b$var$wk.tag && 0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$Hk();
    var b = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 1;
    var c = $e09959a092a7608b$var$ok.transition, d = $e09959a092a7608b$var$C;
    try {
        if ($e09959a092a7608b$var$ok.transition = null, $e09959a092a7608b$var$C = 1, a) return a();
    } finally{
        $e09959a092a7608b$var$C = d, $e09959a092a7608b$var$ok.transition = c, $e09959a092a7608b$var$K = b, 0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$jg();
    }
}
function $e09959a092a7608b$var$Hj() {
    $e09959a092a7608b$var$fj = $e09959a092a7608b$var$ej.current;
    $e09959a092a7608b$var$E($e09959a092a7608b$var$ej);
}
function $e09959a092a7608b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e09959a092a7608b$var$Gf(c));
    if (null !== $e09959a092a7608b$var$Y) for(c = $e09959a092a7608b$var$Y.return; null !== c;){
        var d = c;
        $e09959a092a7608b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e09959a092a7608b$var$$f();
                break;
            case 3:
                $e09959a092a7608b$var$zh();
                $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
                $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
                $e09959a092a7608b$var$Eh();
                break;
            case 5:
                $e09959a092a7608b$var$Bh(d);
                break;
            case 4:
                $e09959a092a7608b$var$zh();
                break;
            case 13:
                $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
                break;
            case 19:
                $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
                break;
            case 10:
                $e09959a092a7608b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $e09959a092a7608b$var$Hj();
        }
        c = c.return;
    }
    $e09959a092a7608b$var$Q = a;
    $e09959a092a7608b$var$Y = a = $e09959a092a7608b$var$Pg(a.current, null);
    $e09959a092a7608b$var$Z = $e09959a092a7608b$var$fj = b;
    $e09959a092a7608b$var$T = 0;
    $e09959a092a7608b$var$pk = null;
    $e09959a092a7608b$var$rk = $e09959a092a7608b$var$qk = $e09959a092a7608b$var$rh = 0;
    $e09959a092a7608b$var$tk = $e09959a092a7608b$var$sk = null;
    if (null !== $e09959a092a7608b$var$fh) {
        for(b = 0; b < $e09959a092a7608b$var$fh.length; b++)if (c = $e09959a092a7608b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e09959a092a7608b$var$fh = null;
    }
    return a;
}
function $e09959a092a7608b$var$Mk(a, b) {
    do {
        var c = $e09959a092a7608b$var$Y;
        try {
            $e09959a092a7608b$var$$g();
            $e09959a092a7608b$var$Fh.current = $e09959a092a7608b$var$Rh;
            if ($e09959a092a7608b$var$Ih) {
                for(var d = $e09959a092a7608b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e09959a092a7608b$var$Ih = !1;
            }
            $e09959a092a7608b$var$Hh = 0;
            $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = $e09959a092a7608b$var$M = null;
            $e09959a092a7608b$var$Jh = !1;
            $e09959a092a7608b$var$Kh = 0;
            $e09959a092a7608b$var$nk.current = null;
            if (null === c || null === c.return) {
                $e09959a092a7608b$var$T = 1;
                $e09959a092a7608b$var$pk = b;
                $e09959a092a7608b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e09959a092a7608b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e09959a092a7608b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e09959a092a7608b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $e09959a092a7608b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e09959a092a7608b$var$Si(f, l, b);
                            $e09959a092a7608b$var$tj();
                            break a;
                        }
                        k = Error($e09959a092a7608b$var$p(426));
                    }
                } else if ($e09959a092a7608b$var$I && h.mode & 1) {
                    var J = $e09959a092a7608b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e09959a092a7608b$var$Vi(J, g, h, f, b);
                        $e09959a092a7608b$var$Jg($e09959a092a7608b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $e09959a092a7608b$var$Ji(k, h);
                4 !== $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 2);
                null === $e09959a092a7608b$var$sk ? $e09959a092a7608b$var$sk = [
                    f
                ] : $e09959a092a7608b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e09959a092a7608b$var$Ni(f, k, b);
                            $e09959a092a7608b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e09959a092a7608b$var$Ri || !$e09959a092a7608b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e09959a092a7608b$var$Qi(f, h, b);
                                $e09959a092a7608b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e09959a092a7608b$var$Sk(c);
        } catch (na) {
            b = na;
            $e09959a092a7608b$var$Y === c && null !== c && ($e09959a092a7608b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e09959a092a7608b$var$Jk() {
    var a = $e09959a092a7608b$var$mk.current;
    $e09959a092a7608b$var$mk.current = $e09959a092a7608b$var$Rh;
    return null === a ? $e09959a092a7608b$var$Rh : a;
}
function $e09959a092a7608b$var$tj() {
    if (0 === $e09959a092a7608b$var$T || 3 === $e09959a092a7608b$var$T || 2 === $e09959a092a7608b$var$T) $e09959a092a7608b$var$T = 4;
    null === $e09959a092a7608b$var$Q || 0 === ($e09959a092a7608b$var$rh & 268435455) && 0 === ($e09959a092a7608b$var$qk & 268435455) || $e09959a092a7608b$var$Ck($e09959a092a7608b$var$Q, $e09959a092a7608b$var$Z);
}
function $e09959a092a7608b$var$Ik(a, b) {
    var c = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 2;
    var d = $e09959a092a7608b$var$Jk();
    if ($e09959a092a7608b$var$Q !== a || $e09959a092a7608b$var$Z !== b) $e09959a092a7608b$var$uk = null, $e09959a092a7608b$var$Kk(a, b);
    for(;;)try {
        $e09959a092a7608b$var$Tk();
        break;
    } catch (e) {
        $e09959a092a7608b$var$Mk(a, e);
    }
    $e09959a092a7608b$var$$g();
    $e09959a092a7608b$var$K = c;
    $e09959a092a7608b$var$mk.current = d;
    if (null !== $e09959a092a7608b$var$Y) throw Error($e09959a092a7608b$var$p(261));
    $e09959a092a7608b$var$Q = null;
    $e09959a092a7608b$var$Z = 0;
    return $e09959a092a7608b$var$T;
}
function $e09959a092a7608b$var$Tk() {
    for(; null !== $e09959a092a7608b$var$Y;)$e09959a092a7608b$var$Uk($e09959a092a7608b$var$Y);
}
function $e09959a092a7608b$var$Lk() {
    for(; null !== $e09959a092a7608b$var$Y && !$e09959a092a7608b$var$cc();)$e09959a092a7608b$var$Uk($e09959a092a7608b$var$Y);
}
function $e09959a092a7608b$var$Uk(a) {
    var b = $e09959a092a7608b$var$Vk(a.alternate, a, $e09959a092a7608b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e09959a092a7608b$var$Sk(a) : $e09959a092a7608b$var$Y = b;
    $e09959a092a7608b$var$nk.current = null;
}
function $e09959a092a7608b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e09959a092a7608b$var$Ej(c, b, $e09959a092a7608b$var$fj), null !== c) {
                $e09959a092a7608b$var$Y = c;
                return;
            }
        } else {
            c = $e09959a092a7608b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e09959a092a7608b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e09959a092a7608b$var$T = 6;
                $e09959a092a7608b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e09959a092a7608b$var$Y = b;
            return;
        }
        $e09959a092a7608b$var$Y = b = a;
    }while (null !== b);
    0 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 5);
}
function $e09959a092a7608b$var$Pk(a, b, c) {
    var d = $e09959a092a7608b$var$C, e = $e09959a092a7608b$var$ok.transition;
    try {
        $e09959a092a7608b$var$ok.transition = null, $e09959a092a7608b$var$C = 1, $e09959a092a7608b$var$Wk(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$ok.transition = e, $e09959a092a7608b$var$C = d;
    }
    return null;
}
function $e09959a092a7608b$var$Wk(a, b, c, d) {
    do $e09959a092a7608b$var$Hk();
    while (null !== $e09959a092a7608b$var$wk);
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e09959a092a7608b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e09959a092a7608b$var$Bc(a, f);
    a === $e09959a092a7608b$var$Q && ($e09959a092a7608b$var$Y = $e09959a092a7608b$var$Q = null, $e09959a092a7608b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e09959a092a7608b$var$vk || ($e09959a092a7608b$var$vk = !0, $e09959a092a7608b$var$Fk($e09959a092a7608b$var$hc, function() {
        $e09959a092a7608b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e09959a092a7608b$var$ok.transition;
        $e09959a092a7608b$var$ok.transition = null;
        var g = $e09959a092a7608b$var$C;
        $e09959a092a7608b$var$C = 1;
        var h = $e09959a092a7608b$var$K;
        $e09959a092a7608b$var$K |= 4;
        $e09959a092a7608b$var$nk.current = null;
        $e09959a092a7608b$var$Oj(a, c);
        $e09959a092a7608b$var$dk(c, a);
        $e09959a092a7608b$var$Oe($e09959a092a7608b$var$Df);
        $e09959a092a7608b$var$dd = !!$e09959a092a7608b$var$Cf;
        $e09959a092a7608b$var$Df = $e09959a092a7608b$var$Cf = null;
        a.current = c;
        $e09959a092a7608b$var$hk(c, a, e);
        $e09959a092a7608b$var$dc();
        $e09959a092a7608b$var$K = h;
        $e09959a092a7608b$var$C = g;
        $e09959a092a7608b$var$ok.transition = f;
    } else a.current = c;
    $e09959a092a7608b$var$vk && ($e09959a092a7608b$var$vk = !1, $e09959a092a7608b$var$wk = a, $e09959a092a7608b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($e09959a092a7608b$var$Ri = null);
    $e09959a092a7608b$var$mc(c.stateNode, d);
    $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e09959a092a7608b$var$Oi) throw $e09959a092a7608b$var$Oi = !1, a = $e09959a092a7608b$var$Pi, $e09959a092a7608b$var$Pi = null, a;
    0 !== ($e09959a092a7608b$var$xk & 1) && 0 !== a.tag && $e09959a092a7608b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e09959a092a7608b$var$zk ? $e09959a092a7608b$var$yk++ : ($e09959a092a7608b$var$yk = 0, $e09959a092a7608b$var$zk = a) : $e09959a092a7608b$var$yk = 0;
    $e09959a092a7608b$var$jg();
    return null;
}
function $e09959a092a7608b$var$Hk() {
    if (null !== $e09959a092a7608b$var$wk) {
        var a = $e09959a092a7608b$var$Dc($e09959a092a7608b$var$xk), b = $e09959a092a7608b$var$ok.transition, c = $e09959a092a7608b$var$C;
        try {
            $e09959a092a7608b$var$ok.transition = null;
            $e09959a092a7608b$var$C = 16 > a ? 16 : a;
            if (null === $e09959a092a7608b$var$wk) var d = !1;
            else {
                a = $e09959a092a7608b$var$wk;
                $e09959a092a7608b$var$wk = null;
                $e09959a092a7608b$var$xk = 0;
                if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(331));
                var e = $e09959a092a7608b$var$K;
                $e09959a092a7608b$var$K |= 4;
                for($e09959a092a7608b$var$V = a.current; null !== $e09959a092a7608b$var$V;){
                    var f = $e09959a092a7608b$var$V, g = f.child;
                    if (0 !== ($e09959a092a7608b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e09959a092a7608b$var$V = l; null !== $e09959a092a7608b$var$V;){
                                    var m = $e09959a092a7608b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e09959a092a7608b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e09959a092a7608b$var$V = q;
                                    else for(; null !== $e09959a092a7608b$var$V;){
                                        m = $e09959a092a7608b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e09959a092a7608b$var$Sj(m);
                                        if (m === l) {
                                            $e09959a092a7608b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e09959a092a7608b$var$V = r;
                                            break;
                                        }
                                        $e09959a092a7608b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e09959a092a7608b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e09959a092a7608b$var$V = g;
                    else b: for(; null !== $e09959a092a7608b$var$V;){
                        f = $e09959a092a7608b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e09959a092a7608b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e09959a092a7608b$var$V = x;
                            break b;
                        }
                        $e09959a092a7608b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e09959a092a7608b$var$V = w; null !== $e09959a092a7608b$var$V;){
                    g = $e09959a092a7608b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e09959a092a7608b$var$V = u;
                    else b: for(g = w; null !== $e09959a092a7608b$var$V;){
                        h = $e09959a092a7608b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e09959a092a7608b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $e09959a092a7608b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e09959a092a7608b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e09959a092a7608b$var$V = F;
                            break b;
                        }
                        $e09959a092a7608b$var$V = h.return;
                    }
                }
                $e09959a092a7608b$var$K = e;
                $e09959a092a7608b$var$jg();
                if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onPostCommitFiberRoot) try {
                    $e09959a092a7608b$var$lc.onPostCommitFiberRoot($e09959a092a7608b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e09959a092a7608b$var$C = c, $e09959a092a7608b$var$ok.transition = b;
        }
    }
    return !1;
}
function $e09959a092a7608b$var$Xk(a, b, c) {
    b = $e09959a092a7608b$var$Ji(c, b);
    b = $e09959a092a7608b$var$Ni(a, b, 1);
    a = $e09959a092a7608b$var$nh(a, b, 1);
    b = $e09959a092a7608b$var$R();
    null !== a && ($e09959a092a7608b$var$Ac(a, 1, b), $e09959a092a7608b$var$Dk(a, b));
}
function $e09959a092a7608b$var$W(a, b, c) {
    if (3 === a.tag) $e09959a092a7608b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e09959a092a7608b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e09959a092a7608b$var$Ri || !$e09959a092a7608b$var$Ri.has(d))) {
                a = $e09959a092a7608b$var$Ji(c, a);
                a = $e09959a092a7608b$var$Qi(b, a, 1);
                b = $e09959a092a7608b$var$nh(b, a, 1);
                a = $e09959a092a7608b$var$R();
                null !== b && ($e09959a092a7608b$var$Ac(b, 1, a), $e09959a092a7608b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e09959a092a7608b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e09959a092a7608b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $e09959a092a7608b$var$Q === a && ($e09959a092a7608b$var$Z & c) === c && (4 === $e09959a092a7608b$var$T || 3 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$Z & 130023424) === $e09959a092a7608b$var$Z && 500 > $e09959a092a7608b$var$B() - $e09959a092a7608b$var$fk ? $e09959a092a7608b$var$Kk(a, 0) : $e09959a092a7608b$var$rk |= c);
    $e09959a092a7608b$var$Dk(a, b);
}
function $e09959a092a7608b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e09959a092a7608b$var$sc, $e09959a092a7608b$var$sc <<= 1, 0 === ($e09959a092a7608b$var$sc & 130023424) && ($e09959a092a7608b$var$sc = 4194304)));
    var c = $e09959a092a7608b$var$R();
    a = $e09959a092a7608b$var$ih(a, b);
    null !== a && ($e09959a092a7608b$var$Ac(a, b, c), $e09959a092a7608b$var$Dk(a, c));
}
function $e09959a092a7608b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e09959a092a7608b$var$Yk(a, c);
}
function $e09959a092a7608b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e09959a092a7608b$var$p(314));
    }
    null !== d && d.delete(b);
    $e09959a092a7608b$var$Yk(a, c);
}
var $e09959a092a7608b$var$Vk;
$e09959a092a7608b$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e09959a092a7608b$var$Wf.current) $e09959a092a7608b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e09959a092a7608b$var$dh = !1, $e09959a092a7608b$var$yj(a, b, c);
            $e09959a092a7608b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e09959a092a7608b$var$dh = !1, $e09959a092a7608b$var$I && 0 !== (b.flags & 1048576) && $e09959a092a7608b$var$ug(b, $e09959a092a7608b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e09959a092a7608b$var$ij(a, b);
            a = b.pendingProps;
            var e = $e09959a092a7608b$var$Yf(b, $e09959a092a7608b$var$H.current);
            $e09959a092a7608b$var$ch(b, c);
            e = $e09959a092a7608b$var$Nh(null, b, d, a, e, c);
            var f = $e09959a092a7608b$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e09959a092a7608b$var$Zf(d) ? (f = !0, $e09959a092a7608b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e09959a092a7608b$var$kh(b), e.updater = $e09959a092a7608b$var$Ei, b.stateNode = e, e._reactInternals = b, $e09959a092a7608b$var$Ii(b, d, a, c), b = $e09959a092a7608b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $e09959a092a7608b$var$I && f && $e09959a092a7608b$var$vg(b), $e09959a092a7608b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e09959a092a7608b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e09959a092a7608b$var$Zk(d);
                a = $e09959a092a7608b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $e09959a092a7608b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e09959a092a7608b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e09959a092a7608b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e09959a092a7608b$var$$i(null, b, d, $e09959a092a7608b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($e09959a092a7608b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $e09959a092a7608b$var$kj(b);
                if (null === a) throw Error($e09959a092a7608b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e09959a092a7608b$var$lh(a, b);
                $e09959a092a7608b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e09959a092a7608b$var$Ji(Error($e09959a092a7608b$var$p(423)), b);
                        b = $e09959a092a7608b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e09959a092a7608b$var$Ji(Error($e09959a092a7608b$var$p(424)), b);
                        b = $e09959a092a7608b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(b.stateNode.containerInfo.firstChild), $e09959a092a7608b$var$xg = b, $e09959a092a7608b$var$I = !0, $e09959a092a7608b$var$zg = null, c = $e09959a092a7608b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e09959a092a7608b$var$Ig();
                    if (d === e) {
                        b = $e09959a092a7608b$var$Zi(a, b, c);
                        break a;
                    }
                    $e09959a092a7608b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e09959a092a7608b$var$Ah(b), null === a && $e09959a092a7608b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e09959a092a7608b$var$Ef(d, e) ? g = null : null !== f && $e09959a092a7608b$var$Ef(d, f) && (b.flags |= 32), $e09959a092a7608b$var$gj(a, b), $e09959a092a7608b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $e09959a092a7608b$var$Eg(b), null;
        case 13:
            return $e09959a092a7608b$var$oj(a, b, c);
        case 4:
            return $e09959a092a7608b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e09959a092a7608b$var$Ug(b, null, d, c) : $e09959a092a7608b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$Yi(a, b, d, e, c);
        case 7:
            return $e09959a092a7608b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e09959a092a7608b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e09959a092a7608b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e09959a092a7608b$var$G($e09959a092a7608b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e09959a092a7608b$var$He(f.value, g)) {
                        if (f.children === e.children && !$e09959a092a7608b$var$Wf.current) {
                            b = $e09959a092a7608b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e09959a092a7608b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e09959a092a7608b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e09959a092a7608b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e09959a092a7608b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e09959a092a7608b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e09959a092a7608b$var$ch(b, c), e = $e09959a092a7608b$var$eh(e), d = d(e), b.flags |= 1, $e09959a092a7608b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e09959a092a7608b$var$Ci(d, b.pendingProps), e = $e09959a092a7608b$var$Ci(d.type, e), $e09959a092a7608b$var$$i(a, b, d, e, c);
        case 15:
            return $e09959a092a7608b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$ij(a, b), b.tag = 1, $e09959a092a7608b$var$Zf(d) ? (a = !0, $e09959a092a7608b$var$cg(b)) : a = !1, $e09959a092a7608b$var$ch(b, c), $e09959a092a7608b$var$Gi(b, d, e), $e09959a092a7608b$var$Ii(b, d, e, c), $e09959a092a7608b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $e09959a092a7608b$var$xj(a, b, c);
        case 22:
            return $e09959a092a7608b$var$dj(a, b, c);
    }
    throw Error($e09959a092a7608b$var$p(156, b.tag));
};
function $e09959a092a7608b$var$Fk(a, b) {
    return $e09959a092a7608b$var$ac(a, b);
}
function $e09959a092a7608b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e09959a092a7608b$var$Bg(a, b, c, d) {
    return new $e09959a092a7608b$var$$k(a, b, c, d);
}
function $e09959a092a7608b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e09959a092a7608b$var$Zk(a) {
    if ("function" === typeof a) return $e09959a092a7608b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e09959a092a7608b$var$Da) return 11;
        if (a === $e09959a092a7608b$var$Ga) return 14;
    }
    return 2;
}
function $e09959a092a7608b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e09959a092a7608b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e09959a092a7608b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e09959a092a7608b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e09959a092a7608b$var$ya:
            return $e09959a092a7608b$var$Tg(c.children, e, f, b);
        case $e09959a092a7608b$var$za:
            g = 8;
            e |= 8;
            break;
        case $e09959a092a7608b$var$Aa:
            return a = $e09959a092a7608b$var$Bg(12, c, b, e | 2), a.elementType = $e09959a092a7608b$var$Aa, a.lanes = f, a;
        case $e09959a092a7608b$var$Ea:
            return a = $e09959a092a7608b$var$Bg(13, c, b, e), a.elementType = $e09959a092a7608b$var$Ea, a.lanes = f, a;
        case $e09959a092a7608b$var$Fa:
            return a = $e09959a092a7608b$var$Bg(19, c, b, e), a.elementType = $e09959a092a7608b$var$Fa, a.lanes = f, a;
        case $e09959a092a7608b$var$Ia:
            return $e09959a092a7608b$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e09959a092a7608b$var$Ba:
                    g = 10;
                    break a;
                case $e09959a092a7608b$var$Ca:
                    g = 9;
                    break a;
                case $e09959a092a7608b$var$Da:
                    g = 11;
                    break a;
                case $e09959a092a7608b$var$Ga:
                    g = 14;
                    break a;
                case $e09959a092a7608b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e09959a092a7608b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e09959a092a7608b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e09959a092a7608b$var$Tg(a, b, c, d) {
    a = $e09959a092a7608b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e09959a092a7608b$var$pj(a, b, c, d) {
    a = $e09959a092a7608b$var$Bg(22, a, d, b);
    a.elementType = $e09959a092a7608b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e09959a092a7608b$var$Qg(a, b, c) {
    a = $e09959a092a7608b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e09959a092a7608b$var$Sg(a, b, c) {
    b = $e09959a092a7608b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e09959a092a7608b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e09959a092a7608b$var$zc(0);
    this.expirationTimes = $e09959a092a7608b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e09959a092a7608b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e09959a092a7608b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $e09959a092a7608b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e09959a092a7608b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e09959a092a7608b$var$kh(f);
    return a;
}
function $e09959a092a7608b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e09959a092a7608b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e09959a092a7608b$var$dl(a) {
    if (!a) return $e09959a092a7608b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e09959a092a7608b$var$Vb(a) !== a || 1 !== a.tag) throw Error($e09959a092a7608b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e09959a092a7608b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e09959a092a7608b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e09959a092a7608b$var$Zf(c)) return $e09959a092a7608b$var$bg(a, c, b);
    }
    return b;
}
function $e09959a092a7608b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $e09959a092a7608b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $e09959a092a7608b$var$dl(null);
    c = a.current;
    d = $e09959a092a7608b$var$R();
    e = $e09959a092a7608b$var$yi(c);
    f = $e09959a092a7608b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e09959a092a7608b$var$nh(c, f, e);
    a.current.lanes = e;
    $e09959a092a7608b$var$Ac(a, e, d);
    $e09959a092a7608b$var$Dk(a, d);
    return a;
}
function $e09959a092a7608b$var$fl(a, b, c, d) {
    var e = b.current, f = $e09959a092a7608b$var$R(), g = $e09959a092a7608b$var$yi(e);
    c = $e09959a092a7608b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e09959a092a7608b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e09959a092a7608b$var$nh(e, b, g);
    null !== a && ($e09959a092a7608b$var$gi(a, e, g, f), $e09959a092a7608b$var$oh(a, e, g));
    return g;
}
function $e09959a092a7608b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e09959a092a7608b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e09959a092a7608b$var$il(a, b) {
    $e09959a092a7608b$var$hl(a, b);
    (a = a.alternate) && $e09959a092a7608b$var$hl(a, b);
}
function $e09959a092a7608b$var$jl() {
    return null;
}
var $e09959a092a7608b$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e09959a092a7608b$var$ll(a) {
    this._internalRoot = a;
}
$e09959a092a7608b$var$ml.prototype.render = $e09959a092a7608b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e09959a092a7608b$var$p(409));
    $e09959a092a7608b$var$fl(a, b, null, null);
};
$e09959a092a7608b$var$ml.prototype.unmount = $e09959a092a7608b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e09959a092a7608b$var$Rk(function() {
            $e09959a092a7608b$var$fl(null, a, null, null);
        });
        b[$e09959a092a7608b$var$uf] = null;
    }
};
function $e09959a092a7608b$var$ml(a) {
    this._internalRoot = a;
}
$e09959a092a7608b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e09959a092a7608b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e09959a092a7608b$var$Qc.length && 0 !== b && b < $e09959a092a7608b$var$Qc[c].priority; c++);
        $e09959a092a7608b$var$Qc.splice(c, 0, a);
        0 === c && $e09959a092a7608b$var$Vc(a);
    }
};
function $e09959a092a7608b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e09959a092a7608b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e09959a092a7608b$var$pl() {}
function $e09959a092a7608b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e09959a092a7608b$var$gl(g);
                f.call(a);
            };
        }
        var g = $e09959a092a7608b$var$el(b, d, a, 0, null, !1, !1, "", $e09959a092a7608b$var$pl);
        a._reactRootContainer = g;
        a[$e09959a092a7608b$var$uf] = g.current;
        $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e09959a092a7608b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e09959a092a7608b$var$gl(k);
            h.call(a);
        };
    }
    var k = $e09959a092a7608b$var$bl(a, 0, !1, null, null, !1, !1, "", $e09959a092a7608b$var$pl);
    a._reactRootContainer = k;
    a[$e09959a092a7608b$var$uf] = k.current;
    $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e09959a092a7608b$var$Rk(function() {
        $e09959a092a7608b$var$fl(b, k, c, d);
    });
    return k;
}
function $e09959a092a7608b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e09959a092a7608b$var$gl(g);
                h.call(a);
            };
        }
        $e09959a092a7608b$var$fl(b, g, a, e);
    } else g = $e09959a092a7608b$var$ql(c, b, a, e, d);
    return $e09959a092a7608b$var$gl(g);
}
$e09959a092a7608b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e09959a092a7608b$var$tc(b.pendingLanes);
                0 !== c && ($e09959a092a7608b$var$Cc(b, c | 1), $e09959a092a7608b$var$Dk(b, $e09959a092a7608b$var$B()), 0 === ($e09959a092a7608b$var$K & 6) && ($e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$jg()));
            }
            break;
        case 13:
            $e09959a092a7608b$var$Rk(function() {
                var b = $e09959a092a7608b$var$ih(a, 1);
                if (null !== b) {
                    var c = $e09959a092a7608b$var$R();
                    $e09959a092a7608b$var$gi(b, a, 1, c);
                }
            }), $e09959a092a7608b$var$il(a, 1);
    }
};
$e09959a092a7608b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e09959a092a7608b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $e09959a092a7608b$var$R();
            $e09959a092a7608b$var$gi(b, a, 134217728, c);
        }
        $e09959a092a7608b$var$il(a, 134217728);
    }
};
$e09959a092a7608b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e09959a092a7608b$var$yi(a), c = $e09959a092a7608b$var$ih(a, b);
        if (null !== c) {
            var d = $e09959a092a7608b$var$R();
            $e09959a092a7608b$var$gi(c, a, b, d);
        }
        $e09959a092a7608b$var$il(a, b);
    }
};
$e09959a092a7608b$var$Hc = function() {
    return $e09959a092a7608b$var$C;
};
$e09959a092a7608b$var$Ic = function(a, b) {
    var c = $e09959a092a7608b$var$C;
    try {
        return $e09959a092a7608b$var$C = a, b();
    } finally{
        $e09959a092a7608b$var$C = c;
    }
};
$e09959a092a7608b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e09959a092a7608b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e09959a092a7608b$var$Db(d);
                        if (!e) throw Error($e09959a092a7608b$var$p(90));
                        $e09959a092a7608b$var$Wa(d);
                        $e09959a092a7608b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e09959a092a7608b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e09959a092a7608b$var$fb(a, !!c.multiple, b, !1);
    }
};
$e09959a092a7608b$var$Gb = $e09959a092a7608b$var$Qk;
$e09959a092a7608b$var$Hb = $e09959a092a7608b$var$Rk;
var $e09959a092a7608b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $e09959a092a7608b$var$Cb,
        $e09959a092a7608b$var$ue,
        $e09959a092a7608b$var$Db,
        $e09959a092a7608b$var$Eb,
        $e09959a092a7608b$var$Fb,
        $e09959a092a7608b$var$Qk
    ]
}, $e09959a092a7608b$var$tl = {
    findFiberByHostInstance: $e09959a092a7608b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $e09959a092a7608b$var$ul = {
    bundleType: $e09959a092a7608b$var$tl.bundleType,
    version: $e09959a092a7608b$var$tl.version,
    rendererPackageName: $e09959a092a7608b$var$tl.rendererPackageName,
    rendererConfig: $e09959a092a7608b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e09959a092a7608b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e09959a092a7608b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e09959a092a7608b$var$tl.findFiberByHostInstance || $e09959a092a7608b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e09959a092a7608b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e09959a092a7608b$var$vl.isDisabled && $e09959a092a7608b$var$vl.supportsFiber) try {
        $e09959a092a7608b$var$kc = $e09959a092a7608b$var$vl.inject($e09959a092a7608b$var$ul), $e09959a092a7608b$var$lc = $e09959a092a7608b$var$vl;
    } catch (a) {}
}
$e09959a092a7608b$export$ae55be85d98224ed = $e09959a092a7608b$var$sl;
$e09959a092a7608b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e09959a092a7608b$var$nl(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$cl(a, b, null, c);
};
$e09959a092a7608b$export$882461b6382ed46c = function(a, b) {
    if (!$e09959a092a7608b$var$nl(a)) throw Error($e09959a092a7608b$var$p(299));
    var c = !1, d = "", e = $e09959a092a7608b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e09959a092a7608b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$e09959a092a7608b$var$uf] = b.current;
    $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e09959a092a7608b$var$ll(b);
};
$e09959a092a7608b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e09959a092a7608b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e09959a092a7608b$var$p(268, a));
    }
    a = $e09959a092a7608b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e09959a092a7608b$export$cd75ccfd720a3cd4 = function(a) {
    return $e09959a092a7608b$var$Rk(a);
};
$e09959a092a7608b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e09959a092a7608b$var$ol(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$rl(null, a, b, !0, c);
};
$e09959a092a7608b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e09959a092a7608b$var$nl(a)) throw Error($e09959a092a7608b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e09959a092a7608b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e09959a092a7608b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e09959a092a7608b$var$uf] = b.current;
    $e09959a092a7608b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e09959a092a7608b$var$ml(b);
};
$e09959a092a7608b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e09959a092a7608b$var$ol(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$rl(null, a, b, !1, c);
};
$e09959a092a7608b$export$502457920280e6be = function(a) {
    if (!$e09959a092a7608b$var$ol(a)) throw Error($e09959a092a7608b$var$p(40));
    return a._reactRootContainer ? ($e09959a092a7608b$var$Rk(function() {
        $e09959a092a7608b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e09959a092a7608b$var$uf] = null;
        });
    }), !0) : !1;
};
$e09959a092a7608b$export$c78a37762a8d58e1 = $e09959a092a7608b$var$Qk;
$e09959a092a7608b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e09959a092a7608b$var$ol(c)) throw Error($e09959a092a7608b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e09959a092a7608b$var$p(38));
    return $e09959a092a7608b$var$rl(a, b, c, !1, d);
};
$e09959a092a7608b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7DCtq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fcjP7"));

});
parcelRegister("fcjP7", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $b1075a8380758f91$export$c4744153514ff05d, (v) => $b1075a8380758f91$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $b1075a8380758f91$export$3e506c1ccc9cc1a7, (v) => $b1075a8380758f91$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $b1075a8380758f91$export$e26fe2ed2fa76875, (v) => $b1075a8380758f91$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $b1075a8380758f91$export$502329bbf4b505b1, (v) => $b1075a8380758f91$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $b1075a8380758f91$export$6e3807111c4874c4, (v) => $b1075a8380758f91$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $b1075a8380758f91$export$c27134553091fb3a, (v) => $b1075a8380758f91$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $b1075a8380758f91$export$33ee1acdc04fd2a2, (v) => $b1075a8380758f91$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $b1075a8380758f91$export$b00a404bbd5edef2, (v) => $b1075a8380758f91$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $b1075a8380758f91$export$8352ce38b91d0c62, (v) => $b1075a8380758f91$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $b1075a8380758f91$export$d66a1c1c77bd778b, (v) => $b1075a8380758f91$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $b1075a8380758f91$export$d3dfb8e4810cb555, (v) => $b1075a8380758f91$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $b1075a8380758f91$export$839f9183b0465a69, (v) => $b1075a8380758f91$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $b1075a8380758f91$export$72fdf0e06517287b, (v) => $b1075a8380758f91$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $b1075a8380758f91$export$4b844e58a3e414b4, (v) => $b1075a8380758f91$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $b1075a8380758f91$export$816d2913ae6b83b1, (v) => $b1075a8380758f91$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $b1075a8380758f91$export$61bcfe829111a1d0, (v) => $b1075a8380758f91$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $b1075a8380758f91$export$7ee8c9beb337bc3f, (v) => $b1075a8380758f91$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $b1075a8380758f91$export$b5836b71941fa3ed, (v) => $b1075a8380758f91$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $b1075a8380758f91$export$cf845f2c119da08a, (v) => $b1075a8380758f91$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1075a8380758f91$export$c4744153514ff05d;
var $b1075a8380758f91$export$3e506c1ccc9cc1a7;
var $b1075a8380758f91$export$e26fe2ed2fa76875;
var $b1075a8380758f91$export$502329bbf4b505b1;
var $b1075a8380758f91$export$6e3807111c4874c4;
var $b1075a8380758f91$export$c27134553091fb3a;
var $b1075a8380758f91$export$33ee1acdc04fd2a2;
var $b1075a8380758f91$export$b00a404bbd5edef2;
var $b1075a8380758f91$export$8352ce38b91d0c62;
var $b1075a8380758f91$export$d66a1c1c77bd778b;
var $b1075a8380758f91$export$d3dfb8e4810cb555;
var $b1075a8380758f91$export$839f9183b0465a69;
var $b1075a8380758f91$export$72fdf0e06517287b;
var $b1075a8380758f91$export$4b844e58a3e414b4;
var $b1075a8380758f91$export$816d2913ae6b83b1;
var $b1075a8380758f91$export$61bcfe829111a1d0;
var $b1075a8380758f91$export$7ee8c9beb337bc3f;
var $b1075a8380758f91$export$b5836b71941fa3ed;
var $b1075a8380758f91$export$cf845f2c119da08a;
"use strict";
function $b1075a8380758f91$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b1075a8380758f91$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b1075a8380758f91$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b1075a8380758f91$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b1075a8380758f91$var$g(C, c)) n < e && 0 > $b1075a8380758f91$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b1075a8380758f91$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b1075a8380758f91$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b1075a8380758f91$var$l = performance;
    $b1075a8380758f91$export$c4744153514ff05d = function() {
        return $b1075a8380758f91$var$l.now();
    };
} else {
    var $b1075a8380758f91$var$p = Date, $b1075a8380758f91$var$q = $b1075a8380758f91$var$p.now();
    $b1075a8380758f91$export$c4744153514ff05d = function() {
        return $b1075a8380758f91$var$p.now() - $b1075a8380758f91$var$q;
    };
}
var $b1075a8380758f91$var$r = [], $b1075a8380758f91$var$t = [], $b1075a8380758f91$var$u = 1, $b1075a8380758f91$var$v = null, $b1075a8380758f91$var$y = 3, $b1075a8380758f91$var$z = !1, $b1075a8380758f91$var$A = !1, $b1075a8380758f91$var$B = !1, $b1075a8380758f91$var$D = "function" === typeof setTimeout ? setTimeout : null, $b1075a8380758f91$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b1075a8380758f91$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b1075a8380758f91$var$G(a) {
    for(var b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t); null !== b;){
        if (null === b.callback) $b1075a8380758f91$var$k($b1075a8380758f91$var$t);
        else if (b.startTime <= a) $b1075a8380758f91$var$k($b1075a8380758f91$var$t), b.sortIndex = b.expirationTime, $b1075a8380758f91$var$f($b1075a8380758f91$var$r, b);
        else break;
        b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
    }
}
function $b1075a8380758f91$var$H(a) {
    $b1075a8380758f91$var$B = !1;
    $b1075a8380758f91$var$G(a);
    if (!$b1075a8380758f91$var$A) {
        if (null !== $b1075a8380758f91$var$h($b1075a8380758f91$var$r)) $b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J);
        else {
            var b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
            null !== b && $b1075a8380758f91$var$K($b1075a8380758f91$var$H, b.startTime - a);
        }
    }
}
function $b1075a8380758f91$var$J(a, b) {
    $b1075a8380758f91$var$A = !1;
    $b1075a8380758f91$var$B && ($b1075a8380758f91$var$B = !1, $b1075a8380758f91$var$E($b1075a8380758f91$var$L), $b1075a8380758f91$var$L = -1);
    $b1075a8380758f91$var$z = !0;
    var c = $b1075a8380758f91$var$y;
    try {
        $b1075a8380758f91$var$G(b);
        for($b1075a8380758f91$var$v = $b1075a8380758f91$var$h($b1075a8380758f91$var$r); null !== $b1075a8380758f91$var$v && (!($b1075a8380758f91$var$v.expirationTime > b) || a && !$b1075a8380758f91$var$M());){
            var d = $b1075a8380758f91$var$v.callback;
            if ("function" === typeof d) {
                $b1075a8380758f91$var$v.callback = null;
                $b1075a8380758f91$var$y = $b1075a8380758f91$var$v.priorityLevel;
                var e = d($b1075a8380758f91$var$v.expirationTime <= b);
                b = $b1075a8380758f91$export$c4744153514ff05d();
                "function" === typeof e ? $b1075a8380758f91$var$v.callback = e : $b1075a8380758f91$var$v === $b1075a8380758f91$var$h($b1075a8380758f91$var$r) && $b1075a8380758f91$var$k($b1075a8380758f91$var$r);
                $b1075a8380758f91$var$G(b);
            } else $b1075a8380758f91$var$k($b1075a8380758f91$var$r);
            $b1075a8380758f91$var$v = $b1075a8380758f91$var$h($b1075a8380758f91$var$r);
        }
        if (null !== $b1075a8380758f91$var$v) var w = !0;
        else {
            var m = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
            null !== m && $b1075a8380758f91$var$K($b1075a8380758f91$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b1075a8380758f91$var$v = null, $b1075a8380758f91$var$y = c, $b1075a8380758f91$var$z = !1;
    }
}
var $b1075a8380758f91$var$N = !1, $b1075a8380758f91$var$O = null, $b1075a8380758f91$var$L = -1, $b1075a8380758f91$var$P = 5, $b1075a8380758f91$var$Q = -1;
function $b1075a8380758f91$var$M() {
    return $b1075a8380758f91$export$c4744153514ff05d() - $b1075a8380758f91$var$Q < $b1075a8380758f91$var$P ? !1 : !0;
}
function $b1075a8380758f91$var$R() {
    if (null !== $b1075a8380758f91$var$O) {
        var a = $b1075a8380758f91$export$c4744153514ff05d();
        $b1075a8380758f91$var$Q = a;
        var b = !0;
        try {
            b = $b1075a8380758f91$var$O(!0, a);
        } finally{
            b ? $b1075a8380758f91$var$S() : ($b1075a8380758f91$var$N = !1, $b1075a8380758f91$var$O = null);
        }
    } else $b1075a8380758f91$var$N = !1;
}
var $b1075a8380758f91$var$S;
if ("function" === typeof $b1075a8380758f91$var$F) $b1075a8380758f91$var$S = function() {
    $b1075a8380758f91$var$F($b1075a8380758f91$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b1075a8380758f91$var$T = new MessageChannel, $b1075a8380758f91$var$U = $b1075a8380758f91$var$T.port2;
    $b1075a8380758f91$var$T.port1.onmessage = $b1075a8380758f91$var$R;
    $b1075a8380758f91$var$S = function() {
        $b1075a8380758f91$var$U.postMessage(null);
    };
} else $b1075a8380758f91$var$S = function() {
    $b1075a8380758f91$var$D($b1075a8380758f91$var$R, 0);
};
function $b1075a8380758f91$var$I(a) {
    $b1075a8380758f91$var$O = a;
    $b1075a8380758f91$var$N || ($b1075a8380758f91$var$N = !0, $b1075a8380758f91$var$S());
}
function $b1075a8380758f91$var$K(a, b) {
    $b1075a8380758f91$var$L = $b1075a8380758f91$var$D(function() {
        a($b1075a8380758f91$export$c4744153514ff05d());
    }, b);
}
$b1075a8380758f91$export$3e506c1ccc9cc1a7 = 5;
$b1075a8380758f91$export$e26fe2ed2fa76875 = 1;
$b1075a8380758f91$export$502329bbf4b505b1 = 4;
$b1075a8380758f91$export$6e3807111c4874c4 = 3;
$b1075a8380758f91$export$c27134553091fb3a = null;
$b1075a8380758f91$export$33ee1acdc04fd2a2 = 2;
$b1075a8380758f91$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b1075a8380758f91$export$8352ce38b91d0c62 = function() {
    $b1075a8380758f91$var$A || $b1075a8380758f91$var$z || ($b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J));
};
$b1075a8380758f91$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b1075a8380758f91$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b1075a8380758f91$export$d3dfb8e4810cb555 = function() {
    return $b1075a8380758f91$var$y;
};
$b1075a8380758f91$export$839f9183b0465a69 = function() {
    return $b1075a8380758f91$var$h($b1075a8380758f91$var$r);
};
$b1075a8380758f91$export$72fdf0e06517287b = function(a) {
    switch($b1075a8380758f91$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b1075a8380758f91$var$y;
    }
    var c = $b1075a8380758f91$var$y;
    $b1075a8380758f91$var$y = b;
    try {
        return a();
    } finally{
        $b1075a8380758f91$var$y = c;
    }
};
$b1075a8380758f91$export$4b844e58a3e414b4 = function() {};
$b1075a8380758f91$export$816d2913ae6b83b1 = function() {};
$b1075a8380758f91$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b1075a8380758f91$var$y;
    $b1075a8380758f91$var$y = a;
    try {
        return b();
    } finally{
        $b1075a8380758f91$var$y = c;
    }
};
$b1075a8380758f91$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b1075a8380758f91$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b1075a8380758f91$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b1075a8380758f91$var$f($b1075a8380758f91$var$t, a), null === $b1075a8380758f91$var$h($b1075a8380758f91$var$r) && a === $b1075a8380758f91$var$h($b1075a8380758f91$var$t) && ($b1075a8380758f91$var$B ? ($b1075a8380758f91$var$E($b1075a8380758f91$var$L), $b1075a8380758f91$var$L = -1) : $b1075a8380758f91$var$B = !0, $b1075a8380758f91$var$K($b1075a8380758f91$var$H, c - d))) : (a.sortIndex = e, $b1075a8380758f91$var$f($b1075a8380758f91$var$r, a), $b1075a8380758f91$var$A || $b1075a8380758f91$var$z || ($b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J)));
    return a;
};
$b1075a8380758f91$export$b5836b71941fa3ed = $b1075a8380758f91$var$M;
$b1075a8380758f91$export$cf845f2c119da08a = function(a) {
    var b = $b1075a8380758f91$var$y;
    return function() {
        var c = $b1075a8380758f91$var$y;
        $b1075a8380758f91$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b1075a8380758f91$var$y = c;
        }
    };
};

});



parcelRegister("hSrj7", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $d03ca97c86512295$export$306c0aa65ff9ec16, (v) => $d03ca97c86512295$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d03ca97c86512295$export$306c0aa65ff9ec16;
"use strict";

var $8tsvq = parcelRequire("8tsvq");
function $d03ca97c86512295$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d03ca97c86512295$var$k = "function" === typeof Object.is ? Object.is : $d03ca97c86512295$var$h, $d03ca97c86512295$var$l = $8tsvq.useState, $d03ca97c86512295$var$m = $8tsvq.useEffect, $d03ca97c86512295$var$n = $8tsvq.useLayoutEffect, $d03ca97c86512295$var$p = $8tsvq.useDebugValue;
function $d03ca97c86512295$var$q(a, b) {
    var d = b(), f = $d03ca97c86512295$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $d03ca97c86512295$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $d03ca97c86512295$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $d03ca97c86512295$var$m(function() {
        $d03ca97c86512295$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $d03ca97c86512295$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $d03ca97c86512295$var$p(d);
    return d;
}
function $d03ca97c86512295$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$d03ca97c86512295$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $d03ca97c86512295$var$t(a, b) {
    return b();
}
var $d03ca97c86512295$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $d03ca97c86512295$var$t : $d03ca97c86512295$var$q;
$d03ca97c86512295$export$306c0aa65ff9ec16 = void 0 !== $8tsvq.useSyncExternalStore ? $8tsvq.useSyncExternalStore : $d03ca97c86512295$var$u;

});

parcelRegister("734S0", function(module, exports) {
"use strict";
var $521c974cc6262250$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $eA2K9 = parcelRequire("eA2K9");
module.exports = function hasNativeSymbols() {
    if (typeof $521c974cc6262250$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $521c974cc6262250$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $eA2K9();
};

});
parcelRegister("eA2K9", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hCx0p", function(module, exports) {
"use strict";
var $cd3f967af4a6a70a$var$test = {
    __proto__: null,
    foo: {}
};
var $cd3f967af4a6a70a$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $cd3f967af4a6a70a$var$test
    }).foo === $cd3f967af4a6a70a$var$test.foo && !($cd3f967af4a6a70a$var$test instanceof $cd3f967af4a6a70a$var$$Object);
};

});

parcelRegister("bOcfK", function(module, exports) {
"use strict";

var $eNxNf = parcelRequire("eNxNf");
var $898dde6b153135b5$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$eNxNf;
};
$898dde6b153135b5$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$eNxNf) return null;
    try {
        return $eNxNf([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $898dde6b153135b5$var$hasPropertyDescriptors;

});
parcelRegister("eNxNf", function(module, exports) {
"use strict";

var $YYhfn = parcelRequire("YYhfn");
/** @type {import('.')} */ var $ac5fdaf5b4392c78$var$$defineProperty = $YYhfn("%Object.defineProperty%", true) || false;
if ($ac5fdaf5b4392c78$var$$defineProperty) try {
    $ac5fdaf5b4392c78$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $ac5fdaf5b4392c78$var$$defineProperty = false;
}
module.exports = $ac5fdaf5b4392c78$var$$defineProperty;

});
parcelRegister("YYhfn", function(module, exports) {
"use strict";
var $0b745c80c77d8e6b$var$undefined1;

var $1c6wl = parcelRequire("1c6wl");

var $iH0K7 = parcelRequire("iH0K7");

var $bIz9d = parcelRequire("bIz9d");

var $l93KB = parcelRequire("l93KB");

var $ebTth = parcelRequire("ebTth");

var $9tZcL = parcelRequire("9tZcL");

var $e6SZU = parcelRequire("e6SZU");
var $0b745c80c77d8e6b$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $0b745c80c77d8e6b$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $0b745c80c77d8e6b$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $0b745c80c77d8e6b$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($0b745c80c77d8e6b$var$$gOPD) try {
    $0b745c80c77d8e6b$var$$gOPD({}, "");
} catch (e) {
    $0b745c80c77d8e6b$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $0b745c80c77d8e6b$var$throwTypeError = function() {
    throw new $9tZcL();
};
var $0b745c80c77d8e6b$var$ThrowTypeError = $0b745c80c77d8e6b$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $0b745c80c77d8e6b$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $0b745c80c77d8e6b$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $0b745c80c77d8e6b$var$throwTypeError;
        }
    }
}() : $0b745c80c77d8e6b$var$throwTypeError;

var $0b745c80c77d8e6b$var$hasSymbols = (parcelRequire("734S0"))();

var $0b745c80c77d8e6b$var$hasProto = (parcelRequire("hCx0p"))();
var $0b745c80c77d8e6b$var$getProto = Object.getPrototypeOf || ($0b745c80c77d8e6b$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $0b745c80c77d8e6b$var$needsEval = {};
var $0b745c80c77d8e6b$var$TypedArray = typeof Uint8Array === "undefined" || !$0b745c80c77d8e6b$var$getProto ? undefined : $0b745c80c77d8e6b$var$getProto(Uint8Array);
var $0b745c80c77d8e6b$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $0b745c80c77d8e6b$var$hasSymbols && $0b745c80c77d8e6b$var$getProto ? $0b745c80c77d8e6b$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $0b745c80c77d8e6b$var$needsEval,
    "%AsyncGenerator%": $0b745c80c77d8e6b$var$needsEval,
    "%AsyncGeneratorFunction%": $0b745c80c77d8e6b$var$needsEval,
    "%AsyncIteratorPrototype%": $0b745c80c77d8e6b$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $1c6wl,
    "%eval%": eval,
    "%EvalError%": $iH0K7,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $0b745c80c77d8e6b$var$$Function,
    "%GeneratorFunction%": $0b745c80c77d8e6b$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $0b745c80c77d8e6b$var$hasSymbols && $0b745c80c77d8e6b$var$getProto ? $0b745c80c77d8e6b$var$getProto($0b745c80c77d8e6b$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$0b745c80c77d8e6b$var$hasSymbols || !$0b745c80c77d8e6b$var$getProto ? undefined : $0b745c80c77d8e6b$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $bIz9d,
    "%ReferenceError%": $l93KB,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$0b745c80c77d8e6b$var$hasSymbols || !$0b745c80c77d8e6b$var$getProto ? undefined : $0b745c80c77d8e6b$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $0b745c80c77d8e6b$var$hasSymbols && $0b745c80c77d8e6b$var$getProto ? $0b745c80c77d8e6b$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $0b745c80c77d8e6b$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $ebTth,
    "%ThrowTypeError%": $0b745c80c77d8e6b$var$ThrowTypeError,
    "%TypedArray%": $0b745c80c77d8e6b$var$TypedArray,
    "%TypeError%": $9tZcL,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $e6SZU,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($0b745c80c77d8e6b$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $0b745c80c77d8e6b$var$errorProto = $0b745c80c77d8e6b$var$getProto($0b745c80c77d8e6b$var$getProto(e));
    $0b745c80c77d8e6b$var$INTRINSICS["%Error.prototype%"] = $0b745c80c77d8e6b$var$errorProto;
}
var $0b745c80c77d8e6b$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $0b745c80c77d8e6b$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $0b745c80c77d8e6b$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $0b745c80c77d8e6b$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $0b745c80c77d8e6b$var$getProto) value = $0b745c80c77d8e6b$var$getProto(gen.prototype);
    }
    $0b745c80c77d8e6b$var$INTRINSICS[name] = value;
    return value;
};
var $0b745c80c77d8e6b$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $fd7Gr = parcelRequire("fd7Gr");

var $cZVTv = parcelRequire("cZVTv");
var $0b745c80c77d8e6b$var$$concat = $fd7Gr.call(Function.call, Array.prototype.concat);
var $0b745c80c77d8e6b$var$$spliceApply = $fd7Gr.call(Function.apply, Array.prototype.splice);
var $0b745c80c77d8e6b$var$$replace = $fd7Gr.call(Function.call, String.prototype.replace);
var $0b745c80c77d8e6b$var$$strSlice = $fd7Gr.call(Function.call, String.prototype.slice);
var $0b745c80c77d8e6b$var$$exec = $fd7Gr.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $0b745c80c77d8e6b$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $0b745c80c77d8e6b$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $0b745c80c77d8e6b$var$stringToPath = function stringToPath(string) {
    var first = $0b745c80c77d8e6b$var$$strSlice(string, 0, 1);
    var last = $0b745c80c77d8e6b$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $ebTth("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $ebTth("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $0b745c80c77d8e6b$var$$replace(string, $0b745c80c77d8e6b$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $0b745c80c77d8e6b$var$$replace(subString, $0b745c80c77d8e6b$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $0b745c80c77d8e6b$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($cZVTv($0b745c80c77d8e6b$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $0b745c80c77d8e6b$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($cZVTv($0b745c80c77d8e6b$var$INTRINSICS, intrinsicName)) {
        var value = $0b745c80c77d8e6b$var$INTRINSICS[intrinsicName];
        if (value === $0b745c80c77d8e6b$var$needsEval) value = $0b745c80c77d8e6b$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $9tZcL("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $ebTth("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $9tZcL("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $9tZcL('"allowMissing" argument must be a boolean');
    if ($0b745c80c77d8e6b$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $ebTth("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $0b745c80c77d8e6b$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $0b745c80c77d8e6b$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $0b745c80c77d8e6b$var$$spliceApply(parts, $0b745c80c77d8e6b$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $0b745c80c77d8e6b$var$$strSlice(part, 0, 1);
        var last = $0b745c80c77d8e6b$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $ebTth("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($cZVTv($0b745c80c77d8e6b$var$INTRINSICS, intrinsicRealName)) value = $0b745c80c77d8e6b$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $9tZcL("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($0b745c80c77d8e6b$var$$gOPD && i + 1 >= parts.length) {
                var desc = $0b745c80c77d8e6b$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $cZVTv(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $0b745c80c77d8e6b$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("1c6wl", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("iH0K7", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("bIz9d", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("l93KB", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("ebTth", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("9tZcL", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("e6SZU", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("fd7Gr", function(module, exports) {
"use strict";

var $3k1s3 = parcelRequire("3k1s3");
module.exports = Function.prototype.bind || $3k1s3;

});
parcelRegister("3k1s3", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $26b45d95c3de106a$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $26b45d95c3de106a$var$toStr = Object.prototype.toString;
var $26b45d95c3de106a$var$max = Math.max;
var $26b45d95c3de106a$var$funcType = "[object Function]";
var $26b45d95c3de106a$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $26b45d95c3de106a$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $26b45d95c3de106a$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $26b45d95c3de106a$var$toStr.apply(target) !== $26b45d95c3de106a$var$funcType) throw new TypeError($26b45d95c3de106a$var$ERROR_MESSAGE + target);
    var args = $26b45d95c3de106a$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $26b45d95c3de106a$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $26b45d95c3de106a$var$concatty(args, arguments));
    };
    var boundLength = $26b45d95c3de106a$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $26b45d95c3de106a$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("cZVTv", function(module, exports) {
"use strict";
var $97681721aaad2266$var$call = Function.prototype.call;
var $97681721aaad2266$var$$hasOwn = Object.prototype.hasOwnProperty;

var $fd7Gr = parcelRequire("fd7Gr");
/** @type {import('.')} */ module.exports = $fd7Gr.call($97681721aaad2266$var$call, $97681721aaad2266$var$$hasOwn);

});




parcelRegister("kR54n", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});

var $d00e5d22a0b5e103$exports = {};
"use strict";

$d00e5d22a0b5e103$exports = (parcelRequire("b8reE"));



var $8tsvq = parcelRequire("8tsvq");
var $416246511aeb39de$exports = {};

$parcel$export($416246511aeb39de$exports, "createRoot", () => $416246511aeb39de$export$882461b6382ed46c, (v) => $416246511aeb39de$export$882461b6382ed46c = v);
$parcel$export($416246511aeb39de$exports, "hydrateRoot", () => $416246511aeb39de$export$757ceba2d55c277e, (v) => $416246511aeb39de$export$757ceba2d55c277e = v);
var $416246511aeb39de$export$882461b6382ed46c;
var $416246511aeb39de$export$757ceba2d55c277e;
"use strict";
var $a2d184922ae7f92f$exports = {};
"use strict";
function $a2d184922ae7f92f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a2d184922ae7f92f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a2d184922ae7f92f$var$checkDCE();

$a2d184922ae7f92f$exports = (parcelRequire("jhxbP"));


var $416246511aeb39de$var$i;
$416246511aeb39de$export$882461b6382ed46c = $a2d184922ae7f92f$exports.createRoot;
$416246511aeb39de$export$757ceba2d55c277e = $a2d184922ae7f92f$exports.hydrateRoot;







var $8tsvq = parcelRequire("8tsvq");
var $12eb31a89aea031d$exports = {};
"use strict";

$12eb31a89aea031d$exports = (parcelRequire("hSrj7"));



var $8tsvq = parcelRequire("8tsvq");
// Shared state between server components and client components
const $39c3abb793dffd30$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $39c3abb793dffd30$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $39c3abb793dffd30$export$8793edee2d425525();
const $39c3abb793dffd30$export$8b8a958a7f6f130c = Object;
const $39c3abb793dffd30$export$fce6876652108ab = (v)=>v === $39c3abb793dffd30$export$6db089fe7b26f5b6;
const $39c3abb793dffd30$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $39c3abb793dffd30$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $39c3abb793dffd30$export$ae936b9d47e5870e = (x)=>$39c3abb793dffd30$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $39c3abb793dffd30$var$table = new WeakMap();
// counter of the key
let $39c3abb793dffd30$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $39c3abb793dffd30$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($39c3abb793dffd30$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $39c3abb793dffd30$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$39c3abb793dffd30$var$counter + "~";
        $39c3abb793dffd30$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $39c3abb793dffd30$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $39c3abb793dffd30$var$table.set(arg, result);
        }
        if (constructor == $39c3abb793dffd30$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $39c3abb793dffd30$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$39c3abb793dffd30$export$fce6876652108ab(index = keys.pop()))if (!$39c3abb793dffd30$export$fce6876652108ab(arg[index])) result += index + ":" + $39c3abb793dffd30$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $39c3abb793dffd30$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $39c3abb793dffd30$export$b94ca9901c60634 = new WeakMap();
const $39c3abb793dffd30$var$EMPTY_CACHE = {};
const $39c3abb793dffd30$var$INITIAL_CACHE = {};
const $39c3abb793dffd30$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $39c3abb793dffd30$export$6e85fd745dc51282 = typeof window != $39c3abb793dffd30$var$STR_UNDEFINED;
const $39c3abb793dffd30$export$842dfe7a9f24298 = typeof document != $39c3abb793dffd30$var$STR_UNDEFINED;
const $39c3abb793dffd30$export$a9116928c9d15917 = ()=>$39c3abb793dffd30$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $39c3abb793dffd30$var$STR_UNDEFINED;
const $39c3abb793dffd30$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $39c3abb793dffd30$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$39c3abb793dffd30$export$fce6876652108ab(key) && cache.get(key) || $39c3abb793dffd30$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$39c3abb793dffd30$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $39c3abb793dffd30$var$INITIAL_CACHE)) $39c3abb793dffd30$var$INITIAL_CACHE[key] = prev;
                state[5](key, $39c3abb793dffd30$export$2321aea138b44780(prev, info), prev || $39c3abb793dffd30$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$39c3abb793dffd30$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $39c3abb793dffd30$var$INITIAL_CACHE) return $39c3abb793dffd30$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$39c3abb793dffd30$export$fce6876652108ab(key) && cache.get(key) || $39c3abb793dffd30$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $39c3abb793dffd30$var$online = true;
const $39c3abb793dffd30$var$isOnline = ()=>$39c3abb793dffd30$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$39c3abb793dffd30$var$onWindowEvent, $39c3abb793dffd30$var$offWindowEvent] = $39c3abb793dffd30$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $39c3abb793dffd30$export$8793edee2d425525,
    $39c3abb793dffd30$export$8793edee2d425525
];
const $39c3abb793dffd30$var$isVisible = ()=>{
    const visibilityState = $39c3abb793dffd30$export$842dfe7a9f24298 && document.visibilityState;
    return $39c3abb793dffd30$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $39c3abb793dffd30$var$initFocus = (callback)=>{
    // focus revalidate
    if ($39c3abb793dffd30$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $39c3abb793dffd30$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($39c3abb793dffd30$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $39c3abb793dffd30$var$offWindowEvent("focus", callback);
    };
};
const $39c3abb793dffd30$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $39c3abb793dffd30$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $39c3abb793dffd30$var$online = false;
    };
    $39c3abb793dffd30$var$onWindowEvent("online", onOnline);
    $39c3abb793dffd30$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $39c3abb793dffd30$var$offWindowEvent("online", onOnline);
        $39c3abb793dffd30$var$offWindowEvent("offline", onOffline);
    };
};
const $39c3abb793dffd30$export$f5ab8217e0edff04 = {
    isOnline: $39c3abb793dffd30$var$isOnline,
    isVisible: $39c3abb793dffd30$var$isVisible
};
const $39c3abb793dffd30$export$b1857f3440a65373 = {
    initFocus: $39c3abb793dffd30$var$initFocus,
    initReconnect: $39c3abb793dffd30$var$initReconnect
};
const $39c3abb793dffd30$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).useId;
const $39c3abb793dffd30$export$d2f4d8e74279c212 = !$39c3abb793dffd30$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $39c3abb793dffd30$export$eba6076d3d7d0c06 = (f)=>$39c3abb793dffd30$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $39c3abb793dffd30$export$700979bc83e7db82 = $39c3abb793dffd30$export$d2f4d8e74279c212 ? (0, $8tsvq.useEffect) : (0, $8tsvq.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $39c3abb793dffd30$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $39c3abb793dffd30$export$3723beb60427dc52 = !$39c3abb793dffd30$export$d2f4d8e74279c212 && $39c3abb793dffd30$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($39c3abb793dffd30$var$navigatorConnection.effectiveType) || $39c3abb793dffd30$var$navigatorConnection.saveData);
const $39c3abb793dffd30$export$dfdc1655ccc5b9cb = (key)=>{
    if ($39c3abb793dffd30$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $39c3abb793dffd30$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $39c3abb793dffd30$var$__timestamp = 0;
const $39c3abb793dffd30$export$3c95c4c8b671ef0 = ()=>++$39c3abb793dffd30$var$__timestamp;
const $39c3abb793dffd30$var$FOCUS_EVENT = 0;
const $39c3abb793dffd30$var$RECONNECT_EVENT = 1;
const $39c3abb793dffd30$var$MUTATE_EVENT = 2;
const $39c3abb793dffd30$var$ERROR_REVALIDATE_EVENT = 3;
var $39c3abb793dffd30$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $39c3abb793dffd30$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $39c3abb793dffd30$var$FOCUS_EVENT,
    MUTATE_EVENT: $39c3abb793dffd30$var$MUTATE_EVENT,
    RECONNECT_EVENT: $39c3abb793dffd30$var$RECONNECT_EVENT
};
async function $39c3abb793dffd30$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $39c3abb793dffd30$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($39c3abb793dffd30$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $39c3abb793dffd30$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $39c3abb793dffd30$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $39c3abb793dffd30$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $39c3abb793dffd30$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($39c3abb793dffd30$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $39c3abb793dffd30$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$39c3abb793dffd30$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $39c3abb793dffd30$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $39c3abb793dffd30$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($39c3abb793dffd30$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $39c3abb793dffd30$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $39c3abb793dffd30$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($39c3abb793dffd30$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $39c3abb793dffd30$export$6db089fe7b26f5b6,
                        _c: $39c3abb793dffd30$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $39c3abb793dffd30$export$6db089fe7b26f5b6,
                    _c: $39c3abb793dffd30$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $39c3abb793dffd30$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $39c3abb793dffd30$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $39c3abb793dffd30$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $39c3abb793dffd30$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$39c3abb793dffd30$export$b94ca9901c60634.has(provider)) {
        const opts = $39c3abb793dffd30$export$2321aea138b44780($39c3abb793dffd30$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $39c3abb793dffd30$export$c9d44e5bea4509be.bind($39c3abb793dffd30$export$6db089fe7b26f5b6, provider);
        let unmount = $39c3abb793dffd30$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$39c3abb793dffd30$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $39c3abb793dffd30$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$39c3abb793dffd30$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($39c3abb793dffd30$export$6db089fe7b26f5b6, $39c3abb793dffd30$var$revalidateAllKeys.bind($39c3abb793dffd30$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $39c3abb793dffd30$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($39c3abb793dffd30$export$6db089fe7b26f5b6, $39c3abb793dffd30$var$revalidateAllKeys.bind($39c3abb793dffd30$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $39c3abb793dffd30$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $39c3abb793dffd30$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $39c3abb793dffd30$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $39c3abb793dffd30$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$39c3abb793dffd30$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $39c3abb793dffd30$export$398604a469f7de9a = (currentData, newData)=>$39c3abb793dffd30$export$e9a4e06c7dfb0bd4(currentData) == $39c3abb793dffd30$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$39c3abb793dffd30$export$69a3209f1a06c04d, $39c3abb793dffd30$export$57e795267c26e600] = $39c3abb793dffd30$export$4008f5b66f9e0b3c(new Map());
// Default config
const $39c3abb793dffd30$export$f84bd70098573c5c = $39c3abb793dffd30$export$2321aea138b44780({
    // events
    onLoadingSlow: $39c3abb793dffd30$export$8793edee2d425525,
    onSuccess: $39c3abb793dffd30$export$8793edee2d425525,
    onError: $39c3abb793dffd30$export$8793edee2d425525,
    onErrorRetry: $39c3abb793dffd30$var$onErrorRetry,
    onDiscarded: $39c3abb793dffd30$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $39c3abb793dffd30$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $39c3abb793dffd30$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $39c3abb793dffd30$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $39c3abb793dffd30$export$69a3209f1a06c04d,
    mutate: $39c3abb793dffd30$export$57e795267c26e600,
    fallback: {}
}, $39c3abb793dffd30$export$f5ab8217e0edff04);
const $39c3abb793dffd30$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $39c3abb793dffd30$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $39c3abb793dffd30$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $39c3abb793dffd30$var$SWRConfigContext = (0, $8tsvq.createContext)({});
const $39c3abb793dffd30$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $8tsvq.useContext)($39c3abb793dffd30$var$SWRConfigContext);
    const isFunctionalConfig = $39c3abb793dffd30$export$f6e2535fb5126e54(value);
    const config = (0, $8tsvq.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $8tsvq.useMemo)(()=>isFunctionalConfig ? config : $39c3abb793dffd30$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $8tsvq.useRef)($39c3abb793dffd30$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $39c3abb793dffd30$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $39c3abb793dffd30$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $39c3abb793dffd30$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $8tsvq.createElement)($39c3abb793dffd30$var$SWRConfigContext.Provider, $39c3abb793dffd30$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $39c3abb793dffd30$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $39c3abb793dffd30$var$enableDevtools = $39c3abb793dffd30$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $39c3abb793dffd30$var$use = $39c3abb793dffd30$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $39c3abb793dffd30$var$setupDevTools = ()=>{
    if ($39c3abb793dffd30$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq)));
};
const $39c3abb793dffd30$export$a3295358bff77e = (args)=>{
    return $39c3abb793dffd30$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $39c3abb793dffd30$export$f1dc0e282d4c1c0 = ()=>{
    return $39c3abb793dffd30$export$2321aea138b44780($39c3abb793dffd30$export$f84bd70098573c5c, (0, $8tsvq.useContext)($39c3abb793dffd30$var$SWRConfigContext));
};
const $39c3abb793dffd30$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $39c3abb793dffd30$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $39c3abb793dffd30$export$b94ca9901c60634.get($39c3abb793dffd30$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $39c3abb793dffd30$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $39c3abb793dffd30$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $39c3abb793dffd30$export$b94ca9901c60634.get($39c3abb793dffd30$export$69a3209f1a06c04d);
            if (key.startsWith($39c3abb793dffd30$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($39c3abb793dffd30$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $39c3abb793dffd30$var$BUILT_IN_MIDDLEWARE = $39c3abb793dffd30$var$use.concat($39c3abb793dffd30$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $39c3abb793dffd30$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $39c3abb793dffd30$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $39c3abb793dffd30$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $39c3abb793dffd30$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($39c3abb793dffd30$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $39c3abb793dffd30$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $39c3abb793dffd30$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $39c3abb793dffd30$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$39c3abb793dffd30$var$setupDevTools();


const $79855d690348307f$export$dbab534a48e651ef = (key)=>(0, $39c3abb793dffd30$export$dfdc1655ccc5b9cb)(key)[0];
/// <reference types="react/experimental" />
const $79855d690348307f$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $79855d690348307f$var$WITH_DEDUPE = {
    dedupe: true
};
const $79855d690348307f$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $39c3abb793dffd30$export$b94ca9901c60634).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $39c3abb793dffd30$export$dfdc1655ccc5b9cb)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $8tsvq.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $8tsvq.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $8tsvq.useRef)(key);
    const fetcherRef = (0, $8tsvq.useRef)(fetcher);
    const configRef = (0, $8tsvq.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $39c3abb793dffd30$export$1251d51d9c571b45)(cache, key);
    const stateDependencies = (0, $8tsvq.useRef)({}).current;
    const fallback = (0, $39c3abb793dffd30$export$fce6876652108ab)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $39c3abb793dffd30$export$fce6876652108ab)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $8tsvq.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $39c3abb793dffd30$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $39c3abb793dffd30$export$fce6876652108ab)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $39c3abb793dffd30$export$2321aea138b44780)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $12eb31a89aea031d$exports.useSyncExternalStore)((0, $8tsvq.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $39c3abb793dffd30$export$fce6876652108ab)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $8tsvq.useRef)(data);
    const returnedData = keepPreviousData ? (0, $39c3abb793dffd30$export$fce6876652108ab)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $39c3abb793dffd30$export$fce6876652108ab)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $39c3abb793dffd30$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $39c3abb793dffd30$export$fce6876652108ab)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $39c3abb793dffd30$export$fce6876652108ab)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $39c3abb793dffd30$export$fce6876652108ab)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $39c3abb793dffd30$export$fce6876652108ab)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $8tsvq.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $39c3abb793dffd30$export$ddb64fe6466374f7) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $39c3abb793dffd30$export$fce6876652108ab)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $39c3abb793dffd30$export$fce6876652108ab)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $39c3abb793dffd30$export$3c95c4c8b671ef0)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $39c3abb793dffd30$export$6db089fe7b26f5b6);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $39c3abb793dffd30$export$fce6876652108ab)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $39c3abb793dffd30$export$f6e2535fb5126e54)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $39c3abb793dffd30$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $8tsvq.useCallback)((...args)=>{
        return (0, $39c3abb793dffd30$export$c9d44e5bea4509be)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $39c3abb793dffd30$export$700979bc83e7db82)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $39c3abb793dffd30$export$fce6876652108ab)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $39c3abb793dffd30$export$700979bc83e7db82)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $39c3abb793dffd30$export$6db089fe7b26f5b6), $79855d690348307f$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $39c3abb793dffd30$export$10213d6aa5ce32e6).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $39c3abb793dffd30$export$10213d6aa5ce32e6).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $39c3abb793dffd30$export$10213d6aa5ce32e6).MUTATE_EVENT) return revalidate();
            else if (type == (0, $39c3abb793dffd30$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $39c3abb793dffd30$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $39c3abb793dffd30$export$fce6876652108ab)(data) || (0, $39c3abb793dffd30$export$d2f4d8e74279c212)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $39c3abb793dffd30$export$eba6076d3d7d0c06)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $39c3abb793dffd30$export$700979bc83e7db82)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $39c3abb793dffd30$export$f6e2535fb5126e54)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($79855d690348307f$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $8tsvq.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $39c3abb793dffd30$export$fce6876652108ab)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $39c3abb793dffd30$export$ddb64fe6466374f7) && (0, $39c3abb793dffd30$export$d2f4d8e74279c212)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $39c3abb793dffd30$export$fce6876652108ab)(req)) {
            const promise = boundMutate(req);
            $79855d690348307f$var$use(promise);
        }
        if ((0, $39c3abb793dffd30$export$fce6876652108ab)(error)) {
            const promise = revalidate($79855d690348307f$var$WITH_DEDUPE);
            if (!(0, $39c3abb793dffd30$export$fce6876652108ab)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $79855d690348307f$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $79855d690348307f$export$4c7bbecdacc3ca2c = (0, $39c3abb793dffd30$export$8b8a958a7f6f130c).defineProperty((0, $39c3abb793dffd30$export$4c7bbecdacc3ca2c), "defaultValue", {
    value: (0, $39c3abb793dffd30$export$f84bd70098573c5c)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $79855d690348307f$export$2e2bcd8739ae039 = (0, $39c3abb793dffd30$export$84d44e54e14b0133)($79855d690348307f$var$useSWRHandler);



var $8tsvq = parcelRequire("8tsvq");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $f018542cedf583c1$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $f018542cedf583c1$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var $f018542cedf583c1$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $f018542cedf583c1$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $f018542cedf583c1$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


function $289faae71d0b9c7d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $289faae71d0b9c7d$export$2e2bcd8739ae039 = $289faae71d0b9c7d$var$stylis_min;


var $1e1e1b885f6c348f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $1e1e1b885f6c348f$export$2e2bcd8739ae039 = $1e1e1b885f6c348f$var$weakMemoize;


// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $a276211492fd575f$var$delimiter = "/*|*/";
var $a276211492fd575f$var$needle = $a276211492fd575f$var$delimiter + "}";
function $a276211492fd575f$var$toSheet(block) {
    if (block) $a276211492fd575f$var$Sheet.current.insert(block + "}");
}
var $a276211492fd575f$var$Sheet = {
    current: null
};
var $a276211492fd575f$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $a276211492fd575f$var$Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $a276211492fd575f$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $a276211492fd575f$var$Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? $a276211492fd575f$var$delimiter : "");
            }
        case -2:
            content.split($a276211492fd575f$var$needle).forEach($a276211492fd575f$var$toSheet);
    }
};
var $a276211492fd575f$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $289faae71d0b9c7d$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($a276211492fd575f$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $a276211492fd575f$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $f018542cedf583c1$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $a276211492fd575f$export$2e2bcd8739ae039 = $a276211492fd575f$var$createCache;


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $fd60843e7f34d2f0$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $fd60843e7f34d2f0$export$2e2bcd8739ae039 = $fd60843e7f34d2f0$var$murmur2;


var $42b8ea70a8bab97a$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $42b8ea70a8bab97a$export$2e2bcd8739ae039 = $42b8ea70a8bab97a$var$unitlessKeys;


function $26c34b7a9787700e$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $26c34b7a9787700e$export$2e2bcd8739ae039 = $26c34b7a9787700e$var$memoize;


var $f967aabe7c900f32$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $f967aabe7c900f32$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $f967aabe7c900f32$var$hyphenateRegex = /[A-Z]|^ms/g;
var $f967aabe7c900f32$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $f967aabe7c900f32$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $f967aabe7c900f32$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $f967aabe7c900f32$var$processStyleName = (0, $26c34b7a9787700e$export$2e2bcd8739ae039)(function(styleName) {
    return $f967aabe7c900f32$var$isCustomProperty(styleName) ? styleName : styleName.replace($f967aabe7c900f32$var$hyphenateRegex, "-$&").toLowerCase();
});
var $f967aabe7c900f32$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($f967aabe7c900f32$var$animationRegex, function(match, p1, p2) {
                $f967aabe7c900f32$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $f967aabe7c900f32$var$cursor
                };
                return p1;
            });
    }
    if ((0, $42b8ea70a8bab97a$export$2e2bcd8739ae039)[key] !== 1 && !$f967aabe7c900f32$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $f967aabe7c900f32$var$contentValuePattern, $f967aabe7c900f32$var$contentValues, $f967aabe7c900f32$var$oldProcessStyleValue, $f967aabe7c900f32$var$msPattern, $f967aabe7c900f32$var$hyphenPattern, $f967aabe7c900f32$var$hyphenatedCache;
var $f967aabe7c900f32$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $f967aabe7c900f32$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $f967aabe7c900f32$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $f967aabe7c900f32$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $f967aabe7c900f32$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $f967aabe7c900f32$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $f967aabe7c900f32$var$cursor;
                var result = interpolation(mergedProps);
                $f967aabe7c900f32$var$cursor = previousCursor;
                return $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $f967aabe7c900f32$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($f967aabe7c900f32$var$isProcessableValue(value)) string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + $f967aabe7c900f32$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($f967aabe7c900f32$var$isProcessableValue(value[_i])) string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + $f967aabe7c900f32$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $f967aabe7c900f32$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $f967aabe7c900f32$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $f967aabe7c900f32$var$cursor;
var $f967aabe7c900f32$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $f967aabe7c900f32$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $f967aabe7c900f32$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $f967aabe7c900f32$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $fd60843e7f34d2f0$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $f967aabe7c900f32$var$cursor
    };
};


var $f97744e9554218f8$var$isBrowser = true;
function $f97744e9554218f8$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $f97744e9554218f8$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $f97744e9554218f8$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $3502267f5140feae$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $3502267f5140feae$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $f97744e9554218f8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3502267f5140feae$var$createEmotion = function createEmotion(options) {
    var cache = (0, $a276211492fd575f$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $f97744e9554218f8$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $3502267f5140feae$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered);
        $3502267f5140feae$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $3502267f5140feae$var$merge(cache.registered, css, $3502267f5140feae$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $f97744e9554218f8$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $3502267f5140feae$var$merge.bind(null, cache.registered, css)
    };
};
var $3502267f5140feae$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
var $3502267f5140feae$export$2e2bcd8739ae039 = $3502267f5140feae$var$createEmotion;


var $ee90a39a48e5fa92$var$_createEmotion = (0, $3502267f5140feae$export$2e2bcd8739ae039)(), $ee90a39a48e5fa92$export$4909b86c8034bf73 = $ee90a39a48e5fa92$var$_createEmotion.flush, $ee90a39a48e5fa92$export$fa8d919ba61d84db = $ee90a39a48e5fa92$var$_createEmotion.hydrate, $ee90a39a48e5fa92$export$a274e22fb40f762e = $ee90a39a48e5fa92$var$_createEmotion.cx, $ee90a39a48e5fa92$export$4950aa0f605343fb = $ee90a39a48e5fa92$var$_createEmotion.merge, $ee90a39a48e5fa92$export$95d99596f328fd52 = $ee90a39a48e5fa92$var$_createEmotion.getRegisteredStyles, $ee90a39a48e5fa92$export$efb9f5caaa2ca0c7 = $ee90a39a48e5fa92$var$_createEmotion.injectGlobal, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e = $ee90a39a48e5fa92$var$_createEmotion.keyframes, $ee90a39a48e5fa92$export$dbf350e5966cf602 = $ee90a39a48e5fa92$var$_createEmotion.css, $ee90a39a48e5fa92$export$995990c5c04c46f0 = $ee90a39a48e5fa92$var$_createEmotion.sheet, $ee90a39a48e5fa92$export$69a3209f1a06c04d = $ee90a39a48e5fa92$var$_createEmotion.cache;



var $8tsvq = parcelRequire("8tsvq");
var $3a460728537dec08$exports = {};
Object.defineProperty($3a460728537dec08$exports, "__esModule", {
    value: true
});
$3a460728537dec08$exports = {
    "contentWidthDefault": "1280px",
    "contentWidthText": "768px",
    "contentWidthFull": "100%",
    "spacing2Xs": "0.25rem",
    "spacingXs": "0.5rem",
    "spacingS": "0.75rem",
    "spacingM": "1rem",
    "spacingL": "1.5rem",
    "spacingXl": "2rem",
    "spacing2Xl": "3rem",
    "spacing3Xl": "4rem",
    "spacing4Xl": "5rem",
    "zIndexNegative": -1,
    "zIndexWorkbench": 0,
    "zIndexDefault": 1,
    "zIndexWorkbenchHeader": 10,
    "zIndexModal": 100,
    "zIndexModalContent": 101,
    "zIndexDropdown": 1000,
    "zIndexTooltip": 10000,
    "zIndexNotification": 100000,
    "borderRadiusSmall": "4px",
    "borderRadiusMedium": "6px",
    "colorBlack": "#0C141C",
    "colorBlueLightest": "#E8F5FF",
    "colorBlueLight": "#98CBFF",
    "colorBlueMid": "#036FE3",
    "colorBlueBase": "#0059C8",
    "colorBlueDark": "#0041AB",
    "blue100": "#E8F5FF",
    "blue200": "#CEECFF",
    "blue300": "#98CBFF",
    "blue400": "#40A0FF",
    "blue500": "#036FE3",
    "blue600": "#0059C8",
    "blue700": "#0041AB",
    "blue800": "#003298",
    "blue900": "#002A8E",
    "colorContrastDark": "#0C141C",
    "colorContrastMid": "#111B2B",
    "colorContrastLight": "#1B273A",
    "colorCoralDark": "#FFE0E0",
    "colorCoralMid": "#FFF2F2",
    "colorElementDarkest": "#67728A",
    "colorElementDark": "#AEC1CC",
    "colorElementMid": "#CFD9E0",
    "colorElementLight": "#E7EBEE",
    "colorElementLightest": "#F7F9FA",
    "gray100": "#F7F9FA",
    "gray200": "#E7EBEE",
    "gray300": "#CFD9E0",
    "gray400": "#AEC1CC",
    "gray500": "#67728A",
    "gray600": "#5A657C",
    "gray700": "#414D63",
    "gray800": "#1B273A",
    "gray900": "#111B2B",
    "colorGreenDark": "#00550C",
    "colorGreenBase": "#006D23",
    "colorGreenMid": "#008539",
    "colorGreenLight": "#9ED696",
    "colorGreenLightest": "#EAF9E8",
    "green100": "#EAF9E8",
    "green200": "#CDF3C6",
    "green300": "#9ED696",
    "green400": "#5DB057",
    "green500": "#008539",
    "green600": "#006D23",
    "green700": "#00550C",
    "green800": "#004700",
    "green900": "#003F00",
    "colorIceDark": "#CEECFF",
    "colorIceMid": "#E8F5FF",
    "colorMintDark": "#CDF3C6",
    "colorMintMid": "#EAF9E8",
    "colorOrangeDark": "#B12D00",
    "colorOrangeBase": "#CC4500",
    "colorOrangeMid": "#F07F23",
    "colorOrangeLight": "#FDE5C0",
    "colorOrangeLightest": "#FFF2E4",
    "orange100": "#FFF2E4",
    "orange200": "#FDE5C0",
    "orange300": "#FDB882",
    "orange400": "#F07F23",
    "orange500": "#CC4500",
    "orange600": "#B12D00",
    "orange700": "#892300",
    "orange800": "#731A00",
    "orange900": "#631C00",
    "colorPeachDark": "#FDE5C0",
    "colorPeachMid": "#FFF2E4",
    "colorPurpleDark": "#5127B5",
    "colorPurpleBase": "#6C3ECF",
    "colorPurpleMid": "#8553E7",
    "colorPurpleLight": "#D1BBFF",
    "colorPurpleLightest": "#F7F2FF",
    "purple100": "#F7F2FF",
    "purple200": "#EDE3FF",
    "purple300": "#D1BBFF",
    "purple400": "#AE89FF",
    "purple500": "#8553E7",
    "purple600": "#6C3ECF",
    "purple700": "#5127B5",
    "purple800": "#3E16A4",
    "purple900": "#340E9C",
    "colorRedDark": "#990017",
    "colorRedBase": "#BD002A",
    "colorRedMid": "#DA294A",
    "colorRedLight": "#FFB1B2",
    "colorRedLightest": "#FFF2F2",
    "red100": "#FFF2F2",
    "red200": "#FFE0E0",
    "red300": "#FFB1B2",
    "red400": "#FF707D",
    "red500": "#DA294A",
    "red600": "#BD002A",
    "red700": "#990017",
    "red800": "#7F0010",
    "red900": "#72000E",
    "colorPrimary": "#0059C8",
    "colorPositive": "#006D23",
    "colorNegative": "#BD002A",
    "colorWarning": "#CC4500",
    "colorTextDark": "#111B2B",
    "colorTextBase": "#1B273A",
    "colorTextMid": "#414D63",
    "colorTextLight": "#5A657C",
    "colorTextLightest": "#67728A",
    "colorWhite": "#ffffff",
    "colorYellowDark": "#956300",
    "colorYellowBase": "#EAAF09",
    "colorYellowMid": "#FFC835",
    "colorYellowLight": "#FFD960",
    "colorYellowLightest": "#FFF6CC",
    "yellow100": "#FEF9DF",
    "yellow200": "#FFF6CC",
    "yellow300": "#FFE993",
    "yellow400": "#FFD960",
    "yellow500": "#FFC835",
    "yellow600": "#EAAF09",
    "yellow700": "#B78300",
    "yellow800": "#956300",
    "yellow900": "#7F5200",
    "boxShadowPositive": "0px 1px 0px rgb(25, 37, 50, 0.1)",
    "boxShadowDefault": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px 3px 7px -3px rgba(25, 37, 50, 0.1), 0px 6px 12px -2px rgba(25, 37, 50, 0.1);",
    "boxShadowHeavy": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px -6px 16px -6px rgba(25, 37, 50, 0.03), 0px 8px 16px -8px rgba(25, 37, 50, 0.2), 0px 13px 27px -5px rgba(25, 37, 50, 0.15);",
    "insetBoxShadowDefault": "inset 0px 2px 0px rgba(225, 228, 232, 0.2);",
    "glowPrimary": "0px 0px 0px 3px #98CBFF",
    "glowNegative": "0px 0px 0px 3px #FFB1B2",
    "glowPositive": "0px 0px 0px 3px #9ED696",
    "glowWarning": "0px 0px 0px 3px #FDE5C0",
    "glowMuted": "0px 0px 0px 3px #E7EBEE",
    "transitionDurationShort": "0.1s",
    "transitionDurationDefault": "0.2s",
    "transitionDurationLong": "0.3s",
    "transitionEasingDefault": "ease-in-out",
    "transitionEasingCubicBezier": "cubic-bezier(0.13, 0.62, 0.11, 0.99)",
    "fontBaseDefault": "16",
    "fontSize4Xl": "3rem",
    "fontSize3Xl": "2.25rem",
    "fontSize2Xl": "1.5rem",
    "fontSizeXl": "1.25rem",
    "fontSizeXlHigh": "1.125rem",
    "fontSizeL": "1rem",
    "fontSizeLHigh": "0.875rem",
    "fontSizeM": "0.875rem",
    "fontSizeMHigh": "0.75rem",
    "fontSizeS": "0.75rem",
    "fontSizeSHigh": "0.625rem",
    "fontStackPrimary": "-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "fontStackMonospace": "SFMono-Regular, Consolas, Liberation Mono, Menlo,monospace",
    "fontWeightNormal": 400,
    "fontWeightMedium": 500,
    "fontWeightDemiBold": 600,
    "letterSpacingDefault": "0rem",
    "letterSpacingWide": "0.1rem",
    "lineHeightDefault": "1.5",
    "lineHeightCondensed": "1.25",
    "lineHeight4Xl": "3.5rem",
    "lineHeight3Xl": "3rem",
    "lineHeight2Xl": "2.25rem",
    "lineHeightXl": "2rem",
    "lineHeightXlHigh": "1.5rem",
    "lineHeightL": "1.5rem",
    "lineHeightLHigh": "1.25rem",
    "lineHeightM": "1.25rem",
    "lineHeightMHigh": "1rem",
    "lineHeightS": "1rem",
    "lineHeightSHigh": "0.75rem"
};



var $8tsvq = parcelRequire("8tsvq");
function $0a621ebff2a8df04$export$2e2bcd8739ae039(t, e) {
    return $0a621ebff2a8df04$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0a621ebff2a8df04$export$2e2bcd8739ae039(t, e);
}


function $c96d5d7e938979f8$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0a621ebff2a8df04$export$2e2bcd8739ae039)(t, o);
}



var $8tsvq = parcelRequire("8tsvq");

var $ab21cee4932cfbed$exports = {};
var $100fb742cc9e90fa$exports = {};
function $100fb742cc9e90fa$var$_setPrototypeOf(t, e) {
    return $100fb742cc9e90fa$exports = $100fb742cc9e90fa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $100fb742cc9e90fa$exports.__esModule = true, $100fb742cc9e90fa$exports["default"] = $100fb742cc9e90fa$exports, $100fb742cc9e90fa$var$_setPrototypeOf(t, e);
}
$100fb742cc9e90fa$exports = $100fb742cc9e90fa$var$_setPrototypeOf, $100fb742cc9e90fa$exports.__esModule = true, $100fb742cc9e90fa$exports["default"] = $100fb742cc9e90fa$exports;


function $ab21cee4932cfbed$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $100fb742cc9e90fa$exports(t, o);
}
$ab21cee4932cfbed$exports = $ab21cee4932cfbed$var$_inheritsLoose, $ab21cee4932cfbed$exports.__esModule = true, $ab21cee4932cfbed$exports["default"] = $ab21cee4932cfbed$exports;



var $8tsvq = parcelRequire("8tsvq");



var $4e21f7e4fe8f58d3$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $4e21f7e4fe8f58d3$var$EmotionCacheContext = /*#__PURE__*/ (0, $8tsvq.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? (0, $a276211492fd575f$export$2e2bcd8739ae039)() : null);
var $4e21f7e4fe8f58d3$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $8tsvq.createContext)({});
var $4e21f7e4fe8f58d3$export$e7094788287c5e9b = $4e21f7e4fe8f58d3$var$EmotionCacheContext.Provider;
var $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $8tsvq.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $4e21f7e4fe8f58d3$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $4e21f7e4fe8f58d3$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $4e21f7e4fe8f58d3$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $4e21f7e4fe8f58d3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4e21f7e4fe8f58d3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4e21f7e4fe8f58d3$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $4e21f7e4fe8f58d3$var$Noop = function Noop() {
    return null;
};
var $4e21f7e4fe8f58d3$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$4e21f7e4fe8f58d3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $f97744e9554218f8$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(registeredStyles);
    var labelFromStack;
    var rules = (0, $f97744e9554218f8$export$6f077d94b33a01aa)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4e21f7e4fe8f58d3$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $4e21f7e4fe8f58d3$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $8tsvq.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$var$Noop, null);
    return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $8tsvq.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $4e21f7e4fe8f58d3$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === "function") return /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $4e21f7e4fe8f58d3$var$render(cache, props, theme, ref);
    });
    return $4e21f7e4fe8f58d3$var$render(cache, props, null, ref);
});






function $7c908f8c65e1ea2a$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $f967aabe7c900f32$export$6321afa313b251b5)(args);
}
var $7c908f8c65e1ea2a$export$2e2bcd8739ae039 = $7c908f8c65e1ea2a$var$css;


var $b7d8f67c6c41081e$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $4e21f7e4fe8f58d3$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return (0, $8tsvq.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4e21f7e4fe8f58d3$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4e21f7e4fe8f58d3$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $8tsvq.createElement).apply(null, createElementArgArray);
};
var $b7d8f67c6c41081e$var$warnedAboutCssPropForGlobal = false;
var $b7d8f67c6c41081e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === "function") return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $4e21f7e4fe8f58d3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)([
        styles
    ]);
    return /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b7d8f67c6c41081e$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $c96d5d7e938979f8$export$2e2bcd8739ae039)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $f018542cedf583c1$export$9d753cd7ae895cce)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + '="' + this.props.serialized.name + '"]');
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $f97744e9554218f8$export$6f077d94b33a01aa)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $8tsvq.Component));
var $b7d8f67c6c41081e$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $b7d8f67c6c41081e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $b7d8f67c6c41081e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $f97744e9554218f8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b7d8f67c6c41081e$var$Noop = function Noop() {
    return null;
};
var $b7d8f67c6c41081e$export$9b9c0f9d9f3552b8 = (0, $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b)(function(props, context) {
    return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $4e21f7e4fe8f58d3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, context.registered);
            (0, $f97744e9554218f8$export$6f077d94b33a01aa)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $b7d8f67c6c41081e$var$merge(context.registered, css, $b7d8f67c6c41081e$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$Noop, null);
        return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $8tsvq.Fragment), null, possiblyStyleElement, ele);
    });
});




var $7c1d3a8c755aa15d$var$me = Object.defineProperty, $7c1d3a8c755aa15d$var$ce = Object.defineProperties;
var $7c1d3a8c755aa15d$var$de = Object.getOwnPropertyDescriptors;
var $7c1d3a8c755aa15d$var$A = Object.getOwnPropertySymbols;
var $7c1d3a8c755aa15d$var$v = Object.prototype.hasOwnProperty, $7c1d3a8c755aa15d$var$j = Object.prototype.propertyIsEnumerable;
var $7c1d3a8c755aa15d$var$X = (e, t, o)=>t in e ? $7c1d3a8c755aa15d$var$me(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : e[t] = o, $7c1d3a8c755aa15d$var$i = (e, t)=>{
    for(var o in t || (t = {}))$7c1d3a8c755aa15d$var$v.call(t, o) && $7c1d3a8c755aa15d$var$X(e, o, t[o]);
    if ($7c1d3a8c755aa15d$var$A) for (var o of $7c1d3a8c755aa15d$var$A(t))$7c1d3a8c755aa15d$var$j.call(t, o) && $7c1d3a8c755aa15d$var$X(e, o, t[o]);
    return e;
}, $7c1d3a8c755aa15d$var$p = (e, t)=>$7c1d3a8c755aa15d$var$ce(e, $7c1d3a8c755aa15d$var$de(t));
var $7c1d3a8c755aa15d$var$c = (e, t)=>{
    var o = {};
    for(var r in e)$7c1d3a8c755aa15d$var$v.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
    if (e != null && $7c1d3a8c755aa15d$var$A) for (var r of $7c1d3a8c755aa15d$var$A(e))t.indexOf(r) < 0 && $7c1d3a8c755aa15d$var$j.call(e, r) && (o[r] = e[r]);
    return o;
};
var $7c1d3a8c755aa15d$var$ye = (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039)`
  /* Remove default margin */
  /* Button has default margin in some browsers, like safari */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd,
  button {
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }

  /* Set core root defaults */
  html:focus-within {
    scroll-behavior: smooth;
  }

  /* Set core body defaults */
  body {
    text-rendering: optimizeSpeed;
    line-height: 1.5;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`, $7c1d3a8c755aa15d$export$c507fb1c2e1ac13a = ({ withNormalize: e = !0, styles: t })=>$8tsvq.createElement((0, $b7d8f67c6c41081e$export$98f03c5d19621d70), {
        styles: (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039)`
        ${e ? $7c1d3a8c755aa15d$var$ye : void 0};
        html {
          border: 0;
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          color: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray800};
          font-family: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontStackPrimary};
          font-size: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontSizeM};
          line-height: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).lineHeightM};
        }

        code {
          font-family: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontStackMonospace};
        }

        fieldset {
          border: 0;
          margin: 0;
          padding: 0;
        }

        *,
        *::after,
        *::before {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
          box-sizing: inherit;
        }

        ${t};
      `
    });
var $7c1d3a8c755aa15d$var$ge = {
    none: 0,
    spacing2Xs: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing2Xs,
    spacingXs: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingXs,
    spacingS: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingS,
    spacingM: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingM,
    spacingL: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingL,
    spacingXl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingXl,
    spacing2Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing2Xl,
    spacing3Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing3Xl,
    spacing4Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing4Xl
};
function $7c1d3a8c755aa15d$var$m(e) {
    return $7c1d3a8c755aa15d$var$ge[e];
}
function $7c1d3a8c755aa15d$var$H(e) {
    return Object.assign({}, e.margin ? {
        margin: $7c1d3a8c755aa15d$var$m(e.margin)
    } : null, e.marginLeft ? {
        marginLeft: $7c1d3a8c755aa15d$var$m(e.marginLeft)
    } : null, e.marginRight ? {
        marginRight: $7c1d3a8c755aa15d$var$m(e.marginRight)
    } : null, e.marginTop ? {
        marginTop: $7c1d3a8c755aa15d$var$m(e.marginTop)
    } : null, e.marginBottom ? {
        marginBottom: $7c1d3a8c755aa15d$var$m(e.marginBottom)
    } : null, e.padding ? {
        padding: $7c1d3a8c755aa15d$var$m(e.padding)
    } : null, e.paddingLeft ? {
        paddingLeft: $7c1d3a8c755aa15d$var$m(e.paddingLeft)
    } : null, e.paddingRight ? {
        paddingRight: $7c1d3a8c755aa15d$var$m(e.paddingRight)
    } : null, e.paddingTop ? {
        paddingTop: $7c1d3a8c755aa15d$var$m(e.paddingTop)
    } : null, e.paddingBottom ? {
        paddingBottom: $7c1d3a8c755aa15d$var$m(e.paddingBottom)
    } : null);
}
var $7c1d3a8c755aa15d$var$ue = "div";
function $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(e) {
    let E = e, { display: t, className: o, margin: r, marginBottom: a, marginLeft: s, marginRight: n, marginTop: l, padding: d, paddingBottom: f, paddingLeft: y, paddingRight: x, paddingTop: u, testId: R, as: h = $7c1d3a8c755aa15d$var$ue } = E, T = $7c1d3a8c755aa15d$var$c(E, [
        "display",
        "className",
        "margin",
        "marginBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "padding",
        "paddingBottom",
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "testId",
        "as"
    ]);
    return {
        boxProps: $7c1d3a8c755aa15d$var$i({
            className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
                display: t
            }), (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)($7c1d3a8c755aa15d$var$i({}, $7c1d3a8c755aa15d$var$H({
                margin: r,
                marginBottom: a,
                marginLeft: s,
                marginRight: n,
                marginTop: l,
                padding: d,
                paddingBottom: f,
                paddingLeft: y,
                paddingRight: x,
                paddingTop: u
            }))), o),
            "data-test-id": R
        }, T),
        Element: h
    };
}
function $7c1d3a8c755aa15d$var$K(e, t) {
    let { boxProps: o, Element: r } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(e);
    return $8tsvq.createElement(r, $7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, o), {
        ref: t
    }), e.children);
}
$7c1d3a8c755aa15d$var$K.displayName = "Box";
var $7c1d3a8c755aa15d$export$e71c4d32a2263218 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$K);
var $7c1d3a8c755aa15d$var$Ee = "div";
function $7c1d3a8c755aa15d$var$V(Ne, se) {
    var U = Ne, { isInline: e, alignItems: t, alignSelf: o, alignContent: r, flex: a, flexBasis: s, flexShrink: n, flexDirection: l, flexGrow: d, flexWrap: f, fullHeight: y, fullWidth: x, gap: u, justifyContent: R, justifyItems: h, justifySelf: T, order: b, children: E, as: I } = U, G = $7c1d3a8c755aa15d$var$c(U, [
        "isInline",
        "alignItems",
        "alignSelf",
        "alignContent",
        "flex",
        "flexBasis",
        "flexShrink",
        "flexDirection",
        "flexGrow",
        "flexWrap",
        "fullHeight",
        "fullWidth",
        "gap",
        "justifyContent",
        "justifyItems",
        "justifySelf",
        "order",
        "children",
        "as"
    ]);
    var N;
    let { boxProps: O, Element: le } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, G), {
        as: I || $7c1d3a8c755aa15d$var$Ee
    }));
    return $8tsvq.createElement(le, $7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, O), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: e ? "inline-flex" : "flex",
            width: x ? "100%" : void 0,
            height: y ? "100%" : void 0,
            flex: a,
            flexBasis: s,
            flexShrink: n,
            flexDirection: l,
            gap: u === "none" ? 0 : (N = (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports)))[u]) != null ? N : u,
            justifyContent: R,
            justifyItems: h,
            justifySelf: T,
            alignItems: t,
            alignSelf: o,
            alignContent: r,
            order: b,
            flexWrap: f,
            flexGrow: d
        }), O.className),
        ref: se
    }), E);
}
$7c1d3a8c755aa15d$var$V.displayName = "Flex";
var $7c1d3a8c755aa15d$export$f51f4c4ede09e011 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$V);
var $7c1d3a8c755aa15d$var$Ge = "div";
function $7c1d3a8c755aa15d$var$Q(u, x) {
    var R = u, { alignContent: e, children: t, columnGap: o = "spacingM", columns: r = "auto", flow: a, isInline: s, justifyContent: n, rowGap: l = "none", rows: d = "auto", as: f } = R, y = $7c1d3a8c755aa15d$var$c(R, [
        "alignContent",
        "children",
        "columnGap",
        "columns",
        "flow",
        "isInline",
        "justifyContent",
        "rowGap",
        "rows",
        "as"
    ]);
    var E, I;
    let h = (G)=>typeof G == "number" ? `repeat(${G}, minmax(0, 1fr))` : G, { boxProps: T, Element: b } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, y), {
        as: f || $7c1d3a8c755aa15d$var$Ge
    }));
    return $8tsvq.createElement(b, $7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, T), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: s ? "inline-grid" : "grid",
            gridTemplateColumns: h(r),
            gridTemplateRows: h(d),
            flow: a,
            justifyContent: n,
            alignContent: e,
            columnGap: (E = $7c1d3a8c755aa15d$var$m(o)) != null ? E : 0,
            rowGap: (I = $7c1d3a8c755aa15d$var$m(l)) != null ? I : 0
        }), T.className),
        ref: x
    }), t);
}
$7c1d3a8c755aa15d$var$Q.displayName = "Grid";
var $7c1d3a8c755aa15d$var$Y = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$Q);
function $7c1d3a8c755aa15d$var$Z(f, d) {
    var y = f, { children: e, columnStart: t, columnEnd: o, rowStart: r, rowEnd: a, area: s, order: n } = y, l = $7c1d3a8c755aa15d$var$c(y, [
        "children",
        "columnStart",
        "columnEnd",
        "rowStart",
        "rowEnd",
        "area",
        "order"
    ]);
    let x = s || [
        r || "auto",
        t || "auto",
        a || "auto",
        o || "auto"
    ].join(" / "), { boxProps: u, Element: R } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(l);
    return $8tsvq.createElement(R, $7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, u), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            gridArea: x,
            order: n
        }), u.className),
        ref: d
    }), e);
}
$7c1d3a8c755aa15d$var$Z.displayName = "GridItem";
var $7c1d3a8c755aa15d$export$9eb849b9b922d396 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$Z);
var $7c1d3a8c755aa15d$export$ef2184bd89960b14 = $7c1d3a8c755aa15d$var$Y;
$7c1d3a8c755aa15d$export$ef2184bd89960b14.Item = $7c1d3a8c755aa15d$export$9eb849b9b922d396;
var $7c1d3a8c755aa15d$var$Ie = "div";
function $7c1d3a8c755aa15d$var$ee(d, l) {
    var f = d, { flexDirection: e = "row", alignItems: t = "center", isInline: o = !1, spacing: r = "spacingM", children: a, as: s } = f, n = $7c1d3a8c755aa15d$var$c(f, [
        "flexDirection",
        "alignItems",
        "isInline",
        "spacing",
        "children",
        "as"
    ]);
    let { boxProps: y, Element: x } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, n), {
        as: s || $7c1d3a8c755aa15d$var$Ie
    }));
    return $8tsvq.createElement($7c1d3a8c755aa15d$export$f51f4c4ede09e011, $7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, y), {
        as: x,
        flexDirection: e,
        alignItems: t,
        isInline: o,
        className: y.className,
        gap: r,
        ref: l
    }), a);
}
$7c1d3a8c755aa15d$var$ee.displayName = "Stack";
var $7c1d3a8c755aa15d$export$694e0d28c7ffc90c = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$ee);
function $7c1d3a8c755aa15d$var$oe() {
    return {
        screenReaderOnly: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            border: 0
        })
    };
}
var $7c1d3a8c755aa15d$export$518e781dade4a416 = (s)=>{
    var n = s, { children: e, className: t, testId: o = "cf-ui-ScreenReaderOnly", as: r = "div" } = n, a = $7c1d3a8c755aa15d$var$c(n, [
        "children",
        "className",
        "testId",
        "as"
    ]);
    let l = $7c1d3a8c755aa15d$var$oe();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement(r, $7c1d3a8c755aa15d$var$p($7c1d3a8c755aa15d$var$i({}, a), {
        "data-test-id": o,
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)(l.screenReaderOnly, t)
    }), e);
};
function $7c1d3a8c755aa15d$export$f680877a34711e37(e, t) {
    return (0, $8tsvq.useMemo)(()=>e || [
            t || "id",
            Math.round(Math.random() * 1e4)
        ].join("_"), []);
}
function $7c1d3a8c755aa15d$export$6f32135080cb4c3({ isOpen: e, defaultIsOpen: t, onOpen: o, onClose: r }) {
    let [a, s] = (0, $8tsvq.useState)(t || !1), n = e !== void 0, l = n ? e : a, d = (0, $8tsvq.useCallback)(()=>{
        n || s(!1), r == null || r();
    }, [
        n,
        r
    ]), f = (0, $8tsvq.useCallback)(()=>{
        n || s(!0), o == null || o();
    }, [
        n,
        o
    ]);
    return {
        isOpen: l,
        isControlled: n,
        handleClose: d,
        handleOpen: f
    };
}
function $7c1d3a8c755aa15d$export$2312e6e6009df96({ onLoad: e } = {}) {
    let [t, o] = (0, $8tsvq.useState)(!1), r = (0, $8tsvq.useRef)(), a = (0, $8tsvq.useCallback)(()=>{
        e == null || e(), o(!0);
    }, [
        e
    ]);
    return (0, $8tsvq.useEffect)(()=>{
        r.current && r.current.complete && a();
    }, [
        a
    ]), {
        ref: r,
        loaded: t,
        onLoad: a
    };
}
function $7c1d3a8c755aa15d$export$c9058316764c140e(...e) {
    return (t)=>{
        e.forEach((o)=>{
            typeof o == "function" ? o(t) : o != null && (o.current = t);
        });
    };
}
var $7c1d3a8c755aa15d$export$125b56fdc77c3731 = ({ status: e })=>{
    switch(e){
        case "published":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorGreenBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorGreenLightest
            };
        case "changed":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorBlueBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorBlueLightest
            };
        case "deleted":
        case "archived":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorRedBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorRedLightest
            };
        case "draft":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorOrangeDark,
                backgroundColor: "#ffefd5"
            };
        case "new":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorWhite,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).blue500
            };
        default:
            return console.warn(`Unknown EntityStatus: ${e}`), {};
    }
};
 //# sourceMappingURL=out.js.map


var $6e6b089c3d63766c$var$N = Object.defineProperty, $6e6b089c3d63766c$var$T = Object.defineProperties;
var $6e6b089c3d63766c$var$v = Object.getOwnPropertyDescriptors;
var $6e6b089c3d63766c$var$m = Object.getOwnPropertySymbols;
var $6e6b089c3d63766c$var$c = Object.prototype.hasOwnProperty, $6e6b089c3d63766c$var$x = Object.prototype.propertyIsEnumerable;
var $6e6b089c3d63766c$var$f = (r, a, t)=>a in r ? $6e6b089c3d63766c$var$N(r, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[a] = t, $6e6b089c3d63766c$var$S = (r, a)=>{
    for(var t in a || (a = {}))$6e6b089c3d63766c$var$c.call(a, t) && $6e6b089c3d63766c$var$f(r, t, a[t]);
    if ($6e6b089c3d63766c$var$m) for (var t of $6e6b089c3d63766c$var$m(a))$6e6b089c3d63766c$var$x.call(a, t) && $6e6b089c3d63766c$var$f(r, t, a[t]);
    return r;
}, $6e6b089c3d63766c$var$d = (r, a)=>$6e6b089c3d63766c$var$T(r, $6e6b089c3d63766c$var$v(a));
var $6e6b089c3d63766c$var$g = (r, a)=>{
    var t = {};
    for(var n in r)$6e6b089c3d63766c$var$c.call(r, n) && a.indexOf(n) < 0 && (t[n] = r[n]);
    if (r != null && $6e6b089c3d63766c$var$m) for (var n of $6e6b089c3d63766c$var$m(r))a.indexOf(n) < 0 && $6e6b089c3d63766c$var$x.call(r, n) && (t[n] = r[n]);
    return t;
};
var $6e6b089c3d63766c$var$h = {
    large: "36px",
    medium: "20px",
    small: "14px"
}, $6e6b089c3d63766c$var$y = ()=>{
    let r = {
        scale1: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    6.666667% {
      transform: scale(1.5, 0.5);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1.5, 0.5);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        scale2: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    20% {
      transform: scale(1.5, 0.5);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    46.666667% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    73.333333% {
      transform: scale(1.5, 0.5);
    }
    80% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        scale3: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1.5, 0.5);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    80% {
      transform: scale(1, 1);
    }
    86.666667% {
      transform: scale(1.5, 0.5);
    }
    93.333333% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        translate1: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(10px, 33.528168px);
    }
    6.666667% {
      transform: translate(10px, 41.764084px);
    }
    13.333333% {
      transform: translate(10px, 33.528168px);
    }
    26.666667% {
      transform: translate(10px, -2.651608px);
    }
    33.333333% {
      transform: translate(10px, -4.471832px);
    }
    40% {
      transform: translate(10px, -2.651608px);
    }
    53.333333% {
      transform: translate(10px, 33.528168px);
    }
    60% {
      transform: translate(10px, 41.764084px);
    }
    66.666667% {
      transform: translate(10px, 33.528168px);
    }
    100% {
      transform: translate(10px, 33.528168px);
    }
  `,
        translate2: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(30px, 33.528168px);
    }
    13.333333% {
      transform: translate(30px, 33.528168px);
    }
    20% {
      transform: translate(30px, 41.764084px);
    }
    26.666667% {
      transform: translate(30px, 33.528168px);
    }
    40% {
      transform: translate(30px, -2.651608px);
    }
    46.666667% {
      transform: translate(30px, -4.471832px);
    }
    53.333333% {
      transform: translate(30px, -2.651608px);
    }
    66.666667% {
      transform: translate(30px, 33.528168px);
    }
    73.333333% {
      transform: translate(30px, 41.764084px);
    }
    80% {
      transform: translate(30px, 33.528168px);
    }
    100% {
      transform: translate(30px, 33.528168px);
    }
  `,
        translate3: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(50px, 33.528168px);
    }
    26.666667% {
      transform: translate(50px, 33.528168px);
    }
    33.333333% {
      transform: translate(50px, 41.764084px);
    }
    40% {
      transform: translate(50px, 33.528168px);
    }
    53.333333% {
      transform: translate(50px, -2.651608px);
    }
    60% {
      transform: translate(50px, -4.471832px);
    }
    66.666667% {
      transform: translate(50px, -2.651608px);
    }
    80% {
      transform: translate(50px, 33.528168px);
    }
    86.666667% {
      transform: translate(50px, 41.764084px);
    }
    93.333333% {
      transform: translate(50px, 33.528168px);
    }
    100% {
      transform: translate(50px, 33.528168px);
    }
  `
    };
    return {
        root: (a)=>(0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
                height: a.customSize ? `${a.customSize}px` : void 0,
                verticalAlign: "middle",
                width: a.customSize ? `${a.customSize}px` : $6e6b089c3d63766c$var$h[a.size]
            }),
        circle1Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale1} 1s linear infinite normal forwards;`
        }),
        circle2Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale2} 1s linear infinite normal forwards;`
        }),
        circle3Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale3} 1s linear infinite normal forwards;`
        }),
        circle1Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate1} 1s linear infinite normal forwards;`
        }),
        circle2Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate2} 1s linear infinite normal forwards;`
        }),
        circle3Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate3} 1s linear infinite normal forwards;`
        })
    };
};
var $6e6b089c3d63766c$var$L = "div", $6e6b089c3d63766c$var$I = {
    default: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray700,
    primary: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).blue500,
    white: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorWhite
}, $6e6b089c3d63766c$export$7f7cbe89f1eacd2 = (0, $8tsvq.forwardRef)((A, P)=>{
    var p = A, { className: r, customSize: a, size: t = "medium", variant: n = "default", testId: z = "cf-ui-spinner" } = p, w = $6e6b089c3d63766c$var$g(p, [
        "className",
        "customSize",
        "size",
        "variant",
        "testId"
    ]);
    let e = $6e6b089c3d63766c$var$y();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement((0, $7c1d3a8c755aa15d$export$e71c4d32a2263218), $6e6b089c3d63766c$var$d($6e6b089c3d63766c$var$S({
        as: $6e6b089c3d63766c$var$L,
        display: "inline-block"
    }, w), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)(e.root({
            size: t,
            customSize: a
        }), r),
        ref: P,
        testId: z
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("svg", {
        className: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: "block",
            fill: $6e6b089c3d63766c$var$I[n]
        }),
        viewBox: "0 0 60 51",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("title", null, "Loading\u2026"), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle1Translate,
        transform: "translate(10,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle1Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle2Translate,
        transform: "translate(30,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle2Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle3Translate,
        transform: "translate(50,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle3Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    })))));
});
$6e6b089c3d63766c$export$7f7cbe89f1eacd2.displayName = "Spinner";
 //# sourceMappingURL=out.js.map


"use strict";
function $5d219f656b13ee51$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $3267bbb6db0678de$exports = {};
// shim for using process in browser
var $3267bbb6db0678de$var$process = $3267bbb6db0678de$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3267bbb6db0678de$var$cachedSetTimeout;
var $3267bbb6db0678de$var$cachedClearTimeout;
function $3267bbb6db0678de$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3267bbb6db0678de$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3267bbb6db0678de$var$cachedSetTimeout = setTimeout;
        else $3267bbb6db0678de$var$cachedSetTimeout = $3267bbb6db0678de$var$defaultSetTimout;
    } catch (e) {
        $3267bbb6db0678de$var$cachedSetTimeout = $3267bbb6db0678de$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3267bbb6db0678de$var$cachedClearTimeout = clearTimeout;
        else $3267bbb6db0678de$var$cachedClearTimeout = $3267bbb6db0678de$var$defaultClearTimeout;
    } catch (e) {
        $3267bbb6db0678de$var$cachedClearTimeout = $3267bbb6db0678de$var$defaultClearTimeout;
    }
})();
function $3267bbb6db0678de$var$runTimeout(fun) {
    if ($3267bbb6db0678de$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3267bbb6db0678de$var$cachedSetTimeout === $3267bbb6db0678de$var$defaultSetTimout || !$3267bbb6db0678de$var$cachedSetTimeout) && setTimeout) {
        $3267bbb6db0678de$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3267bbb6db0678de$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3267bbb6db0678de$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3267bbb6db0678de$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3267bbb6db0678de$var$runClearTimeout(marker) {
    if ($3267bbb6db0678de$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3267bbb6db0678de$var$cachedClearTimeout === $3267bbb6db0678de$var$defaultClearTimeout || !$3267bbb6db0678de$var$cachedClearTimeout) && clearTimeout) {
        $3267bbb6db0678de$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3267bbb6db0678de$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3267bbb6db0678de$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3267bbb6db0678de$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3267bbb6db0678de$var$queue = [];
var $3267bbb6db0678de$var$draining = false;
var $3267bbb6db0678de$var$currentQueue;
var $3267bbb6db0678de$var$queueIndex = -1;
function $3267bbb6db0678de$var$cleanUpNextTick() {
    if (!$3267bbb6db0678de$var$draining || !$3267bbb6db0678de$var$currentQueue) return;
    $3267bbb6db0678de$var$draining = false;
    if ($3267bbb6db0678de$var$currentQueue.length) $3267bbb6db0678de$var$queue = $3267bbb6db0678de$var$currentQueue.concat($3267bbb6db0678de$var$queue);
    else $3267bbb6db0678de$var$queueIndex = -1;
    if ($3267bbb6db0678de$var$queue.length) $3267bbb6db0678de$var$drainQueue();
}
function $3267bbb6db0678de$var$drainQueue() {
    if ($3267bbb6db0678de$var$draining) return;
    var timeout = $3267bbb6db0678de$var$runTimeout($3267bbb6db0678de$var$cleanUpNextTick);
    $3267bbb6db0678de$var$draining = true;
    var len = $3267bbb6db0678de$var$queue.length;
    while(len){
        $3267bbb6db0678de$var$currentQueue = $3267bbb6db0678de$var$queue;
        $3267bbb6db0678de$var$queue = [];
        while(++$3267bbb6db0678de$var$queueIndex < len)if ($3267bbb6db0678de$var$currentQueue) $3267bbb6db0678de$var$currentQueue[$3267bbb6db0678de$var$queueIndex].run();
        $3267bbb6db0678de$var$queueIndex = -1;
        len = $3267bbb6db0678de$var$queue.length;
    }
    $3267bbb6db0678de$var$currentQueue = null;
    $3267bbb6db0678de$var$draining = false;
    $3267bbb6db0678de$var$runClearTimeout(timeout);
}
$3267bbb6db0678de$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3267bbb6db0678de$var$queue.push(new $3267bbb6db0678de$var$Item(fun, args));
    if ($3267bbb6db0678de$var$queue.length === 1 && !$3267bbb6db0678de$var$draining) $3267bbb6db0678de$var$runTimeout($3267bbb6db0678de$var$drainQueue);
};
// v8 likes predictible objects
function $3267bbb6db0678de$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3267bbb6db0678de$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3267bbb6db0678de$var$process.title = "browser";
$3267bbb6db0678de$var$process.browser = true;
$3267bbb6db0678de$var$process.env = {};
$3267bbb6db0678de$var$process.argv = [];
$3267bbb6db0678de$var$process.version = ""; // empty string to avoid regexp issues
$3267bbb6db0678de$var$process.versions = {};
function $3267bbb6db0678de$var$noop() {}
$3267bbb6db0678de$var$process.on = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.addListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.once = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.off = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.removeListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.removeAllListeners = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.emit = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.prependListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.prependOnceListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.listeners = function(name) {
    return [];
};
$3267bbb6db0678de$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3267bbb6db0678de$var$process.cwd = function() {
    return "/";
};
$3267bbb6db0678de$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3267bbb6db0678de$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $3b0e765f17086bfd$var$toString } = Object.prototype;
const { getPrototypeOf: $3b0e765f17086bfd$var$getPrototypeOf } = Object;
const $3b0e765f17086bfd$var$kindOf = ((cache)=>(thing)=>{
        const str = $3b0e765f17086bfd$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $3b0e765f17086bfd$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$3b0e765f17086bfd$var$kindOf(thing) === type;
};
const $3b0e765f17086bfd$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $3b0e765f17086bfd$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $3b0e765f17086bfd$var$isUndefined = $3b0e765f17086bfd$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $3b0e765f17086bfd$var$isBuffer(val) {
    return val !== null && !$3b0e765f17086bfd$var$isUndefined(val) && val.constructor !== null && !$3b0e765f17086bfd$var$isUndefined(val.constructor) && $3b0e765f17086bfd$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $3b0e765f17086bfd$var$isArrayBuffer = $3b0e765f17086bfd$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $3b0e765f17086bfd$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $3b0e765f17086bfd$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $3b0e765f17086bfd$var$isString = $3b0e765f17086bfd$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $3b0e765f17086bfd$var$isFunction = $3b0e765f17086bfd$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $3b0e765f17086bfd$var$isNumber = $3b0e765f17086bfd$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $3b0e765f17086bfd$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $3b0e765f17086bfd$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $3b0e765f17086bfd$var$isPlainObject = (val)=>{
    if ($3b0e765f17086bfd$var$kindOf(val) !== "object") return false;
    const prototype = $3b0e765f17086bfd$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $3b0e765f17086bfd$var$isDate = $3b0e765f17086bfd$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $3b0e765f17086bfd$var$isFile = $3b0e765f17086bfd$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $3b0e765f17086bfd$var$isBlob = $3b0e765f17086bfd$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $3b0e765f17086bfd$var$isFileList = $3b0e765f17086bfd$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $3b0e765f17086bfd$var$isStream = (val)=>$3b0e765f17086bfd$var$isObject(val) && $3b0e765f17086bfd$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $3b0e765f17086bfd$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $3b0e765f17086bfd$var$isFunction(thing.append) && ((kind = $3b0e765f17086bfd$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $3b0e765f17086bfd$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $3b0e765f17086bfd$var$isURLSearchParams = $3b0e765f17086bfd$var$kindOfTest("URLSearchParams");
const [$3b0e765f17086bfd$var$isReadableStream, $3b0e765f17086bfd$var$isRequest, $3b0e765f17086bfd$var$isResponse, $3b0e765f17086bfd$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($3b0e765f17086bfd$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $3b0e765f17086bfd$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $3b0e765f17086bfd$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($3b0e765f17086bfd$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $3b0e765f17086bfd$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $3b0e765f17086bfd$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $3b0e765f17086bfd$var$isContextDefined = (context)=>!$3b0e765f17086bfd$var$isUndefined(context) && context !== $3b0e765f17086bfd$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $3b0e765f17086bfd$var$merge() {
    const { caseless: caseless } = $3b0e765f17086bfd$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $3b0e765f17086bfd$var$findKey(result, key) || key;
        if ($3b0e765f17086bfd$var$isPlainObject(result[targetKey]) && $3b0e765f17086bfd$var$isPlainObject(val)) result[targetKey] = $3b0e765f17086bfd$var$merge(result[targetKey], val);
        else if ($3b0e765f17086bfd$var$isPlainObject(val)) result[targetKey] = $3b0e765f17086bfd$var$merge({}, val);
        else if ($3b0e765f17086bfd$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $3b0e765f17086bfd$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $3b0e765f17086bfd$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $3b0e765f17086bfd$var$forEach(b, (val, key)=>{
        if (thisArg && $3b0e765f17086bfd$var$isFunction(val)) a[key] = (0, $5d219f656b13ee51$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $3b0e765f17086bfd$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $3b0e765f17086bfd$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $3b0e765f17086bfd$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $3b0e765f17086bfd$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $3b0e765f17086bfd$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $3b0e765f17086bfd$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($3b0e765f17086bfd$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$3b0e765f17086bfd$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $3b0e765f17086bfd$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $3b0e765f17086bfd$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $3b0e765f17086bfd$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $3b0e765f17086bfd$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $3b0e765f17086bfd$var$isHTMLForm = $3b0e765f17086bfd$var$kindOfTest("HTMLFormElement");
const $3b0e765f17086bfd$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $3b0e765f17086bfd$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $3b0e765f17086bfd$var$isRegExp = $3b0e765f17086bfd$var$kindOfTest("RegExp");
const $3b0e765f17086bfd$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $3b0e765f17086bfd$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $3b0e765f17086bfd$var$freezeMethods = (obj)=>{
    $3b0e765f17086bfd$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($3b0e765f17086bfd$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$3b0e765f17086bfd$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $3b0e765f17086bfd$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $3b0e765f17086bfd$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $3b0e765f17086bfd$var$noop = ()=>{};
const $3b0e765f17086bfd$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $3b0e765f17086bfd$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $3b0e765f17086bfd$var$DIGIT = "0123456789";
const $3b0e765f17086bfd$var$ALPHABET = {
    DIGIT: $3b0e765f17086bfd$var$DIGIT,
    ALPHA: $3b0e765f17086bfd$var$ALPHA,
    ALPHA_DIGIT: $3b0e765f17086bfd$var$ALPHA + $3b0e765f17086bfd$var$ALPHA.toUpperCase() + $3b0e765f17086bfd$var$DIGIT
};
const $3b0e765f17086bfd$var$generateString = (size = 16, alphabet = $3b0e765f17086bfd$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $3b0e765f17086bfd$var$isSpecCompliantForm(thing) {
    return !!(thing && $3b0e765f17086bfd$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $3b0e765f17086bfd$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($3b0e765f17086bfd$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $3b0e765f17086bfd$var$isArray(source) ? [] : {};
                $3b0e765f17086bfd$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$3b0e765f17086bfd$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $3b0e765f17086bfd$var$isAsyncFn = $3b0e765f17086bfd$var$kindOfTest("AsyncFunction");
const $3b0e765f17086bfd$var$isThenable = (thing)=>thing && ($3b0e765f17086bfd$var$isObject(thing) || $3b0e765f17086bfd$var$isFunction(thing)) && $3b0e765f17086bfd$var$isFunction(thing.then) && $3b0e765f17086bfd$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $3b0e765f17086bfd$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $3b0e765f17086bfd$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $3b0e765f17086bfd$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $3b0e765f17086bfd$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $3b0e765f17086bfd$var$isFunction($3b0e765f17086bfd$var$_global.postMessage));
const $3b0e765f17086bfd$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($3b0e765f17086bfd$var$_global) : typeof $3267bbb6db0678de$exports !== "undefined" && $3267bbb6db0678de$exports.nextTick || $3b0e765f17086bfd$var$_setImmediate;
var // *********************
$3b0e765f17086bfd$export$2e2bcd8739ae039 = {
    isArray: $3b0e765f17086bfd$var$isArray,
    isArrayBuffer: $3b0e765f17086bfd$var$isArrayBuffer,
    isBuffer: $3b0e765f17086bfd$var$isBuffer,
    isFormData: $3b0e765f17086bfd$var$isFormData,
    isArrayBufferView: $3b0e765f17086bfd$var$isArrayBufferView,
    isString: $3b0e765f17086bfd$var$isString,
    isNumber: $3b0e765f17086bfd$var$isNumber,
    isBoolean: $3b0e765f17086bfd$var$isBoolean,
    isObject: $3b0e765f17086bfd$var$isObject,
    isPlainObject: $3b0e765f17086bfd$var$isPlainObject,
    isReadableStream: $3b0e765f17086bfd$var$isReadableStream,
    isRequest: $3b0e765f17086bfd$var$isRequest,
    isResponse: $3b0e765f17086bfd$var$isResponse,
    isHeaders: $3b0e765f17086bfd$var$isHeaders,
    isUndefined: $3b0e765f17086bfd$var$isUndefined,
    isDate: $3b0e765f17086bfd$var$isDate,
    isFile: $3b0e765f17086bfd$var$isFile,
    isBlob: $3b0e765f17086bfd$var$isBlob,
    isRegExp: $3b0e765f17086bfd$var$isRegExp,
    isFunction: $3b0e765f17086bfd$var$isFunction,
    isStream: $3b0e765f17086bfd$var$isStream,
    isURLSearchParams: $3b0e765f17086bfd$var$isURLSearchParams,
    isTypedArray: $3b0e765f17086bfd$var$isTypedArray,
    isFileList: $3b0e765f17086bfd$var$isFileList,
    forEach: $3b0e765f17086bfd$var$forEach,
    merge: $3b0e765f17086bfd$var$merge,
    extend: $3b0e765f17086bfd$var$extend,
    trim: $3b0e765f17086bfd$var$trim,
    stripBOM: $3b0e765f17086bfd$var$stripBOM,
    inherits: $3b0e765f17086bfd$var$inherits,
    toFlatObject: $3b0e765f17086bfd$var$toFlatObject,
    kindOf: $3b0e765f17086bfd$var$kindOf,
    kindOfTest: $3b0e765f17086bfd$var$kindOfTest,
    endsWith: $3b0e765f17086bfd$var$endsWith,
    toArray: $3b0e765f17086bfd$var$toArray,
    forEachEntry: $3b0e765f17086bfd$var$forEachEntry,
    matchAll: $3b0e765f17086bfd$var$matchAll,
    isHTMLForm: $3b0e765f17086bfd$var$isHTMLForm,
    hasOwnProperty: $3b0e765f17086bfd$var$hasOwnProperty,
    hasOwnProp: $3b0e765f17086bfd$var$hasOwnProperty,
    reduceDescriptors: $3b0e765f17086bfd$var$reduceDescriptors,
    freezeMethods: $3b0e765f17086bfd$var$freezeMethods,
    toObjectSet: $3b0e765f17086bfd$var$toObjectSet,
    toCamelCase: $3b0e765f17086bfd$var$toCamelCase,
    noop: $3b0e765f17086bfd$var$noop,
    toFiniteNumber: $3b0e765f17086bfd$var$toFiniteNumber,
    findKey: $3b0e765f17086bfd$var$findKey,
    global: $3b0e765f17086bfd$var$_global,
    isContextDefined: $3b0e765f17086bfd$var$isContextDefined,
    ALPHABET: $3b0e765f17086bfd$var$ALPHABET,
    generateString: $3b0e765f17086bfd$var$generateString,
    isSpecCompliantForm: $3b0e765f17086bfd$var$isSpecCompliantForm,
    toJSONObject: $3b0e765f17086bfd$var$toJSONObject,
    isAsyncFn: $3b0e765f17086bfd$var$isAsyncFn,
    isThenable: $3b0e765f17086bfd$var$isThenable,
    setImmediate: $3b0e765f17086bfd$var$_setImmediate,
    asap: $3b0e765f17086bfd$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $1802f87332a7475d$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).inherits($1802f87332a7475d$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $1802f87332a7475d$var$prototype = $1802f87332a7475d$var$AxiosError.prototype;
const $1802f87332a7475d$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $1802f87332a7475d$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($1802f87332a7475d$var$AxiosError, $1802f87332a7475d$var$descriptors);
Object.defineProperty($1802f87332a7475d$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$1802f87332a7475d$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($1802f87332a7475d$var$prototype);
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $1802f87332a7475d$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $1802f87332a7475d$export$2e2bcd8739ae039 = $1802f87332a7475d$var$AxiosError;


// eslint-disable-next-line strict
var $a161484968d4e2d6$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $de29dcc6a077369b$export$a143d493d941bafc;
var $de29dcc6a077369b$export$e4cf37d7f6fb9e0a;
var $de29dcc6a077369b$export$f99ded8fe4b79145;
var $de29dcc6a077369b$export$599f31c3813fae4d;
"use strict";
var $8cf1f36cb432a705$export$a48f0734ac7c2329;
var $8cf1f36cb432a705$export$d622b2ad8d90c771;
var $8cf1f36cb432a705$export$6100ba28696e12de;
"use strict";
$8cf1f36cb432a705$export$a48f0734ac7c2329 = $8cf1f36cb432a705$var$byteLength;
$8cf1f36cb432a705$export$d622b2ad8d90c771 = $8cf1f36cb432a705$var$toByteArray;
$8cf1f36cb432a705$export$6100ba28696e12de = $8cf1f36cb432a705$var$fromByteArray;
var $8cf1f36cb432a705$var$lookup = [];
var $8cf1f36cb432a705$var$revLookup = [];
var $8cf1f36cb432a705$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8cf1f36cb432a705$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8cf1f36cb432a705$var$i = 0, $8cf1f36cb432a705$var$len = $8cf1f36cb432a705$var$code.length; $8cf1f36cb432a705$var$i < $8cf1f36cb432a705$var$len; ++$8cf1f36cb432a705$var$i){
    $8cf1f36cb432a705$var$lookup[$8cf1f36cb432a705$var$i] = $8cf1f36cb432a705$var$code[$8cf1f36cb432a705$var$i];
    $8cf1f36cb432a705$var$revLookup[$8cf1f36cb432a705$var$code.charCodeAt($8cf1f36cb432a705$var$i)] = $8cf1f36cb432a705$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8cf1f36cb432a705$var$revLookup["-".charCodeAt(0)] = 62;
$8cf1f36cb432a705$var$revLookup["_".charCodeAt(0)] = 63;
function $8cf1f36cb432a705$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8cf1f36cb432a705$var$byteLength(b64) {
    var lens = $8cf1f36cb432a705$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8cf1f36cb432a705$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8cf1f36cb432a705$var$toByteArray(b64) {
    var tmp;
    var lens = $8cf1f36cb432a705$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8cf1f36cb432a705$var$Arr($8cf1f36cb432a705$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 18 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 2 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 10 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8cf1f36cb432a705$var$tripletToBase64(num) {
    return $8cf1f36cb432a705$var$lookup[num >> 18 & 0x3F] + $8cf1f36cb432a705$var$lookup[num >> 12 & 0x3F] + $8cf1f36cb432a705$var$lookup[num >> 6 & 0x3F] + $8cf1f36cb432a705$var$lookup[num & 0x3F];
}
function $8cf1f36cb432a705$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8cf1f36cb432a705$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8cf1f36cb432a705$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8cf1f36cb432a705$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8cf1f36cb432a705$var$lookup[tmp >> 2] + $8cf1f36cb432a705$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8cf1f36cb432a705$var$lookup[tmp >> 10] + $8cf1f36cb432a705$var$lookup[tmp >> 4 & 0x3F] + $8cf1f36cb432a705$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $44ef5096b7191751$export$aafa59e2e03f2942;
var $44ef5096b7191751$export$68d8715fc104d294;
$44ef5096b7191751$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$44ef5096b7191751$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $de29dcc6a077369b$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$de29dcc6a077369b$export$a143d493d941bafc = $de29dcc6a077369b$var$Buffer;
$de29dcc6a077369b$export$e4cf37d7f6fb9e0a = $de29dcc6a077369b$var$SlowBuffer;
$de29dcc6a077369b$export$f99ded8fe4b79145 = 50;
var $de29dcc6a077369b$var$K_MAX_LENGTH = 0x7fffffff;
$de29dcc6a077369b$export$599f31c3813fae4d = $de29dcc6a077369b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $de29dcc6a077369b$var$Buffer.TYPED_ARRAY_SUPPORT = $de29dcc6a077369b$var$typedArraySupport();
if (!$de29dcc6a077369b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $de29dcc6a077369b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($de29dcc6a077369b$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$de29dcc6a077369b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($de29dcc6a077369b$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$de29dcc6a077369b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $de29dcc6a077369b$var$createBuffer(length) {
    if (length > $de29dcc6a077369b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $de29dcc6a077369b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $de29dcc6a077369b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $de29dcc6a077369b$var$allocUnsafe(arg);
    }
    return $de29dcc6a077369b$var$from(arg, encodingOrOffset, length);
}
$de29dcc6a077369b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $de29dcc6a077369b$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $de29dcc6a077369b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $de29dcc6a077369b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($de29dcc6a077369b$var$isInstance(value, ArrayBuffer) || value && $de29dcc6a077369b$var$isInstance(value.buffer, ArrayBuffer)) return $de29dcc6a077369b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($de29dcc6a077369b$var$isInstance(value, SharedArrayBuffer) || value && $de29dcc6a077369b$var$isInstance(value.buffer, SharedArrayBuffer))) return $de29dcc6a077369b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $de29dcc6a077369b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $de29dcc6a077369b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $de29dcc6a077369b$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $de29dcc6a077369b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $de29dcc6a077369b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($de29dcc6a077369b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($de29dcc6a077369b$var$Buffer, Uint8Array);
function $de29dcc6a077369b$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $de29dcc6a077369b$var$alloc(size, fill, encoding) {
    $de29dcc6a077369b$var$assertSize(size);
    if (size <= 0) return $de29dcc6a077369b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $de29dcc6a077369b$var$createBuffer(size).fill(fill, encoding) : $de29dcc6a077369b$var$createBuffer(size).fill(fill);
    return $de29dcc6a077369b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $de29dcc6a077369b$var$Buffer.alloc = function(size, fill, encoding) {
    return $de29dcc6a077369b$var$alloc(size, fill, encoding);
};
function $de29dcc6a077369b$var$allocUnsafe(size) {
    $de29dcc6a077369b$var$assertSize(size);
    return $de29dcc6a077369b$var$createBuffer(size < 0 ? 0 : $de29dcc6a077369b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $de29dcc6a077369b$var$Buffer.allocUnsafe = function(size) {
    return $de29dcc6a077369b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $de29dcc6a077369b$var$Buffer.allocUnsafeSlow = function(size) {
    return $de29dcc6a077369b$var$allocUnsafe(size);
};
function $de29dcc6a077369b$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$de29dcc6a077369b$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $de29dcc6a077369b$var$byteLength(string, encoding) | 0;
    var buf = $de29dcc6a077369b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $de29dcc6a077369b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $de29dcc6a077369b$var$checked(array.length) | 0;
    var buf = $de29dcc6a077369b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $de29dcc6a077369b$var$fromArrayView(arrayView) {
    if ($de29dcc6a077369b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $de29dcc6a077369b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $de29dcc6a077369b$var$fromArrayLike(arrayView);
}
function $de29dcc6a077369b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $de29dcc6a077369b$var$Buffer.prototype);
    return buf;
}
function $de29dcc6a077369b$var$fromObject(obj) {
    if ($de29dcc6a077369b$var$Buffer.isBuffer(obj)) {
        var len = $de29dcc6a077369b$var$checked(obj.length) | 0;
        var buf = $de29dcc6a077369b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $de29dcc6a077369b$var$numberIsNaN(obj.length)) return $de29dcc6a077369b$var$createBuffer(0);
        return $de29dcc6a077369b$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $de29dcc6a077369b$var$fromArrayLike(obj.data);
}
function $de29dcc6a077369b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $de29dcc6a077369b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $de29dcc6a077369b$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $de29dcc6a077369b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $de29dcc6a077369b$var$Buffer.alloc(+length);
}
$de29dcc6a077369b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $de29dcc6a077369b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$de29dcc6a077369b$var$Buffer.compare = function compare(a, b) {
    if ($de29dcc6a077369b$var$isInstance(a, Uint8Array)) a = $de29dcc6a077369b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($de29dcc6a077369b$var$isInstance(b, Uint8Array)) b = $de29dcc6a077369b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(a) || !$de29dcc6a077369b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$de29dcc6a077369b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$de29dcc6a077369b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $de29dcc6a077369b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $de29dcc6a077369b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($de29dcc6a077369b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $de29dcc6a077369b$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$de29dcc6a077369b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $de29dcc6a077369b$var$byteLength(string, encoding) {
    if ($de29dcc6a077369b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $de29dcc6a077369b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $de29dcc6a077369b$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $de29dcc6a077369b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $de29dcc6a077369b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$de29dcc6a077369b$var$Buffer.byteLength = $de29dcc6a077369b$var$byteLength;
function $de29dcc6a077369b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $de29dcc6a077369b$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $de29dcc6a077369b$var$utf8Slice(this, start, end);
        case "ascii":
            return $de29dcc6a077369b$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $de29dcc6a077369b$var$latin1Slice(this, start, end);
        case "base64":
            return $de29dcc6a077369b$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $de29dcc6a077369b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$de29dcc6a077369b$var$Buffer.prototype._isBuffer = true;
function $de29dcc6a077369b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$de29dcc6a077369b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$de29dcc6a077369b$var$swap(this, i, i + 1);
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $de29dcc6a077369b$var$swap(this, i, i + 3);
        $de29dcc6a077369b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $de29dcc6a077369b$var$swap(this, i, i + 7);
        $de29dcc6a077369b$var$swap(this, i + 1, i + 6);
        $de29dcc6a077369b$var$swap(this, i + 2, i + 5);
        $de29dcc6a077369b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $de29dcc6a077369b$var$utf8Slice(this, 0, length);
    return $de29dcc6a077369b$var$slowToString.apply(this, arguments);
};
$de29dcc6a077369b$var$Buffer.prototype.toLocaleString = $de29dcc6a077369b$var$Buffer.prototype.toString;
$de29dcc6a077369b$var$Buffer.prototype.equals = function equals(b) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $de29dcc6a077369b$var$Buffer.compare(this, b) === 0;
};
$de29dcc6a077369b$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $de29dcc6a077369b$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($de29dcc6a077369b$var$customInspectSymbol) $de29dcc6a077369b$var$Buffer.prototype[$de29dcc6a077369b$var$customInspectSymbol] = $de29dcc6a077369b$var$Buffer.prototype.inspect;
$de29dcc6a077369b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($de29dcc6a077369b$var$isInstance(target, Uint8Array)) target = $de29dcc6a077369b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $de29dcc6a077369b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($de29dcc6a077369b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $de29dcc6a077369b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($de29dcc6a077369b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $de29dcc6a077369b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $de29dcc6a077369b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $de29dcc6a077369b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$de29dcc6a077369b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$de29dcc6a077369b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $de29dcc6a077369b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$de29dcc6a077369b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $de29dcc6a077369b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $de29dcc6a077369b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($de29dcc6a077369b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $de29dcc6a077369b$var$utf8Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $de29dcc6a077369b$var$asciiWrite(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$asciiToBytes(string), buf, offset, length);
}
function $de29dcc6a077369b$var$base64Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$base64ToBytes(string), buf, offset, length);
}
function $de29dcc6a077369b$var$ucs2Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$de29dcc6a077369b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $de29dcc6a077369b$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $de29dcc6a077369b$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $de29dcc6a077369b$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $de29dcc6a077369b$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $de29dcc6a077369b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$de29dcc6a077369b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $de29dcc6a077369b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8cf1f36cb432a705$export$6100ba28696e12de(buf);
    else return $8cf1f36cb432a705$export$6100ba28696e12de(buf.slice(start, end));
}
function $de29dcc6a077369b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $de29dcc6a077369b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $de29dcc6a077369b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $de29dcc6a077369b$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $de29dcc6a077369b$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $de29dcc6a077369b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $de29dcc6a077369b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $de29dcc6a077369b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$de29dcc6a077369b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $de29dcc6a077369b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $de29dcc6a077369b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$de29dcc6a077369b$var$Buffer.prototype.readUintLE = $de29dcc6a077369b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readUintBE = $de29dcc6a077369b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint8 = $de29dcc6a077369b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$de29dcc6a077369b$var$Buffer.prototype.readUint16LE = $de29dcc6a077369b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint16BE = $de29dcc6a077369b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$de29dcc6a077369b$var$Buffer.prototype.readUint32LE = $de29dcc6a077369b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint32BE = $de29dcc6a077369b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$de29dcc6a077369b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$de29dcc6a077369b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$de29dcc6a077369b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$de29dcc6a077369b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 8, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$de29dcc6a077369b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 8, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $de29dcc6a077369b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$de29dcc6a077369b$var$Buffer.prototype.writeUintLE = $de29dcc6a077369b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUintBE = $de29dcc6a077369b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint8 = $de29dcc6a077369b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint16LE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint16BE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint32LE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint32BE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $de29dcc6a077369b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $44ef5096b7191751$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$de29dcc6a077369b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeFloat(this, value, offset, true, noAssert);
};
$de29dcc6a077369b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeFloat(this, value, offset, false, noAssert);
};
function $de29dcc6a077369b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $44ef5096b7191751$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$de29dcc6a077369b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeDouble(this, value, offset, true, noAssert);
};
$de29dcc6a077369b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$de29dcc6a077369b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$de29dcc6a077369b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$de29dcc6a077369b$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $de29dcc6a077369b$var$Buffer.isBuffer(val) ? val : $de29dcc6a077369b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $de29dcc6a077369b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $de29dcc6a077369b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($de29dcc6a077369b$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $de29dcc6a077369b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $de29dcc6a077369b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $de29dcc6a077369b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $de29dcc6a077369b$var$base64ToBytes(str) {
    return $8cf1f36cb432a705$export$d622b2ad8d90c771($de29dcc6a077369b$var$base64clean(str));
}
function $de29dcc6a077369b$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $de29dcc6a077369b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $de29dcc6a077369b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $de29dcc6a077369b$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $987194e734735588$require$Buffer = $de29dcc6a077369b$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $987194e734735588$var$isVisitable(thing) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $987194e734735588$var$removeBrackets(key) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $987194e734735588$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $987194e734735588$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $987194e734735588$var$isFlatArray(arr) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(arr) && !arr.some($987194e734735588$var$isVisitable);
}
const $987194e734735588$var$predicates = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject((0, $3b0e765f17086bfd$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $987194e734735588$var$toFormData(obj, formData, options) {
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $a161484968d4e2d6$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $987194e734735588$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) && $987194e734735588$var$isFlatArray(value) || ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFileList(value) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $987194e734735588$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $987194e734735588$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($987194e734735588$var$isVisitable(value)) return true;
        formData.append($987194e734735588$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($987194e734735588$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $987194e734735588$var$isVisitable
    });
    function build(value, path) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $987194e734735588$export$2e2bcd8739ae039 = $987194e734735588$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $2d62ebc7b44b3614$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $2d62ebc7b44b3614$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $987194e734735588$export$2e2bcd8739ae039)(params, this, options);
}
const $2d62ebc7b44b3614$var$prototype = $2d62ebc7b44b3614$var$AxiosURLSearchParams.prototype;
$2d62ebc7b44b3614$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$2d62ebc7b44b3614$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $2d62ebc7b44b3614$var$encode);
    } : $2d62ebc7b44b3614$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $2d62ebc7b44b3614$export$2e2bcd8739ae039 = $2d62ebc7b44b3614$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $cc1325dddfd5d959$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $cc1325dddfd5d959$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $cc1325dddfd5d959$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $2d62ebc7b44b3614$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $a420fff59be7902c$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $a420fff59be7902c$export$2e2bcd8739ae039 = $a420fff59be7902c$var$InterceptorManager;





"use strict";
var $9db4fba95d842126$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $34729f01ce81b7d2$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $2d62ebc7b44b3614$export$2e2bcd8739ae039);


"use strict";
var $19ab5cefba3b154c$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $8356c2adc32eacfe$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $f2ec196bcb20148e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $34729f01ce81b7d2$export$2e2bcd8739ae039,
        FormData: $19ab5cefba3b154c$export$2e2bcd8739ae039,
        Blob: $8356c2adc32eacfe$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $8ea2ef8349325b95$exports = {};

$parcel$export($8ea2ef8349325b95$exports, "hasBrowserEnv", () => $8ea2ef8349325b95$export$c4996c4b7b93b0bf);
$parcel$export($8ea2ef8349325b95$exports, "navigator", () => $8ea2ef8349325b95$export$ec7c8efa7f5790ae);
$parcel$export($8ea2ef8349325b95$exports, "hasStandardBrowserEnv", () => $8ea2ef8349325b95$export$c0bcc9250309d66);
$parcel$export($8ea2ef8349325b95$exports, "hasStandardBrowserWebWorkerEnv", () => $8ea2ef8349325b95$export$c81692cf5af97dac);
$parcel$export($8ea2ef8349325b95$exports, "origin", () => $8ea2ef8349325b95$export$f710a83a91838a36);
const $8ea2ef8349325b95$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $8ea2ef8349325b95$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $8ea2ef8349325b95$export$c0bcc9250309d66 = $8ea2ef8349325b95$export$c4996c4b7b93b0bf && (!$8ea2ef8349325b95$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($8ea2ef8349325b95$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $8ea2ef8349325b95$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $8ea2ef8349325b95$export$f710a83a91838a36 = $8ea2ef8349325b95$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $5d16336510b0e3a5$export$2e2bcd8739ae039 = {
    ...$8ea2ef8349325b95$exports,
    ...(0, $f2ec196bcb20148e$export$2e2bcd8739ae039)
};


"use strict";
function $54c9a72f9f4172e8$export$2e2bcd8739ae039(data, options) {
    return (0, $987194e734735588$export$2e2bcd8739ae039)(data, new (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).isNode && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $9d923ad61888379b$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $9d923ad61888379b$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $9d923ad61888379b$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $9d923ad61888379b$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(formData) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($9d923ad61888379b$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $9d923ad61888379b$export$2e2bcd8739ae039 = $9d923ad61888379b$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $5d85921ddf900d80$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $5d85921ddf900d80$var$defaults = {
    transitional: (0, $9db4fba95d842126$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $9d923ad61888379b$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBuffer(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isStream(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFile(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $54c9a72f9f4172e8$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $987194e734735588$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $5d85921ddf900d80$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $5d85921ddf900d80$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isResponse(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $1802f87332a7475d$export$2e2bcd8739ae039).from(e, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $5d85921ddf900d80$var$defaults.headers[method] = {};
});
var $5d85921ddf900d80$export$2e2bcd8739ae039 = $5d85921ddf900d80$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $00ff3ca42995cecb$var$ignoreDuplicateOf = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $00ff3ca42995cecb$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $00ff3ca42995cecb$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $2b4c00835bd82ca3$var$$internals = Symbol("internals");
function $2b4c00835bd82ca3$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2b4c00835bd82ca3$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) ? value.map($2b4c00835bd82ca3$var$normalizeValue) : String(value);
}
function $2b4c00835bd82ca3$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2b4c00835bd82ca3$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2b4c00835bd82ca3$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $2b4c00835bd82ca3$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2b4c00835bd82ca3$var$buildAccessors(obj, header) {
    const accessorName = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2b4c00835bd82ca3$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2b4c00835bd82ca3$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$2b4c00835bd82ca3$var$isValidHeaderName(header)) setHeaders((0, $00ff3ca42995cecb$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2b4c00835bd82ca3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2b4c00835bd82ca3$var$parseTokens(value);
                if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $2b4c00835bd82ca3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $2b4c00835bd82ca3$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2b4c00835bd82ca3$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2b4c00835bd82ca3$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2b4c00835bd82ca3$var$$internals] = this[$2b4c00835bd82ca3$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2b4c00835bd82ca3$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$2b4c00835bd82ca3$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).reduceDescriptors($2b4c00835bd82ca3$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).freezeMethods($2b4c00835bd82ca3$var$AxiosHeaders);
var $2b4c00835bd82ca3$export$2e2bcd8739ae039 = $2b4c00835bd82ca3$var$AxiosHeaders;


"use strict";
function $cf865322512f7c70$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $5d85921ddf900d80$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $96fd7b558634ab1c$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $1802f87332a7475d$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).inherits($96fd7b558634ab1c$var$CanceledError, (0, $1802f87332a7475d$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $96fd7b558634ab1c$export$2e2bcd8739ae039 = $96fd7b558634ab1c$var$CanceledError;







"use strict";
function $b50ed5d1058a3519$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $c0626b65ee4f58ad$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $86b5300eb8c2d89a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $86b5300eb8c2d89a$export$2e2bcd8739ae039 = $86b5300eb8c2d89a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $1e06ddf250092091$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $1e06ddf250092091$export$2e2bcd8739ae039 = $1e06ddf250092091$var$throttle;



const $08491b187ed7125f$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $86b5300eb8c2d89a$export$2e2bcd8739ae039)(50, 250);
    return (0, $1e06ddf250092091$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $08491b187ed7125f$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $08491b187ed7125f$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).asap(()=>fn(...args));






"use strict";
var $654ad96f5dc2640f$export$2e2bcd8739ae039 = (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $7e458861153e1793$export$2e2bcd8739ae039 = (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $b3c557b1375283cb$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $26a5e67631084dd7$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $209a10c5f4d85343$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $b3c557b1375283cb$export$2e2bcd8739ae039)(requestedURL)) return (0, $26a5e67631084dd7$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $3714d3e24358701c$var$headersToObject = (thing)=>thing instanceof (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $3714d3e24358701c$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(target) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($3714d3e24358701c$var$headersToObject(a), $3714d3e24358701c$var$headersToObject(b), true)
    };
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $e73b2be4d36acc11$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $3714d3e24358701c$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $cc1325dddfd5d959$export$2e2bcd8739ae039)((0, $209a10c5f4d85343$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $654ad96f5dc2640f$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $7e458861153e1793$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $665ff90d985d53de$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $665ff90d985d53de$export$2e2bcd8739ae039 = $665ff90d985d53de$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $e73b2be4d36acc11$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b50ed5d1058a3519$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("Request aborted", (0, $1802f87332a7475d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("Network Error", (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $9db4fba95d842126$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $1802f87332a7475d$export$2e2bcd8739ae039).ETIMEDOUT : (0, $1802f87332a7475d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $08491b187ed7125f$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $08491b187ed7125f$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $c0626b65ee4f58ad$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $08a9a6bf5f67a1dd$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $1802f87332a7475d$export$2e2bcd8739ae039) ? err : new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $08a9a6bf5f67a1dd$export$2e2bcd8739ae039 = $08a9a6bf5f67a1dd$var$composeSignals;


const $5bfc0d8311c377d7$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $5bfc0d8311c377d7$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $5bfc0d8311c377d7$var$readStream(iterable))yield* $5bfc0d8311c377d7$export$71b051935044bd5d(chunk, chunkSize);
};
const $5bfc0d8311c377d7$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $5bfc0d8311c377d7$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $5bfc0d8311c377d7$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $db39780280fa948e$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $db39780280fa948e$var$isReadableStreamSupported = $db39780280fa948e$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $db39780280fa948e$var$encodeText = $db39780280fa948e$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $db39780280fa948e$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $db39780280fa948e$var$supportsRequestStream = $db39780280fa948e$var$isReadableStreamSupported && $db39780280fa948e$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $db39780280fa948e$var$DEFAULT_CHUNK_SIZE = 65536;
const $db39780280fa948e$var$supportsResponseStream = $db39780280fa948e$var$isReadableStreamSupported && $db39780280fa948e$var$test(()=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $db39780280fa948e$var$resolvers = {
    stream: $db39780280fa948e$var$supportsResponseStream && ((res)=>res.body)
};
$db39780280fa948e$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$db39780280fa948e$var$resolvers[type] && ($db39780280fa948e$var$resolvers[type] = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $db39780280fa948e$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(body)) return (await $db39780280fa948e$var$encodeText(body)).byteLength;
};
const $db39780280fa948e$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $db39780280fa948e$var$getBodyLength(body) : length;
};
var $db39780280fa948e$export$2e2bcd8739ae039 = $db39780280fa948e$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $e73b2be4d36acc11$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $08a9a6bf5f67a1dd$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $db39780280fa948e$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $db39780280fa948e$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $08491b187ed7125f$export$d9fadd12586c18d6)(requestContentLength, (0, $08491b187ed7125f$export$c1b28109d46c3592)((0, $08491b187ed7125f$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $5bfc0d8311c377d7$export$b0119225647bd83)(_request.body, $db39780280fa948e$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $db39780280fa948e$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($db39780280fa948e$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $08491b187ed7125f$export$d9fadd12586c18d6)(responseContentLength, (0, $08491b187ed7125f$export$c1b28109d46c3592)((0, $08491b187ed7125f$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $5bfc0d8311c377d7$export$b0119225647bd83)(response.body, $db39780280fa948e$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $db39780280fa948e$var$resolvers[(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey($db39780280fa948e$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $b50ed5d1058a3519$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("Network Error", (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $1802f87332a7475d$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $2945414447657243$var$knownAdapters = {
    http: (0, $a161484968d4e2d6$export$2e2bcd8739ae039),
    xhr: (0, $665ff90d985d53de$export$2e2bcd8739ae039),
    fetch: (0, $db39780280fa948e$export$2e2bcd8739ae039)
};
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach($2945414447657243$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $2945414447657243$var$renderReason = (reason)=>`- ${reason}`;
const $2945414447657243$var$isResolvedHandle = (adapter)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $2945414447657243$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$2945414447657243$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $2945414447657243$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($2945414447657243$var$renderReason).join("\n") : " " + $2945414447657243$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $2945414447657243$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f06f8d6e3348094a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(null, config);
}
function $f06f8d6e3348094a$export$2e2bcd8739ae039(config) {
    $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
    config.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $2945414447657243$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $5d85921ddf900d80$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039)(reason)) {
            $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $73d2af2398262305$export$a4ad2735b021c132 = "1.7.7";



"use strict";
const $97dffca93d4e7f32$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $97dffca93d4e7f32$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $97dffca93d4e7f32$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $97dffca93d4e7f32$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $73d2af2398262305$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$97dffca93d4e7f32$var$deprecatedWarnings[opt]) {
            $97dffca93d4e7f32$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $97dffca93d4e7f32$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("options must be an object", (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $97dffca93d4e7f32$export$2e2bcd8739ae039 = {
    assertOptions: $97dffca93d4e7f32$var$assertOptions,
    validators: $97dffca93d4e7f32$var$validators
};



"use strict";
const $0979936342606ee7$var$validators = (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $0979936342606ee7$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $a420fff59be7902c$export$2e2bcd8739ae039)(),
            response: new (0, $a420fff59be7902c$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3714d3e24358701c$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean),
            forcedJSONParsing: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean),
            clarifyTimeoutError: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $0979936342606ee7$var$validators.function,
                serialize: $0979936342606ee7$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f06f8d6e3348094a$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f06f8d6e3348094a$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3714d3e24358701c$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $209a10c5f4d85343$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $cc1325dddfd5d959$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0979936342606ee7$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3714d3e24358701c$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3714d3e24358701c$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $0979936342606ee7$var$Axios.prototype[method] = generateHTTPMethod();
    $0979936342606ee7$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $0979936342606ee7$export$2e2bcd8739ae039 = $0979936342606ee7$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $edb97a8a31a981a0$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $edb97a8a31a981a0$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $edb97a8a31a981a0$export$2e2bcd8739ae039 = $edb97a8a31a981a0$var$CancelToken;






"use strict";
function $b9d9bbe99a0c13e8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $c7eac602bd26f638$export$2e2bcd8739ae039(payload) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $7f625779f2088931$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($7f625779f2088931$var$HttpStatusCode).forEach(([key, value])=>{
    $7f625779f2088931$var$HttpStatusCode[value] = key;
});
var $7f625779f2088931$export$2e2bcd8739ae039 = $7f625779f2088931$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $4caf0f2bcd8b9e34$var$createInstance(defaultConfig) {
    const context = new (0, $0979936342606ee7$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $5d219f656b13ee51$export$2e2bcd8739ae039)((0, $0979936342606ee7$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).extend(instance, (0, $0979936342606ee7$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $4caf0f2bcd8b9e34$var$createInstance((0, $3714d3e24358701c$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $4caf0f2bcd8b9e34$var$axios = $4caf0f2bcd8b9e34$var$createInstance((0, $5d85921ddf900d80$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$4caf0f2bcd8b9e34$var$axios.Axios = (0, $0979936342606ee7$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$4caf0f2bcd8b9e34$var$axios.CanceledError = (0, $96fd7b558634ab1c$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.CancelToken = (0, $edb97a8a31a981a0$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.isCancel = (0, $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.VERSION = (0, $73d2af2398262305$export$a4ad2735b021c132);
$4caf0f2bcd8b9e34$var$axios.toFormData = (0, $987194e734735588$export$2e2bcd8739ae039);
// Expose AxiosError class
$4caf0f2bcd8b9e34$var$axios.AxiosError = (0, $1802f87332a7475d$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$4caf0f2bcd8b9e34$var$axios.Cancel = $4caf0f2bcd8b9e34$var$axios.CanceledError;
// Expose all/spread
$4caf0f2bcd8b9e34$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$4caf0f2bcd8b9e34$var$axios.spread = (0, $b9d9bbe99a0c13e8$export$2e2bcd8739ae039);
// Expose isAxiosError
$4caf0f2bcd8b9e34$var$axios.isAxiosError = (0, $c7eac602bd26f638$export$2e2bcd8739ae039);
// Expose mergeConfig
$4caf0f2bcd8b9e34$var$axios.mergeConfig = (0, $3714d3e24358701c$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.AxiosHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.formToJSON = (thing)=>(0, $9d923ad61888379b$export$2e2bcd8739ae039)((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$4caf0f2bcd8b9e34$var$axios.getAdapter = (0, $2945414447657243$export$2e2bcd8739ae039).getAdapter;
$4caf0f2bcd8b9e34$var$axios.HttpStatusCode = (0, $7f625779f2088931$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.default = $4caf0f2bcd8b9e34$var$axios;
var // this module should only have a default export
$4caf0f2bcd8b9e34$export$2e2bcd8739ae039 = $4caf0f2bcd8b9e34$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b0959eebdd834785$export$1c00760e9e5a4e95, AxiosError: $b0959eebdd834785$export$c1fbed17c2f6a328, CanceledError: $b0959eebdd834785$export$1ab0c6b20d94fa14, isCancel: $b0959eebdd834785$export$3b22524397b493c6, CancelToken: $b0959eebdd834785$export$fd08e3cb425f0d61, VERSION: $b0959eebdd834785$export$a4ad2735b021c132, all: $b0959eebdd834785$export$84bf76cd7afc7469, Cancel: $b0959eebdd834785$export$848c9b7ead0df967, isAxiosError: $b0959eebdd834785$export$fbafdbe06a5b5a9a, spread: $b0959eebdd834785$export$3ae0fd4797ed47c8, toFormData: $b0959eebdd834785$export$10ae0d317ea97f8b, AxiosHeaders: $b0959eebdd834785$export$4e7d6ff0f3e6520, HttpStatusCode: $b0959eebdd834785$export$a972f69c851492b3, formToJSON: $b0959eebdd834785$export$86d7c59254d6a2c9, getAdapter: $b0959eebdd834785$export$17ddc20a97d669e2, mergeConfig: $b0959eebdd834785$export$7ec1ebcfa9d8bd6a } = (0, $4caf0f2bcd8b9e34$export$2e2bcd8739ae039);


var $41c099b1976cc56f$exports = {};
(function(global1, factory) {
    $41c099b1976cc56f$exports = factory();
})($41c099b1976cc56f$exports, function() {
    "use strict";
    var toStringFunction = Function.prototype.toString;
    var create = Object.create, defineProperty = Object.defineProperty, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getPrototypeOf$1 = Object.getPrototypeOf;
    var _a = Object.prototype, hasOwnProperty = _a.hasOwnProperty, propertyIsEnumerable = _a.propertyIsEnumerable;
    var SYMBOL_PROPERTIES = typeof getOwnPropertySymbols === "function";
    var WEAK_MAP = typeof WeakMap === "function";
    /**
     * @function createCache
     *
     * @description
     * get a new cache object to prevent circular references
     *
     * @returns the new cache object
     */ var createCache = function() {
        if (WEAK_MAP) return function() {
            return new WeakMap();
        };
        var Cache = /** @class */ function() {
            function Cache() {
                this._keys = [];
                this._values = [];
            }
            Cache.prototype.has = function(key) {
                return !!~this._keys.indexOf(key);
            };
            Cache.prototype.get = function(key) {
                return this._values[this._keys.indexOf(key)];
            };
            Cache.prototype.set = function(key, value) {
                this._keys.push(key);
                this._values.push(value);
            };
            return Cache;
        }();
        return function() {
            return new Cache();
        };
    }();
    /**
     * @function getCleanClone
     *
     * @description
     * get an empty version of the object with the same prototype it has
     *
     * @param object the object to build a clean clone from
     * @param realm the realm the object resides in
     * @returns the empty cloned object
     */ var getCleanClone = function(object, realm) {
        var prototype = object.__proto__ || getPrototypeOf$1(object);
        if (!prototype) return create(null);
        var Constructor = prototype.constructor;
        if (Constructor === realm.Object) return prototype === realm.Object.prototype ? {} : create(prototype);
        if (~toStringFunction.call(Constructor).indexOf("[native code]")) try {
            return new Constructor();
        } catch (_a) {}
        return create(prototype);
    };
    /**
     * @function getObjectCloneLoose
     *
     * @description
     * get a copy of the object based on loose rules, meaning all enumerable keys
     * and symbols are copied, but property descriptors are not considered
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneLoose = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        for(var key in object)if (hasOwnProperty.call(object, key)) clone[key] = handleCopy(object[key], cache);
        if (SYMBOL_PROPERTIES) {
            var symbols = getOwnPropertySymbols(object);
            for(var index = 0, length_1 = symbols.length, symbol = void 0; index < length_1; ++index){
                symbol = symbols[index];
                if (propertyIsEnumerable.call(object, symbol)) clone[symbol] = handleCopy(object[symbol], cache);
            }
        }
        return clone;
    };
    /**
     * @function getObjectCloneStrict
     *
     * @description
     * get a copy of the object based on strict rules, meaning all keys and symbols
     * are copied based on the original property descriptors
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneStrict = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        var properties = SYMBOL_PROPERTIES ? getOwnPropertyNames(object).concat(getOwnPropertySymbols(object)) : getOwnPropertyNames(object);
        for(var index = 0, length_2 = properties.length, property = void 0, descriptor = void 0; index < length_2; ++index){
            property = properties[index];
            if (property !== "callee" && property !== "caller") {
                descriptor = getOwnPropertyDescriptor(object, property);
                if (descriptor) {
                    // Only clone the value if actually a value, not a getter / setter.
                    if (!descriptor.get && !descriptor.set) descriptor.value = handleCopy(object[property], cache);
                    try {
                        defineProperty(clone, property, descriptor);
                    } catch (error) {
                        // Tee above can fail on node in edge cases, so fall back to the loose assignment.
                        clone[property] = descriptor.value;
                    }
                } else // In extra edge cases where the property descriptor cannot be retrived, fall back to
                // the loose assignment.
                clone[property] = handleCopy(object[property], cache);
            }
        }
        return clone;
    };
    /**
     * @function getRegExpFlags
     *
     * @description
     * get the flags to apply to the copied regexp
     *
     * @param regExp the regexp to get the flags of
     * @returns the flags for the regexp
     */ var getRegExpFlags = function(regExp) {
        var flags = "";
        if (regExp.global) flags += "g";
        if (regExp.ignoreCase) flags += "i";
        if (regExp.multiline) flags += "m";
        if (regExp.unicode) flags += "u";
        if (regExp.sticky) flags += "y";
        return flags;
    };
    // utils
    var isArray = Array.isArray;
    var getPrototypeOf = Object.getPrototypeOf;
    var GLOBAL_THIS = function() {
        if (typeof globalThis !== "undefined") return globalThis;
        if (typeof self !== "undefined") return self;
        if (typeof window !== "undefined") return window;
        if (typeof $parcel$global !== "undefined") return $parcel$global;
        if (console && console.error) console.error('Unable to locate global object, returning "this".');
        return this;
    }();
    /**
     * @function copy
     *
     * @description
     * copy an value deeply as much as possible
     *
     * If `strict` is applied, then all properties (including non-enumerable ones)
     * are copied with their original property descriptors on both objects and arrays.
     *
     * The value is compared to the global constructors in the `realm` provided,
     * and the native constructor is always used to ensure that extensions of native
     * objects (allows in ES2015+) are maintained.
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.isStrict] should the copy be strict
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ function copy(value, options) {
        // manually coalesced instead of default parameters for performance
        var isStrict = !!(options && options.isStrict);
        var realm = options && options.realm || GLOBAL_THIS;
        var getObjectClone = isStrict ? getObjectCloneStrict : getObjectCloneLoose;
        /**
         * @function handleCopy
         *
         * @description
         * copy the value recursively based on its type
         *
         * @param value the value to copy
         * @returns the copied value
         */ var handleCopy = function(value, cache) {
            if (!value || typeof value !== "object") return value;
            if (cache.has(value)) return cache.get(value);
            var prototype = value.__proto__ || getPrototypeOf(value);
            var Constructor = prototype && prototype.constructor;
            // plain objects
            if (!Constructor || Constructor === realm.Object) return getObjectClone(value, realm, handleCopy, cache);
            var clone;
            // arrays
            if (isArray(value)) {
                // if strict, include non-standard properties
                if (isStrict) return getObjectCloneStrict(value, realm, handleCopy, cache);
                clone = new Constructor();
                cache.set(value, clone);
                for(var index = 0, length_1 = value.length; index < length_1; ++index)clone[index] = handleCopy(value[index], cache);
                return clone;
            }
            // dates
            if (value instanceof realm.Date) return new Constructor(value.getTime());
            // regexps
            if (value instanceof realm.RegExp) {
                clone = new Constructor(value.source, value.flags || getRegExpFlags(value));
                clone.lastIndex = value.lastIndex;
                return clone;
            }
            // maps
            if (realm.Map && value instanceof realm.Map) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value, key) {
                    clone.set(key, handleCopy(value, cache));
                });
                return clone;
            }
            // sets
            if (realm.Set && value instanceof realm.Set) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value) {
                    clone.add(handleCopy(value, cache));
                });
                return clone;
            }
            // blobs
            if (realm.Blob && value instanceof realm.Blob) return value.slice(0, value.size, value.type);
            // buffers (node-only)
            if (realm.Buffer && realm.Buffer.isBuffer(value)) {
                clone = realm.Buffer.allocUnsafe ? realm.Buffer.allocUnsafe(value.length) : new Constructor(value.length);
                cache.set(value, clone);
                value.copy(clone);
                return clone;
            }
            // arraybuffers / dataviews
            if (realm.ArrayBuffer) {
                // dataviews
                if (realm.ArrayBuffer.isView(value)) {
                    clone = new Constructor(value.buffer.slice(0));
                    cache.set(value, clone);
                    return clone;
                }
                // arraybuffers
                if (value instanceof realm.ArrayBuffer) {
                    clone = value.slice(0);
                    cache.set(value, clone);
                    return clone;
                }
            }
            // if the value cannot / should not be cloned, don't
            if (// promise-like
            typeof value.then === "function" || // errors
            value instanceof Error || // weakmaps
            realm.WeakMap && value instanceof realm.WeakMap || // weaksets
            realm.WeakSet && value instanceof realm.WeakSet) return value;
            // assume anything left is a custom constructor
            return getObjectClone(value, realm, handleCopy, cache);
        };
        return handleCopy(value, createCache());
    }
    // Adding reference to allow usage in CommonJS libraries compiled using TSC, which
    // expects there to be a default property on the exported value. See
    // [#37](https://github.com/planttheidea/fast-copy/issues/37) for details.
    copy.default = copy;
    /**
     * @function strictCopy
     *
     * @description
     * copy the value with `strict` option pre-applied
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ copy.strict = function strictCopy(value, options) {
        return copy(value, {
            isStrict: true,
            realm: options ? options.realm : void 0
        });
    };
    return copy;
});


var $6e19be61753cbc35$exports = {};
"use strict";
var $79acdf0dd8ee88cb$exports = {};
"use strict";
var $41979e9c210b0e24$exports = {};
"use strict";

var $YYhfn = parcelRequire("YYhfn");
var $2d0686bfb37fdbd7$exports = {};
"use strict";

var $YYhfn = parcelRequire("YYhfn");
var $cf0a941e98230036$exports = {};
"use strict";

var $fd7Gr = parcelRequire("fd7Gr");

var $YYhfn = parcelRequire("YYhfn");
var $ea158f189d6b1536$exports = {};
"use strict";

var $YYhfn = parcelRequire("YYhfn");
var $d17fa704c8baf562$exports = {};
"use strict";

var $eNxNf = parcelRequire("eNxNf");

var $ebTth = parcelRequire("ebTth");

var $9tZcL = parcelRequire("9tZcL");
var $2e199f77a4ceed31$exports = {};
"use strict";

var $YYhfn = parcelRequire("YYhfn");
var $2e199f77a4ceed31$var$$gOPD = $YYhfn("%Object.getOwnPropertyDescriptor%", true);
if ($2e199f77a4ceed31$var$$gOPD) try {
    $2e199f77a4ceed31$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $2e199f77a4ceed31$var$$gOPD = null;
}
$2e199f77a4ceed31$exports = $2e199f77a4ceed31$var$$gOPD;


/** @type {import('.')} */ $d17fa704c8baf562$exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $9tZcL("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $9tZcL("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $9tZcL("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $9tZcL("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $9tZcL("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $9tZcL("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$2e199f77a4ceed31$exports && $2e199f77a4ceed31$exports(obj, property);
    if ($eNxNf) $eNxNf(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $ebTth("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};



var $ea158f189d6b1536$var$hasDescriptors = (parcelRequire("bOcfK"))();


var $9tZcL = parcelRequire("9tZcL");
var $ea158f189d6b1536$var$$floor = $YYhfn("%Math.floor%");
/** @type {import('.')} */ $ea158f189d6b1536$exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $9tZcL("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $ea158f189d6b1536$var$$floor(length) !== length) throw new $9tZcL("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $2e199f77a4ceed31$exports) {
        var desc = $2e199f77a4ceed31$exports(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($ea158f189d6b1536$var$hasDescriptors) $d17fa704c8baf562$exports(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $d17fa704c8baf562$exports(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};



var $9tZcL = parcelRequire("9tZcL");
var $cf0a941e98230036$var$$apply = $YYhfn("%Function.prototype.apply%");
var $cf0a941e98230036$var$$call = $YYhfn("%Function.prototype.call%");
var $cf0a941e98230036$var$$reflectApply = $YYhfn("%Reflect.apply%", true) || $fd7Gr.call($cf0a941e98230036$var$$call, $cf0a941e98230036$var$$apply);

var $eNxNf = parcelRequire("eNxNf");
var $cf0a941e98230036$var$$max = $YYhfn("%Math.max%");
$cf0a941e98230036$exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $9tZcL("a function is required");
    var func = $cf0a941e98230036$var$$reflectApply($fd7Gr, $cf0a941e98230036$var$$call, arguments);
    return $ea158f189d6b1536$exports(func, 1 + $cf0a941e98230036$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $cf0a941e98230036$var$applyBind = function applyBind() {
    return $cf0a941e98230036$var$$reflectApply($fd7Gr, $cf0a941e98230036$var$$apply, arguments);
};
if ($eNxNf) $eNxNf($cf0a941e98230036$exports, "apply", {
    value: $cf0a941e98230036$var$applyBind
});
else $cf0a941e98230036$exports.apply = $cf0a941e98230036$var$applyBind;


var $2d0686bfb37fdbd7$var$$indexOf = $cf0a941e98230036$exports($YYhfn("String.prototype.indexOf"));
$2d0686bfb37fdbd7$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $YYhfn(name, !!allowMissing);
    if (typeof intrinsic === "function" && $2d0686bfb37fdbd7$var$$indexOf(name, ".prototype.") > -1) return $cf0a941e98230036$exports(intrinsic);
    return intrinsic;
};


var $5a5c8f99294101b7$exports = {};
var $5a5c8f99294101b7$var$hasMap = typeof Map === "function" && Map.prototype;
var $5a5c8f99294101b7$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $5a5c8f99294101b7$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $5a5c8f99294101b7$var$mapSize = $5a5c8f99294101b7$var$hasMap && $5a5c8f99294101b7$var$mapSizeDescriptor && typeof $5a5c8f99294101b7$var$mapSizeDescriptor.get === "function" ? $5a5c8f99294101b7$var$mapSizeDescriptor.get : null;
var $5a5c8f99294101b7$var$mapForEach = $5a5c8f99294101b7$var$hasMap && Map.prototype.forEach;
var $5a5c8f99294101b7$var$hasSet = typeof Set === "function" && Set.prototype;
var $5a5c8f99294101b7$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $5a5c8f99294101b7$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $5a5c8f99294101b7$var$setSize = $5a5c8f99294101b7$var$hasSet && $5a5c8f99294101b7$var$setSizeDescriptor && typeof $5a5c8f99294101b7$var$setSizeDescriptor.get === "function" ? $5a5c8f99294101b7$var$setSizeDescriptor.get : null;
var $5a5c8f99294101b7$var$setForEach = $5a5c8f99294101b7$var$hasSet && Set.prototype.forEach;
var $5a5c8f99294101b7$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $5a5c8f99294101b7$var$weakMapHas = $5a5c8f99294101b7$var$hasWeakMap ? WeakMap.prototype.has : null;
var $5a5c8f99294101b7$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $5a5c8f99294101b7$var$weakSetHas = $5a5c8f99294101b7$var$hasWeakSet ? WeakSet.prototype.has : null;
var $5a5c8f99294101b7$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $5a5c8f99294101b7$var$weakRefDeref = $5a5c8f99294101b7$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $5a5c8f99294101b7$var$booleanValueOf = Boolean.prototype.valueOf;
var $5a5c8f99294101b7$var$objectToString = Object.prototype.toString;
var $5a5c8f99294101b7$var$functionToString = Function.prototype.toString;
var $5a5c8f99294101b7$var$$match = String.prototype.match;
var $5a5c8f99294101b7$var$$slice = String.prototype.slice;
var $5a5c8f99294101b7$var$$replace = String.prototype.replace;
var $5a5c8f99294101b7$var$$toUpperCase = String.prototype.toUpperCase;
var $5a5c8f99294101b7$var$$toLowerCase = String.prototype.toLowerCase;
var $5a5c8f99294101b7$var$$test = RegExp.prototype.test;
var $5a5c8f99294101b7$var$$concat = Array.prototype.concat;
var $5a5c8f99294101b7$var$$join = Array.prototype.join;
var $5a5c8f99294101b7$var$$arrSlice = Array.prototype.slice;
var $5a5c8f99294101b7$var$$floor = Math.floor;
var $5a5c8f99294101b7$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $5a5c8f99294101b7$var$gOPS = Object.getOwnPropertySymbols;
var $5a5c8f99294101b7$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $5a5c8f99294101b7$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $5a5c8f99294101b7$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $5a5c8f99294101b7$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $5a5c8f99294101b7$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $5a5c8f99294101b7$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $5a5c8f99294101b7$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $5a5c8f99294101b7$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$5a5c8f99294101b7$var$$floor(-num) : $5a5c8f99294101b7$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $5a5c8f99294101b7$var$$slice.call(str, intStr.length + 1);
            return $5a5c8f99294101b7$var$$replace.call(intStr, sepRegex, "$&_") + "." + $5a5c8f99294101b7$var$$replace.call($5a5c8f99294101b7$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $5a5c8f99294101b7$var$$replace.call(str, sepRegex, "$&_");
}
var $7b3c9bafdaa6f1e6$exports = {};
"use strict";


var $5a5c8f99294101b7$var$inspectCustom = $7b3c9bafdaa6f1e6$exports.custom;
var $5a5c8f99294101b7$var$inspectSymbol = $5a5c8f99294101b7$var$isSymbol($5a5c8f99294101b7$var$inspectCustom) ? $5a5c8f99294101b7$var$inspectCustom : null;
$5a5c8f99294101b7$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($5a5c8f99294101b7$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($5a5c8f99294101b7$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $5a5c8f99294101b7$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($5a5c8f99294101b7$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($5a5c8f99294101b7$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $5a5c8f99294101b7$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $5a5c8f99294101b7$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $5a5c8f99294101b7$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $5a5c8f99294101b7$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $5a5c8f99294101b7$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($5a5c8f99294101b7$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $5a5c8f99294101b7$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($5a5c8f99294101b7$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$5a5c8f99294101b7$var$isRegExp(obj)) {
        var name = $5a5c8f99294101b7$var$nameOf(obj);
        var keys = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $5a5c8f99294101b7$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($5a5c8f99294101b7$var$isSymbol(obj)) {
        var symString = $5a5c8f99294101b7$var$hasShammedSymbols ? $5a5c8f99294101b7$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $5a5c8f99294101b7$var$symToString.call(obj);
        return typeof obj === "object" && !$5a5c8f99294101b7$var$hasShammedSymbols ? $5a5c8f99294101b7$var$markBoxed(symString) : symString;
    }
    if ($5a5c8f99294101b7$var$isElement(obj)) {
        var s = "<" + $5a5c8f99294101b7$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $5a5c8f99294101b7$var$wrapQuotes($5a5c8f99294101b7$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $5a5c8f99294101b7$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($5a5c8f99294101b7$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        if (indent && !$5a5c8f99294101b7$var$singleLineValues(xs)) return "[" + $5a5c8f99294101b7$var$indentedJoin(xs, indent) + "]";
        return "[ " + $5a5c8f99294101b7$var$$join.call(xs, ", ") + " ]";
    }
    if ($5a5c8f99294101b7$var$isError(obj)) {
        var parts = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$5a5c8f99294101b7$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $5a5c8f99294101b7$var$$join.call($5a5c8f99294101b7$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $5a5c8f99294101b7$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($5a5c8f99294101b7$var$inspectSymbol && typeof obj[$5a5c8f99294101b7$var$inspectSymbol] === "function" && $7b3c9bafdaa6f1e6$exports) return $7b3c9bafdaa6f1e6$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($5a5c8f99294101b7$var$isMap(obj)) {
        var mapParts = [];
        if ($5a5c8f99294101b7$var$mapForEach) $5a5c8f99294101b7$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $5a5c8f99294101b7$var$collectionOf("Map", $5a5c8f99294101b7$var$mapSize.call(obj), mapParts, indent);
    }
    if ($5a5c8f99294101b7$var$isSet(obj)) {
        var setParts = [];
        if ($5a5c8f99294101b7$var$setForEach) $5a5c8f99294101b7$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $5a5c8f99294101b7$var$collectionOf("Set", $5a5c8f99294101b7$var$setSize.call(obj), setParts, indent);
    }
    if ($5a5c8f99294101b7$var$isWeakMap(obj)) return $5a5c8f99294101b7$var$weakCollectionOf("WeakMap");
    if ($5a5c8f99294101b7$var$isWeakSet(obj)) return $5a5c8f99294101b7$var$weakCollectionOf("WeakSet");
    if ($5a5c8f99294101b7$var$isWeakRef(obj)) return $5a5c8f99294101b7$var$weakCollectionOf("WeakRef");
    if ($5a5c8f99294101b7$var$isNumber(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect(Number(obj)));
    if ($5a5c8f99294101b7$var$isBigInt(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect($5a5c8f99294101b7$var$bigIntValueOf.call(obj)));
    if ($5a5c8f99294101b7$var$isBoolean(obj)) return $5a5c8f99294101b7$var$markBoxed($5a5c8f99294101b7$var$booleanValueOf.call(obj));
    if ($5a5c8f99294101b7$var$isString(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof $parcel$global !== "undefined" && obj === $parcel$global) return "{ [object globalThis] }";
    if (!$5a5c8f99294101b7$var$isDate(obj) && !$5a5c8f99294101b7$var$isRegExp(obj)) {
        var ys = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        var isPlainObject = $5a5c8f99294101b7$var$gPO ? $5a5c8f99294101b7$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $5a5c8f99294101b7$var$toStringTag && Object(obj) === obj && $5a5c8f99294101b7$var$toStringTag in obj ? $5a5c8f99294101b7$var$$slice.call($5a5c8f99294101b7$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $5a5c8f99294101b7$var$$join.call($5a5c8f99294101b7$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $5a5c8f99294101b7$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $5a5c8f99294101b7$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $5a5c8f99294101b7$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $5a5c8f99294101b7$var$quote(s) {
    return $5a5c8f99294101b7$var$$replace.call(String(s), /"/g, "&quot;");
}
function $5a5c8f99294101b7$var$isArray(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === "[object Array]" && (!$5a5c8f99294101b7$var$toStringTag || !(typeof obj === "object" && $5a5c8f99294101b7$var$toStringTag in obj));
}
function $5a5c8f99294101b7$var$isDate(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === "[object Date]" && (!$5a5c8f99294101b7$var$toStringTag || !(typeof obj === "object" && $5a5c8f99294101b7$var$toStringTag in obj));
}
function $5a5c8f99294101b7$var$isRegExp(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === "[object RegExp]" && (!$5a5c8f99294101b7$var$toStringTag || !(typeof obj === "object" && $5a5c8f99294101b7$var$toStringTag in obj));
}
function $5a5c8f99294101b7$var$isError(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === "[object Error]" && (!$5a5c8f99294101b7$var$toStringTag || !(typeof obj === "object" && $5a5c8f99294101b7$var$toStringTag in obj));
}
function $5a5c8f99294101b7$var$isString(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === "[object String]" && (!$5a5c8f99294101b7$var$toStringTag || !(typeof obj === "object" && $5a5c8f99294101b7$var$toStringTag in obj));
}
function $5a5c8f99294101b7$var$isNumber(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === "[object Number]" && (!$5a5c8f99294101b7$var$toStringTag || !(typeof obj === "object" && $5a5c8f99294101b7$var$toStringTag in obj));
}
function $5a5c8f99294101b7$var$isBoolean(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === "[object Boolean]" && (!$5a5c8f99294101b7$var$toStringTag || !(typeof obj === "object" && $5a5c8f99294101b7$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $5a5c8f99294101b7$var$isSymbol(obj) {
    if ($5a5c8f99294101b7$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$5a5c8f99294101b7$var$symToString) return false;
    try {
        $5a5c8f99294101b7$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$5a5c8f99294101b7$var$bigIntValueOf) return false;
    try {
        $5a5c8f99294101b7$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $5a5c8f99294101b7$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $5a5c8f99294101b7$var$has(obj, key) {
    return $5a5c8f99294101b7$var$hasOwn.call(obj, key);
}
function $5a5c8f99294101b7$var$toStr(obj) {
    return $5a5c8f99294101b7$var$objectToString.call(obj);
}
function $5a5c8f99294101b7$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $5a5c8f99294101b7$var$$match.call($5a5c8f99294101b7$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $5a5c8f99294101b7$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $5a5c8f99294101b7$var$isMap(x) {
    if (!$5a5c8f99294101b7$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $5a5c8f99294101b7$var$mapSize.call(x);
        try {
            $5a5c8f99294101b7$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakMap(x) {
    if (!$5a5c8f99294101b7$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $5a5c8f99294101b7$var$weakMapHas.call(x, $5a5c8f99294101b7$var$weakMapHas);
        try {
            $5a5c8f99294101b7$var$weakSetHas.call(x, $5a5c8f99294101b7$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakRef(x) {
    if (!$5a5c8f99294101b7$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $5a5c8f99294101b7$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isSet(x) {
    if (!$5a5c8f99294101b7$var$setSize || !x || typeof x !== "object") return false;
    try {
        $5a5c8f99294101b7$var$setSize.call(x);
        try {
            $5a5c8f99294101b7$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakSet(x) {
    if (!$5a5c8f99294101b7$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $5a5c8f99294101b7$var$weakSetHas.call(x, $5a5c8f99294101b7$var$weakSetHas);
        try {
            $5a5c8f99294101b7$var$weakMapHas.call(x, $5a5c8f99294101b7$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $5a5c8f99294101b7$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $5a5c8f99294101b7$var$inspectString($5a5c8f99294101b7$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $5a5c8f99294101b7$var$$replace.call($5a5c8f99294101b7$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $5a5c8f99294101b7$var$lowbyte);
    return $5a5c8f99294101b7$var$wrapQuotes(s, "single", opts);
}
function $5a5c8f99294101b7$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $5a5c8f99294101b7$var$$toUpperCase.call(n.toString(16));
}
function $5a5c8f99294101b7$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $5a5c8f99294101b7$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $5a5c8f99294101b7$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $5a5c8f99294101b7$var$indentedJoin(entries, indent) : $5a5c8f99294101b7$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $5a5c8f99294101b7$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($5a5c8f99294101b7$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $5a5c8f99294101b7$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $5a5c8f99294101b7$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $5a5c8f99294101b7$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $5a5c8f99294101b7$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $5a5c8f99294101b7$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $5a5c8f99294101b7$var$arrObjKeys(obj, inspect) {
    var isArr = $5a5c8f99294101b7$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $5a5c8f99294101b7$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $5a5c8f99294101b7$var$gOPS === "function" ? $5a5c8f99294101b7$var$gOPS(obj) : [];
    var symMap;
    if ($5a5c8f99294101b7$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$5a5c8f99294101b7$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($5a5c8f99294101b7$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($5a5c8f99294101b7$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $5a5c8f99294101b7$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($5a5c8f99294101b7$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}



var $9tZcL = parcelRequire("9tZcL");
var $41979e9c210b0e24$var$$WeakMap = $YYhfn("%WeakMap%", true);
var $41979e9c210b0e24$var$$Map = $YYhfn("%Map%", true);
var $41979e9c210b0e24$var$$weakMapGet = $2d0686bfb37fdbd7$exports("WeakMap.prototype.get", true);
var $41979e9c210b0e24$var$$weakMapSet = $2d0686bfb37fdbd7$exports("WeakMap.prototype.set", true);
var $41979e9c210b0e24$var$$weakMapHas = $2d0686bfb37fdbd7$exports("WeakMap.prototype.has", true);
var $41979e9c210b0e24$var$$mapGet = $2d0686bfb37fdbd7$exports("Map.prototype.get", true);
var $41979e9c210b0e24$var$$mapSet = $2d0686bfb37fdbd7$exports("Map.prototype.set", true);
var $41979e9c210b0e24$var$$mapHas = $2d0686bfb37fdbd7$exports("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $41979e9c210b0e24$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $41979e9c210b0e24$var$listGet = function(objects, key) {
    var node = $41979e9c210b0e24$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $41979e9c210b0e24$var$listSet = function(objects, key, value) {
    var node = $41979e9c210b0e24$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $41979e9c210b0e24$var$listHas = function(objects, key) {
    return !!$41979e9c210b0e24$var$listGetNode(objects, key);
};
/** @type {import('.')} */ $41979e9c210b0e24$exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $9tZcL("Side channel does not contain " + $5a5c8f99294101b7$exports(key));
        },
        get: function(key) {
            if ($41979e9c210b0e24$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $41979e9c210b0e24$var$$weakMapGet($wm, key);
            } else if ($41979e9c210b0e24$var$$Map) {
                if ($m) return $41979e9c210b0e24$var$$mapGet($m, key);
            } else {
                if ($o) return $41979e9c210b0e24$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($41979e9c210b0e24$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $41979e9c210b0e24$var$$weakMapHas($wm, key);
            } else if ($41979e9c210b0e24$var$$Map) {
                if ($m) return $41979e9c210b0e24$var$$mapHas($m, key);
            } else {
                if ($o) return $41979e9c210b0e24$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($41979e9c210b0e24$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $41979e9c210b0e24$var$$WeakMap();
                $41979e9c210b0e24$var$$weakMapSet($wm, key, value);
            } else if ($41979e9c210b0e24$var$$Map) {
                if (!$m) $m = new $41979e9c210b0e24$var$$Map();
                $41979e9c210b0e24$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $41979e9c210b0e24$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};


var $e2d71df10770edb6$exports = {};
"use strict";
var $0895067d86be0ed7$exports = {};
"use strict";
var $0895067d86be0ed7$var$replace = String.prototype.replace;
var $0895067d86be0ed7$var$percentTwenties = /%20/g;
var $0895067d86be0ed7$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$0895067d86be0ed7$exports = {
    "default": $0895067d86be0ed7$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $0895067d86be0ed7$var$replace.call(value, $0895067d86be0ed7$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $0895067d86be0ed7$var$Format.RFC1738,
    RFC3986: $0895067d86be0ed7$var$Format.RFC3986
};


var $e2d71df10770edb6$var$has = Object.prototype.hasOwnProperty;
var $e2d71df10770edb6$var$isArray = Array.isArray;
var $e2d71df10770edb6$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $e2d71df10770edb6$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($e2d71df10770edb6$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $e2d71df10770edb6$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $e2d71df10770edb6$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($e2d71df10770edb6$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$e2d71df10770edb6$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($e2d71df10770edb6$var$isArray(target) && !$e2d71df10770edb6$var$isArray(source)) mergeTarget = $e2d71df10770edb6$var$arrayToObject(target, options);
    if ($e2d71df10770edb6$var$isArray(target) && $e2d71df10770edb6$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($e2d71df10770edb6$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($e2d71df10770edb6$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $e2d71df10770edb6$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $e2d71df10770edb6$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $e2d71df10770edb6$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $e2d71df10770edb6$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $e2d71df10770edb6$var$limit){
        var segment = string.length >= $e2d71df10770edb6$var$limit ? string.slice(j, j + $e2d71df10770edb6$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $0895067d86be0ed7$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xC0 | c >> 6] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xE0 | c >> 12] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 6 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xF0 | c >> 18] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 12 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 6 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $e2d71df10770edb6$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $e2d71df10770edb6$var$compactQueue(queue);
    return value;
};
var $e2d71df10770edb6$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $e2d71df10770edb6$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $e2d71df10770edb6$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $e2d71df10770edb6$var$maybeMap = function maybeMap(val, fn) {
    if ($e2d71df10770edb6$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$e2d71df10770edb6$exports = {
    arrayToObject: $e2d71df10770edb6$var$arrayToObject,
    assign: $e2d71df10770edb6$var$assign,
    combine: $e2d71df10770edb6$var$combine,
    compact: $e2d71df10770edb6$var$compact,
    decode: $e2d71df10770edb6$var$decode,
    encode: $e2d71df10770edb6$var$encode,
    isBuffer: $e2d71df10770edb6$var$isBuffer,
    isRegExp: $e2d71df10770edb6$var$isRegExp,
    maybeMap: $e2d71df10770edb6$var$maybeMap,
    merge: $e2d71df10770edb6$var$merge
};



var $79acdf0dd8ee88cb$var$has = Object.prototype.hasOwnProperty;
var $79acdf0dd8ee88cb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $79acdf0dd8ee88cb$var$isArray = Array.isArray;
var $79acdf0dd8ee88cb$var$push = Array.prototype.push;
var $79acdf0dd8ee88cb$var$pushToArray = function(arr, valueOrArray) {
    $79acdf0dd8ee88cb$var$push.apply(arr, $79acdf0dd8ee88cb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $79acdf0dd8ee88cb$var$toISO = Date.prototype.toISOString;
var $79acdf0dd8ee88cb$var$defaultFormat = $0895067d86be0ed7$exports.default;
var $79acdf0dd8ee88cb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $e2d71df10770edb6$exports.encode,
    encodeValuesOnly: false,
    format: $79acdf0dd8ee88cb$var$defaultFormat,
    formatter: $0895067d86be0ed7$exports.formatters[$79acdf0dd8ee88cb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $79acdf0dd8ee88cb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $79acdf0dd8ee88cb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $79acdf0dd8ee88cb$var$sentinel = {};
var $79acdf0dd8ee88cb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($79acdf0dd8ee88cb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($79acdf0dd8ee88cb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $79acdf0dd8ee88cb$var$isArray(obj)) obj = $e2d71df10770edb6$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $79acdf0dd8ee88cb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($79acdf0dd8ee88cb$var$isNonNullishPrimitive(obj) || $e2d71df10770edb6$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $79acdf0dd8ee88cb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $79acdf0dd8ee88cb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $79acdf0dd8ee88cb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $e2d71df10770edb6$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($79acdf0dd8ee88cb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $79acdf0dd8ee88cb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $79acdf0dd8ee88cb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $79acdf0dd8ee88cb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $41979e9c210b0e24$exports();
        valueSideChannel.set($79acdf0dd8ee88cb$var$sentinel, sideChannel);
        $79acdf0dd8ee88cb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $79acdf0dd8ee88cb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $79acdf0dd8ee88cb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $79acdf0dd8ee88cb$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $79acdf0dd8ee88cb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $0895067d86be0ed7$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$79acdf0dd8ee88cb$var$has.call($0895067d86be0ed7$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $0895067d86be0ed7$exports.formatters[format];
    var filter = $79acdf0dd8ee88cb$var$defaults.filter;
    if (typeof opts.filter === "function" || $79acdf0dd8ee88cb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $79acdf0dd8ee88cb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $79acdf0dd8ee88cb$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $79acdf0dd8ee88cb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $79acdf0dd8ee88cb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $79acdf0dd8ee88cb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $79acdf0dd8ee88cb$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $79acdf0dd8ee88cb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $79acdf0dd8ee88cb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $79acdf0dd8ee88cb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $79acdf0dd8ee88cb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $79acdf0dd8ee88cb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $79acdf0dd8ee88cb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $79acdf0dd8ee88cb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $79acdf0dd8ee88cb$var$defaults.strictNullHandling
    };
};
$79acdf0dd8ee88cb$exports = function(object, opts) {
    var obj = object;
    var options = $79acdf0dd8ee88cb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($79acdf0dd8ee88cb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $79acdf0dd8ee88cb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $41979e9c210b0e24$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $79acdf0dd8ee88cb$var$pushToArray(keys, $79acdf0dd8ee88cb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $bad802c248311354$exports = {};
"use strict";

var $bad802c248311354$var$has = Object.prototype.hasOwnProperty;
var $bad802c248311354$var$isArray = Array.isArray;
var $bad802c248311354$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $e2d71df10770edb6$exports.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $bad802c248311354$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $bad802c248311354$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $bad802c248311354$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $bad802c248311354$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $bad802c248311354$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $bad802c248311354$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $bad802c248311354$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $bad802c248311354$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $bad802c248311354$var$defaults.decoder, charset, "key");
            val = $e2d71df10770edb6$exports.maybeMap($bad802c248311354$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $bad802c248311354$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $bad802c248311354$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $bad802c248311354$var$isArray(val) ? [
            val
        ] : val;
        var existing = $bad802c248311354$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $e2d71df10770edb6$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $bad802c248311354$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $bad802c248311354$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $bad802c248311354$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $bad802c248311354$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $bad802c248311354$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $bad802c248311354$var$parseObject(keys, val, options, valuesParsed);
};
var $bad802c248311354$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $bad802c248311354$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $bad802c248311354$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $bad802c248311354$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $bad802c248311354$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $bad802c248311354$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $bad802c248311354$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $bad802c248311354$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $bad802c248311354$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $bad802c248311354$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $bad802c248311354$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $bad802c248311354$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $bad802c248311354$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $e2d71df10770edb6$exports.isRegExp(opts.delimiter) ? opts.delimiter : $bad802c248311354$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $bad802c248311354$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $bad802c248311354$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $bad802c248311354$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $bad802c248311354$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $bad802c248311354$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $bad802c248311354$var$defaults.strictNullHandling
    };
};
$bad802c248311354$exports = function(str, opts) {
    var options = $bad802c248311354$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $bad802c248311354$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $bad802c248311354$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $e2d71df10770edb6$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $e2d71df10770edb6$exports.compact(obj);
};



$6e19be61753cbc35$exports = {
    formats: $0895067d86be0ed7$exports,
    parse: $bad802c248311354$exports,
    stringify: $79acdf0dd8ee88cb$exports
};


var $cf72726b0112c451$exports = {};
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $cf72726b0112c451$var$stringTag = "[object String]";
/** Used for built-in method references. */ var $cf72726b0112c451$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cf72726b0112c451$var$objectToString = $cf72726b0112c451$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $cf72726b0112c451$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cf72726b0112c451$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $cf72726b0112c451$var$isString(value) {
    return typeof value == "string" || !$cf72726b0112c451$var$isArray(value) && $cf72726b0112c451$var$isObjectLike(value) && $cf72726b0112c451$var$objectToString.call(value) == $cf72726b0112c451$var$stringTag;
}
$cf72726b0112c451$exports = $cf72726b0112c451$var$isString;


var $e7d72dade9aebf3b$exports = {};
"use strict";
class $e7d72dade9aebf3b$var$AbortError extends Error {
    constructor(){
        super("Throttled function aborted");
        this.name = "AbortError";
    }
}
const $e7d72dade9aebf3b$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError("Expected `limit` to be a finite number");
    if (!Number.isFinite(interval)) throw new TypeError("Expected `interval` to be a finite number");
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $e7d72dade9aebf3b$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
$e7d72dade9aebf3b$exports = $e7d72dade9aebf3b$var$pThrottle;
$e7d72dade9aebf3b$exports.AbortError = $e7d72dade9aebf3b$var$AbortError;


var $3bdddaf3abddf785$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $3bdddaf3abddf785$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $3bdddaf3abddf785$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $3bdddaf3abddf785$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $3bdddaf3abddf785$var$funcProto = Function.prototype, $3bdddaf3abddf785$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $3bdddaf3abddf785$var$funcToString = $3bdddaf3abddf785$var$funcProto.toString;
/** Used to check objects for own properties. */ var $3bdddaf3abddf785$var$hasOwnProperty = $3bdddaf3abddf785$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $3bdddaf3abddf785$var$objectCtorString = $3bdddaf3abddf785$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3bdddaf3abddf785$var$objectToString = $3bdddaf3abddf785$var$objectProto.toString;
/** Built-in value references. */ var $3bdddaf3abddf785$var$getPrototype = $3bdddaf3abddf785$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3bdddaf3abddf785$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $3bdddaf3abddf785$var$isPlainObject(value) {
    if (!$3bdddaf3abddf785$var$isObjectLike(value) || $3bdddaf3abddf785$var$objectToString.call(value) != $3bdddaf3abddf785$var$objectTag || $3bdddaf3abddf785$var$isHostObject(value)) return false;
    var proto = $3bdddaf3abddf785$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $3bdddaf3abddf785$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $3bdddaf3abddf785$var$funcToString.call(Ctor) == $3bdddaf3abddf785$var$objectCtorString;
}
$3bdddaf3abddf785$exports = $3bdddaf3abddf785$var$isPlainObject;



function $24b323c95a04241b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $24b323c95a04241b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $24b323c95a04241b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $24b323c95a04241b$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $24b323c95a04241b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $24b323c95a04241b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $24b323c95a04241b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $24b323c95a04241b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = !0, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $24b323c95a04241b$var$_defineProperty(e, r, t) {
    return (r = $24b323c95a04241b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $24b323c95a04241b$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $24b323c95a04241b$var$_setPrototypeOf(t, e);
}
function $24b323c95a04241b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $24b323c95a04241b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $24b323c95a04241b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24b323c95a04241b$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24b323c95a04241b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $24b323c95a04241b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24b323c95a04241b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $24b323c95a04241b$var$_regeneratorRuntime() {
    $24b323c95a04241b$var$_regeneratorRuntime = function() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(typeof e + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $24b323c95a04241b$var$_setPrototypeOf(t, e) {
    return $24b323c95a04241b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $24b323c95a04241b$var$_setPrototypeOf(t, e);
}
function $24b323c95a04241b$var$_slicedToArray(r, e) {
    return $24b323c95a04241b$var$_arrayWithHoles(r) || $24b323c95a04241b$var$_iterableToArrayLimit(r, e) || $24b323c95a04241b$var$_unsupportedIterableToArray(r, e) || $24b323c95a04241b$var$_nonIterableRest();
}
function $24b323c95a04241b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $24b323c95a04241b$var$_toPropertyKey(t) {
    var i = $24b323c95a04241b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $24b323c95a04241b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24b323c95a04241b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24b323c95a04241b$var$_typeof(o);
}
function $24b323c95a04241b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $24b323c95a04241b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $24b323c95a04241b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $24b323c95a04241b$var$_wrapRegExp() {
    $24b323c95a04241b$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $24b323c95a04241b$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $24b323c95a04241b$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $24b323c95a04241b$var$_wrapRegExp.apply(this, arguments);
}
function $24b323c95a04241b$var$asyncToken(instance, getToken) {
    instance.interceptors.request.use(function(config) {
        return getToken().then(function(accessToken) {
            config.headers.set("Authorization", "Bearer ".concat(accessToken));
            return config;
        });
    });
}
function $24b323c95a04241b$var$isNode() {
    /**
   * Polyfills of 'process' might set process.browser === true
   *
   * See:
   * https://github.com/webpack/node-libs-browser/blob/master/mock/process.js#L8
   * https://github.com/defunctzombie/node-process/blob/master/browser.js#L156
   **/ return typeof $3267bbb6db0678de$exports !== "undefined" && false;
}
function $24b323c95a04241b$var$isReactNative() {
    return typeof window !== "undefined" && "navigator" in window && "product" in window.navigator && window.navigator.product === "ReactNative";
}
function $24b323c95a04241b$var$getNodeVersion() {
    return $3267bbb6db0678de$exports.versions && $3267bbb6db0678de$exports.versions.node ? "v".concat($3267bbb6db0678de$exports.versions.node) : $3267bbb6db0678de$exports.version;
}
function $24b323c95a04241b$var$getWindow() {
    return window;
}
function $24b323c95a04241b$var$noop() {
    return undefined;
}
var $24b323c95a04241b$var$delay = function delay(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $24b323c95a04241b$var$defaultWait = function defaultWait(attempts) {
    return Math.pow(Math.SQRT2, attempts);
};
function $24b323c95a04241b$var$rateLimit(instance) {
    var maxRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    var _instance$defaults = instance.defaults, _instance$defaults$re = _instance$defaults.responseLogger, responseLogger = _instance$defaults$re === void 0 ? $24b323c95a04241b$var$noop : _instance$defaults$re, _instance$defaults$re2 = _instance$defaults.requestLogger, requestLogger = _instance$defaults$re2 === void 0 ? $24b323c95a04241b$var$noop : _instance$defaults$re2;
    instance.interceptors.request.use(function(config) {
        requestLogger(config);
        return config;
    }, function(error) {
        requestLogger(error);
        return Promise.reject(error);
    });
    instance.interceptors.response.use(function(response) {
        // we don't need to do anything here
        responseLogger(response);
        return response;
    }, /*#__PURE__*/ function() {
        var _ref = $24b323c95a04241b$var$_asyncToGenerator(/*#__PURE__*/ $24b323c95a04241b$var$_regeneratorRuntime().mark(function _callee(error) {
            var response, config, doneAttempts, retryErrorType, wait;
            return $24b323c95a04241b$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        response = error.response;
                        config = error.config;
                        responseLogger(error);
                        // Do not retry if it is disabled or no request config exists (not an axios error)
                        if (!(!config || !instance.defaults.retryOnError)) {
                            _context.next = 5;
                            break;
                        }
                        return _context.abrupt("return", Promise.reject(error));
                    case 5:
                        // Retried already for max attempts
                        doneAttempts = config.attempts || 1;
                        if (!(doneAttempts > maxRetry)) {
                            _context.next = 9;
                            break;
                        }
                        error.attempts = config.attempts;
                        return _context.abrupt("return", Promise.reject(error));
                    case 9:
                        retryErrorType = null;
                        wait = $24b323c95a04241b$var$defaultWait(doneAttempts); // Errors without response did not receive anything from the server
                        if (!response) retryErrorType = "Connection";
                        else if (response.status >= 500 && response.status < 600) // 5** errors are server related
                        retryErrorType = "Server ".concat(response.status);
                        else if (response.status === 429) {
                            // 429 errors are exceeded rate limit exceptions
                            retryErrorType = "Rate limit";
                            // all headers are lowercased by axios https://github.com/mzabriskie/axios/issues/413
                            if (response.headers && error.response.headers["x-contentful-ratelimit-reset"]) wait = response.headers["x-contentful-ratelimit-reset"];
                        }
                        if (!retryErrorType) {
                            _context.next = 19;
                            break;
                        }
                        // convert to ms and add jitter
                        wait = Math.floor(wait * 1000 + Math.random() * 200 + 500);
                        instance.defaults.logHandler("warning", "".concat(retryErrorType, " error occurred. Waiting for ").concat(wait, " ms before retrying..."));
                        // increase attempts counter
                        config.attempts = doneAttempts + 1;
                        /* Somehow between the interceptor and retrying the request the httpAgent/httpsAgent gets transformed from an Agent-like object
             to a regular object, causing failures on retries after rate limits. Removing these properties here fixes the error, but retry
             requests still use the original http/httpsAgent property */ delete config.httpAgent;
                        delete config.httpsAgent;
                        return _context.abrupt("return", $24b323c95a04241b$var$delay(wait).then(function() {
                            return instance(config);
                        }));
                    case 19:
                        return _context.abrupt("return", Promise.reject(error));
                    case 20:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }());
}
var $24b323c95a04241b$var$PERCENTAGE_REGEX = /*#__PURE__*/ $24b323c95a04241b$var$_wrapRegExp(/(\d+)(%)/, {
    value: 1
});
function $24b323c95a04241b$var$calculateLimit(type) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
    var limit = max;
    if ($24b323c95a04241b$var$PERCENTAGE_REGEX.test(type)) {
        var _type$match;
        var groups = (_type$match = type.match($24b323c95a04241b$var$PERCENTAGE_REGEX)) === null || _type$match === void 0 ? void 0 : _type$match.groups;
        if (groups && groups.value) {
            var percentage = parseInt(groups.value) / 100;
            limit = Math.round(max * percentage);
        }
    }
    return Math.min(30, Math.max(1, limit));
}
function $24b323c95a04241b$var$createThrottle(limit, logger) {
    logger("info", "Throttle request to ".concat(limit, "/s"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($e7d72dade9aebf3b$exports)))({
        limit: limit,
        interval: 1000,
        strict: false
    });
}
var $24b323c95a04241b$var$rateLimitThrottle = function(axiosInstance) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
    var _axiosInstance$defaul = axiosInstance.defaults.logHandler, logHandler = _axiosInstance$defaul === void 0 ? $24b323c95a04241b$var$noop : _axiosInstance$defaul;
    var limit = (0, (/*@__PURE__*/$parcel$interopDefault($cf72726b0112c451$exports)))(type) ? $24b323c95a04241b$var$calculateLimit(type) : $24b323c95a04241b$var$calculateLimit("auto", type);
    var throttle = $24b323c95a04241b$var$createThrottle(limit, logHandler);
    var isCalculated = false;
    var requestInterceptorId = axiosInstance.interceptors.request.use(function(config) {
        return throttle(function() {
            return config;
        })();
    }, function(error) {
        return Promise.reject(error);
    });
    var responseInterceptorId = axiosInstance.interceptors.response.use(function(response) {
        if (!isCalculated && (0, (/*@__PURE__*/$parcel$interopDefault($cf72726b0112c451$exports)))(type) && (type === "auto" || $24b323c95a04241b$var$PERCENTAGE_REGEX.test(type)) && response.headers && response.headers["x-contentful-ratelimit-second-limit"]) {
            var rawLimit = parseInt(response.headers["x-contentful-ratelimit-second-limit"]);
            var nextLimit = $24b323c95a04241b$var$calculateLimit(type, rawLimit);
            if (nextLimit !== limit) {
                if (requestInterceptorId) axiosInstance.interceptors.request.eject(requestInterceptorId);
                limit = nextLimit;
                throttle = $24b323c95a04241b$var$createThrottle(nextLimit, logHandler);
                requestInterceptorId = axiosInstance.interceptors.request.use(function(config) {
                    return throttle(function() {
                        return config;
                    })();
                }, function(error) {
                    return Promise.reject(error);
                });
            }
            isCalculated = true;
        }
        return response;
    }, function(error) {
        return Promise.reject(error);
    });
    return function() {
        axiosInstance.interceptors.request.eject(requestInterceptorId);
        axiosInstance.interceptors.response.eject(responseInterceptorId);
    };
};
// Matches 'sub.host:port' or 'host:port' and extracts hostname and port
// Also enforces toplevel domain specified, no spaces and no protocol
var $24b323c95a04241b$var$HOST_REGEX = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
/**
 * Create pre-configured axios instance
 * @private
 * @param {AxiosStatic} axios - Axios library
 * @param {CreateHttpClientParams} options - Initialization parameters for the HTTP client
 * @return {AxiosInstance} Initialized axios instance
 */ function $24b323c95a04241b$export$5ff1805767bd358a(axios, options) {
    var defaultConfig = {
        insecure: false,
        retryOnError: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logHandler: function logHandler(level, data) {
            if (level === "error" && data) {
                var title = [
                    data.name,
                    data.message
                ].filter(function(a) {
                    return a;
                }).join(" - ");
                console.error("[error] ".concat(title));
                console.error(data);
                return;
            }
            console.log("[".concat(level, "] ").concat(data));
        },
        // Passed to axios
        headers: {},
        httpAgent: false,
        httpsAgent: false,
        timeout: 30000,
        throttle: 0,
        basePath: "",
        adapter: undefined,
        maxContentLength: 1073741824,
        // 1GB
        maxBodyLength: 1073741824 // 1GB
    };
    var config = $24b323c95a04241b$var$_objectSpread2($24b323c95a04241b$var$_objectSpread2({}, defaultConfig), options);
    if (!config.accessToken) {
        var missingAccessTokenError = new TypeError("Expected parameter accessToken");
        config.logHandler("error", missingAccessTokenError);
        throw missingAccessTokenError;
    }
    // Construct axios baseURL option
    var protocol = config.insecure ? "http" : "https";
    var space = config.space ? "".concat(config.space, "/") : "";
    var hostname = config.defaultHostname;
    var port = config.insecure ? 80 : 443;
    if (config.host && $24b323c95a04241b$var$HOST_REGEX.test(config.host)) {
        var parsed = config.host.split(":");
        if (parsed.length === 2) {
            var _parsed = $24b323c95a04241b$var$_slicedToArray(parsed, 2);
            hostname = _parsed[0];
            port = _parsed[1];
        } else hostname = parsed[0];
    }
    // Ensure that basePath does start but not end with a slash
    if (config.basePath) config.basePath = "/".concat(config.basePath.split("/").filter(Boolean).join("/"));
    var baseURL = options.baseURL || "".concat(protocol, "://").concat(hostname, ":").concat(port).concat(config.basePath, "/spaces/").concat(space);
    if (!config.headers.Authorization && typeof config.accessToken !== "function") config.headers.Authorization = "Bearer " + config.accessToken;
    var axiosOptions = {
        // Axios
        baseURL: baseURL,
        headers: config.headers,
        httpAgent: config.httpAgent,
        httpsAgent: config.httpsAgent,
        proxy: config.proxy,
        timeout: config.timeout,
        adapter: config.adapter,
        maxContentLength: config.maxContentLength,
        maxBodyLength: config.maxBodyLength,
        paramsSerializer: {
            serialize: function serialize(params) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6e19be61753cbc35$exports))).stringify(params);
            }
        },
        // Contentful
        logHandler: config.logHandler,
        responseLogger: config.responseLogger,
        requestLogger: config.requestLogger,
        retryOnError: config.retryOnError
    };
    var instance = axios.create(axiosOptions);
    instance.httpClientParams = options;
    /**
   * Creates a new axios instance with the same default base parameters as the
   * current one, and with any overrides passed to the newParams object
   * This is useful as the SDKs use dependency injection to get the axios library
   * and the version of the library comes from different places depending
   * on whether it's a browser build or a node.js build.
   * @private
   * @param {CreateHttpClientParams} newParams - Initialization parameters for the HTTP client
   * @return {AxiosInstance} Initialized axios instance
   */ instance.cloneWithNewParams = function(newParams) {
        return $24b323c95a04241b$export$5ff1805767bd358a(axios, $24b323c95a04241b$var$_objectSpread2($24b323c95a04241b$var$_objectSpread2({}, (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(options)), newParams));
    };
    /**
   * Apply interceptors.
   * Please note that the order of interceptors is important
   */ if (config.onBeforeRequest) instance.interceptors.request.use(config.onBeforeRequest);
    if (typeof config.accessToken === "function") $24b323c95a04241b$var$asyncToken(instance, config.accessToken);
    if (config.throttle) $24b323c95a04241b$var$rateLimitThrottle(instance, config.throttle);
    $24b323c95a04241b$var$rateLimit(instance, config.retryLimit);
    if (config.onError) instance.interceptors.response.use(function(response) {
        return response;
    }, config.onError);
    return instance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Creates request parameters configuration by parsing an existing query object
 * @private
 * @param {Object} query
 * @return {Object} Config object with `params` property, ready to be used in axios
 */ function $24b323c95a04241b$export$b9eda6f1d11bafa2(_ref) {
    var query = _ref.query;
    var config = {};
    delete query.resolveLinks;
    config.params = (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(query);
    return config;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $24b323c95a04241b$export$2d463bb1e491631d(obj, path) {
    if (!(path in obj)) {
        var err = new Error();
        err.name = "PropertyMissing";
        err.message = "Required property ".concat(path, " missing from:\n\n").concat(JSON.stringify(obj), "\n\n");
        throw err;
    }
    return true;
}
// copied from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
function $24b323c95a04241b$var$deepFreeze(object) {
    var propNames = Object.getOwnPropertyNames(object);
    var _iterator = $24b323c95a04241b$var$_createForOfIteratorHelper(propNames), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var name = _step.value;
            var value = object[name];
            if (value && $24b323c95a04241b$var$_typeof(value) === "object") $24b323c95a04241b$var$deepFreeze(value);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return Object.freeze(object);
}
function $24b323c95a04241b$export$5f59ea1ba3499740(obj) {
    $24b323c95a04241b$var$deepFreeze(obj.sys || {});
    return obj;
}
function $24b323c95a04241b$var$getBrowserOS() {
    var win = $24b323c95a04241b$var$getWindow();
    if (!win) return null;
    var userAgent = win.navigator.userAgent;
    // TODO: platform is deprecated.
    var platform = win.navigator.platform;
    var macosPlatforms = [
        "Macintosh",
        "MacIntel",
        "MacPPC",
        "Mac68K"
    ];
    var windowsPlatforms = [
        "Win32",
        "Win64",
        "Windows",
        "WinCE"
    ];
    var iosPlatforms = [
        "iPhone",
        "iPad",
        "iPod"
    ];
    if (macosPlatforms.indexOf(platform) !== -1) return "macOS";
    else if (iosPlatforms.indexOf(platform) !== -1) return "iOS";
    else if (windowsPlatforms.indexOf(platform) !== -1) return "Windows";
    else if (/Android/.test(userAgent)) return "Android";
    else if (/Linux/.test(platform)) return "Linux";
    return null;
}
function $24b323c95a04241b$var$getNodeOS() {
    var platform = $3267bbb6db0678de$exports.platform || "linux";
    var version = $3267bbb6db0678de$exports.version || "0.0.0";
    var platformMap = {
        android: "Android",
        aix: "Linux",
        darwin: "macOS",
        freebsd: "Linux",
        linux: "Linux",
        openbsd: "Linux",
        sunos: "Linux",
        win32: "Windows"
    };
    if (platform in platformMap) return "".concat(platformMap[platform] || "Linux", "/").concat(version);
    return null;
}
function $24b323c95a04241b$export$56c7340f89ca57c5(sdk, application, integration, feature) {
    var headerParts = [];
    if (application) headerParts.push("app ".concat(application));
    if (integration) headerParts.push("integration ".concat(integration));
    if (feature) headerParts.push("feature " + feature);
    headerParts.push("sdk ".concat(sdk));
    var platform = null;
    try {
        if ($24b323c95a04241b$var$isReactNative()) {
            platform = $24b323c95a04241b$var$getBrowserOS();
            headerParts.push("platform ReactNative");
        } else if ($24b323c95a04241b$var$isNode()) {
            platform = $24b323c95a04241b$var$getNodeOS();
            headerParts.push("platform node.js/".concat($24b323c95a04241b$var$getNodeVersion()));
        } else {
            platform = $24b323c95a04241b$var$getBrowserOS();
            headerParts.push("platform browser");
        }
    } catch (e) {
        platform = null;
    }
    if (platform) headerParts.push("os ".concat(platform));
    return "".concat(headerParts.filter(function(item) {
        return item !== "";
    }).join("; "), ";");
}
/**
 * Mixes in a method to return just a plain object with no additional methods
 * @private
 * @param data - Any plain JSON response returned from the API
 * @return Enhanced object with toPlainObject method
 */ function $24b323c95a04241b$export$8530f7b85295aab2(data) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return Object.defineProperty(data, "toPlainObject", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function value() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(this);
        }
    });
}
/**
 * Handles errors received from the server. Parses the error into a more useful
 * format, places it in an exception and throws it.
 * See https://www.contentful.com/developers/docs/references/errors/
 * for more details on the data received on the errorResponse.data property
 * and the expected error codes.
 * @private
 */ function $24b323c95a04241b$export$cc3fdd528b56c4a9(errorResponse) {
    var config = errorResponse.config, response = errorResponse.response;
    var errorName;
    // Obscure the Management token
    if (config && config.headers && config.headers["Authorization"]) {
        var token = "...".concat(config.headers["Authorization"].toString().substr(-5));
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3bdddaf3abddf785$exports)))(response) || !(0, (/*@__PURE__*/$parcel$interopDefault($3bdddaf3abddf785$exports)))(config)) throw errorResponse;
    var data = response === null || response === void 0 ? void 0 : response.data;
    var errorData = {
        status: response === null || response === void 0 ? void 0 : response.status,
        statusText: response === null || response === void 0 ? void 0 : response.statusText,
        message: "",
        details: {}
    };
    if (config && (0, (/*@__PURE__*/$parcel$interopDefault($3bdddaf3abddf785$exports)))(config)) errorData.request = {
        url: config.url,
        headers: config.headers,
        method: config.method,
        payloadData: config.data
    };
    if (data && $24b323c95a04241b$var$_typeof(data) === "object") {
        var _data$sys;
        if ("requestId" in data) errorData.requestId = data.requestId || "UNKNOWN";
        if ("message" in data) errorData.message = data.message || "";
        if ("details" in data) errorData.details = data.details || {};
        errorName = (_data$sys = data.sys) === null || _data$sys === void 0 ? void 0 : _data$sys.id;
    }
    var error = new Error();
    error.name = errorName && errorName !== "Unknown" ? errorName : "".concat(response === null || response === void 0 ? void 0 : response.status, " ").concat(response === null || response === void 0 ? void 0 : response.statusText);
    try {
        error.message = JSON.stringify(errorData, null, "  ");
    } catch (_unused) {
        var _errorData$message;
        error.message = (_errorData$message = errorData === null || errorData === void 0 ? void 0 : errorData.message) !== null && _errorData$message !== void 0 ? _errorData$message : "";
    }
    throw error;
}



var $a15838d6adce0ad4$exports = {};

$parcel$export($a15838d6adce0ad4$exports, "wrapSpace", () => $a15838d6adce0ad4$export$cb5ff1eae4996863);

function $a15838d6adce0ad4$export$cb5ff1eae4996863(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)(data));
}


var $206a6a54e62df523$exports = {};

$parcel$export($206a6a54e62df523$exports, "wrapEntry", () => $206a6a54e62df523$export$3c25ec50ddfd858c);
$parcel$export($206a6a54e62df523$exports, "wrapEntryCollection", () => $206a6a54e62df523$export$d5eecd09c78a1741);



var $kR54n = parcelRequire("kR54n");
function $89639679f16b8887$export$2e2bcd8739ae039(data) {
    return Object.defineProperty(data, "stringifySafe", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function() {
            let serializer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            let indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            return (0, (/*@__PURE__*/$parcel$interopDefault($kR54n)))(this, serializer, indent, (key, value)=>{
                return {
                    sys: {
                        type: "Link",
                        linkType: "Entry",
                        id: value.sys.id,
                        circular: true
                    }
                };
            });
        }
    });
}



var $ca1cd7dc0760fd40$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $ca1cd7dc0760fd40$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
function $ca1cd7dc0760fd40$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $ca1cd7dc0760fd40$var$UNRESOLVED_LINK = {}; // unique object to avoid polyfill bloat using Symbol()
/**
 * isLink Function
 * Checks if the object has sys.type "Link"
 * @param object
 */ var $ca1cd7dc0760fd40$var$isLink = function isLink(object) {
    return object && object.sys && object.sys.type === "Link";
};
/**
 * isResourceLink Function
 * Checks if the object has sys.type "ResourceLink"
 * @param object
 */ var $ca1cd7dc0760fd40$var$isResourceLink = function isResourceLink(object) {
    return object && object.sys && object.sys.type === "ResourceLink";
};
/**
 * Creates a key with spaceId and a key without for entityMap
 *
 * @param {*} sys
 * @param {String} sys.type
 * @param {String} sys.id
 * @param {*} sys.space
 * @param {*} sys.space.sys
 * @param {String} sys.space.id
 * @return {string[]}
 */ var $ca1cd7dc0760fd40$var$makeEntityMapKeys = function makeEntityMapKeys(sys) {
    if (sys.space && sys.environment) return [
        sys.type + "!" + sys.id,
        sys.space.sys.id + "!" + sys.environment.sys.id + "!" + sys.type + "!" + sys.id
    ];
    return [
        sys.type + "!" + sys.id
    ];
};
/**
 * Looks up in entityMap
 *
 * @param entityMap
 * @param {*} linkData
 * @param {String} linkData.type
 * @param {String} linkData.linkType
 * @param {String} linkData.id
 * @param {String} linkData.urn
 * @return {String}
 */ var $ca1cd7dc0760fd40$var$lookupInEntityMap = function lookupInEntityMap(entityMap, linkData) {
    var entryId = linkData.entryId, linkType = linkData.linkType, spaceId = linkData.spaceId, environmentId = linkData.environmentId;
    if (spaceId && environmentId) return entityMap.get(spaceId + "!" + environmentId + "!" + linkType + "!" + entryId);
    return entityMap.get(linkType + "!" + entryId);
};
var $ca1cd7dc0760fd40$var$getIdsFromUrn = function getIdsFromUrn(urn) {
    var regExp = /.*:spaces\/([^/]+)(?:\/environments\/([^/]+))?\/entries\/([^/]+)$/;
    if (!regExp.test(urn)) return undefined;
    var _urn$match = urn.match(regExp), _urn$match2 = $ca1cd7dc0760fd40$var$_slicedToArray(_urn$match, 4), _ = _urn$match2[0], spaceId = _urn$match2[1], _urn$match2$ = _urn$match2[2], environmentId = _urn$match2$ === undefined ? "master" : _urn$match2$, entryId = _urn$match2[3];
    return {
        spaceId: spaceId,
        environmentId: environmentId,
        entryId: entryId
    };
};
/**
 * getResolvedLink Function
 *
 * @param entityMap
 * @param link
 * @return {undefined}
 */ var $ca1cd7dc0760fd40$var$getResolvedLink = function getResolvedLink(entityMap, link) {
    var _link$sys = link.sys, type = _link$sys.type, linkType = _link$sys.linkType;
    if (type === "ResourceLink") {
        if (!linkType.startsWith("Contentful:")) return link;
        var urn = link.sys.urn;
        var _getIdsFromUrn = $ca1cd7dc0760fd40$var$getIdsFromUrn(urn), spaceId = _getIdsFromUrn.spaceId, environmentId = _getIdsFromUrn.environmentId, _entryId = _getIdsFromUrn.entryId;
        var extractedLinkType = linkType.split(":")[1];
        return $ca1cd7dc0760fd40$var$lookupInEntityMap(entityMap, {
            linkType: extractedLinkType,
            entryId: _entryId,
            spaceId: spaceId,
            environmentId: environmentId
        }) || $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
    }
    var entryId = link.sys.id;
    return $ca1cd7dc0760fd40$var$lookupInEntityMap(entityMap, {
        linkType: linkType,
        entryId: entryId
    }) || $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
};
/**
 * cleanUpLinks Function
 * - Removes unresolvable links from Arrays and Objects
 *
 * @param {Object[]|Object} input
 */ var $ca1cd7dc0760fd40$var$cleanUpLinks = function cleanUpLinks(input) {
    if (Array.isArray(input)) return input.filter(function(val) {
        return val !== $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
    });
    for(var key in input)if (input[key] === $ca1cd7dc0760fd40$var$UNRESOLVED_LINK) delete input[key];
    return input;
};
/**
 * walkMutate Function
 * @param input
 * @param predicate
 * @param mutator
 * @param removeUnresolved
 * @return {*}
 */ var $ca1cd7dc0760fd40$var$walkMutate = function walkMutate(input, predicate, mutator, removeUnresolved) {
    if (predicate(input)) return mutator(input);
    if (input && (typeof input === "undefined" ? "undefined" : $ca1cd7dc0760fd40$var$_typeof(input)) === "object") {
        for(var key in input)// eslint-disable-next-line no-prototype-builtins
        if (input.hasOwnProperty(key)) input[key] = walkMutate(input[key], predicate, mutator, removeUnresolved);
        if (removeUnresolved) input = $ca1cd7dc0760fd40$var$cleanUpLinks(input);
    }
    return input;
};
var $ca1cd7dc0760fd40$var$normalizeLink = function normalizeLink(entityMap, link, removeUnresolved) {
    var resolvedLink = $ca1cd7dc0760fd40$var$getResolvedLink(entityMap, link);
    if (resolvedLink === $ca1cd7dc0760fd40$var$UNRESOLVED_LINK) return removeUnresolved ? resolvedLink : link;
    return resolvedLink;
};
var $ca1cd7dc0760fd40$var$makeEntryObject = function makeEntryObject(item, itemEntryPoints) {
    if (!Array.isArray(itemEntryPoints)) return item;
    var entryPoints = Object.keys(item).filter(function(ownKey) {
        return itemEntryPoints.indexOf(ownKey) !== -1;
    });
    return entryPoints.reduce(function(entryObj, entryPoint) {
        entryObj[entryPoint] = item[entryPoint];
        return entryObj;
    }, {});
};
/**
 * resolveResponse Function
 * Resolves contentful response to normalized form.
 * @param {Object} response Contentful response
 * @param {{removeUnresolved: Boolean, itemEntryPoints: Array<String>}|{}} options
 * @param {Boolean} options.removeUnresolved - Remove unresolved links default:false
 * @param {Array<String>} options.itemEntryPoints - Resolve links only in those item properties
 * @return {Object}
 */ var $ca1cd7dc0760fd40$var$resolveResponse = function resolveResponse(response, options) {
    options = options || {};
    if (!response.items) return [];
    var responseClone = (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(response);
    var allIncludes = Object.keys(responseClone.includes || {}).reduce(function(all, type) {
        return [].concat($ca1cd7dc0760fd40$var$_toConsumableArray(all), $ca1cd7dc0760fd40$var$_toConsumableArray(response.includes[type]));
    }, []);
    var allEntries = [].concat($ca1cd7dc0760fd40$var$_toConsumableArray(responseClone.items), $ca1cd7dc0760fd40$var$_toConsumableArray(allIncludes)).filter(function(entity) {
        return Boolean(entity.sys);
    });
    var entityMap = new Map(allEntries.reduce(function(acc, entity) {
        var entries = $ca1cd7dc0760fd40$var$makeEntityMapKeys(entity.sys).map(function(key) {
            return [
                key,
                entity
            ];
        });
        acc.push.apply(acc, $ca1cd7dc0760fd40$var$_toConsumableArray(entries));
        return acc;
    }, []));
    allEntries.forEach(function(item) {
        var entryObject = $ca1cd7dc0760fd40$var$makeEntryObject(item, options.itemEntryPoints);
        Object.assign(item, $ca1cd7dc0760fd40$var$walkMutate(entryObject, function(x) {
            return $ca1cd7dc0760fd40$var$isLink(x) || $ca1cd7dc0760fd40$var$isResourceLink(x);
        }, function(link) {
            return $ca1cd7dc0760fd40$var$normalizeLink(entityMap, link, options.removeUnresolved);
        }, options.removeUnresolved));
    });
    return responseClone.items;
};
var $ca1cd7dc0760fd40$export$2e2bcd8739ae039 = $ca1cd7dc0760fd40$var$resolveResponse;


function $206a6a54e62df523$export$3c25ec50ddfd858c(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $206a6a54e62df523$export$d5eecd09c78a1741(data, _ref) {
    let { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = _ref;
    const wrappedData = (0, $89639679f16b8887$export$2e2bcd8739ae039)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
    if (resolveLinks) wrappedData.items = (0, $ca1cd7dc0760fd40$export$2e2bcd8739ae039)(wrappedData, {
        removeUnresolved: removeUnresolved,
        itemEntryPoints: [
            "fields"
        ]
    });
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)(wrappedData);
}


var $11cd1c5d46f60b03$exports = {};

$parcel$export($11cd1c5d46f60b03$exports, "wrapAsset", () => $11cd1c5d46f60b03$export$a0be037962933a64);
$parcel$export($11cd1c5d46f60b03$exports, "wrapAssetCollection", () => $11cd1c5d46f60b03$export$703c04942b452817);


function $11cd1c5d46f60b03$export$a0be037962933a64(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $11cd1c5d46f60b03$export$703c04942b452817(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $06fe4c90f1058af1$exports = {};

$parcel$export($06fe4c90f1058af1$exports, "wrapAssetKey", () => $06fe4c90f1058af1$export$c3716da8516cbd37);


function $06fe4c90f1058af1$export$c3716da8516cbd37(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $aa045771e14ce9f6$exports = {};

$parcel$export($aa045771e14ce9f6$exports, "wrapContentType", () => $aa045771e14ce9f6$export$8ffdd5df20b16d17);
$parcel$export($aa045771e14ce9f6$exports, "wrapContentTypeCollection", () => $aa045771e14ce9f6$export$3d2cfb0ebcba8025);


function $aa045771e14ce9f6$export$8ffdd5df20b16d17(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $aa045771e14ce9f6$export$3d2cfb0ebcba8025(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $57fa5d94a906c611$exports = {};

$parcel$export($57fa5d94a906c611$exports, "wrapLocale", () => $57fa5d94a906c611$export$8dc16501d170823d);
$parcel$export($57fa5d94a906c611$exports, "wrapLocaleCollection", () => $57fa5d94a906c611$export$7e4340f6ba44035a);


function $57fa5d94a906c611$export$8dc16501d170823d(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $57fa5d94a906c611$export$7e4340f6ba44035a(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $8efe14b02c001f44$exports = {};

$parcel$export($8efe14b02c001f44$exports, "wrapTag", () => $8efe14b02c001f44$export$e1decaf6a8504f95);
$parcel$export($8efe14b02c001f44$exports, "wrapTagCollection", () => $8efe14b02c001f44$export$6dec601a1a726211);


function $8efe14b02c001f44$export$e1decaf6a8504f95(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $8efe14b02c001f44$export$6dec601a1a726211(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $e41a6e5d48dcbf50$export$2e2bcd8739ae039 = {
    space: $a15838d6adce0ad4$exports,
    entry: $206a6a54e62df523$exports,
    asset: $11cd1c5d46f60b03$exports,
    assetKey: $06fe4c90f1058af1$exports,
    contentType: $aa045771e14ce9f6$exports,
    locale: $57fa5d94a906c611$exports,
    tag: $8efe14b02c001f44$exports
};





function $a70d67d792b25bfa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a70d67d792b25bfa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a70d67d792b25bfa$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a70d67d792b25bfa$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a70d67d792b25bfa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a70d67d792b25bfa$var$_defineProperty(obj, key, value) {
    key = $a70d67d792b25bfa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a70d67d792b25bfa$var$_toPropertyKey(arg) {
    var key = $a70d67d792b25bfa$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a70d67d792b25bfa$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
async function $a70d67d792b25bfa$export$2e2bcd8739ae039(http, query) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!query || !query.initial && !query.nextSyncToken && !query.nextPageToken) throw new Error("Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing");
    if (query && query.content_type && !query.type) query.type = "Entry";
    else if (query && query.content_type && query.type && query.type !== "Entry") throw new Error("When using the `content_type` filter your `type` parameter cannot be different from `Entry`.");
    const defaultOptions = {
        resolveLinks: true,
        removeUnresolved: false,
        paginate: true
    };
    const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved, paginate: paginate } = $a70d67d792b25bfa$var$_objectSpread($a70d67d792b25bfa$var$_objectSpread({}, defaultOptions), options);
    const syncOptions = {
        paginate: paginate
    };
    const response = await $a70d67d792b25bfa$var$getSyncPage(http, [], query, syncOptions);
    // clones response.items used in includes because we don't want these to be mutated
    if (resolveLinks) response.items = (0, $ca1cd7dc0760fd40$export$2e2bcd8739ae039)(response, {
        removeUnresolved: removeUnresolved,
        itemEntryPoints: [
            "fields"
        ]
    });
    // maps response items again after getters are attached
    const mappedResponseItems = $a70d67d792b25bfa$var$mapResponseItems(response.items);
    if (response.nextSyncToken) mappedResponseItems.nextSyncToken = response.nextSyncToken;
    if (response.nextPageToken) mappedResponseItems.nextPageToken = response.nextPageToken;
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $89639679f16b8887$export$2e2bcd8739ae039)((0, $24b323c95a04241b$export$8530f7b85295aab2)(mappedResponseItems)));
}
/**
 * @private
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @return {Object} Entities mapped to an object for each entity type
 */ function $a70d67d792b25bfa$var$mapResponseItems(items) {
    const reducer = (type)=>{
        return (accumulated, item)=>{
            if (item.sys.type === type) accumulated.push((0, $24b323c95a04241b$export$8530f7b85295aab2)(item));
            return accumulated;
        };
    };
    return {
        entries: items.reduce(reducer("Entry"), []),
        assets: items.reduce(reducer("Asset"), []),
        deletedEntries: items.reduce(reducer("DeletedEntry"), []),
        deletedAssets: items.reduce(reducer("DeletedAsset"), [])
    };
}
/**
 * If the response contains a nextPageUrl, extracts the sync token to get the
 * next page and calls itself again with that token.
 * Otherwise, if the response contains a nextSyncUrl, extracts the sync token
 * and returns it.
 * On each call of this function, any retrieved items are collected in the
 * supplied items array, which gets returned in the end
 * @private
 * @param {Object} http
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @param {Object} query
 * @param {Object} options - Sync page options object
 * @param {boolean} [options.paginate = true] - If further sync pages should automatically be crawled
 * @return {Promise<{items: Array, nextSyncToken: string}>}
 */ async function $a70d67d792b25bfa$var$getSyncPage(http, items, query, _ref) {
    let { paginate: paginate } = _ref;
    if (query.nextSyncToken) {
        query.sync_token = query.nextSyncToken;
        delete query.nextSyncToken;
    }
    if (query.nextPageToken) {
        query.sync_token = query.nextPageToken;
        delete query.nextPageToken;
    }
    if (query.sync_token) {
        delete query.initial;
        delete query.type;
        delete query.content_type;
        delete query.limit;
    }
    const response = await http.get("sync", (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
        query: query
    }));
    const data = response.data || {};
    items = items.concat(data.items || []);
    if (data.nextPageUrl) {
        if (paginate) {
            delete query.initial;
            query.sync_token = $a70d67d792b25bfa$var$getToken(data.nextPageUrl);
            return $a70d67d792b25bfa$var$getSyncPage(http, items, query, {
                paginate: paginate
            });
        }
        return {
            items: items,
            nextPageToken: $a70d67d792b25bfa$var$getToken(data.nextPageUrl)
        };
    } else if (data.nextSyncUrl) return {
        items: items,
        nextSyncToken: $a70d67d792b25bfa$var$getToken(data.nextSyncUrl)
    };
    else return {
        items: []
    };
}
/**
 * Extracts token out of an url
 * @private
 */ function $a70d67d792b25bfa$var$getToken(url) {
    const urlParts = url.split("?");
    return urlParts.length > 0 ? urlParts[1].replace("sync_token=", "") : "";
}


function $acfacf05f6be6c47$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $acfacf05f6be6c47$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $acfacf05f6be6c47$var$ownKeys(Object(source), !0).forEach(function(key) {
            $acfacf05f6be6c47$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $acfacf05f6be6c47$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $acfacf05f6be6c47$var$_defineProperty(obj, key, value) {
    key = $acfacf05f6be6c47$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $acfacf05f6be6c47$var$_toPropertyKey(arg) {
    var key = $acfacf05f6be6c47$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $acfacf05f6be6c47$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $acfacf05f6be6c47$export$2e2bcd8739ae039(query) {
    if (!query.select) return query;
    // The selection of fields for the query is limited
    // Get the different parts that are listed for selection
    const allSelects = Array.isArray(query.select) ? query.select : query.select.split(",").map((q)=>q.trim());
    // Move the parts into a set for easy access and deduplication
    const selectedSet = new Set(allSelects);
    // If we already select all of `sys` we can just return
    // since we're anyway fetching everything that is needed
    if (selectedSet.has("sys")) return query;
    // We don't select `sys` so we need to ensure the minimum set
    selectedSet.add("sys.id");
    selectedSet.add("sys.type");
    // Reassign the normalized sys properties
    return $acfacf05f6be6c47$var$_objectSpread($acfacf05f6be6c47$var$_objectSpread({}, query), {}, {
        select: [
            ...selectedSet
        ].join(",")
    });
}


class $a7e32c1f31f2bcbf$export$2191b9da168c6cf0 extends Error {
    constructor(name, message){
        super(`Invalid "${name}" provided, ` + message);
        this.name = "ValidationError";
    }
}
function $a7e32c1f31f2bcbf$export$2e2bcd8739ae039(name, timestamp, options) {
    options = options || {};
    if (typeof timestamp !== "number") throw new $a7e32c1f31f2bcbf$export$2191b9da168c6cf0(name, `only numeric values are allowed for timestamps, provided type was "${typeof timestamp}"`);
    if (options.maximum && timestamp > options.maximum) throw new $a7e32c1f31f2bcbf$export$2191b9da168c6cf0(name, `value (${timestamp}) cannot be further in the future than expected maximum (${options.maximum})`);
    if (options.now && timestamp < options.now) throw new $a7e32c1f31f2bcbf$export$2191b9da168c6cf0(name, `value (${timestamp}) cannot be in the past, current time was ${options.now}`);
}


function $160dd87da30dde6a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $160dd87da30dde6a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $160dd87da30dde6a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $160dd87da30dde6a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $160dd87da30dde6a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $160dd87da30dde6a$var$_defineProperty(obj, key, value) {
    key = $160dd87da30dde6a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $160dd87da30dde6a$var$_toPropertyKey(arg) {
    var key = $160dd87da30dde6a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $160dd87da30dde6a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $160dd87da30dde6a$var$ASSET_KEY_MAX_LIFETIME = 172800;
function $160dd87da30dde6a$export$2e2bcd8739ae039(_ref) {
    let { http: http, getGlobalOptions: getGlobalOptions } = _ref;
    const { wrapSpace: wrapSpace } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).space;
    const { wrapContentType: wrapContentType, wrapContentTypeCollection: wrapContentTypeCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).contentType;
    const { wrapEntry: wrapEntry, wrapEntryCollection: wrapEntryCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).entry;
    const { wrapAsset: wrapAsset, wrapAssetCollection: wrapAssetCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).asset;
    const { wrapTag: wrapTag, wrapTagCollection: wrapTagCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).tag;
    const { wrapAssetKey: wrapAssetKey } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).assetKey;
    const { wrapLocaleCollection: wrapLocaleCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).locale;
    const notFoundError = (id)=>{
        const error = new Error("The resource could not be found.");
        error.sys = {
            type: "Error",
            id: "NotFound"
        };
        error.details = {
            type: "Entry",
            id: id,
            environment: getGlobalOptions().environment,
            space: getGlobalOptions().space
        };
        return error;
    };
    /**
   * Gets the Space which the client is currently configured to use
   * @memberof ContentfulClientAPI
   * @return {Promise<Entities.Space>} Promise for a Space
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   * // returns the space object with the above <space-id>
   * const space = await client.getSpace()
   * console.log(space)
   */ async function getSpace() {
        switchToSpace(http);
        try {
            const response = await http.get("/");
            return wrapSpace(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a Content Type
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.ContentType>} Promise for a Content Type
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const contentType = await client.getContentType('<content_type_id>')
   * console.log(contentType)
   */ async function getContentType(id) {
        switchToEnvironment(http);
        try {
            const response = await http.get(`content_types/${id}`);
            return wrapContentType(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Content Types
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.ContentTypeCollection>} Promise for a collection of Content Types
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getContentTypes()
   * console.log(response.items)
   */ async function getContentTypes() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        try {
            const response = await http.get("content_types", (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapContentTypeCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets an Entry
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Entry>} Promise for an Entry
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const entry = await client.getEntry('<entry_id>')
   * console.log(entry)
   */ async function getEntry(id) {
        let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!id) throw notFoundError(id);
        try {
            const response = await this.getEntries($160dd87da30dde6a$var$_objectSpread({
                "sys.id": id
            }, query));
            if (response.items.length > 0) return wrapEntry(response.items[0]);
            else throw notFoundError(id);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Entries
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.EntryCollection>} Promise for a collection of Entries
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getEntries()
   * console.log(response.items)
   */ async function getEntries() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions(query);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get("entries", (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapEntryCollection(response.data, {
                resolveLinks: resolveLinks,
                removeUnresolved: removeUnresolved
            });
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets an Asset
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Asset>} Promise for an Asset
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const asset = await client.getAsset('<asset_id>')
   * console.log(asset)
   */ async function getAsset(id) {
        let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        switchToEnvironment(http);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get(`assets/${id}`, (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapAsset(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Assets
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.AssetCollection>} Promise for a collection of Assets
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getAssets()
   * console.log(response.items)
   */ async function getAssets() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get("assets", (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapAssetCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a Tag
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.Tag>} Promise for a Tag
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const tag = await client.getTag('<asset_id>')
   * console.log(tag)
   */ async function getTag(id) {
        switchToEnvironment(http);
        try {
            const response = await http.get(`tags/${id}`);
            return wrapTag(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Tags
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters.
   * @return {Promise<Entities.TagCollection>} Promise for a collection of Tags
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getTags()
   * console.log(response.items)
   */ async function getTags() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get("tags", (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapTagCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Creates an asset key for signing asset URLs (Embargoed Assets)
   * @memberof ContentfulClientAPI
   * @param {number} expiresAt - UNIX timestamp in the future, maximum of 48h from now
   * @return {Promise<Entities.AssetKey>} Promise for an AssetKey
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const assetKey = await client.getAssetKey(<UNIX timestamp>)
   * console.log(assetKey)
   */ async function createAssetKey(expiresAt) {
        switchToEnvironment(http);
        try {
            const now = Math.floor(Date.now() / 1000);
            const currentMaxLifetime = now + $160dd87da30dde6a$var$ASSET_KEY_MAX_LIFETIME;
            (0, $a7e32c1f31f2bcbf$export$2e2bcd8739ae039)("expiresAt", expiresAt, {
                maximum: currentMaxLifetime,
                now: now
            });
            const params = {
                expiresAt: expiresAt
            };
            const response = await http.post("asset_keys", params);
            return wrapAssetKey(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Locale
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.LocaleCollection>} Promise for a collection of Locale
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getLocales()
   * console.log(response.items)
   */ async function getLocales() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        try {
            const response = await http.get("locales", (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapLocaleCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Synchronizes either all the content or only new content since last sync
   * See <a href="https://www.contentful.com/developers/docs/concepts/sync/">Synchronization</a> for more information.
   * <strong> Important note: </strong> The the sync api endpoint does not support include or link resolution.
   * However contentful.js is doing link resolution client side if you only make an initial sync.
   * For the delta sync (using nextSyncToken) it is not possible since the sdk wont have access to all the data to make such an operation.
   * @memberof ContentfulClientAPI
   * @param  {Object} query - Query object for the sync call. One of initial or nextSyncToken always needs to be specified, but not both.
   * @param  {boolean?} query.initial - Indicates if this is the first sync. Use it if you don't have a sync token.
   * @param  {string?} query.nextSyncToken - The token you got the last time you used this method. Ensures you only get changed content.
   * @param  {string=} query.type - Filter by this type (all (default), Entry, Asset, Deletion, DeletedAsset or DeletedEntry)
   * @param  {string=} query.content_type - Filter by this content type id
   * @param  {boolean=} query.resolveLinks - When true, links to other Entries or Assets are resolved. Default: true.
   * @param  {Object} options
   * @param  {boolean=} [options.paginate = true] - Set to false to disable pagination
   * @return {Promise<Sync.SyncCollection>} Promise for the collection resulting of a sync operation
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.sync({
   *   initial: true
   * })
   * console.log({
   *   entries: response.entries,
   *   assets: response.assets,
   *   nextSyncToken: response.nextSyncToken
   * })
   */ async function sync() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            paginate: true
        };
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions(query);
        switchToEnvironment(http);
        return (0, $a70d67d792b25bfa$export$2e2bcd8739ae039)(http, query, $160dd87da30dde6a$var$_objectSpread({
            resolveLinks: resolveLinks,
            removeUnresolved: removeUnresolved
        }, options));
    }
    /**
  * Parse raw json data into collection of entry objects.Links will be resolved also
  * @memberof ContentfulClientAPI
  * @param {Object} raw json data
  * @example
  * let data = {items: [
  *    {
  *    sys: {type: 'Entry', locale: 'en-US'},
  *    fields: {
  *      animal: {sys: {type: 'Link', linkType: 'Animal', id: 'oink'}},
  *      anotheranimal: {sys: {type: 'Link', linkType: 'Animal', id: 'middle-parrot'}}
  *    }
  *  }
  * ],
  * includes: {
  *  Animal: [
  *    {
  *      sys: {type: 'Animal', id: 'oink', locale: 'en-US'},
  *      fields: {
  *        name: 'Pig',
  *        friend: {sys: {type: 'Link', linkType: 'Animal', id: 'groundhog'}}
  *      }
  *    }
  *   ]
  *  }
  * }
  * console.log( data.items[0].fields.foo ); // undefined
  * let parsedData = client.parseEntries(data);
  * console.log( parsedData.items[0].fields.foo ); // foo
  */ function parseEntries(data) {
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions({});
        return wrapEntryCollection(data, {
            resolveLinks: resolveLinks,
            removeUnresolved: removeUnresolved
        });
    }
    /*
   * Switches BaseURL to use /environments path
   * */ function switchToEnvironment(http) {
        http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
    }
    /*
   * Switches BaseURL to use /spaces path
   * */ function switchToSpace(http) {
        http.defaults.baseURL = getGlobalOptions().spaceBaseUrl;
    }
    return {
        getSpace: getSpace,
        getContentType: getContentType,
        getContentTypes: getContentTypes,
        getEntry: getEntry,
        getEntries: getEntries,
        getAsset: getAsset,
        getAssets: getAssets,
        getTag: getTag,
        getTags: getTags,
        createAssetKey: createAssetKey,
        getLocales: getLocales,
        parseEntries: parseEntries,
        sync: sync
    };
}


/**
 * Link resolution can be set globally, or it can be turned off for the methods
 * which make use of it. The local setting always overrides the global setting.
 * @private
 * @param {boolean} globalSetting - Global library setting for link resolution
 * @returns {function} Link resolver method preconfigured with global setting
 */ function $d7bfcc00e4073776$export$2e2bcd8739ae039(globalSettings) {
    /**
   * Link resolver method
   * @param {Object} query - regular query object used for collection endpoints
   */ return function getGlobalOptions(query) {
        return Object.assign({}, globalSettings, query);
    };
}


function $27e65424bfb9f508$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $27e65424bfb9f508$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $27e65424bfb9f508$var$ownKeys(Object(source), !0).forEach(function(key) {
            $27e65424bfb9f508$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $27e65424bfb9f508$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $27e65424bfb9f508$var$_defineProperty(obj, key, value) {
    key = $27e65424bfb9f508$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27e65424bfb9f508$var$_toPropertyKey(arg) {
    var key = $27e65424bfb9f508$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $27e65424bfb9f508$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $27e65424bfb9f508$export$5d730b7aed1a3eb0(params) {
    if (!params.accessToken) throw new TypeError("Expected parameter accessToken");
    if (!params.space) throw new TypeError("Expected parameter space");
    const defaultConfig = {
        resolveLinks: true,
        removeUnresolved: false,
        defaultHostname: "cdn.contentful.com",
        environment: "master"
    };
    const config = $27e65424bfb9f508$var$_objectSpread($27e65424bfb9f508$var$_objectSpread({}, defaultConfig), params);
    const userAgentHeader = (0, $24b323c95a04241b$export$56c7340f89ca57c5)(`contentful.js/${"9.3.7"}`, config.application, config.integration);
    config.headers = $27e65424bfb9f508$var$_objectSpread($27e65424bfb9f508$var$_objectSpread({}, config.headers), {}, {
        "Content-Type": "application/vnd.contentful.delivery.v1+json",
        "X-Contentful-User-Agent": userAgentHeader
    });
    const http = (0, $24b323c95a04241b$export$5ff1805767bd358a)((0, $4caf0f2bcd8b9e34$export$2e2bcd8739ae039), config);
    const getGlobalOptions = (0, $d7bfcc00e4073776$export$2e2bcd8739ae039)({
        resolveLinks: config.resolveLinks,
        environment: config.environment,
        removeUnresolved: config.removeUnresolved,
        spaceBaseUrl: http.defaults.baseURL,
        environmentBaseUrl: `${http.defaults.baseURL}environments/${config.environment}`
    });
    // Append environment to baseURL
    http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
    return (0, $160dd87da30dde6a$export$2e2bcd8739ae039)({
        http: http,
        getGlobalOptions: getGlobalOptions
    });
}


/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8tsvq = parcelRequire("8tsvq");

/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $cec6b334748d9a6c$var$_extends() {
    $cec6b334748d9a6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cec6b334748d9a6c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $cec6b334748d9a6c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($cec6b334748d9a6c$export$e19cd5f9376f8cee || ($cec6b334748d9a6c$export$e19cd5f9376f8cee = {}));
const $cec6b334748d9a6c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $cec6b334748d9a6c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $cec6b334748d9a6c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $cec6b334748d9a6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $cec6b334748d9a6c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $cec6b334748d9a6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
    }
    return $cec6b334748d9a6c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $cec6b334748d9a6c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $cec6b334748d9a6c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $cec6b334748d9a6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $cec6b334748d9a6c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $cec6b334748d9a6c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $cec6b334748d9a6c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $cec6b334748d9a6c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $cec6b334748d9a6c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $cec6b334748d9a6c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $cec6b334748d9a6c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $cec6b334748d9a6c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $cec6b334748d9a6c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $cec6b334748d9a6c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $cec6b334748d9a6c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($cec6b334748d9a6c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        let location = $cec6b334748d9a6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $cec6b334748d9a6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        let location = $cec6b334748d9a6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $cec6b334748d9a6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $cec6b334748d9a6c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($cec6b334748d9a6c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($cec6b334748d9a6c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $cec6b334748d9a6c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($cec6b334748d9a6c$var$ResultType || ($cec6b334748d9a6c$var$ResultType = {}));
const $cec6b334748d9a6c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $cec6b334748d9a6c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $cec6b334748d9a6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $cec6b334748d9a6c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $cec6b334748d9a6c$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($cec6b334748d9a6c$var$isIndexRoute(route)) {
            let indexRoute = $cec6b334748d9a6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $cec6b334748d9a6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $cec6b334748d9a6c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $cec6b334748d9a6c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $cec6b334748d9a6c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $cec6b334748d9a6c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $cec6b334748d9a6c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $cec6b334748d9a6c$var$flattenRoutes(routes);
    $cec6b334748d9a6c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $cec6b334748d9a6c$export$30d21fd6d7295f52(pathname);
        matches = $cec6b334748d9a6c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $cec6b334748d9a6c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $cec6b334748d9a6c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $cec6b334748d9a6c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $cec6b334748d9a6c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $cec6b334748d9a6c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $cec6b334748d9a6c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $cec6b334748d9a6c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $cec6b334748d9a6c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $cec6b334748d9a6c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $cec6b334748d9a6c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $cec6b334748d9a6c$var$paramRe = /^:[\w-]+$/;
const $cec6b334748d9a6c$var$dynamicSegmentValue = 3;
const $cec6b334748d9a6c$var$indexRouteValue = 2;
const $cec6b334748d9a6c$var$emptySegmentValue = 1;
const $cec6b334748d9a6c$var$staticSegmentValue = 10;
const $cec6b334748d9a6c$var$splatPenalty = -2;
const $cec6b334748d9a6c$var$isSplat = (s)=>s === "*";
function $cec6b334748d9a6c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($cec6b334748d9a6c$var$isSplat)) initialScore += $cec6b334748d9a6c$var$splatPenalty;
    if (index) initialScore += $cec6b334748d9a6c$var$indexRouteValue;
    return segments.filter((s)=>!$cec6b334748d9a6c$var$isSplat(s)).reduce((score, segment)=>score + ($cec6b334748d9a6c$var$paramRe.test(segment) ? $cec6b334748d9a6c$var$dynamicSegmentValue : segment === "" ? $cec6b334748d9a6c$var$emptySegmentValue : $cec6b334748d9a6c$var$staticSegmentValue), initialScore);
}
function $cec6b334748d9a6c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $cec6b334748d9a6c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $cec6b334748d9a6c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $cec6b334748d9a6c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $cec6b334748d9a6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $cec6b334748d9a6c$export$a5c6d149b50c1d86($cec6b334748d9a6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $cec6b334748d9a6c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $cec6b334748d9a6c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $cec6b334748d9a6c$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $cec6b334748d9a6c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $cec6b334748d9a6c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $cec6b334748d9a6c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $cec6b334748d9a6c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $cec6b334748d9a6c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $cec6b334748d9a6c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $cec6b334748d9a6c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $cec6b334748d9a6c$var$normalizeSearch(search),
        hash: $cec6b334748d9a6c$var$normalizeHash(hash)
    };
}
function $cec6b334748d9a6c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $cec6b334748d9a6c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $cec6b334748d9a6c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $cec6b334748d9a6c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $cec6b334748d9a6c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $cec6b334748d9a6c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $cec6b334748d9a6c$var$_extends({}, toArg);
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $cec6b334748d9a6c$var$getInvalidPathError("?", "pathname", "search", to));
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $cec6b334748d9a6c$var$getInvalidPathError("#", "pathname", "hash", to));
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $cec6b334748d9a6c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $cec6b334748d9a6c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $cec6b334748d9a6c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $cec6b334748d9a6c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $cec6b334748d9a6c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $cec6b334748d9a6c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $cec6b334748d9a6c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $cec6b334748d9a6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $cec6b334748d9a6c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $cec6b334748d9a6c$export$4051a07651545597(data, init) {
    return new $cec6b334748d9a6c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $cec6b334748d9a6c$export$42a99a7a4bc0e76a extends Error {
}
class $cec6b334748d9a6c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $cec6b334748d9a6c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $cec6b334748d9a6c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $cec6b334748d9a6c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $cec6b334748d9a6c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $cec6b334748d9a6c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $cec6b334748d9a6c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $cec6b334748d9a6c$var$unwrapTrackedPromise(value) {
    if (!$cec6b334748d9a6c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $cec6b334748d9a6c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $cec6b334748d9a6c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $cec6b334748d9a6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $cec6b334748d9a6c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $cec6b334748d9a6c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $cec6b334748d9a6c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $cec6b334748d9a6c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $cec6b334748d9a6c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $cec6b334748d9a6c$var$validMutationMethods = new Set($cec6b334748d9a6c$var$validMutationMethodsArr);
const $cec6b334748d9a6c$var$validRequestMethodsArr = [
    "get",
    ...$cec6b334748d9a6c$var$validMutationMethodsArr
];
const $cec6b334748d9a6c$var$validRequestMethods = new Set($cec6b334748d9a6c$var$validRequestMethodsArr);
const $cec6b334748d9a6c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $cec6b334748d9a6c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $cec6b334748d9a6c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cec6b334748d9a6c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cec6b334748d9a6c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $cec6b334748d9a6c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $cec6b334748d9a6c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $cec6b334748d9a6c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cec6b334748d9a6c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $cec6b334748d9a6c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $cec6b334748d9a6c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$cec6b334748d9a6c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$cec6b334748d9a6c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $cec6b334748d9a6c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $cec6b334748d9a6c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $cec6b334748d9a6c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $cec6b334748d9a6c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$cec6b334748d9a6c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $cec6b334748d9a6c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $cec6b334748d9a6c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $cec6b334748d9a6c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $cec6b334748d9a6c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $cec6b334748d9a6c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($cec6b334748d9a6c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $cec6b334748d9a6c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $cec6b334748d9a6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $cec6b334748d9a6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $cec6b334748d9a6c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $cec6b334748d9a6c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $cec6b334748d9a6c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $cec6b334748d9a6c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $cec6b334748d9a6c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $cec6b334748d9a6c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $cec6b334748d9a6c$var$findNearestBoundary(matches).route.id,
            {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $cec6b334748d9a6c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($cec6b334748d9a6c$var$isErrorResult(result) && $cec6b334748d9a6c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $cec6b334748d9a6c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $cec6b334748d9a6c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $cec6b334748d9a6c$var$_extends({
            matches: updatedMatches || matches
        }, $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $cec6b334748d9a6c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $cec6b334748d9a6c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $cec6b334748d9a6c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $cec6b334748d9a6c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $cec6b334748d9a6c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $cec6b334748d9a6c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $cec6b334748d9a6c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $cec6b334748d9a6c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($cec6b334748d9a6c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $cec6b334748d9a6c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $cec6b334748d9a6c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $cec6b334748d9a6c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $cec6b334748d9a6c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $cec6b334748d9a6c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $cec6b334748d9a6c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $cec6b334748d9a6c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $cec6b334748d9a6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $cec6b334748d9a6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $cec6b334748d9a6c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cec6b334748d9a6c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $cec6b334748d9a6c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($cec6b334748d9a6c$var$isRedirectResult(actionResult) || $cec6b334748d9a6c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($cec6b334748d9a6c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $cec6b334748d9a6c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($cec6b334748d9a6c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($cec6b334748d9a6c$var$isDeferredResult(actionResult)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $cec6b334748d9a6c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $cec6b334748d9a6c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $cec6b334748d9a6c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $cec6b334748d9a6c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $cec6b334748d9a6c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cec6b334748d9a6c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $cec6b334748d9a6c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) result = await $cec6b334748d9a6c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $cec6b334748d9a6c$export$3e9cee6b33872309(!$cec6b334748d9a6c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $cec6b334748d9a6c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $cec6b334748d9a6c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $cec6b334748d9a6c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $cec6b334748d9a6c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace : $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $cec6b334748d9a6c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($cec6b334748d9a6c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $cec6b334748d9a6c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $cec6b334748d9a6c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $cec6b334748d9a6c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $cec6b334748d9a6c$var$ResultType.redirect,
                response: $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $cec6b334748d9a6c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: $cec6b334748d9a6c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $cec6b334748d9a6c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $cec6b334748d9a6c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $cec6b334748d9a6c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $cec6b334748d9a6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $cec6b334748d9a6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $cec6b334748d9a6c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $cec6b334748d9a6c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $cec6b334748d9a6c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $cec6b334748d9a6c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $cec6b334748d9a6c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$cec6b334748d9a6c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $cec6b334748d9a6c$export$4d0306f8f6a4585b = Symbol("deferred");
function $cec6b334748d9a6c$export$3336b097a6fbc59a(routes, opts) {
    $cec6b334748d9a6c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cec6b334748d9a6c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $cec6b334748d9a6c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cec6b334748d9a6c$var$createLocation("", $cec6b334748d9a6c$export$fe53371bee54353d(url), null, "default");
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cec6b334748d9a6c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($cec6b334748d9a6c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $cec6b334748d9a6c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cec6b334748d9a6c$var$createLocation("", $cec6b334748d9a6c$export$fe53371bee54353d(url), null, "default");
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cec6b334748d9a6c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $cec6b334748d9a6c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $cec6b334748d9a6c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $cec6b334748d9a6c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($cec6b334748d9a6c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$cec6b334748d9a6c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $cec6b334748d9a6c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($cec6b334748d9a6c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $cec6b334748d9a6c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $cec6b334748d9a6c$var$isResponse(result) ? result : $cec6b334748d9a6c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($cec6b334748d9a6c$var$isDataStrategyResult(e) && $cec6b334748d9a6c$var$isResponse(e.result)) {
                if (e.type === $cec6b334748d9a6c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($cec6b334748d9a6c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($cec6b334748d9a6c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $cec6b334748d9a6c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $cec6b334748d9a6c$var$_extends({}, context, {
                statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $cec6b334748d9a6c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $cec6b334748d9a6c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $cec6b334748d9a6c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategy || $cec6b334748d9a6c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($cec6b334748d9a6c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $cec6b334748d9a6c$export$fec11da027c70692(routes, context, error) {
    let newContext = $cec6b334748d9a6c$var$_extends({}, context, {
        statusCode: $cec6b334748d9a6c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $cec6b334748d9a6c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $cec6b334748d9a6c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $cec6b334748d9a6c$export$cae722b0cc860f13(to ? to : ".", $cec6b334748d9a6c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $cec6b334748d9a6c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $cec6b334748d9a6c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $cec6b334748d9a6c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $cec6b334748d9a6c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $cec6b334748d9a6c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$cec6b334748d9a6c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$cec6b334748d9a6c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $cec6b334748d9a6c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $cec6b334748d9a6c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $cec6b334748d9a6c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$cec6b334748d9a6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$cec6b334748d9a6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $cec6b334748d9a6c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $cec6b334748d9a6c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $cec6b334748d9a6c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $cec6b334748d9a6c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $cec6b334748d9a6c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $cec6b334748d9a6c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $cec6b334748d9a6c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $cec6b334748d9a6c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($cec6b334748d9a6c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $cec6b334748d9a6c$var$shouldRevalidateLoader(match, $cec6b334748d9a6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $cec6b334748d9a6c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $cec6b334748d9a6c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $cec6b334748d9a6c$var$shouldRevalidateLoader(fetcherMatch, $cec6b334748d9a6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $cec6b334748d9a6c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $cec6b334748d9a6c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $cec6b334748d9a6c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $cec6b334748d9a6c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $cec6b334748d9a6c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$cec6b334748d9a6c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $cec6b334748d9a6c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$cec6b334748d9a6c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $cec6b334748d9a6c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $cec6b334748d9a6c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $cec6b334748d9a6c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$cec6b334748d9a6c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $cec6b334748d9a6c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $cec6b334748d9a6c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $cec6b334748d9a6c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $cec6b334748d9a6c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $cec6b334748d9a6c$var$ResultType.data,
                result: undefined
            });
        };
        return $cec6b334748d9a6c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $cec6b334748d9a6c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $cec6b334748d9a6c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $cec6b334748d9a6c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $cec6b334748d9a6c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($cec6b334748d9a6c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: e
            };
        }
        if (type === $cec6b334748d9a6c$var$ResultType.error) return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: new $cec6b334748d9a6c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $cec6b334748d9a6c$var$ResultType.error) {
        if ($cec6b334748d9a6c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $cec6b334748d9a6c$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: result,
            statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($cec6b334748d9a6c$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $cec6b334748d9a6c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($cec6b334748d9a6c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $cec6b334748d9a6c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $cec6b334748d9a6c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $cec6b334748d9a6c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $cec6b334748d9a6c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $cec6b334748d9a6c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $cec6b334748d9a6c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($cec6b334748d9a6c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $cec6b334748d9a6c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $cec6b334748d9a6c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $cec6b334748d9a6c$export$3e9cee6b33872309(!$cec6b334748d9a6c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $cec6b334748d9a6c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $cec6b334748d9a6c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $cec6b334748d9a6c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $cec6b334748d9a6c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($cec6b334748d9a6c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $cec6b334748d9a6c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($cec6b334748d9a6c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $cec6b334748d9a6c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $cec6b334748d9a6c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $cec6b334748d9a6c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $cec6b334748d9a6c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $cec6b334748d9a6c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $cec6b334748d9a6c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $cec6b334748d9a6c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $cec6b334748d9a6c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $cec6b334748d9a6c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(path) : path;
    return $cec6b334748d9a6c$export$fe53371bee54353d($cec6b334748d9a6c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $cec6b334748d9a6c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $cec6b334748d9a6c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $cec6b334748d9a6c$var$ResultType.data || result.type === $cec6b334748d9a6c$var$ResultType.error);
}
function $cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result) {
    return $cec6b334748d9a6c$var$isResponse(result.result) && $cec6b334748d9a6c$var$redirectStatusCodes.has(result.result.status);
}
function $cec6b334748d9a6c$var$isDeferredResult(result) {
    return result.type === $cec6b334748d9a6c$var$ResultType.deferred;
}
function $cec6b334748d9a6c$var$isErrorResult(result) {
    return result.type === $cec6b334748d9a6c$var$ResultType.error;
}
function $cec6b334748d9a6c$var$isRedirectResult(result) {
    return (result && result.type) === $cec6b334748d9a6c$var$ResultType.redirect;
}
function $cec6b334748d9a6c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $cec6b334748d9a6c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $cec6b334748d9a6c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $cec6b334748d9a6c$var$isRedirectResponse(result) {
    if (!$cec6b334748d9a6c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $cec6b334748d9a6c$var$isValidMethod(method) {
    return $cec6b334748d9a6c$var$validRequestMethods.has(method.toLowerCase());
}
function $cec6b334748d9a6c$var$isMutationMethod(method) {
    return $cec6b334748d9a6c$var$validMutationMethods.has(method.toLowerCase());
}
async function $cec6b334748d9a6c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$cec6b334748d9a6c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($cec6b334748d9a6c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $cec6b334748d9a6c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $cec6b334748d9a6c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $cec6b334748d9a6c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $cec6b334748d9a6c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $cec6b334748d9a6c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $cec6b334748d9a6c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $cec6b334748d9a6c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $cec6b334748d9a6c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $cec6b334748d9a6c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $cec6b334748d9a6c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $cec6b334748d9a6c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $cec6b334748d9a6c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $cec6b334748d9a6c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $cec6b334748d9a6c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $cec6b334748d9a6c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $cec6b334748d9a6c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $cec6b334748d9a6c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $cec6b334748d9a6c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $cec6b334748d9a6c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8tsvq = parcelRequire("8tsvq");

function $5bc57f835864eb51$var$_extends() {
    $5bc57f835864eb51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5bc57f835864eb51$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $5bc57f835864eb51$export$3add0d5dce533e2e = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$145dfa71566a64dc = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$var$AwaitContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $5bc57f835864eb51$export$26749e8557646306 = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$c7914228fb69b0f5 = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$9072aa6dd1f93057 = /*#__PURE__*/ $8tsvq.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $5bc57f835864eb51$var$RouteErrorContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $5bc57f835864eb51$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5bc57f835864eb51$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $5bc57f835864eb51$export$9c954a9d03d32f4a() {
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $5bc57f835864eb51$export$45d76561a5302f2b() {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $5bc57f835864eb51$export$1b3f31771c5d07c() {
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $5bc57f835864eb51$export$6c330e8992e8a295(pattern) {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    return $8tsvq.useMemo(()=>(0, $cec6b334748d9a6c$export$81336c211d5ff295)(pattern, (0, $cec6b334748d9a6c$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $5bc57f835864eb51$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $5bc57f835864eb51$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8tsvq.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $5bc57f835864eb51$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $5bc57f835864eb51$var$useNavigateStable() : $5bc57f835864eb51$var$useNavigateUnstable();
}
function $5bc57f835864eb51$var$useNavigateUnstable() {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8tsvq.useRef(false);
    $5bc57f835864eb51$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8tsvq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $5bc57f835864eb51$var$OutletContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $5bc57f835864eb51$export$4138103a3ae699cc() {
    return $8tsvq.useContext($5bc57f835864eb51$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $5bc57f835864eb51$export$a3be3530d8e40d0b(context) {
    let outlet = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $5bc57f835864eb51$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $5bc57f835864eb51$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8tsvq.useMemo(()=>(0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $5bc57f835864eb51$export$5d3fca4a98652595(routes, locationArg) {
    return $5bc57f835864eb51$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $5bc57f835864eb51$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: parentMatches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $5bc57f835864eb51$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $cec6b334748d9a6c$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $cec6b334748d9a6c$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $5bc57f835864eb51$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5bc57f835864eb51$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $cec6b334748d9a6c$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5bc57f835864eb51$var$DefaultErrorComponent() {
    let error = $5bc57f835864eb51$export$ed527bf60f6e05f2();
    let message = (0, $cec6b334748d9a6c$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8tsvq.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8tsvq.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $5bc57f835864eb51$var$defaultErrorElement = /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$DefaultErrorComponent, null);
class $5bc57f835864eb51$var$RenderErrorBoundary extends $8tsvq.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $5bc57f835864eb51$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5bc57f835864eb51$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $5bc57f835864eb51$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5bc57f835864eb51$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8tsvq.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $5bc57f835864eb51$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($5bc57f835864eb51$var$DataRouterHook || {});
var $5bc57f835864eb51$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($5bc57f835864eb51$var$DataRouterStateHook || {});
function $5bc57f835864eb51$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5bc57f835864eb51$var$useDataRouterContext(hookName) {
    let ctx = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    !ctx && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $5bc57f835864eb51$var$useDataRouterState(hookName) {
    let state = $8tsvq.useContext($5bc57f835864eb51$export$145dfa71566a64dc);
    !state && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return state;
}
function $5bc57f835864eb51$var$useRouteContext(hookName) {
    let route = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    !route && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $5bc57f835864eb51$var$useCurrentRouteId(hookName) {
    let route = $5bc57f835864eb51$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $5bc57f835864eb51$export$5fc8298006ad9e58() {
    return $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5bc57f835864eb51$export$d0fd4b7106de2769() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5bc57f835864eb51$export$600dc272ed516c15() {
    let dataRouterContext = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseRevalidator);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRevalidator);
    return $8tsvq.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5bc57f835864eb51$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseMatches);
    return $8tsvq.useMemo(()=>matches.map((m)=>(0, $cec6b334748d9a6c$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5bc57f835864eb51$export$1448a5050d252c4d() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5bc57f835864eb51$export$fd5d37484eab868d(routeId) {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5bc57f835864eb51$export$fdc00f3f26066d5e() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseActionData);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $5bc57f835864eb51$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8tsvq.useContext($5bc57f835864eb51$var$RouteErrorContext);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRouteError);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $5bc57f835864eb51$export$78a72ddb39bdd145() {
    let value = $8tsvq.useContext($5bc57f835864eb51$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $5bc57f835864eb51$export$17f53340677d5831() {
    let value = $8tsvq.useContext($5bc57f835864eb51$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $5bc57f835864eb51$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $5bc57f835864eb51$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseBlocker);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8tsvq.useState("");
    let blockerFunction = $8tsvq.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $5bc57f835864eb51$var$_extends({}, currentLocation, {
                pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $5bc57f835864eb51$var$_extends({}, nextLocation, {
                pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8tsvq.useEffect(()=>{
        let key = String(++$5bc57f835864eb51$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8tsvq.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $cec6b334748d9a6c$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $5bc57f835864eb51$var$useNavigateStable() {
    let { router: router } = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseNavigateStable);
    let id = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8tsvq.useRef(false);
    $5bc57f835864eb51$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8tsvq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $5bc57f835864eb51$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $5bc57f835864eb51$var$alreadyWarned = {};
function $5bc57f835864eb51$var$warningOnce(key, cond, message) {
    if (!cond && !$5bc57f835864eb51$var$alreadyWarned[key]) $5bc57f835864eb51$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5bc57f835864eb51$var$START_TRANSITION = "startTransition";
const $5bc57f835864eb51$var$startTransitionImpl = $8tsvq[$5bc57f835864eb51$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5bc57f835864eb51$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8tsvq.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        if (v7_startTransition && $5bc57f835864eb51$var$startTransitionImpl) $5bc57f835864eb51$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8tsvq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8tsvq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8tsvq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8tsvq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $5bc57f835864eb51$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $5bc57f835864eb51$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $5bc57f835864eb51$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $5bc57f835864eb51$var$startTransitionImpl ? $5bc57f835864eb51$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $5bc57f835864eb51$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let navigate = $5bc57f835864eb51$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, (0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8tsvq.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $5bc57f835864eb51$export$910ae8079b2c2852(props) {
    return $5bc57f835864eb51$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $5bc57f835864eb51$export$e7b0ac011bb776c6(_props) {
    (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $5bc57f835864eb51$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $cec6b334748d9a6c$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8tsvq.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $5bc57f835864eb51$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $cec6b334748d9a6c$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8tsvq.useMemo(()=>{
        let trailingPathname = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $5bc57f835864eb51$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $5bc57f835864eb51$export$5d3fca4a98652595($5bc57f835864eb51$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5bc57f835864eb51$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$ResolveAwait, null, children));
}
var $5bc57f835864eb51$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($5bc57f835864eb51$var$AwaitRenderStatus || {});
const $5bc57f835864eb51$var$neverSettledPromise = new Promise(()=>{});
class $5bc57f835864eb51$var$AwaitErrorBoundary extends $8tsvq.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5bc57f835864eb51$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5bc57f835864eb51$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5bc57f835864eb51$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $5bc57f835864eb51$var$AwaitRenderStatus.error : "_data" in promise ? $5bc57f835864eb51$var$AwaitRenderStatus.success : $5bc57f835864eb51$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5bc57f835864eb51$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error && promise._error instanceof (0, $cec6b334748d9a6c$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $5bc57f835864eb51$var$neverSettledPromise;
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $5bc57f835864eb51$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $5bc57f835864eb51$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $5bc57f835864eb51$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8tsvq.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8tsvq.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8tsvq.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5bc57f835864eb51$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $5bc57f835864eb51$export$e7b0ac011bb776c6) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5bc57f835864eb51$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5bc57f835864eb51$export$daf73786167a7f72(matches) {
    return $5bc57f835864eb51$var$_renderMatches(matches);
}
function $5bc57f835864eb51$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8tsvq.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8tsvq.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8tsvq.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $5bc57f835864eb51$export$f30f7e456d254e83(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5bc57f835864eb51$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $5bc57f835864eb51$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $63c245eaedba316b$var$_extends() {
    $63c245eaedba316b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63c245eaedba316b$var$_extends.apply(this, arguments);
}
function $63c245eaedba316b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $63c245eaedba316b$var$defaultMethod = "get";
const $63c245eaedba316b$var$defaultEncType = "application/x-www-form-urlencoded";
function $63c245eaedba316b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $63c245eaedba316b$var$isButtonElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $63c245eaedba316b$var$isFormElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $63c245eaedba316b$var$isInputElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $63c245eaedba316b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $63c245eaedba316b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$63c245eaedba316b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $63c245eaedba316b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $63c245eaedba316b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $63c245eaedba316b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $63c245eaedba316b$var$_formDataSupportsSubmitter = null;
function $63c245eaedba316b$var$isFormDataSubmitterSupported() {
    if ($63c245eaedba316b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $63c245eaedba316b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $63c245eaedba316b$var$_formDataSupportsSubmitter = true;
    }
    return $63c245eaedba316b$var$_formDataSupportsSubmitter;
}
const $63c245eaedba316b$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $63c245eaedba316b$var$getFormEncType(encType) {
    if (encType != null && !$63c245eaedba316b$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $63c245eaedba316b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($63c245eaedba316b$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $63c245eaedba316b$var$defaultMethod;
        encType = $63c245eaedba316b$var$getFormEncType(target.getAttribute("enctype")) || $63c245eaedba316b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($63c245eaedba316b$var$isButtonElement(target) || $63c245eaedba316b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $63c245eaedba316b$var$defaultMethod;
        encType = $63c245eaedba316b$var$getFormEncType(target.getAttribute("formenctype")) || $63c245eaedba316b$var$getFormEncType(form.getAttribute("enctype")) || $63c245eaedba316b$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$63c245eaedba316b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($63c245eaedba316b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $63c245eaedba316b$var$defaultMethod;
        action = null;
        encType = $63c245eaedba316b$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $63c245eaedba316b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $63c245eaedba316b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $63c245eaedba316b$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $63c245eaedba316b$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $63c245eaedba316b$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $63c245eaedba316b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $63c245eaedba316b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $63c245eaedba316b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5bc57f835864eb51$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $63c245eaedba316b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $63c245eaedba316b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $63c245eaedba316b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5bc57f835864eb51$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $63c245eaedba316b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $63c245eaedba316b$var$_extends({}, state, {
        errors: $63c245eaedba316b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $63c245eaedba316b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $cec6b334748d9a6c$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $63c245eaedba316b$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8tsvq.createContext({
    isTransitioning: false
});
const $63c245eaedba316b$export$148fd98d095596d4 = /*#__PURE__*/ $8tsvq.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $63c245eaedba316b$var$START_TRANSITION = "startTransition";
const $63c245eaedba316b$var$startTransitionImpl = $8tsvq[$63c245eaedba316b$var$START_TRANSITION];
const $63c245eaedba316b$var$FLUSH_SYNC = "flushSync";
const $63c245eaedba316b$var$flushSyncImpl = $a2d184922ae7f92f$exports[$63c245eaedba316b$var$FLUSH_SYNC];
const $63c245eaedba316b$var$USE_ID = "useId";
const $63c245eaedba316b$var$useIdImpl = $8tsvq[$63c245eaedba316b$var$USE_ID];
function $63c245eaedba316b$var$startTransitionSafe(cb) {
    if ($63c245eaedba316b$var$startTransitionImpl) $63c245eaedba316b$var$startTransitionImpl(cb);
    else cb();
}
function $63c245eaedba316b$var$flushSyncSafe(cb) {
    if ($63c245eaedba316b$var$flushSyncImpl) $63c245eaedba316b$var$flushSyncImpl(cb);
    else cb();
}
class $63c245eaedba316b$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $63c245eaedba316b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8tsvq.useState(router.state);
    let [pendingState, setPendingState] = $8tsvq.useState();
    let [vtContext, setVtContext] = $8tsvq.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8tsvq.useState();
    let [transition, setTransition] = $8tsvq.useState();
    let [interruption, setInterruption] = $8tsvq.useState();
    let fetcherData = $8tsvq.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8tsvq.useCallback((cb)=>{
        if (v7_startTransition) $63c245eaedba316b$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8tsvq.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $63c245eaedba316b$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $63c245eaedba316b$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $63c245eaedba316b$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $63c245eaedba316b$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $63c245eaedba316b$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8tsvq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8tsvq.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $63c245eaedba316b$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8tsvq.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8tsvq.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8tsvq.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8tsvq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8tsvq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8tsvq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8tsvq.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $63c245eaedba316b$var$MemoizedDataRoutes = /*#__PURE__*/ $8tsvq.memo($63c245eaedba316b$var$DataRoutes);
function $63c245eaedba316b$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5bc57f835864eb51$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $63c245eaedba316b$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $63c245eaedba316b$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $63c245eaedba316b$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $63c245eaedba316b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $63c245eaedba316b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $63c245eaedba316b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8tsvq.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref7, $63c245eaedba316b$var$_excluded);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $63c245eaedba316b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($63c245eaedba316b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5bc57f835864eb51$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $63c245eaedba316b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8tsvq.createElement("a", $63c245eaedba316b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $63c245eaedba316b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8tsvq.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref8, $63c245eaedba316b$var$_excluded2);
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let routerState = $8tsvq.useContext((0, $5bc57f835864eb51$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $63c245eaedba316b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$a6c7ac8248d6e38a, $63c245eaedba316b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $63c245eaedba316b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8tsvq.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $63c245eaedba316b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref9, $63c245eaedba316b$var$_excluded3);
    let submit = $63c245eaedba316b$export$47c85c6e3a081d3();
    let formAction = $63c245eaedba316b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8tsvq.createElement("form", $63c245eaedba316b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $63c245eaedba316b$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $63c245eaedba316b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $63c245eaedba316b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($63c245eaedba316b$var$DataRouterHook || ($63c245eaedba316b$var$DataRouterHook = {}));
var $63c245eaedba316b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($63c245eaedba316b$var$DataRouterStateHook || ($63c245eaedba316b$var$DataRouterStateHook = {}));
// Internal hooks
function $63c245eaedba316b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $63c245eaedba316b$var$useDataRouterContext(hookName) {
    let ctx = $8tsvq.useContext((0, $5bc57f835864eb51$export$3add0d5dce533e2e));
    !ctx && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $63c245eaedba316b$var$useDataRouterState(hookName) {
    let state = $8tsvq.useContext((0, $5bc57f835864eb51$export$145dfa71566a64dc));
    !state && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $63c245eaedba316b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8tsvq.useCallback((event)=>{
        if ($63c245eaedba316b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $cec6b334748d9a6c$export$fe53371bee54353d)(location) === (0, $cec6b334748d9a6c$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $63c245eaedba316b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8tsvq.useRef($63c245eaedba316b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8tsvq.useRef(false);
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let searchParams = $8tsvq.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $63c245eaedba316b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    let setSearchParams = $8tsvq.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $63c245eaedba316b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $63c245eaedba316b$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $63c245eaedba316b$var$fetcherId = 0;
let $63c245eaedba316b$var$getUniqueFetcherId = ()=>"__" + String(++$63c245eaedba316b$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $63c245eaedba316b$export$47c85c6e3a081d3() {
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let currentRouteId = (0, $5bc57f835864eb51$export$5fc8298006ad9e58)();
    return $8tsvq.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $63c245eaedba316b$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $63c245eaedba316b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $63c245eaedba316b$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $63c245eaedba316b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let routeContext = $8tsvq.useContext((0, $5bc57f835864eb51$export$9072aa6dd1f93057));
    !routeContext && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $63c245eaedba316b$var$_extends({}, (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $cec6b334748d9a6c$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $63c245eaedba316b$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseFetcher);
    let state = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8tsvq.useContext($63c245eaedba316b$export$148fd98d095596d4);
    let route = $8tsvq.useContext((0, $5bc57f835864eb51$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    !route && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $63c245eaedba316b$var$useIdImpl ? $63c245eaedba316b$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8tsvq.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($63c245eaedba316b$var$getUniqueFetcherId());
    // Registration/cleanup
    $8tsvq.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8tsvq.useCallback((href, opts)=>{
        !routeId && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $63c245eaedba316b$export$47c85c6e3a081d3();
    let submit = $8tsvq.useCallback((target, opts)=>{
        submitImpl(target, $63c245eaedba316b$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8tsvq.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8tsvq.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$a7fed597f4b8afd8, $63c245eaedba316b$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $cec6b334748d9a6c$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8tsvq.useMemo(()=>$63c245eaedba316b$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $63c245eaedba316b$export$fa996778a3a31087() {
    let state = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $63c245eaedba316b$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $63c245eaedba316b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $63c245eaedba316b$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let matches = (0, $5bc57f835864eb51$export$2378eb7f5ff86053)();
    let navigation = (0, $5bc57f835864eb51$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8tsvq.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $63c245eaedba316b$var$usePageHide($8tsvq.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $63c245eaedba316b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($63c245eaedba316b$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $63c245eaedba316b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($63c245eaedba316b$var$_extends({}, location, {
                    pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($63c245eaedba316b$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $63c245eaedba316b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8tsvq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $63c245eaedba316b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8tsvq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $63c245eaedba316b$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5bc57f835864eb51$export$b273b3273281a049)(when);
    $8tsvq.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8tsvq.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $63c245eaedba316b$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8tsvq.useContext($63c245eaedba316b$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { basename: basename } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $cec6b334748d9a6c$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $cec6b334748d9a6c$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $7acc1b1aefcd90a7$exports = {};
$7acc1b1aefcd90a7$exports = new URL("logo.73c7dafb.png", import.meta.url).toString();


const $bf0d4196deb7c8c8$var$MAIN_SITE_URL = "https://www.newsalist.net";
const $bf0d4196deb7c8c8$var$VIDEOS_SITE_URL = "https://videos.newsalist.net";
const $bf0d4196deb7c8c8$var$MAIN_CATEGORIES = [
    {
        label: "\u0645\u0642\u0627\u0644\u0627\u062A",
        href: `${$bf0d4196deb7c8c8$var$MAIN_SITE_URL}/category/mqalat/`
    },
    {
        label: "\u0627\u0644\u0625\u0641\u062A\u062A\u0627\u062D\u064A\u0651\u0629",
        href: `${$bf0d4196deb7c8c8$var$MAIN_SITE_URL}/category/alifttahyh/`
    },
    {
        label: "\u0625\u0639\u0631\u0641 \u0623\u0643\u062B\u0631",
        href: `${$bf0d4196deb7c8c8$var$MAIN_SITE_URL}/category/iarf-akthr/`
    },
    {
        label: "\u0627\u0644\u062D\u062F\u062B",
        href: `${$bf0d4196deb7c8c8$var$MAIN_SITE_URL}/category/alhdth/`
    },
    {
        label: "\u0623\u0646\u062A\u0645 \u0648\u0627\u0644\u062D\u062F\u062B",
        href: `${$bf0d4196deb7c8c8$var$MAIN_SITE_URL}/category/antm-walhdth/`
    }
];
const $bf0d4196deb7c8c8$var$Header = ()=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("header", {
        className: "site-header",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "site-header__top",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "container site-header__top-inner",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                            className: "site-header__tagline",
                            children: "\xab\xa0\u0644\u0627 \u062A\u0642\u0641 \u0645\u062A\u0641\u0631\u062C\u0627\u064B\xa0\xbb"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                            href: $bf0d4196deb7c8c8$var$VIDEOS_SITE_URL,
                            className: "site-header__live-link",
                            rel: "noopener",
                            children: "\u0641\u064A\u062F\u064A\u0648"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "site-header__brand-bar",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "container site-header__brand-inner",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                            href: $bf0d4196deb7c8c8$var$MAIN_SITE_URL,
                            className: "site-header__back",
                            rel: "noopener",
                            "aria-label": "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0646\u064A\u0648\u0632\u0627\u0644\u064A\u0633\u062A",
                            title: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0646\u064A\u0648\u0632\u0627\u0644\u064A\u0633\u062A",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                    className: "site-header__back-long",
                                    children: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0646\u064A\u0648\u0632\u0627\u0644\u064A\u0633\u062A \u2190"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                    className: "site-header__back-short",
                                    "aria-hidden": "true",
                                    children: "\u2190"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                            href: "/",
                            className: "site-header__brand",
                            "aria-label": "\u0646\u064A\u0648\u0632\u0627\u0644\u064A\u0633\u062A \u2014 \u0641\u0644\u0627\u0634 \u0646\u064A\u0648\u0632",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7acc1b1aefcd90a7$exports))),
                                    alt: "Newsalist",
                                    width: 300,
                                    height: 111,
                                    className: "site-header__logo"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                    className: "site-header__section",
                                    children: "\u0641\u0644\u0627\u0634"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                            className: "site-header__spacer",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("nav", {
                className: "site-header__nav",
                "aria-label": "\u0627\u0644\u062A\u0635\u0641\u0651\u062D \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "container site-header__nav-inner",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                            href: "/",
                            className: "site-header__nav-link site-header__nav-link--active",
                            children: "\u0641\u0644\u0627\u0634 \u0646\u064A\u0648\u0632"
                        }),
                        $bf0d4196deb7c8c8$var$MAIN_CATEGORIES.map((cat)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: cat.href,
                                className: "site-header__nav-link",
                                rel: "noopener",
                                children: cat.label
                            }, cat.href))
                    ]
                })
            })
        ]
    });
};
var $bf0d4196deb7c8c8$export$2e2bcd8739ae039 = $bf0d4196deb7c8c8$var$Header;




const $f066148deeb3f081$var$MAIN_SITE_URL = "https://www.newsalist.net";
const $f066148deeb3f081$var$VIDEOS_SITE_URL = "https://videos.newsalist.net";
const $f066148deeb3f081$var$QUICK_LINKS = [
    {
        label: "\u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
        href: $f066148deeb3f081$var$MAIN_SITE_URL
    },
    {
        label: "\u0641\u064A\u062F\u064A\u0648",
        href: $f066148deeb3f081$var$VIDEOS_SITE_URL
    },
    {
        label: "\u0644\u0644\u0625\u0639\u0644\u0627\u0646 \u0645\u0639\u0646\u0627",
        href: `${$f066148deeb3f081$var$MAIN_SITE_URL}/contact`
    },
    {
        label: "\u0623\u0646\u062A\u0645 \u0648\u0627\u0644\u062D\u062F\u062B",
        href: `${$f066148deeb3f081$var$MAIN_SITE_URL}/category/antm-walhdth/`
    },
    {
        label: "\u0627\u0644\u062D\u062F\u062B",
        href: `${$f066148deeb3f081$var$MAIN_SITE_URL}/category/alhdth/`
    },
    {
        label: "\u0625\u0639\u0631\u0641 \u0623\u0643\u062B\u0631",
        href: `${$f066148deeb3f081$var$MAIN_SITE_URL}/category/iarf-akthr/`
    },
    {
        label: "\u0645\u0642\u0627\u0644\u0627\u062A",
        href: `${$f066148deeb3f081$var$MAIN_SITE_URL}/category/mqalat/`
    }
];
const $f066148deeb3f081$var$SOCIAL_LINKS = [
    {
        label: "\u0648\u0627\u062A\u0633\u0627\u0628",
        href: "https://chat.whatsapp.com/GMEvPxxSgTg0dTyP1l3sqz",
        icon: "WA"
    },
    {
        label: "\u0641\u064A\u0633\u0628\u0648\u0643",
        href: "https://www.facebook.com/profile.php?id=100087373202655",
        icon: "f"
    },
    {
        label: "\u062A\u0648\u064A\u062A\u0631",
        href: "https://twitter.com/newsalist",
        icon: "X"
    },
    {
        label: "\u0625\u0646\u0633\u062A\u063A\u0631\u0627\u0645",
        href: "https://www.instagram.com/newsalist",
        icon: "IG"
    },
    {
        label: "\u0644\u064A\u0646\u0643\u062F\u0625\u0646",
        href: "https://www.linkedin.com/in/newsalist-net-664330255",
        icon: "in"
    },
    {
        label: "\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        href: "mailto:desk@newsalist.net",
        icon: "@"
    }
];
const $f066148deeb3f081$var$Footer = ()=>{
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("footer", {
        className: "site-footer",
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            className: "container site-footer__inner",
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "site-footer__brand-col",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7acc1b1aefcd90a7$exports))),
                            alt: "Newsalist",
                            width: 300,
                            height: 111,
                            className: "site-footer__logo"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            className: "site-footer__section",
                            children: "\u0641\u0644\u0627\u0634 \u0646\u064A\u0648\u0632"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            className: "site-footer__tagline",
                            children: "\xab\xa0\u0644\u0627 \u062A\u0642\u0641 \u0645\u062A\u0641\u0631\u062C\u0627\u064B\xa0\xbb"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                            className: "site-footer__rights",
                            children: [
                                "\xa9 ",
                                year,
                                "\u060C \u0643\u0644 \u0627\u0644\u062D\u0642\u0648\u0642 \u0645\u062D\u0641\u0648\u0638\u0629."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "site-footer__col",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                            className: "site-footer__col-title",
                            children: "\u0631\u0648\u0627\u0628\u0637 \u0633\u0631\u064A\u0639\u0629"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "site-footer__list",
                            children: $f066148deeb3f081$var$QUICK_LINKS.map((link)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                        href: link.href,
                                        className: "site-footer__link",
                                        rel: "noopener",
                                        children: link.label
                                    })
                                }, link.href))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "site-footer__col",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                            className: "site-footer__col-title",
                            children: "\u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "site-footer__social",
                            children: $f066148deeb3f081$var$SOCIAL_LINKS.map((s)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                        href: s.href,
                                        className: "site-footer__social-link",
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        "aria-label": s.label,
                                        title: s.label,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            children: s.icon
                                        })
                                    })
                                }, s.href))
                        })
                    ]
                })
            ]
        })
    });
};
var $f066148deeb3f081$export$2e2bcd8739ae039 = $f066148deeb3f081$var$Footer;




var $8tsvq = parcelRequire("8tsvq");


var $8tsvq = parcelRequire("8tsvq");
function $d2e4c754b87197f5$var$r() {
    return $d2e4c754b87197f5$var$r = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $d2e4c754b87197f5$var$r.apply(this, arguments);
}
var $d2e4c754b87197f5$var$n, $d2e4c754b87197f5$var$t = [
    "children",
    "options"
], $d2e4c754b87197f5$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($d2e4c754b87197f5$var$n || ($d2e4c754b87197f5$var$n = {}));
var $d2e4c754b87197f5$var$a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, r) {
    return e[r.toLowerCase()] = r, e;
}, {
    for: "htmlFor"
}), $d2e4c754b87197f5$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $d2e4c754b87197f5$var$l = [
    "style",
    "script"
], $d2e4c754b87197f5$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $d2e4c754b87197f5$var$u = /mailto:/i, $d2e4c754b87197f5$var$s = /\n{2,}$/, $d2e4c754b87197f5$var$d = /^(\s*>[\s\S]*?)(?=\n{2,})/, $d2e4c754b87197f5$var$f = /^ *> ?/gm, $d2e4c754b87197f5$var$p = /^ {2,}\n/, $d2e4c754b87197f5$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $d2e4c754b87197f5$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $d2e4c754b87197f5$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $d2e4c754b87197f5$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $d2e4c754b87197f5$var$k = /^(?:\n *)*\n/, $d2e4c754b87197f5$var$v = /\r\n?/g, $d2e4c754b87197f5$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $d2e4c754b87197f5$var$b = /^\[\^([^\]]+)]/, $d2e4c754b87197f5$var$S = /\f/g, $d2e4c754b87197f5$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $d2e4c754b87197f5$var$w = /^\s*?\[(x|\s)\]/, $d2e4c754b87197f5$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d2e4c754b87197f5$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d2e4c754b87197f5$var$L = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $d2e4c754b87197f5$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $d2e4c754b87197f5$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $d2e4c754b87197f5$var$O = /^<!--[\s\S]*?(?:-->)/, $d2e4c754b87197f5$var$$ = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $d2e4c754b87197f5$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $d2e4c754b87197f5$var$M = /^\{.*\}$/, $d2e4c754b87197f5$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $d2e4c754b87197f5$var$I = /^<([^ >]+@[^ >]+)>/, $d2e4c754b87197f5$var$U = /^<([^ >]+:\/[^ >]+)>/, $d2e4c754b87197f5$var$D = /-([a-z])?/gi, $d2e4c754b87197f5$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $d2e4c754b87197f5$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $d2e4c754b87197f5$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $d2e4c754b87197f5$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $d2e4c754b87197f5$var$P = /(\[|\])/g, $d2e4c754b87197f5$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $d2e4c754b87197f5$var$W = /\t/g, $d2e4c754b87197f5$var$G = /(^ *\||\| *$)/g, $d2e4c754b87197f5$var$Z = /^ *:-+: *$/, $d2e4c754b87197f5$var$q = /^ *:-+ *$/, $d2e4c754b87197f5$var$Q = /^ *-+: *$/, $d2e4c754b87197f5$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $d2e4c754b87197f5$var$X = new RegExp("^([*_])\\1" + $d2e4c754b87197f5$var$V + "\\1\\1(?!\\1)"), $d2e4c754b87197f5$var$J = new RegExp("^([*_])" + $d2e4c754b87197f5$var$V + "\\1(?!\\1|\\w)"), $d2e4c754b87197f5$var$K = new RegExp("^==" + $d2e4c754b87197f5$var$V + "=="), $d2e4c754b87197f5$var$Y = new RegExp("^~~" + $d2e4c754b87197f5$var$V + "~~"), $d2e4c754b87197f5$var$ee = /^\\([^0-9A-Za-z\s])/, $d2e4c754b87197f5$var$re = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $d2e4c754b87197f5$var$ne = /^\n+/, $d2e4c754b87197f5$var$te = /^([ \t]*)/, $d2e4c754b87197f5$var$ie = /\\([^\\])/g, $d2e4c754b87197f5$var$ae = / *\n+$/, $d2e4c754b87197f5$var$oe = /(?:^|\n)( *)$/, $d2e4c754b87197f5$var$le = "(?:\\d+\\.)", $d2e4c754b87197f5$var$ce = "(?:[*+-])";
function $d2e4c754b87197f5$var$ue(e) {
    return "( *)(" + (1 === e ? $d2e4c754b87197f5$var$le : $d2e4c754b87197f5$var$ce) + ") +";
}
var $d2e4c754b87197f5$var$se = $d2e4c754b87197f5$var$ue(1), $d2e4c754b87197f5$var$de = $d2e4c754b87197f5$var$ue(2);
function $d2e4c754b87197f5$var$fe(e) {
    return new RegExp("^" + (1 === e ? $d2e4c754b87197f5$var$se : $d2e4c754b87197f5$var$de));
}
var $d2e4c754b87197f5$var$pe = $d2e4c754b87197f5$var$fe(1), $d2e4c754b87197f5$var$he = $d2e4c754b87197f5$var$fe(2);
function $d2e4c754b87197f5$var$me(e) {
    return new RegExp("^" + (1 === e ? $d2e4c754b87197f5$var$se : $d2e4c754b87197f5$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $d2e4c754b87197f5$var$le : $d2e4c754b87197f5$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $d2e4c754b87197f5$var$ge = $d2e4c754b87197f5$var$me(1), $d2e4c754b87197f5$var$ye = $d2e4c754b87197f5$var$me(2);
function $d2e4c754b87197f5$var$ke(e) {
    var r = 1 === e ? $d2e4c754b87197f5$var$le : $d2e4c754b87197f5$var$ce;
    return new RegExp("^( *)(" + r + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + r + " (?!" + r + " ))\\n*|\\s*\\n*$)");
}
var $d2e4c754b87197f5$var$ve = $d2e4c754b87197f5$var$ke(1), $d2e4c754b87197f5$var$xe = $d2e4c754b87197f5$var$ke(2);
function $d2e4c754b87197f5$var$be(e, r) {
    var n = 1 === r, t = n ? $d2e4c754b87197f5$var$ve : $d2e4c754b87197f5$var$xe, a = n ? $d2e4c754b87197f5$var$ge : $d2e4c754b87197f5$var$ye, o = n ? $d2e4c754b87197f5$var$pe : $d2e4c754b87197f5$var$he;
    return {
        match: function(e, r, n) {
            var i = $d2e4c754b87197f5$var$oe.exec(n);
            return i && (r.list || !r.inline && !r.simple) ? t.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse: function(e, r, t) {
            var i = n ? +e[2] : void 0, l = e[0].replace($d2e4c754b87197f5$var$s, "\n").match(a), c = !1;
            return {
                items: l.map(function(e, n) {
                    var i = o.exec(e)[0].length, a = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(a, "").replace(o, ""), s = n === l.length - 1, d = -1 !== u.indexOf("\n\n") || s && c;
                    c = d;
                    var f, p = t.inline, h = t.list;
                    t.list = !0, d ? (t.inline = !1, f = u.replace($d2e4c754b87197f5$var$ae, "\n\n")) : (t.inline = !0, f = u.replace($d2e4c754b87197f5$var$ae, ""));
                    var m = r(f, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: function(r, n, t) {
            return e(r.ordered ? "ol" : "ul", {
                key: t.key,
                start: r.type === $d2e4c754b87197f5$export$e0aa44767d8750d5.orderedList ? r.start : void 0
            }, r.items.map(function(r, i) {
                return e("li", {
                    key: i
                }, n(r, t));
            }));
        }
    };
}
var $d2e4c754b87197f5$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $d2e4c754b87197f5$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $d2e4c754b87197f5$var$we = [
    $d2e4c754b87197f5$var$d,
    $d2e4c754b87197f5$var$m,
    $d2e4c754b87197f5$var$g,
    $d2e4c754b87197f5$var$C,
    $d2e4c754b87197f5$var$L,
    $d2e4c754b87197f5$var$z,
    $d2e4c754b87197f5$var$O,
    $d2e4c754b87197f5$var$j,
    $d2e4c754b87197f5$var$ge,
    $d2e4c754b87197f5$var$ve,
    $d2e4c754b87197f5$var$ye,
    $d2e4c754b87197f5$var$xe
], $d2e4c754b87197f5$var$Ce = [].concat($d2e4c754b87197f5$var$we, [
    /^[^\n]+(?:  \n|\n{2,})/,
    $d2e4c754b87197f5$var$A,
    $d2e4c754b87197f5$var$B
]);
function $d2e4c754b87197f5$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $d2e4c754b87197f5$var$Le(e) {
    return $d2e4c754b87197f5$var$Q.test(e) ? "right" : $d2e4c754b87197f5$var$Z.test(e) ? "center" : $d2e4c754b87197f5$var$q.test(e) ? "left" : null;
}
function $d2e4c754b87197f5$var$Ae(e, r, n, t) {
    var a = n.inTable;
    n.inTable = !0;
    var o = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce(function(e, a) {
        return "|" === a.trim() ? e.push(t ? {
            type: $d2e4c754b87197f5$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $d2e4c754b87197f5$export$e0aa44767d8750d5.text,
            text: a
        }) : "" !== a && e.push.apply(e, r(a, n)), e;
    }, []);
    n.inTable = a;
    var l = [
        []
    ];
    return o.forEach(function(e, r) {
        e.type === $d2e4c754b87197f5$export$e0aa44767d8750d5.tableSeparator ? 0 !== r && r !== o.length - 1 && l.push([]) : (e.type !== $d2e4c754b87197f5$export$e0aa44767d8750d5.text || null != o[r + 1] && o[r + 1].type !== $d2e4c754b87197f5$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), l[l.length - 1].push(e));
    }), l;
}
function $d2e4c754b87197f5$var$Te(e, r, n) {
    n.inline = !0;
    var t = e[2] ? e[2].replace($d2e4c754b87197f5$var$G, "").split("|").map($d2e4c754b87197f5$var$Le) : [], a = e[3] ? function(e, r, n) {
        return e.trim().split("\n").map(function(e) {
            return $d2e4c754b87197f5$var$Ae(e, r, n, !0);
        });
    }(e[3], r, n) : [], o = $d2e4c754b87197f5$var$Ae(e[1], r, n, !!a.length);
    return n.inline = !1, a.length ? {
        align: t,
        cells: a,
        header: o,
        type: $d2e4c754b87197f5$export$e0aa44767d8750d5.table
    } : {
        children: o,
        type: $d2e4c754b87197f5$export$e0aa44767d8750d5.paragraph
    };
}
function $d2e4c754b87197f5$var$Oe(e, r) {
    return null == e.align[r] ? {} : {
        textAlign: e.align[r]
    };
}
function $d2e4c754b87197f5$var$$e(e) {
    return function(r, n) {
        return n.inline ? e.exec(r) : null;
    };
}
function $d2e4c754b87197f5$var$Be(e) {
    return function(r, n) {
        return n.inline || n.simple ? e.exec(r) : null;
    };
}
function $d2e4c754b87197f5$var$Me(e) {
    return function(r, n) {
        return n.inline || n.simple ? null : e.exec(r);
    };
}
function $d2e4c754b87197f5$var$Re(e) {
    return function(r) {
        return e.exec(r);
    };
}
function $d2e4c754b87197f5$var$Ie(e, r, n) {
    if (r.inline || r.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    var t = "";
    e.split("\n").every(function(e) {
        return !$d2e4c754b87197f5$var$we.some(function(r) {
            return r.test(e);
        }) && (t += e + "\n", e.trim());
    });
    var i = t.trimEnd();
    return "" == i ? null : [
        t,
        i
    ];
}
function $d2e4c754b87197f5$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $d2e4c754b87197f5$var$De(e) {
    return e.replace($d2e4c754b87197f5$var$ie, "$1");
}
function $d2e4c754b87197f5$var$je(e, r, n) {
    var t = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    var a = e(r, n);
    return n.inline = t, n.simple = i, a;
}
function $d2e4c754b87197f5$var$Ne(e, r, n) {
    var t = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    var a = e(r, n);
    return n.inline = t, n.simple = i, a;
}
function $d2e4c754b87197f5$var$He(e, r, n) {
    var t = n.inline || !1;
    n.inline = !1;
    var i = e(r, n);
    return n.inline = t, i;
}
var $d2e4c754b87197f5$var$Fe = function(e, r, n) {
    return {
        children: $d2e4c754b87197f5$var$je(r, e[1], n)
    };
};
function $d2e4c754b87197f5$var$Pe() {
    return {};
}
function $d2e4c754b87197f5$var$_e() {
    return null;
}
function $d2e4c754b87197f5$var$We() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $d2e4c754b87197f5$var$Ge(e, r, n) {
    for(var t = e, i = r.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || n;
}
function $d2e4c754b87197f5$var$Ze(e, r) {
    var n = $d2e4c754b87197f5$var$Ge(r, e);
    return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $d2e4c754b87197f5$var$Ge(r, e + ".component", e) : e;
}
function $d2e4c754b87197f5$export$69f434acfbdb0b32(n, t) {
    var s;
    function G(e, n) {
        var i, a = $d2e4c754b87197f5$var$Ge(t.overrides, e + ".props", {});
        return (i = t).createElement.apply(i, [
            $d2e4c754b87197f5$var$Ze(e, t.overrides),
            $d2e4c754b87197f5$var$r({}, n, a, {
                className: $d2e4c754b87197f5$var$We(null == n ? void 0 : n.className, a.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function Z(r) {
        r = r.replace($d2e4c754b87197f5$var$E, "");
        var n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $d2e4c754b87197f5$var$_.test(r));
        for(var i = le(oe(n ? r : r.trimEnd().replace($d2e4c754b87197f5$var$ne, "") + "\n\n", {
            inline: n
        })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === t.wrapper) return i;
        var a, o = t.wrapper || (n ? "span" : "div");
        if (i.length > 1 || t.forceWrapper) a = i;
        else {
            if (1 === i.length) return "string" == typeof (a = i[0]) ? G("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $8tsvq.createElement(o, {
            key: "outer"
        }, a);
    }
    function q(r, n) {
        var i = n.match($d2e4c754b87197f5$var$c);
        return i ? i.reduce(function(n, i, o) {
            var l = i.indexOf("=");
            if (-1 !== l) {
                var c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($d2e4c754b87197f5$var$$) && (e = e.replace($d2e4c754b87197f5$var$D, function(e, r) {
                        return r.toUpperCase();
                    })), e;
                })(i.slice(0, l)).trim(), u = function(e) {
                    var r = e[0];
                    return ('"' === r || "'" === r) && e.length >= 2 && e[e.length - 1] === r ? e.slice(1, -1) : e;
                }(i.slice(l + 1).trim()), s = $d2e4c754b87197f5$var$a[c] || c, d = n[s] = function(e, r, n, t) {
                    return "style" === r ? n.split(/;\s?/).reduce(function(e, r) {
                        var n = r.slice(0, r.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = r.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === r || "src" === r ? t(n, e, r) : (n.match($d2e4c754b87197f5$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(r, c, u, t.sanitizer);
                "string" == typeof d && ($d2e4c754b87197f5$var$A.test(d) || $d2e4c754b87197f5$var$B.test(d)) && (n[s] = $8tsvq.cloneElement(Z(d.trim()), {
                    key: o
                }));
            } else "style" !== i && (n[$d2e4c754b87197f5$var$a[i] || i] = !0);
            return n;
        }, {}) : null;
    }
    void 0 === n && (n = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.sanitizer = t.sanitizer || $d2e4c754b87197f5$export$3e2338ea76b578c9, t.slugify = t.slugify || $d2e4c754b87197f5$export$c383cdd2a518017a, t.namedCodesToUnicode = t.namedCodesToUnicode ? $d2e4c754b87197f5$var$r({}, $d2e4c754b87197f5$var$o, t.namedCodesToUnicode) : $d2e4c754b87197f5$var$o, t.createElement = t.createElement || $8tsvq.createElement;
    var Q = [], V = {}, ie = ((s = {})[$d2e4c754b87197f5$export$e0aa44767d8750d5.blockQuote] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$d),
        order: 1,
        parse: function(e, r, n) {
            return {
                children: r(e[0].replace($d2e4c754b87197f5$var$f, ""), n)
            };
        },
        render: function(e, r, n) {
            return G("blockquote", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.breakLine] = {
        match: $d2e4c754b87197f5$var$Re($d2e4c754b87197f5$var$p),
        order: 1,
        parse: $d2e4c754b87197f5$var$Pe,
        render: function(e, r, n) {
            return G("br", {
                key: n.key
            });
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.breakThematic] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$h),
        order: 1,
        parse: $d2e4c754b87197f5$var$Pe,
        render: function(e, r, n) {
            return G("hr", {
                key: n.key
            });
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.codeBlock] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$g),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
            };
        },
        render: function(e, n, t) {
            return G("pre", {
                key: t.key
            }, G("code", $d2e4c754b87197f5$var$r({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.codeFenced] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$m),
        order: 0,
        parse: function(e) {
            return {
                attrs: q("code", e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: $d2e4c754b87197f5$export$e0aa44767d8750d5.codeBlock
            };
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.codeInline] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$y),
        order: 3,
        parse: function(e) {
            return {
                text: e[2]
            };
        },
        render: function(e, r, n) {
            return G("code", {
                key: n.key
            }, e.text);
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.footnote] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$x),
        order: 0,
        parse: function(e) {
            return Q.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: $d2e4c754b87197f5$var$_e
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.footnoteReference] = {
        match: $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$b),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1], $d2e4c754b87197f5$export$c383cdd2a518017a),
                text: e[1]
            };
        },
        render: function(e, r, n) {
            return G("a", {
                key: n.key,
                href: t.sanitizer(e.target, "a", "href")
            }, G("sup", {
                key: n.key
            }, e.text));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.gfmTask] = {
        match: $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$w),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, r, n) {
            return G("input", {
                checked: e.completed,
                key: n.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.heading] = {
        match: $d2e4c754b87197f5$var$Me(t.enforceAtxHeadings ? $d2e4c754b87197f5$var$z : $d2e4c754b87197f5$var$C),
        order: 1,
        parse: function(e, r, n) {
            return {
                children: $d2e4c754b87197f5$var$je(r, e[2], n),
                id: t.slugify(e[2], $d2e4c754b87197f5$export$c383cdd2a518017a),
                level: e[1].length
            };
        },
        render: function(e, r, n) {
            return G("h" + e.level, {
                id: e.id,
                key: n.key
            }, r(e.children, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.headingSetext] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$L),
        order: 0,
        parse: function(e, r, n) {
            return {
                children: $d2e4c754b87197f5$var$je(r, e[1], n),
                level: "=" === e[2] ? 1 : 2,
                type: $d2e4c754b87197f5$export$e0aa44767d8750d5.heading
            };
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.htmlBlock] = {
        match: $d2e4c754b87197f5$var$Re($d2e4c754b87197f5$var$A),
        order: 1,
        parse: function(e, r, n) {
            var t, i = e[3].match($d2e4c754b87197f5$var$te), a = new RegExp("^" + i[1], "gm"), o = e[3].replace(a, ""), c = (t = o, $d2e4c754b87197f5$var$Ce.some(function(e) {
                return e.test(t);
            }) ? $d2e4c754b87197f5$var$He : $d2e4c754b87197f5$var$je), u = e[1].toLowerCase(), s = -1 !== $d2e4c754b87197f5$var$l.indexOf(u), d = (s ? u : e[1]).trim(), f = {
                attrs: q(d, e[2]),
                noInnerParse: s,
                tag: d
            };
            return n.inAnchor = n.inAnchor || "a" === u, s ? f.text = e[3] : f.children = c(r, o, n), n.inAnchor = !1, f;
        },
        render: function(e, n, t) {
            return G(e.tag, $d2e4c754b87197f5$var$r({
                key: t.key
            }, e.attrs), e.text || n(e.children, t));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.htmlSelfClosing] = {
        match: $d2e4c754b87197f5$var$Re($d2e4c754b87197f5$var$B),
        order: 1,
        parse: function(e) {
            var r = e[1].trim();
            return {
                attrs: q(r, e[2] || ""),
                tag: r
            };
        },
        render: function(e, n, t) {
            return G(e.tag, $d2e4c754b87197f5$var$r({}, e.attrs, {
                key: t.key
            }));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.htmlComment] = {
        match: $d2e4c754b87197f5$var$Re($d2e4c754b87197f5$var$O),
        order: 1,
        parse: function() {
            return {};
        },
        render: $d2e4c754b87197f5$var$_e
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.image] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$Ee),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: $d2e4c754b87197f5$var$De(e[2]),
                title: e[3]
            };
        },
        render: function(e, r, n) {
            return G("img", {
                key: n.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: t.sanitizer(e.target, "img", "src")
            });
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.link] = {
        match: $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$Se),
        order: 3,
        parse: function(e, r, n) {
            return {
                children: $d2e4c754b87197f5$var$Ne(r, e[1], n),
                target: $d2e4c754b87197f5$var$De(e[2]),
                title: e[3]
            };
        },
        render: function(e, r, n) {
            return G("a", {
                key: n.key,
                href: t.sanitizer(e.target, "a", "href"),
                title: e.title
            }, r(e.children, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.linkAngleBraceStyleDetector] = {
        match: $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$U),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: $d2e4c754b87197f5$export$e0aa44767d8750d5.text
                    }
                ],
                target: e[1],
                type: $d2e4c754b87197f5$export$e0aa44767d8750d5.link
            };
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.linkBareUrlDetector] = {
        match: function(e, r) {
            return r.inAnchor ? null : $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$R)(e, r);
        },
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: $d2e4c754b87197f5$export$e0aa44767d8750d5.text
                    }
                ],
                target: e[1],
                title: void 0,
                type: $d2e4c754b87197f5$export$e0aa44767d8750d5.link
            };
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.linkMailtoDetector] = {
        match: $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$I),
        order: 0,
        parse: function(e) {
            var r = e[1], n = e[1];
            return $d2e4c754b87197f5$var$u.test(n) || (n = "mailto:" + n), {
                children: [
                    {
                        text: r.replace("mailto:", ""),
                        type: $d2e4c754b87197f5$export$e0aa44767d8750d5.text
                    }
                ],
                target: n,
                type: $d2e4c754b87197f5$export$e0aa44767d8750d5.link
            };
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.orderedList] = $d2e4c754b87197f5$var$be(G, 1), s[$d2e4c754b87197f5$export$e0aa44767d8750d5.unorderedList] = $d2e4c754b87197f5$var$be(G, 2), s[$d2e4c754b87197f5$export$e0aa44767d8750d5.newlineCoalescer] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$k),
        order: 3,
        parse: $d2e4c754b87197f5$var$Pe,
        render: function() {
            return "\n";
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.paragraph] = {
        match: $d2e4c754b87197f5$var$Ie,
        order: 3,
        parse: $d2e4c754b87197f5$var$Fe,
        render: function(e, r, n) {
            return G("p", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.ref] = {
        match: $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$N),
        order: 0,
        parse: function(e) {
            return V[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: $d2e4c754b87197f5$var$_e
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.refImage] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$H),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, r, n) {
            return V[e.ref] ? G("img", {
                key: n.key,
                alt: e.alt,
                src: t.sanitizer(V[e.ref].target, "img", "src"),
                title: V[e.ref].title
            }) : null;
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.refLink] = {
        match: $d2e4c754b87197f5$var$$e($d2e4c754b87197f5$var$F),
        order: 0,
        parse: function(e, r, n) {
            return {
                children: r(e[1], n),
                fallbackChildren: r(e[0].replace($d2e4c754b87197f5$var$P, "\\$1"), n),
                ref: e[2]
            };
        },
        render: function(e, r, n) {
            return V[e.ref] ? G("a", {
                key: n.key,
                href: t.sanitizer(V[e.ref].target, "a", "href"),
                title: V[e.ref].title
            }, r(e.children, n)) : G("span", {
                key: n.key
            }, r(e.fallbackChildren, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.table] = {
        match: $d2e4c754b87197f5$var$Me($d2e4c754b87197f5$var$j),
        order: 1,
        parse: $d2e4c754b87197f5$var$Te,
        render: function(e, r, n) {
            var t = e;
            return G("table", {
                key: n.key
            }, G("thead", null, G("tr", null, t.header.map(function(e, i) {
                return G("th", {
                    key: i,
                    style: $d2e4c754b87197f5$var$Oe(t, i)
                }, r(e, n));
            }))), G("tbody", null, t.cells.map(function(e, i) {
                return G("tr", {
                    key: i
                }, e.map(function(e, i) {
                    return G("td", {
                        key: i,
                        style: $d2e4c754b87197f5$var$Oe(t, i)
                    }, r(e, n));
                }));
            })));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.text] = {
        match: $d2e4c754b87197f5$var$Re($d2e4c754b87197f5$var$re),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace($d2e4c754b87197f5$var$T, function(e, r) {
                    return t.namedCodesToUnicode[r] ? t.namedCodesToUnicode[r] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.textBolded] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$X),
        order: 2,
        parse: function(e, r, n) {
            return {
                children: r(e[2], n)
            };
        },
        render: function(e, r, n) {
            return G("strong", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.textEmphasized] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$J),
        order: 3,
        parse: function(e, r, n) {
            return {
                children: r(e[2], n)
            };
        },
        render: function(e, r, n) {
            return G("em", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.textEscaped] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$ee),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: $d2e4c754b87197f5$export$e0aa44767d8750d5.text
            };
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.textMarked] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$K),
        order: 3,
        parse: $d2e4c754b87197f5$var$Fe,
        render: function(e, r, n) {
            return G("mark", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$d2e4c754b87197f5$export$e0aa44767d8750d5.textStrikethroughed] = {
        match: $d2e4c754b87197f5$var$Be($d2e4c754b87197f5$var$Y),
        order: 3,
        parse: $d2e4c754b87197f5$var$Fe,
        render: function(e, r, n) {
            return G("del", {
                key: n.key
            }, r(e.children, n));
        }
    }, s);
    !0 === t.disableParsingRawHTML && (delete ie[$d2e4c754b87197f5$export$e0aa44767d8750d5.htmlBlock], delete ie[$d2e4c754b87197f5$export$e0aa44767d8750d5.htmlSelfClosing]);
    var ae, oe = function(e) {
        var r = Object.keys(e);
        function n(t, i) {
            for(var a = [], o = ""; t;)for(var l = 0; l < r.length;){
                var c = r[l], u = e[c], s = u.match(t, i, o);
                if (s) {
                    var d = s[0];
                    t = t.substring(d.length);
                    var f = u.parse(s, n, i);
                    null == f.type && (f.type = c), a.push(f), o = d;
                    break;
                }
                l++;
            }
            return a;
        }
        return r.sort(function(r, n) {
            var t = e[r].order, i = e[n].order;
            return t !== i ? t - i : r < n ? -1 : 1;
        }), function(e, r) {
            return n(function(e) {
                return e.replace($d2e4c754b87197f5$var$v, "\n").replace($d2e4c754b87197f5$var$S, "").replace($d2e4c754b87197f5$var$W, "    ");
            }(e), r);
        };
    }(ie), le = (ae = function(e, r) {
        return function(n, t, i) {
            var a = e[n.type].render;
            return r ? r(function() {
                return a(n, t, i);
            }, n, t, i) : a(n, t, i);
        };
    }(ie, t.renderRule), function e(r, n) {
        if (void 0 === n && (n = {}), Array.isArray(r)) {
            for(var t = n.key, i = [], a = !1, o = 0; o < r.length; o++){
                n.key = o;
                var l = e(r[o], n), c = "string" == typeof l;
                c && a ? i[i.length - 1] += l : null !== l && i.push(l), a = c;
            }
            return n.key = t, i;
        }
        return ae(r, e, n);
    }), ce = Z(n);
    return Q.length ? G("div", null, ce, G("footer", {
        key: "footer"
    }, Q.map(function(e) {
        return G("div", {
            id: t.slugify(e.identifier, $d2e4c754b87197f5$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(oe(e.footnote, {
            inline: !0
        })));
    }))) : ce;
}
function $d2e4c754b87197f5$export$2e2bcd8739ae039(r) {
    var n = r.children, i = void 0 === n ? "" : n, a = r.options, o = function(e, r) {
        if (null == e) return {};
        var n, t, i = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)r.indexOf(n = a[t]) >= 0 || (i[n] = e[n]);
        return i;
    }(r, $d2e4c754b87197f5$var$t);
    return $8tsvq.cloneElement($d2e4c754b87197f5$export$69f434acfbdb0b32(i, a), o);
}



/**
 * Format de date arabe libanais déterministe — « 19 أيار · 14:23 »
 * Évite toute divergence de locale entre navigateurs.
 */ const $f7d51e66c81567d6$var$LEBANESE_MONTHS = [
    "\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u062B\u0627\u0646\u064A",
    "\u0634\u0628\u0627\u0637",
    "\u0622\u0630\u0627\u0631",
    "\u0646\u064A\u0633\u0627\u0646",
    "\u0623\u064A\u0627\u0631",
    "\u062D\u0632\u064A\u0631\u0627\u0646",
    "\u062A\u0645\u0648\u0632",
    "\u0622\u0628",
    "\u0623\u064A\u0644\u0648\u0644",
    "\u062A\u0634\u0631\u064A\u0646 \u0627\u0644\u0623\u0648\u0644",
    "\u062A\u0634\u0631\u064A\u0646 \u0627\u0644\u062B\u0627\u0646\u064A",
    "\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0648\u0644"
];
const $f7d51e66c81567d6$var$formatFlashTime = (iso)=>{
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const month = $f7d51e66c81567d6$var$LEBANESE_MONTHS[d.getMonth()] || "";
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${day} ${month} \xb7 ${hh}:${mm}`;
};
const $f7d51e66c81567d6$var$Content = ({ entries: entries, onLoadMore: onLoadMore, loading: loading, hasMore: hasMore })=>{
    const observer = (0, $8tsvq.useRef)();
    const lastEntryRef = (0, $8tsvq.useCallback)((node)=>{
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((items)=>{
            if (items[0].isIntersecting && hasMore) onLoadMore();
        });
        if (node) observer.current.observe(node);
    }, [
        loading,
        hasMore,
        onLoadMore
    ]);
    const navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
                className: "flash-hero",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "container container--narrow flash-hero__inner",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("span", {
                            className: "flash-hero__eyebrow",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                    className: "flash-hero__dot",
                                    "aria-hidden": "true"
                                }),
                                "\u0645\u0628\u0627\u0634\u0631"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
                            className: "flash-hero__title",
                            children: "\u0646\u0634\u0631\u0629 \u0627\u0644\u0623\u062E\u0628\u0627\u0631"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            className: "flash-hero__subtitle",
                            children: "\u0622\u062E\u0631 \u0627\u0644\u062A\u0637\u0648\u0631\u0627\u062A \u0641\u064A \u0644\u0628\u0646\u0627\u0646 \u0648\u0627\u0644\u0639\u0627\u0644\u0645"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
                className: "flash-feed",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "container container--narrow",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                            className: "flash-feed__title",
                            children: "\u0627\u0644\u0623\u062E\u0628\u0627\u0631"
                        }),
                        entries.length === 0 ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            className: "flash-empty",
                            children: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062E\u0628\u0627\u0631 \u062D\u0627\u0644\u064A\u064B\u0627."
                        }) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "flash-feed__list",
                            children: entries.map((entry, index)=>{
                                const truncatedBody = entry.body.split(" ").slice(0, 50).join(" ") + "\u2026";
                                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                                        ref: index === entries.length - 1 ? lastEntryRef : null,
                                        className: "flash-card",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                                className: "flash-card__time",
                                                children: $f7d51e66c81567d6$var$formatFlashTime(entry.date)
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                                                className: "flash-card__title",
                                                children: entry.title
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "flash-card__body",
                                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d2e4c754b87197f5$export$2e2bcd8739ae039), {
                                                    children: truncatedBody
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn",
                                                onClick: ()=>navigate(`/post/${entry.slug}`),
                                                children: "\u0627\u0642\u0631\u0623 \u0627\u0644\u0645\u0632\u064A\u062F"
                                            })
                                        ]
                                    })
                                }, entry.slug + index);
                            })
                        }),
                        loading && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            className: "flash-loading flash-loading--inline",
                            role: "status",
                            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $6e6b089c3d63766c$export$7f7cbe89f1eacd2), {
                                size: "large"
                            })
                        }),
                        !hasMore && entries.length > 0 && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            className: "flash-empty",
                            children: "\u2014 \u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0623\u062E\u0628\u0627\u0631 \u0627\u0644\u0645\u062A\u0627\u062D\u0629 \u2014"
                        })
                    ]
                })
            })
        ]
    });
};
var $f7d51e66c81567d6$export$2e2bcd8739ae039 = $f7d51e66c81567d6$var$Content;





var $8tsvq = parcelRequire("8tsvq");

/* Format de date arabe libanais déterministe — « 19 أيار 2026 · 14:23 » */ const $1ee7f935235d4c62$var$LEBANESE_MONTHS = [
    "\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u062B\u0627\u0646\u064A",
    "\u0634\u0628\u0627\u0637",
    "\u0622\u0630\u0627\u0631",
    "\u0646\u064A\u0633\u0627\u0646",
    "\u0623\u064A\u0627\u0631",
    "\u062D\u0632\u064A\u0631\u0627\u0646",
    "\u062A\u0645\u0648\u0632",
    "\u0622\u0628",
    "\u0623\u064A\u0644\u0648\u0644",
    "\u062A\u0634\u0631\u064A\u0646 \u0627\u0644\u0623\u0648\u0644",
    "\u062A\u0634\u0631\u064A\u0646 \u0627\u0644\u062B\u0627\u0646\u064A",
    "\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0648\u0644"
];
const $1ee7f935235d4c62$var$formatFullDate = (iso)=>{
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const month = $1ee7f935235d4c62$var$LEBANESE_MONTHS[d.getMonth()] || "";
    const year = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${day} ${month} ${year} \xb7 ${hh}:${mm}`;
};
const $1ee7f935235d4c62$var$Post = ({ entries: entries = [] })=>{
    const { id: id } = (0, $5bc57f835864eb51$export$99eaa27ddbbb95ef)();
    const navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    const [entry] = (0, $8tsvq.useState)(entries.find((e)=>e.slug === id));
    if (!entry) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        className: "container container--narrow",
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
            className: "flash-loading",
            role: "status",
            children: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026"
        })
    });
    const shareOnFacebook = ()=>{
        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
        window.open(url, "_blank", "width=600,height=400");
    };
    const shareOnTwitter = ()=>{
        const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(entry.title)}`;
        window.open(url, "_blank", "width=600,height=400");
    };
    const shareOnWhatsApp = ()=>{
        const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`;
        window.open(url, "_blank");
    };
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "container container--narrow",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "post__back-row",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--ghost",
                    onClick: ()=>navigate("/"),
                    children: "\u2190 \u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0641\u0644\u0627\u0634"
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "post",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        className: "post__time",
                        children: $1ee7f935235d4c62$var$formatFullDate(entry.date)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
                        className: "post__title",
                        children: entry.title
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "post__body",
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d2e4c754b87197f5$export$2e2bcd8739ae039), {
                            children: entry.body
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        className: "post__share",
                        "aria-label": "\u0645\u0634\u0627\u0631\u0643\u0629",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                                type: "button",
                                className: "post__share-btn post__share-btn--facebook",
                                onClick: shareOnFacebook,
                                children: "\u0645\u0634\u0627\u0631\u0643\u0629 \u0639\u0644\u0649 \u0641\u064A\u0633\u0628\u0648\u0643"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                                type: "button",
                                className: "post__share-btn post__share-btn--twitter",
                                onClick: shareOnTwitter,
                                children: "\u0645\u0634\u0627\u0631\u0643\u0629 \u0639\u0644\u0649 \u062A\u0648\u064A\u062A\u0631"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                                type: "button",
                                className: "post__share-btn post__share-btn--whatsapp",
                                onClick: shareOnWhatsApp,
                                children: "\u0645\u0634\u0627\u0631\u0643\u0629 \u0639\u0644\u0649 \u0648\u0627\u062A\u0633\u0627\u0628"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $1ee7f935235d4c62$export$2e2bcd8739ae039 = $1ee7f935235d4c62$var$Post;


const $c3c8ef5796d3b74c$var$client = (0, $27e65424bfb9f508$export$5d730b7aed1a3eb0)({
    space: "hbhoppvvcn53",
    accessToken: "qKYG286tDhftaQ386vtmhiGXfSKwoHotW2Voh--sqrc"
});
const $c3c8ef5796d3b74c$var$ITEMS_PER_PAGE = 20;
const $c3c8ef5796d3b74c$var$fetcher = async (key, skip = 0)=>{
    const entryItems = await $c3c8ef5796d3b74c$var$client.getEntries({
        content_type: "article",
        order: "-fields.date",
        limit: $c3c8ef5796d3b74c$var$ITEMS_PER_PAGE,
        skip: skip,
        "fields.category.sys.id": "3yk6ZcPzfN9tGdhyGjwrEN"
    });
    const entries = entryItems.items.map((entry)=>{
        const { fields: fields } = entry;
        return {
            title: fields.title,
            body: fields.body,
            date: fields.date,
            slug: fields.slug
        };
    });
    return {
        entries: entries,
        total: entryItems.total
    };
};
const $c3c8ef5796d3b74c$var$ScrollHandler = ()=>{
    const location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    (0, $8tsvq.useEffect)(()=>{
        document.documentElement.style.scrollBehavior = "auto";
        document.body.style.scrollBehavior = "auto";
        window.history.scrollRestoration = "manual";
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        location
    ]);
    return null;
};
const $c3c8ef5796d3b74c$var$Shell = ({ children: children })=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "flash-news-container",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                href: "#main",
                className: "skip-link",
                children: "\u062A\u062E\u0637\u0651\u064A \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u062A\u0648\u0649"
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $bf0d4196deb7c8c8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("main", {
                id: "main",
                className: "flash-main",
                children: children
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f066148deeb3f081$export$2e2bcd8739ae039), {})
        ]
    });
const $c3c8ef5796d3b74c$var$App = ()=>{
    const [page, setPage] = (0, $8tsvq.useState)(0);
    const { data: data, error: error } = (0, $79855d690348307f$export$2e2bcd8739ae039)([
        "contentful",
        page * $c3c8ef5796d3b74c$var$ITEMS_PER_PAGE
    ], ([key, skip])=>$c3c8ef5796d3b74c$var$fetcher(key, skip));
    const [allEntries, setAllEntries] = (0, $8tsvq.useState)([]);
    const [loading, setLoading] = (0, $8tsvq.useState)(false);
    const [hasMore, setHasMore] = (0, $8tsvq.useState)(true);
    if (error) {
        console.log(error);
        return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($c3c8ef5796d3b74c$var$Shell, {
            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "container container--narrow",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                    className: "flash-error",
                    children: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062D\u062A\u0648\u0649. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0644\u0627\u062D\u0642\u064B\u0627."
                })
            })
        });
    }
    if (!data && page === 0) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($c3c8ef5796d3b74c$var$Shell, {
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
            className: "flash-loading",
            role: "status",
            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $6e6b089c3d63766c$export$7f7cbe89f1eacd2), {
                size: "large"
            })
        })
    });
    if (data && data.entries.length > 0 && allEntries.length === 0) {
        setAllEntries(data.entries);
        setHasMore(data.entries.length < data.total);
    }
    const loadMore = async ()=>{
        if (loading || !hasMore) return;
        setLoading(true);
        const nextPage = page + 1;
        const newData = await $c3c8ef5796d3b74c$var$fetcher("contentful", nextPage * $c3c8ef5796d3b74c$var$ITEMS_PER_PAGE);
        setPage(nextPage);
        setAllEntries((prev)=>[
                ...prev,
                ...newData.entries
            ]);
        setHasMore(allEntries.length + newData.entries.length < newData.total);
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $63c245eaedba316b$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($c3c8ef5796d3b74c$var$ScrollHandler, {}),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($c3c8ef5796d3b74c$var$Shell, {
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $5bc57f835864eb51$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7d51e66c81567d6$export$2e2bcd8739ae039), {
                                entries: allEntries,
                                onLoadMore: loadMore,
                                loading: loading,
                                hasMore: hasMore
                            })
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                            path: "/post/:id",
                            element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $1ee7f935235d4c62$export$2e2bcd8739ae039), {
                                entries: allEntries
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $c3c8ef5796d3b74c$export$2e2bcd8739ae039 = $c3c8ef5796d3b74c$var$App;


const $22cce652dfc8bdb5$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($416246511aeb39de$exports))).createRoot(document.getElementById("root"));
$22cce652dfc8bdb5$var$root.render(/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).StrictMode, {
    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $c3c8ef5796d3b74c$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.c8552069.js.map
